webpackJsonp([171],[
/* 0 */,
/* 1 */,
/* 2 */,
/* 3 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_vue__ = __webpack_require__(48);

/* harmony default export */ __webpack_exports__["a"] = (new __WEBPACK_IMPORTED_MODULE_0_vue__["default"]());

/***/ }),
/* 4 */,
/* 5 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_lodash_merge__ = __webpack_require__(306);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_lodash_merge___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_lodash_merge__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__core_helpers_bus__ = __webpack_require__(3);



/* harmony default export */ __webpack_exports__["a"] = ({
  data: function data() {
    return {
      show: false,
      options: {},
      defaultOptions: {
        fullscreen: false,
        maxWidth: 520
      },
      skipNextAction: false
    };
  },

  computed: {
    fullscreen: function fullscreen() {
      return this.$vuetify.breakpoint.xsOnly;
    },
    transition: function transition() {
      return this.fullscreen ? 'dialog-bottom-transition' : undefined;
    }
  },
  methods: {
    open: function open() {
      var _this = this;

      var options = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : {};

      var alias = options.alias || this.name;
      this.show = true;
      this.skipNextAction = false;
      this.options = __WEBPACK_IMPORTED_MODULE_0_lodash_merge___default()({}, this.defaultOptions, options);
      this.onOpen();
      this.$emit('open');

      __WEBPACK_IMPORTED_MODULE_1__core_helpers_bus__["a" /* default */].$on('close' + alias + 'Dialog', function () {
        _this.cancel();
      }); // subscribe to event openNAMEDialog
    },
    ok: function ok() {
      var data = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : {};

      this.show = false;
      if (!this.skipNextAction) {
        this.skipNextAction = true;
        if (this.options.ok) {
          this.options.ok(data);
        }
        this.onOk();
        var payload = { type: 'ok', data: data };
        this.onClose();
        this.$emit('close', payload);
      }
    },
    cancel: function cancel() {
      this.show = false;
      if (!this.skipNextAction) {
        this.skipNextAction = true;
        if (this.options.cancel) {
          this.options.cancel();
        }
        this.onCancel();
        var payload = { type: 'cancel' };
        this.onClose();
        this.$emit('close', payload);
      }
    },
    onOpen: function onOpen() {},
    onOk: function onOk() {},
    onCancel: function onCancel() {},
    onClose: function onClose() {},
    getQueryString: function getQueryString() {
      return this.$router.currentRoute.query[this.className];
    },
    serializeQuery: function serializeQuery() {
      return true;
    },
    deserializeQuery: function deserializeQuery() {
      return true;
    }
  },
  created: function created() {
    var name = this.$options.name;
    __WEBPACK_IMPORTED_MODULE_1__core_helpers_bus__["a" /* default */].$on('open' + name, this.open); // subscribe to event open{ComponentName}
  },

  watch: {
    /**
     * This is here when you click overlay and the dialog closes. Only perform
     * is ignoreNext is false (meaning it hasn't already been processed by cancel()
     * @param {Boolean} val
     */
    show: function show(val) {
      if (!val) {
        if (!this.skipNextAction) {
          this.cancel();
        }
      }
      this.skipNextAction = false;
    }
  }
});

/***/ }),
/* 6 */,
/* 7 */,
/* 8 */,
/* 9 */,
/* 10 */,
/* 11 */,
/* 12 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony default export */ __webpack_exports__["a"] = ({
  data: function data() {
    return {
      months: ['January', 'February', 'March', 'April', 'May', 'June', 'July', 'August', 'September', 'October', 'November', 'December'],
      days: ['Sunday', 'Monday', 'Tuesday', 'Wednesday', 'Thursday', 'Friday', 'Saturday'],
      shortMonths: ['Jan', 'Feb', 'Mar', 'Apr', 'May', 'Jun', 'Jul', 'Aug', 'Sept', 'Oct', 'Nov', 'Dec'],
      shortDays: ['Sun', 'Mon', 'Tues', 'Wed', 'Thurs', 'Fri', 'Sat']
    };
  },

  methods: {
    birthdateToTimestamp: function birthdateToTimestamp(birthdate) {
      var extractedNumbers = birthdate.replace(/\D/g, '');
      var constructedDate = new Date(extractedNumbers.slice(4, 8), extractedNumbers.slice(0, 2) - 1, extractedNumbers.slice(2, 4));
      if (constructedDate.getTime()) {
        return Date.UTC(constructedDate.getFullYear(), constructedDate.getMonth(), constructedDate.getDate(), 12) / 1000;
      }
    },
    getTypeForFile: function getTypeForFile(file) {
      var recordTypesDictionary = {
        'IMAGE_READ': 'MRI Report',
        'MRI': 'MRI Image',
        'PRE_OP_NOTE': 'Pre-operative Note',
        'POST_OP_NOTE': 'Post-operative Note',
        'OP_NOTE': 'Operative Note',
        'OFFICE_VISIT': 'Office Visit',
        'MESSAGE': 'Clinical Message',
        'XRAY': 'X-Ray',
        'OTHER_IMAGING': 'Imaging',
        'LAB_RESULT': 'Lab Result',
        'PROGRESS_NOTE': 'Progress Note',
        'DIAGNOSTIC_REPORT': 'Diagnostic Report',
        'REFERRAL': 'Referral',
        'COMPLETED_PRIOR_AUTH': 'Completed Prior-Auth',
        'UNKNOWN': 'Medical Record'
      };
      if (file.recordType) {
        if (recordTypesDictionary[file.recordType]) {
          return recordTypesDictionary[file.recordType];
        } else {
          return 'Medical Record';
        }
      } else {
        return 'Medical Record';
      }
    },
    getTimestampOfStartOfThisMonth: function getTimestampOfStartOfThisMonth() {
      var nowdate = new Date();
      var monthStartDay = new Date(nowdate.getFullYear(), nowdate.getMonth(), 1);

      monthStartDay.setHours(0, 0, 0, 0);
      var monthStartDayCutoff = monthStartDay.getTime() / 1000;
      return monthStartDayCutoff;
    },
    getCurrentMonthName: function getCurrentMonthName() {
      var nowdate = new Date();
      return this.shortMonths[nowdate.getMonth()];
    },
    getTimestampOfStartOfPreviousMonth: function getTimestampOfStartOfPreviousMonth() {
      var nowdate = new Date();
      var year = nowdate.getFullYear();
      var month = nowdate.getMonth();

      if (month === 0) {
        month = 11;
        year = year - 1;
      } else {
        month = month - 1;
      }
      var monthStartDay = new Date(year, month, 1);

      monthStartDay.setHours(0, 0, 0, 0);
      var monthStartDayCutoff = monthStartDay.getTime() / 1000;
      return monthStartDayCutoff;
    },
    getPreviousMonthName: function getPreviousMonthName() {
      var nowdate = new Date();
      var month = nowdate.getMonth();

      if (month === 0) {
        month = 11;
      } else {
        month = month - 1;
      }

      return this.shortMonths[month];
    },
    getDateStringFromTimestamp: function getDateStringFromTimestamp(timestamp) {
      var d = new Date(timestamp * 1000);
      return d.getMonth() + 1 + '/' + d.getDate() + '/' + d.getFullYear();
    },
    getBirthdateStringFromTimestamp: function getBirthdateStringFromTimestamp(timestamp) {
      var d = new Date(timestamp * 1000);
      var MyDateString = ('0' + (d.getMonth() + 1)).slice(-2) + '/' + ('0' + d.getDate()).slice(-2) + '/' + d.getFullYear();
      return MyDateString;
    },
    getLongDateStringFromTimestamp: function getLongDateStringFromTimestamp(timestamp) {
      var d = new Date(timestamp * 1000);
      return this.days[d.getDay()] + ' ' + this.months[d.getMonth()] + ' ' + d.getDate() + ', ' + d.getFullYear();
    },
    getMediumDateWithDayDateStringFromTimestamp: function getMediumDateWithDayDateStringFromTimestamp(timestamp) {
      var d = new Date(timestamp * 1000);
      return this.shortDays[d.getDay()] + ' ' + this.shortMonths[d.getMonth()] + ' ' + d.getDate() + ', ' + d.getFullYear();
    },
    dateForSortingFromTimestamp: function dateForSortingFromTimestamp(timestamp) {
      // this method takes a timestamp and returns a date string in the format yyyymmdd
      var d = new Date(timestamp * 1000);
      return d.getFullYear() + ('0' + (d.getMonth() + 1)).slice(-2) + ('0' + d.getDate()).slice(-2);
    },
    providerDisplayNameFromProviderObject: function providerDisplayNameFromProviderObject(provider) {
      if (provider) {
        if (provider.firstName) {
          var name = provider.firstName + ' ' + provider.lastName;

          if (provider.credentials) {
            name = name + ' ' + provider.credentials;
          }
          return name;
        }
        if (provider.organizationName) {
          return provider.organizationName;
        }
        if (provider.coveredEntityName) {
          return provider.coveredEntityName;
        }
      }
    },
    providerDisplayAddressFromProviderObject: function providerDisplayAddressFromProviderObject(provider) {
      if (provider.address) {
        var addressString = provider.address.line1;
        if (provider.address.line2) {
          addressString = addressString + ' ' + provider.address.line2;
        }

        addressString = addressString + ' ' + provider.address.city + ' ' + provider.address.state + ' ' + provider.address.zip;

        return addressString;
      }
      return '';
    },
    patientDisplayAddressFromPatientObject: function patientDisplayAddressFromPatientObject(patient) {
      if (patient.address) {
        var addressString = patient.address.line1;
        if (patient.address.line2) {
          addressString = addressString + ' ' + patient.address.line2;
        }

        addressString = addressString + ' ' + patient.address.city + ' ' + patient.address.state + ' ' + patient.address.zip;

        return addressString;
      }
      return 'Missing Address';
    },
    shouldShowPendingProviderReview: function shouldShowPendingProviderReview(timestamp) {
      var nowdate = new Date().getTime() / 1000;

      var timestampOfWhenThePatientCanViewTheDocument = this.businessDaysFromDate(timestamp, 2);
      console.log(timestampOfWhenThePatientCanViewTheDocument);

      if (nowdate > timestampOfWhenThePatientCanViewTheDocument) {
        return false;
      } else {
        return true;
      }
    },
    businessDaysFromDate: function businessDaysFromDate(d, businessDays) {
      var date = new Date(d * 1000);
      var counter = 0;
      var tmp = new Date(date);
      while (businessDays >= 0) {
        tmp.setTime(date.getTime() + counter * 86400000);
        if (this.isBusinessDay(tmp)) {
          --businessDays;
        }
        ++counter;
      }
      return tmp.getTime() / 1000;
    },
    isBusinessDay: function isBusinessDay(date) {
      var dayOfWeek = date.getDay();
      if (dayOfWeek === 0 || dayOfWeek === 6) {
        // Weekend
        return false;
      }
      var holidays = ['12/31+5', '1/1', '1/2+1', '1-3/1', '2-3/1', '5~1/1', '7/3+5', '7/4', '7/5+1', '9-1/1', '10-2/1', '11/10+5', '11/11', '11/12+1', '11-4/4', '12/24+5', '12/25', '12/26+1'];
      var dayOfMonth = date.getDate();
      var month = date.getMonth() + 1;
      var monthDay = month + '/' + dayOfMonth;
      if (holidays.indexOf(monthDay) > -1) {
        return false;
      }
      var monthDayDay = monthDay + '+' + dayOfWeek;
      if (holidays.indexOf(monthDayDay) > -1) {
        return false;
      }
      var weekOfMonth = Math.floor((dayOfMonth - 1) / 7) + 1;
      var monthWeekDay = month + '-' + weekOfMonth + '/' + dayOfWeek;
      if (holidays.indexOf(monthWeekDay) > -1) {
        return false;
      }
      var lastDayOfMonth = new Date(date);
      lastDayOfMonth.setMonth(lastDayOfMonth.getMonth() + 1);
      lastDayOfMonth.setDate(0);
      var negWeekOfMonth = Math.floor((lastDayOfMonth.getDate() - dayOfMonth - 1) / 7) + 1;
      var monthNegWeekDay = month + '~' + negWeekOfMonth + '/' + dayOfWeek;
      if (holidays.indexOf(monthNegWeekDay) > -1) {
        return false;
      }
      return true;
    },
    transformPartnerIDToHumanReadableName: function transformPartnerIDToHumanReadableName(theID) {
      if (theID.includes('5a4fa82c8e4b74e028665d04')) {
        return 'SmartChoice';
      } else if (theID.includes('5acb94000495d7065c909bc2')) {
        return 'Grayhawk';
      } else if (theID.includes('5b73507c4aef2028740f662b')) {
        return 'ImagineMD';
      } else if (theID.includes('5a3f56ec92808ba8d3d5a391')) {
        return 'Newpark';
      } else {
        return 'invalidID: ' + theID;
      }
    }
  }
});

/***/ }),
/* 13 */,
/* 14 */,
/* 15 */,
/* 16 */,
/* 17 */,
/* 18 */,
/* 19 */,
/* 20 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_vue_loader_lib_selector_type_script_index_0_Avatar_vue__ = __webpack_require__(173);
/* unused harmony namespace reexport */
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__node_modules_vue_loader_lib_template_compiler_index_id_data_v_34731ab8_hasScoped_true_transformToRequire_video_src_poster_source_src_img_src_image_xlink_href_buble_transforms_node_modules_vue_loader_lib_selector_type_template_index_0_Avatar_vue__ = __webpack_require__(382);
function injectStyle (ssrContext) {
  __webpack_require__(380)
}
var normalizeComponent = __webpack_require__(0)
/* script */


/* template */

/* template functional */
var __vue_template_functional__ = false
/* styles */
var __vue_styles__ = injectStyle
/* scopeId */
var __vue_scopeId__ = "data-v-34731ab8"
/* moduleIdentifier (server only) */
var __vue_module_identifier__ = null
var Component = normalizeComponent(
  __WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_vue_loader_lib_selector_type_script_index_0_Avatar_vue__["a" /* default */],
  __WEBPACK_IMPORTED_MODULE_1__node_modules_vue_loader_lib_template_compiler_index_id_data_v_34731ab8_hasScoped_true_transformToRequire_video_src_poster_source_src_img_src_image_xlink_href_buble_transforms_node_modules_vue_loader_lib_selector_type_template_index_0_Avatar_vue__["a" /* default */],
  __vue_template_functional__,
  __vue_styles__,
  __vue_scopeId__,
  __vue_module_identifier__
)

/* harmony default export */ __webpack_exports__["a"] = (Component.exports);


/***/ }),
/* 21 */,
/* 22 */,
/* 23 */,
/* 24 */,
/* 25 */,
/* 26 */,
/* 27 */,
/* 28 */,
/* 29 */,
/* 30 */,
/* 31 */,
/* 32 */,
/* 33 */,
/* 34 */,
/* 35 */,
/* 36 */,
/* 37 */,
/* 38 */,
/* 39 */,
/* 40 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_vue_loader_lib_selector_type_script_index_0_Titlebar_vue__ = __webpack_require__(205);
/* unused harmony namespace reexport */
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__node_modules_vue_loader_lib_template_compiler_index_id_data_v_2b2daa94_hasScoped_true_transformToRequire_video_src_poster_source_src_img_src_image_xlink_href_buble_transforms_node_modules_vue_loader_lib_selector_type_template_index_0_Titlebar_vue__ = __webpack_require__(456);
function injectStyle (ssrContext) {
  __webpack_require__(455)
}
var normalizeComponent = __webpack_require__(0)
/* script */


/* template */

/* template functional */
var __vue_template_functional__ = false
/* styles */
var __vue_styles__ = injectStyle
/* scopeId */
var __vue_scopeId__ = "data-v-2b2daa94"
/* moduleIdentifier (server only) */
var __vue_module_identifier__ = null
var Component = normalizeComponent(
  __WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_vue_loader_lib_selector_type_script_index_0_Titlebar_vue__["a" /* default */],
  __WEBPACK_IMPORTED_MODULE_1__node_modules_vue_loader_lib_template_compiler_index_id_data_v_2b2daa94_hasScoped_true_transformToRequire_video_src_poster_source_src_img_src_image_xlink_href_buble_transforms_node_modules_vue_loader_lib_selector_type_template_index_0_Titlebar_vue__["a" /* default */],
  __vue_template_functional__,
  __vue_styles__,
  __vue_scopeId__,
  __vue_module_identifier__
)

/* harmony default export */ __webpack_exports__["a"] = (Component.exports);


/***/ }),
/* 41 */,
/* 42 */,
/* 43 */,
/* 44 */,
/* 45 */,
/* 46 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_json_stringify__ = __webpack_require__(660);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_json_stringify___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_json_stringify__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_babel_runtime_helpers_typeof__ = __webpack_require__(662);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_babel_runtime_helpers_typeof___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_1_babel_runtime_helpers_typeof__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_axios__ = __webpack_require__(675);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_axios___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_2_axios__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3_simple_web_worker__ = __webpack_require__(277);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3_simple_web_worker___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_3_simple_web_worker__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4__consts__ = __webpack_require__(694);






var opts = {};
if (window.location.href.indexOf('mock=1') === -1) {
  opts.baseURL = "https://api-dot-onechart-prod.appspot.com";
} else {
  opts.baseURL = Object({"NODE_ENV":"production","SERVICES_URL":"https://api-dot-onechart-prod.appspot.com","PDF_VIEWER_URL":"https://onechart-pdf-viewer.firebaseapp.com/","DICOM_VIEWER_URL":"https://onechart-image-viewer.firebaseapp.com/","FIREBASE_CONFIG":{
    apiKey: 'AIzaSyBhHTQWfKsJSMkk8Be_ajV6oAbwCy79PlU',
    authDomain: 'onechart-prod.firebaseapp.com',
    databaseURL: 'https://onechart-prod.firebaseio.com',
    projectId: 'onechart-prod',
    storageBucket: 'onechart-prod.appspot.com',
    messagingSenderId: '530093705162'
  }}).MOCK_SERVICES_URL;
}

var ax = __WEBPACK_IMPORTED_MODULE_2_axios___default.a.create(opts);

ax.transformRequest = function (data) {
  var dict = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : null;

  if ((typeof data === 'undefined' ? 'undefined' : __WEBPACK_IMPORTED_MODULE_1_babel_runtime_helpers_typeof___default()(data)) === 'object') {
    data = __WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_json_stringify___default()(data);
  }
  dict = dict || __WEBPACK_IMPORTED_MODULE_4__consts__["a" /* request */];
  return __WEBPACK_IMPORTED_MODULE_3_simple_web_worker___default.a.run(function (data, dict) {
    for (var prop in dict) {
      data = data.replace(new RegExp('"' + prop + '"', 'g'), '"' + dict[prop] + '"');
    }
    return JSON.parse(data);
  }, [data, dict]);
};

ax.transformResponse = function (data) {
  var dict = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : null;

  if ((typeof data === 'undefined' ? 'undefined' : __WEBPACK_IMPORTED_MODULE_1_babel_runtime_helpers_typeof___default()(data)) === 'object') {
    data = __WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_json_stringify___default()(data);
  }
  dict = dict || __WEBPACK_IMPORTED_MODULE_4__consts__["b" /* response */];
  return __WEBPACK_IMPORTED_MODULE_3_simple_web_worker___default.a.run(function (jsonStr, dict) {
    function isObject(arg) {
      if (arg) {
        var type = Object.prototype.toString.call(arg);
        return type.indexOf('Object') !== -1;
      }
      return false;
    }

    function isArray(arg) {
      if (arg) {
        var type = Object.prototype.toString.call(arg);
        return type.indexOf('Array') !== -1;
      }
      return false;
    }

    function iterateNodes(data) {
      var returnObj = isArray(data) ? [] : {};
      for (var prop in data) {
        if (data.hasOwnProperty(prop) && prop.match(/^[A-Z0-9]/)) {
          if (!!data[prop] && (isObject(data[prop]) || isArray(data[prop]))) {
            returnObj[prop] = iterateNodes(data[prop]);
          } else {
            returnObj[prop] = data[prop];
          }
        }
      }
      return returnObj;
    }

    for (var prop in dict) {
      jsonStr = jsonStr.replace(new RegExp('"' + prop + '"', 'g'), '"' + dict[prop] + '"');
    }
    var json = {};
    try {
      json = JSON.parse(jsonStr);
    } catch (e) {}
    var data = iterateNodes(json);
    return data;
  }, [data, dict]);
};

/* harmony default export */ __webpack_exports__["a"] = (ax);

/***/ }),
/* 47 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
function parseParams(url, hash) {
  for (var e in hash) {
    if (hash.hasOwnProperty(e)) {
      var regExp = new RegExp(':(' + e + ')\\b', 'g');
      if (regExp.test(url)) {
        url = url.replace(regExp, hash[e]);
        delete hash[e];
      }
    }
  }
  url = url.replace(/\/:\w+/gi, ''); // strip any "/:ids" that were still remaining
  url = url.replace(/\/$/gi, ''); // strip trailing slash "/"
  return url;
}

function parseQuery(url, hash) {
  if (url.indexOf('?') !== -1) {
    var queryParams = [];
    var baseUrl = url.split('?').shift();
    var params = url.split('?').pop().split('&');
    for (var i = 0; i < params.length; i++) {
      var param = params[i];
      if (hash[param] !== undefined) {
        queryParams.push(param + '=' + encodeURIComponent(hash[param]));
      }
    }
    return baseUrl + '?' + queryParams.join('&');
  }
  return url;
}

function parseUrl(url, hash) {
  url = parseParams(url, hash);
  url = parseQuery(url, hash);
  return url;
}

/* harmony default export */ __webpack_exports__["a"] = (parseUrl);

/***/ }),
/* 48 */,
/* 49 */,
/* 50 */,
/* 51 */,
/* 52 */,
/* 53 */,
/* 54 */,
/* 55 */,
/* 56 */,
/* 57 */,
/* 58 */,
/* 59 */,
/* 60 */,
/* 61 */,
/* 62 */,
/* 63 */,
/* 64 */,
/* 65 */,
/* 66 */,
/* 67 */,
/* 68 */,
/* 69 */,
/* 70 */,
/* 71 */,
/* 72 */,
/* 73 */,
/* 74 */,
/* 75 */,
/* 76 */,
/* 77 */,
/* 78 */,
/* 79 */,
/* 80 */,
/* 81 */,
/* 82 */,
/* 83 */,
/* 84 */,
/* 85 */,
/* 86 */,
/* 87 */,
/* 88 */,
/* 89 */,
/* 90 */,
/* 91 */,
/* 92 */,
/* 93 */,
/* 94 */,
/* 95 */,
/* 96 */,
/* 97 */,
/* 98 */,
/* 99 */,
/* 100 */,
/* 101 */,
/* 102 */,
/* 103 */,
/* 104 */,
/* 105 */,
/* 106 */,
/* 107 */,
/* 108 */,
/* 109 */,
/* 110 */,
/* 111 */,
/* 112 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_vue_loader_lib_selector_type_script_index_0_Icon_vue__ = __webpack_require__(174);
/* unused harmony namespace reexport */
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__node_modules_vue_loader_lib_template_compiler_index_id_data_v_7918303a_hasScoped_false_transformToRequire_video_src_poster_source_src_img_src_image_xlink_href_buble_transforms_node_modules_vue_loader_lib_selector_type_template_index_0_Icon_vue__ = __webpack_require__(381);
var normalizeComponent = __webpack_require__(0)
/* script */


/* template */

/* template functional */
var __vue_template_functional__ = false
/* styles */
var __vue_styles__ = null
/* scopeId */
var __vue_scopeId__ = null
/* moduleIdentifier (server only) */
var __vue_module_identifier__ = null
var Component = normalizeComponent(
  __WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_vue_loader_lib_selector_type_script_index_0_Icon_vue__["a" /* default */],
  __WEBPACK_IMPORTED_MODULE_1__node_modules_vue_loader_lib_template_compiler_index_id_data_v_7918303a_hasScoped_false_transformToRequire_video_src_poster_source_src_img_src_image_xlink_href_buble_transforms_node_modules_vue_loader_lib_selector_type_template_index_0_Icon_vue__["a" /* default */],
  __vue_template_functional__,
  __vue_styles__,
  __vue_scopeId__,
  __vue_module_identifier__
)

/* harmony default export */ __webpack_exports__["a"] = (Component.exports);


/***/ }),
/* 113 */,
/* 114 */,
/* 115 */,
/* 116 */,
/* 117 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_vue_loader_lib_selector_type_script_index_0_FormTextarea_vue__ = __webpack_require__(208);
/* unused harmony namespace reexport */
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__node_modules_vue_loader_lib_template_compiler_index_id_data_v_e43a143e_hasScoped_true_transformToRequire_video_src_poster_source_src_img_src_image_xlink_href_buble_transforms_node_modules_vue_loader_lib_selector_type_template_index_0_FormTextarea_vue__ = __webpack_require__(463);
function injectStyle (ssrContext) {
  __webpack_require__(462)
}
var normalizeComponent = __webpack_require__(0)
/* script */


/* template */

/* template functional */
var __vue_template_functional__ = false
/* styles */
var __vue_styles__ = injectStyle
/* scopeId */
var __vue_scopeId__ = "data-v-e43a143e"
/* moduleIdentifier (server only) */
var __vue_module_identifier__ = null
var Component = normalizeComponent(
  __WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_vue_loader_lib_selector_type_script_index_0_FormTextarea_vue__["a" /* default */],
  __WEBPACK_IMPORTED_MODULE_1__node_modules_vue_loader_lib_template_compiler_index_id_data_v_e43a143e_hasScoped_true_transformToRequire_video_src_poster_source_src_img_src_image_xlink_href_buble_transforms_node_modules_vue_loader_lib_selector_type_template_index_0_FormTextarea_vue__["a" /* default */],
  __vue_template_functional__,
  __vue_styles__,
  __vue_scopeId__,
  __vue_module_identifier__
)

/* harmony default export */ __webpack_exports__["a"] = (Component.exports);


/***/ }),
/* 118 */,
/* 119 */,
/* 120 */,
/* 121 */,
/* 122 */,
/* 123 */,
/* 124 */,
/* 125 */,
/* 126 */,
/* 127 */,
/* 128 */,
/* 129 */,
/* 130 */,
/* 131 */,
/* 132 */,
/* 133 */,
/* 134 */,
/* 135 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_vue__ = __webpack_require__(48);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_vuex__ = __webpack_require__(2);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__modules_admin__ = __webpack_require__(655);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3__modules_auth__ = __webpack_require__(695);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4__modules_file__ = __webpack_require__(746);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_5__modules_patient__ = __webpack_require__(751);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_6__modules_provider__ = __webpack_require__(756);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_7__modules_registration__ = __webpack_require__(761);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_8__modules_upload__ = __webpack_require__(766);











__WEBPACK_IMPORTED_MODULE_0_vue__["default"].use(__WEBPACK_IMPORTED_MODULE_1_vuex__["a" /* default */]);

var store = new __WEBPACK_IMPORTED_MODULE_1_vuex__["a" /* default */].Store({
  modules: {
    admin: __WEBPACK_IMPORTED_MODULE_2__modules_admin__["a" /* default */],
    auth: __WEBPACK_IMPORTED_MODULE_3__modules_auth__["a" /* default */],
    file: __WEBPACK_IMPORTED_MODULE_4__modules_file__["a" /* default */],
    patient: __WEBPACK_IMPORTED_MODULE_5__modules_patient__["a" /* default */],
    provider: __WEBPACK_IMPORTED_MODULE_6__modules_provider__["a" /* default */],
    registration: __WEBPACK_IMPORTED_MODULE_7__modules_registration__["a" /* default */],
    upload: __WEBPACK_IMPORTED_MODULE_8__modules_upload__["a" /* default */]
  }
});

/* harmony default export */ __webpack_exports__["a"] = (store);

/***/ }),
/* 136 */,
/* 137 */,
/* 138 */,
/* 139 */,
/* 140 */,
/* 141 */,
/* 142 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_extends__ = __webpack_require__(1);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_extends___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_extends__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__core_components_Footer__ = __webpack_require__(301);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__core_components_Backdrop__ = __webpack_require__(367);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3__components_headers_DesktopHeader__ = __webpack_require__(370);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4__components_headers_MobileHeader__ = __webpack_require__(388);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_5_vuex__ = __webpack_require__(2);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_6__core_helpers_bus__ = __webpack_require__(3);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_7__core_helpers_idle__ = __webpack_require__(391);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_8__components_headers_ApplicationHeader__ = __webpack_require__(392);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_9__components_headers_GlobalNavigationToolbar__ = __webpack_require__(398);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_10__components_dialogs_IdleDialog__ = __webpack_require__(417);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_11__components_RequestLogs__ = __webpack_require__(194);

//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//













/* harmony default export */ __webpack_exports__["a"] = ({
  name: 'app',
  components: {
    IdleDialog: __WEBPACK_IMPORTED_MODULE_10__components_dialogs_IdleDialog__["a" /* default */],
    DesktopHeader: __WEBPACK_IMPORTED_MODULE_3__components_headers_DesktopHeader__["a" /* default */],
    MobileHeader: __WEBPACK_IMPORTED_MODULE_4__components_headers_MobileHeader__["a" /* default */],
    DesktopFooter: __WEBPACK_IMPORTED_MODULE_1__core_components_Footer__["a" /* default */],
    Backdrop: __WEBPACK_IMPORTED_MODULE_2__core_components_Backdrop__["a" /* default */],
    ApplicationHeader: __WEBPACK_IMPORTED_MODULE_8__components_headers_ApplicationHeader__["a" /* default */],
    GlobalNavigationToolbar: __WEBPACK_IMPORTED_MODULE_9__components_headers_GlobalNavigationToolbar__["a" /* default */],
    RequestLogs: __WEBPACK_IMPORTED_MODULE_11__components_RequestLogs__["a" /* default */]
  },
  data: function data() {
    return {
      drawer: true,
      newLayout: false,
      // loading dialog trigger
      appLoading: false,
      pageLoading: false,
      // Toast properties
      date: null,
      showSnackbar: false,
      snackbarType: '',
      snackbarText: '',
      drawerItems: [{ title: 'Patients', icon: 'face', method: 'right-drawer-navPatient' }, { title: 'Logout', icon: 'exit_to_app', method: 'right-drawer-logout' }],
      pending: {},
      executeShowIdleDialog: null,
      lastActiveTime: null,
      idleAway: null,
      activeTimeInterval: null
    };
  },

  computed: __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_extends___default()({}, Object(__WEBPACK_IMPORTED_MODULE_5_vuex__["d" /* mapState */])('auth', ['user', 'brandingPartner']), Object(__WEBPACK_IMPORTED_MODULE_5_vuex__["d" /* mapState */])('admin', ['loadingRequests', 'loadingFiles']), Object(__WEBPACK_IMPORTED_MODULE_5_vuex__["d" /* mapState */])('patient', ['patient']), {
    isDesktop: function isDesktop() {
      return this.$vuetify.breakpoint.smAndUp;
    },
    isMobile: function isMobile() {
      return this.$vuetify.breakpoint.smAndDown;
    },
    showHeader: function showHeader() {
      return this.$route.meta.hideHeader !== true;
    },
    centerContentVertically: function centerContentVertically() {
      if (this.$route.name === 'NewPatientPage') {
        return true;
      } else {
        return false;
      }
    },
    sizingClass: function sizingClass() {
      if (this.newLayout) {
        return 'xs12';
      } else {
        return 'xs12 sm8';
      }
    },
    classes: function classes() {
      var classes = [];
      if (this.$vuetify.breakpoint.smAndDown) {
        classes.push('device--mobile');
      } else {
        classes.push('device--desktop');
      }
      classes.push('default-branding');
      return classes.join(', ');
    }
  }),
  watch: {},
  methods: __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_extends___default()({}, Object(__WEBPACK_IMPORTED_MODULE_5_vuex__["b" /* mapActions */])('auth', ['getUser', 'signOut', 'setBranding']), {
    toggleDrawer: function toggleDrawer() {
      if (this.drawer) {
        this.drawer = false;
      } else {
        this.drawer = true;
      }
    },
    logout: function logout() {
      this.pending = null;
      this.signOut();
      this.$router.push('/login');
    },
    toast: function toast(text, type) {
      this.showSnackbar = true;
      this.snackbarType = type;
      this.snackbarText = text;
    },
    navPatients: function navPatients() {
      this.$router.push({
        name: 'PatientsPage'
      });
    },
    showIdleDialog: function showIdleDialog() {
      if (this.user) {
        this.$refs.idleDialog.open({
          persistent: true,
          ok: this.logout
        });
      }
    },
    setUnloadTimestamp: function setUnloadTimestamp() {
      // Store
      sessionStorage.setItem('unload', new Date().getTime() / 1000);
      // Retrieve
    },
    parseURLParameters: function parseURLParameters() {
      var search = this.$route.query;
      if (search.partner) {
        var partner = {};
        partner.id = search.partner;
        partner.accessCode = search.accessCode;
        this.setPartner(partner);
        this.partnerID = search.partner;
        this.partnerAccessCode = search.accessCode;
      }
    },
    setBrandingColors: function setBrandingColors(id) {
      if (id === '5a4fa82c8e4b74e028665d04') {
        this.$vuetify.theme.primary = '#8AC340';
        this.$vuetify.theme.contrast = '#FFFFFF';
        this.$vuetify.theme.headerColor = '#666666';
      } else if (id === '5acb94000495d7065c909bc2') {
        this.$vuetify.theme.contrast = '#BDBDBD';
      } else if (id === '5b73507c4aef2028740f662b') {
        this.$vuetify.theme.primary = '#E59A1C';
        this.$vuetify.theme.contrast = '#BDBDBD';
        this.$vuetify.theme.headerColor = '#505050';
      } else if (id === '5a3f56ec92808ba8d3d5a391') {
        this.$vuetify.theme.primary = '#00B4BE';
        this.$vuetify.theme.contrast = '#BDBDBD';
      } else if (id === 'legaldemo') {
        this.$vuetify.theme.primary = '#10499C';
        this.$vuetify.theme.contrast = '#FFFFFF';
        this.$vuetify.theme.headerColor = '#96B7E7';
      }
    },
    checkFocus: function checkFocus() {
      var _this = this;

      var fiveMinuteTimeout = 1000 * 60 * 5; // 5 minutes

      // If the user isn't on the page, set a timeout to logout in five minutes
      if (!document.hasFocus()) {
        this.idleAway = setTimeout(function () {
          _this.logout();
        }, fiveMinuteTimeout);
      } else {
        if (new Date() - this.lastActiveTime > fiveMinuteTimeout) {
          this.logout();
        }
        clearTimeout(this.idleAway);
      }
    }
  }),
  created: function created() {
    var _this2 = this;

    window.addEventListener('beforeunload', this.setUnloadTimestamp);
    var partner = {};
    var search = this.$route.query;
    if (search.partner) {
      partner.id = search.partner;
    } else {
      partner.id = this.$subdomainPartner;
    }

    this.setBranding({ id: partner.id });
    this.setBrandingColors(partner.id);

    // Event listeners to see if the user is away from the page
    window.addEventListener('focus', this.checkFocus);
    window.addEventListener('visibilityChange', this.checkFocus);
    window.addEventListener('blur', this.checkFocus);

    // Initialize the active tracking interval
    this.lastActiveTime = new Date();
    this.activeTimeInterval = setInterval(function () {
      _this2.lastActiveTime = new Date();
    }, 5000); // 5 seconds

    var offset = 10000; // 10 seconds (This is so the onAway state isn't being fired more than every 10 seconds)
    var timeout = 1000 * 60 * 4 - offset; // 4 minutes - offset

    var idle = new __WEBPACK_IMPORTED_MODULE_7__core_helpers_idle__["a" /* default */]({
      onAway: function onAway() {
        _this2.executeShowIdleDialog = setTimeout(function () {
          _this2.showIdleDialog();
        }, timeout);

        // Clear interval while the user is inactive
        clearInterval(_this2.activeTimeInterval);
      },
      onAwayBack: function onAwayBack() {
        clearTimeout(_this2.executeShowIdleDialog);
        clearTimeout(_this2.idleAway);
        _this2.lastActiveTime = new Date();

        // Interval to track when the user was last active, for mobile tracking mostly
        _this2.activeTimeInterval = setInterval(function () {
          _this2.lastActiveTime = new Date();
        }, 5000); // 5 seconds
      }
    });
    idle.setAwayTimeout(offset); // 10 seconds
  },
  mounted: function mounted() {
    var _this3 = this;

    this.lastActiveTime = new Date();

    if (localStorage.getItem('newLayout')) {
      this.newLayout = true;
    }

    __WEBPACK_IMPORTED_MODULE_6__core_helpers_bus__["a" /* default */].$on('toast', function (data) {
      _this3.toast(data.text, data.type);
    });
    __WEBPACK_IMPORTED_MODULE_6__core_helpers_bus__["a" /* default */].$on('toggleNewLayout', function () {
      _this3.newLayout = !_this3.newLayout;
      localStorage.setItem('newLayout', true);
    });
    __WEBPACK_IMPORTED_MODULE_6__core_helpers_bus__["a" /* default */].$on('right-drawer-logout', function () {
      _this3.logout();
      __WEBPACK_IMPORTED_MODULE_6__core_helpers_bus__["a" /* default */].$emit('closeLeftDrawer');
    });
    __WEBPACK_IMPORTED_MODULE_6__core_helpers_bus__["a" /* default */].$on('right-drawer-navPatient', function () {
      _this3.navPatients();
      __WEBPACK_IMPORTED_MODULE_6__core_helpers_bus__["a" /* default */].$emit('closeLeftDrawer');
    });
    __WEBPACK_IMPORTED_MODULE_6__core_helpers_bus__["a" /* default */].$on('startLoading', function () {
      _this3.appLoading = false;
    });
    __WEBPACK_IMPORTED_MODULE_6__core_helpers_bus__["a" /* default */].$on('stopLoading', function () {
      _this3.appLoading = false;
      _this3.pageLoading = false;
    });
    __WEBPACK_IMPORTED_MODULE_6__core_helpers_bus__["a" /* default */].$on('startPageLoading', function () {
      _this3.pageLoading = false;
      _this3.appLoading = false;
    });
    __WEBPACK_IMPORTED_MODULE_6__core_helpers_bus__["a" /* default */].$on('stopPageLoading', function () {
      _this3.pageLoading = false;
    });
    this.$store.subscribe(function (mutation, state) {
      switch (mutation.type) {
        case 'auth/setAuthToken':
          _this3.getUser();
          break;
        case 'patient/setPatient':
          break;
      }
    });

    // If the directed page is upload file page, does not redirect to login page
    if (sessionStorage.getItem('login')) {
      if (sessionStorage.getItem('unload')) {
        // The user is returning from a reload event or from navigating away
        if (new Date().getTime() / 1000 - sessionStorage.getItem('unload') > 1000 * 60 * 4) {
          // it has been longer than 4 minutes, prompt a login
          this.signOut();
          this.$router.push('/login');
        } else {
          // it has been less than 4 minutes, do nothing
        }
      }
    } else {
      // there is no record of a login within this session, prompt to log in again
      this.signOut();
      // this.$router.push('/login')
    }
  }
});

/***/ }),
/* 143 */,
/* 144 */,
/* 145 */,
/* 146 */,
/* 147 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__core_consts__ = __webpack_require__(303);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__components_dialogs_TermsOfUseDialog__ = __webpack_require__(304);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__components_dialogs_PrivacyPolicyDialog__ = __webpack_require__(362);
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//





/* harmony default export */ __webpack_exports__["a"] = ({
  name: 'UiAppFooter',
  props: {
    auth: Boolean,
    hide: Boolean,
    version: String
  },
  components: {
    TermsOfUseDialog: __WEBPACK_IMPORTED_MODULE_1__components_dialogs_TermsOfUseDialog__["a" /* default */],
    PrivacyPolicyDialog: __WEBPACK_IMPORTED_MODULE_2__components_dialogs_PrivacyPolicyDialog__["a" /* default */]
  },
  data: function data() {
    return {
      year: new Date().getFullYear(),
      consts: __WEBPACK_IMPORTED_MODULE_0__core_consts__["a" /* default */]
    };
  },

  methods: {
    footerClasses: function footerClasses() {
      if (this.hide) {
        return 'ui--hide';
      }
      return '';
    },
    showTerms: function showTerms() {
      this.$refs.termsOfUseDialog.open();
    },
    showPrivacy: function showPrivacy() {
      this.$refs.privacyPolicyDialog.open();
    },
    showFeedbackDialog: function showFeedbackDialog() {
      this.dialog({
        opts: {
          width: 488,
          title: this.lang('common.title.giveFeedback')
        },
        component: 'UiFeedback'
      });
    }
  }
});

/***/ }),
/* 148 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__core_mixins_DialogMixin__ = __webpack_require__(5);
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//



/* harmony default export */ __webpack_exports__["a"] = ({
  name: 'TermsOfUse',
  mixins: [__WEBPACK_IMPORTED_MODULE_0__core_mixins_DialogMixin__["a" /* default */]],
  data: function data() {
    return {
      addendum: false,
      opened: false
    };
  },

  methods: {
    onClose: function onClose() {
      this.opened = false;
    },
    onOpen: function onOpen() {
      this.opened = true;
    }
  },
  mounted: function mounted() {
    this.$on('open', this.onOpen);
    this.$on('close', this.onClose);
  }
});

/***/ }),
/* 149 */,
/* 150 */,
/* 151 */,
/* 152 */,
/* 153 */,
/* 154 */,
/* 155 */,
/* 156 */,
/* 157 */,
/* 158 */,
/* 159 */,
/* 160 */,
/* 161 */,
/* 162 */,
/* 163 */,
/* 164 */,
/* 165 */,
/* 166 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__core_mixins_DialogMixin__ = __webpack_require__(5);
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//



/* harmony default export */ __webpack_exports__["a"] = ({
  name: 'TermsOfUse',
  mixins: [__WEBPACK_IMPORTED_MODULE_0__core_mixins_DialogMixin__["a" /* default */]],
  data: function data() {
    return {
      addendum: false,
      opened: false
    };
  },

  methods: {
    onClose: function onClose() {
      this.opened = false;
    },
    onOpen: function onOpen() {
      this.opened = true;
    }
  },
  mounted: function mounted() {
    this.$on('open', this.onOpen);
    this.$on('close', this.onClose);
  }
});

/***/ }),
/* 167 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__core_helpers_bus__ = __webpack_require__(3);
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//



/* harmony default export */ __webpack_exports__["a"] = ({
  name: 'OneBackdrop',
  data: function data() {
    return {
      showBackdrop: false,
      drawer: 'none'
    };
  },

  methods: {
    show: function show(val) {
      this.showBackdrop = val;
      setTimeout(function () {
        if (val) {
          document.querySelector('html').classList.add('overflow-y-hidden');
        } else {
          document.querySelector('html').classList.remove('overflow-y-hidden');
        }
      });
    },
    closeDrawers: function closeDrawers() {
      __WEBPACK_IMPORTED_MODULE_0__core_helpers_bus__["a" /* default */].$emit('closeLeftDrawer');
      __WEBPACK_IMPORTED_MODULE_0__core_helpers_bus__["a" /* default */].$emit('closeRightDrawer');
    }
  },
  mounted: function mounted() {
    var _this = this;

    __WEBPACK_IMPORTED_MODULE_0__core_helpers_bus__["a" /* default */].$on('openLeftDrawer', function () {
      if (_this.drawer === 'left') {
        _this.show(!_this.showBackdrop);
      } else {
        _this.show(true);
      }
      _this.drawer = 'left';
    });
    __WEBPACK_IMPORTED_MODULE_0__core_helpers_bus__["a" /* default */].$on('openRightDrawer', function () {
      if (_this.drawer === 'right') {
        _this.show(!_this.showBackdrop);
      } else {
        _this.show(true);
      }
      _this.drawer = 'right';
    });
    __WEBPACK_IMPORTED_MODULE_0__core_helpers_bus__["a" /* default */].$on('closeLeftDrawer', function () {
      _this.show(false);
      _this.drawer = 'none';
    });
    __WEBPACK_IMPORTED_MODULE_0__core_helpers_bus__["a" /* default */].$on('closeRightDrawer', function () {
      _this.show(false);
      _this.drawer = 'none';
    });
  }
});

/***/ }),
/* 168 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_extends__ = __webpack_require__(1);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_extends___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_extends__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__core_components_DesktopHeader__ = __webpack_require__(169);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__components_headers_DesktopHeaderLinks__ = __webpack_require__(175);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3_vuex__ = __webpack_require__(2);

//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//






/* harmony default export */ __webpack_exports__["a"] = ({
  name: 'OneHeader',
  components: {
    DesktopHeader: __WEBPACK_IMPORTED_MODULE_1__core_components_DesktopHeader__["a" /* default */],
    DesktopHeaderLinks: __WEBPACK_IMPORTED_MODULE_2__components_headers_DesktopHeaderLinks__["a" /* default */]
  },
  props: {
    provider: {
      type: Object
    }
  },
  data: function data() {
    var _this = this;

    return {
      menuItems: [{
        label: 'links.account.label',
        action: function action() {
          return _this.$router.push('/account');
        }
      }, {
        label: 'links.signout.label',
        action: function action() {
          return _this.$emit('signout');
        }
      }]
    };
  },

  computed: __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_extends___default()({}, Object(__WEBPACK_IMPORTED_MODULE_3_vuex__["d" /* mapState */])('auth', ['user']), Object(__WEBPACK_IMPORTED_MODULE_3_vuex__["d" /* mapState */])('provider', ['partner']))
});

/***/ }),
/* 169 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_vue_loader_lib_selector_type_script_index_0_DesktopHeader_vue__ = __webpack_require__(170);
/* unused harmony namespace reexport */
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__node_modules_vue_loader_lib_template_compiler_index_id_data_v_777b2677_hasScoped_true_transformToRequire_video_src_poster_source_src_img_src_image_xlink_href_buble_transforms_node_modules_vue_loader_lib_selector_type_template_index_0_DesktopHeader_vue__ = __webpack_require__(383);
function injectStyle (ssrContext) {
  __webpack_require__(372)
}
var normalizeComponent = __webpack_require__(0)
/* script */


/* template */

/* template functional */
var __vue_template_functional__ = false
/* styles */
var __vue_styles__ = injectStyle
/* scopeId */
var __vue_scopeId__ = "data-v-777b2677"
/* moduleIdentifier (server only) */
var __vue_module_identifier__ = null
var Component = normalizeComponent(
  __WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_vue_loader_lib_selector_type_script_index_0_DesktopHeader_vue__["a" /* default */],
  __WEBPACK_IMPORTED_MODULE_1__node_modules_vue_loader_lib_template_compiler_index_id_data_v_777b2677_hasScoped_true_transformToRequire_video_src_poster_source_src_img_src_image_xlink_href_buble_transforms_node_modules_vue_loader_lib_selector_type_template_index_0_DesktopHeader_vue__["a" /* default */],
  __vue_template_functional__,
  __vue_styles__,
  __vue_scopeId__,
  __vue_module_identifier__
)

/* customBlocks */
var customBlock = __webpack_require__(384)
if (customBlock && customBlock.__esModule) {
  customBlock = customBlock.default
}
if (typeof customBlock === "function") {
  customBlock(Component)
}


/* harmony default export */ __webpack_exports__["a"] = (Component.exports);


/***/ }),
/* 170 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_lodash_each__ = __webpack_require__(77);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_lodash_each___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_lodash_each__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_lodash_isNil__ = __webpack_require__(172);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_lodash_isNil___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_1_lodash_isNil__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__core_components_Avatar__ = __webpack_require__(20);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3__core_components_Icon__ = __webpack_require__(112);
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//






/* harmony default export */ __webpack_exports__["a"] = ({
  name: 'UiHeader',
  components: {
    Avatar: __WEBPACK_IMPORTED_MODULE_2__core_components_Avatar__["a" /* default */],
    Icon: __WEBPACK_IMPORTED_MODULE_3__core_components_Icon__["a" /* default */]
  },
  props: {
    user: {
      type: Object
    },
    userImageUrl: {
      type: String
    },
    mainMenu: {
      type: Array,
      default: function _default() {
        return [];
      }
    }
  },
  computed: {
    showAlert: function showAlert() {
      if (this.user.needsPasswordChange) {
        return true;
      }
      return false;
    },
    username: function username() {
      return this.user.firstName + ' ' + this.user.lastName;
    },
    showLogo: function showLogo() {
      return 'https://storage.googleapis.com/onechart-assets/logos/header/' + this.$subdomainPartner + '.png';
    },
    menuItems: function menuItems() {
      var items = [];
      __WEBPACK_IMPORTED_MODULE_0_lodash_each___default()(this.mainMenu, function (item) {
        if (__WEBPACK_IMPORTED_MODULE_1_lodash_isNil___default()(item.condition) || item.condition) {
          items.push(item);
        }
      });
      return items;
    }
  },
  methods: {
    navToSupport: function navToSupport() {
      location.href = 'https://www.zendesk.com/';
    },
    gotoMainPage: function gotoMainPage() {
      this.$router.push('/');
    }
  }
});

/***/ }),
/* 171 */,
/* 172 */,
/* 173 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_object_assign__ = __webpack_require__(143);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_object_assign___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_object_assign__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__core_components_Icon__ = __webpack_require__(112);

//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//



var defaultAvatarSize = 100;

/* harmony default export */ __webpack_exports__["a"] = ({
  name: 'UiAvatar',
  components: {
    Icon: __WEBPACK_IMPORTED_MODULE_1__core_components_Icon__["a" /* default */]
  },
  props: {
    name: {
      type: String,
      default: ''
    },
    label: {
      type: String,
      default: ''
    },
    icon: {
      type: String
    },
    value: {
      type: String
    },
    backgroundColor: {
      type: String,
      default: '#F0F0F0'
    },
    font: {
      type: String,
      default: 'sans-serif'
    },
    fontSize: {
      type: Number,
      default: 32
    },
    scaleFont: {
      type: Boolean,
      default: true
    },
    color: {
      type: String,
      default: '#979797'
    },
    size: {
      type: Number,
      default: 80
    },
    src: {
      type: String
    },
    rounded: {
      type: Boolean,
      default: true
    },
    radius: {
      type: Number,
      default: 0
    },
    borderSize: {
      type: Number,
      default: 0
    },
    borderColor: {
      type: String,
      default: 'white'
    },
    showStatus: {
      type: Boolean,
      default: false
    }
  },

  computed: {
    showText: function showText() {
      return !this.src && !this.icon;
    },
    showIcon: function showIcon() {
      return !this.src && !this.value;
    },
    background: function background() {
      return this.backgroundColor;
    },
    fontColor: function fontColor() {
      return this.color;
    },
    isImage: function isImage() {
      return Boolean(this.src);
    },
    avatarStyle: function avatarStyle() {
      var style = {
        position: 'relative',
        width: this.size + 'px',
        height: this.size + 'px',
        minWidth: this.size + 'px',
        minHeight: this.size + 'px',
        borderRadius: this.rounded ? '50%' : this.radius + 'px',
        border: this.borderSize + 'px solid ' + this.borderColor
      };

      var imgBackgroundAndFontStyle = {
        background: 'transparent url(' + this.src + ') no-repeat scroll 0% 0% / ' + this.size + 'px ' + this.size + 'px content-box border-box'
      };

      var initialBackgroundAndFontStyle = {
        backgroundColor: this.background,
        // font: Math.floor(this.size / 2.5) + `px/100px ${this.font}`,
        color: this.fontColor
      };

      var backgroundAndFontStyle = this.isImage ? imgBackgroundAndFontStyle : initialBackgroundAndFontStyle;

      __WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_object_assign___default()(style, backgroundAndFontStyle);

      return style;
    },
    textStyle: function textStyle() {
      var ratio = this.size / defaultAvatarSize;
      var style = {
        color: this.fontColor,
        fontSize: this.scaleFont ? Math.round(this.fontSize * ratio) + 'px' : this.fontSize + 'px'
      };
      return style;
    },


    // Math.floor(this.borderSize * 0.5) + `px solid ${this.borderColor}`
    statusStyle: function statusStyle() {
      var style = {
        position: 'absolute',
        top: Math.round(this.borderSize * 0.5) + 'px',
        width: this.size + 'px',
        height: this.size + 'px',
        minWidth: this.size + 'px',
        minHeight: this.size + 'px',
        borderRadius: '50%'
      };
      return style;
    },
    indicatorStyle: function indicatorStyle() {
      var ratio = this.size / defaultAvatarSize;
      var defaultSize = 16;
      var defaultBorderSize = 3;

      var style = {
        position: 'absolute',
        top: '0',
        left: '50%',
        transform: 'translate(-50%, -50%)',
        width: Math.round(defaultSize * ratio) + 'px',
        height: Math.round(defaultSize * ratio) + 'px',
        background: '#ff8200',
        borderRadius: '50%',
        border: Math.max(1, Math.round(defaultBorderSize * ratio)) + 'px solid white'
      };
      return style;
    },
    labelStyle: function labelStyle() {
      var style = {
        color: this.fontColor
      };
      return style;
    },
    text: function text() {
      var value = this.value || this.initial(this.name);
      return value;
    }
  },

  methods: {
    initial: function initial(name) {
      var parts = name.split(/[ -]/);
      var value = '';

      for (var i = 0; i < parts.length; i++) {
        value += parts[i].charAt(0);
      }

      if (value.length > 3 && value.search(/[A-Z]/) !== -1) {
        value = value.replace(/[a-z]+/g, '');
      }

      value = value.substr(0, 3).toUpperCase();

      return value;
    }
  }
});

/***/ }),
/* 174 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
//
//
//
//

/* harmony default export */ __webpack_exports__["a"] = ({
  name: 'UiIcon',
  props: {
    icon: {
      type: String,
      default: ''
    },
    size: {
      type: Number,
      default: 24
    },
    color: {
      type: String,
      default: 'black'
    }
  },
  computed: {
    style: function style() {
      var style = {};
      var size = this.size + 'px';
      style.display = 'inline-block';
      style.fontSize = size;
      style.width = size;
      style.color = this.color;
      return style;
    }
  },
  mounted: function mounted() {
    console.log();
  }
});

/***/ }),
/* 175 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_vue_loader_lib_selector_type_script_index_0_DesktopHeaderLinks_vue__ = __webpack_require__(176);
/* unused harmony namespace reexport */
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__node_modules_vue_loader_lib_template_compiler_index_id_data_v_347e7b64_hasScoped_true_transformToRequire_video_src_poster_source_src_img_src_image_xlink_href_buble_transforms_node_modules_vue_loader_lib_selector_type_template_index_0_DesktopHeaderLinks_vue__ = __webpack_require__(386);
function injectStyle (ssrContext) {
  __webpack_require__(385)
}
var normalizeComponent = __webpack_require__(0)
/* script */


/* template */

/* template functional */
var __vue_template_functional__ = false
/* styles */
var __vue_styles__ = injectStyle
/* scopeId */
var __vue_scopeId__ = "data-v-347e7b64"
/* moduleIdentifier (server only) */
var __vue_module_identifier__ = null
var Component = normalizeComponent(
  __WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_vue_loader_lib_selector_type_script_index_0_DesktopHeaderLinks_vue__["a" /* default */],
  __WEBPACK_IMPORTED_MODULE_1__node_modules_vue_loader_lib_template_compiler_index_id_data_v_347e7b64_hasScoped_true_transformToRequire_video_src_poster_source_src_img_src_image_xlink_href_buble_transforms_node_modules_vue_loader_lib_selector_type_template_index_0_DesktopHeaderLinks_vue__["a" /* default */],
  __vue_template_functional__,
  __vue_styles__,
  __vue_scopeId__,
  __vue_module_identifier__
)

/* harmony default export */ __webpack_exports__["a"] = (Component.exports);


/***/ }),
/* 176 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//

/* harmony default export */ __webpack_exports__["a"] = ({
  name: 'UiHeaderLinks'
});

/***/ }),
/* 177 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_extends__ = __webpack_require__(1);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_extends___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_extends__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__core_components_Icon__ = __webpack_require__(112);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_lodash_each__ = __webpack_require__(77);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_lodash_each___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_2_lodash_each__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3_lodash_isNil__ = __webpack_require__(172);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3_lodash_isNil___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_3_lodash_isNil__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4__core_components_Avatar__ = __webpack_require__(20);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_5_vuex__ = __webpack_require__(2);

//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//








/* harmony default export */ __webpack_exports__["a"] = ({
  name: 'OneMobileHeader',
  components: {
    Icon: __WEBPACK_IMPORTED_MODULE_1__core_components_Icon__["a" /* default */],
    Avatar: __WEBPACK_IMPORTED_MODULE_4__core_components_Avatar__["a" /* default */]
  },
  props: {
    selection: {
      type: Array,
      default: function _default() {
        return [];
      }
    },
    userImageUrl: {
      type: String
    }
  },
  data: function data() {
    return {
      showSearch: false
    };
  },

  methods: {
    toggleSearch: function toggleSearch() {
      this.showSearch = !this.showSearch;
    },
    gotoMainPage: function gotoMainPage() {
      this.$router.push('/');
    }
  },
  computed: __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_extends___default()({}, Object(__WEBPACK_IMPORTED_MODULE_5_vuex__["d" /* mapState */])('auth', ['user']), {
    username: function username() {
      return this.user.firstName + ' ' + this.user.lastName;
    },
    menuItems: function menuItems() {
      var items = [];
      __WEBPACK_IMPORTED_MODULE_2_lodash_each___default()(this.mainMenu, function (item) {
        if (__WEBPACK_IMPORTED_MODULE_3_lodash_isNil___default()(item.condition) || item.condition) {
          items.push(item);
        }
      });
      return items;
    }
  })
});

/***/ }),
/* 178 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_extends__ = __webpack_require__(1);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_extends___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_extends__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__core_components_DesktopHeader__ = __webpack_require__(169);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__components_headers_DesktopHeaderLinks__ = __webpack_require__(175);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3__components_dialogs_EditPatientInfoDialog__ = __webpack_require__(394);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4_vuex__ = __webpack_require__(2);

//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//







/* harmony default export */ __webpack_exports__["a"] = ({
  name: 'OneHeader',
  components: {
    DesktopHeader: __WEBPACK_IMPORTED_MODULE_1__core_components_DesktopHeader__["a" /* default */],
    DesktopHeaderLinks: __WEBPACK_IMPORTED_MODULE_2__components_headers_DesktopHeaderLinks__["a" /* default */],
    EditPatientInfoDialog: __WEBPACK_IMPORTED_MODULE_3__components_dialogs_EditPatientInfoDialog__["a" /* default */]
  },
  props: {
    provider: {
      type: Object
    },
    fullWidth: {
      type: Boolean,
      default: false
    }
  },
  data: function data() {
    return {
      menuItems: [{ title: 'Logout', icon: 'exit_to_app', method: 'logout' }]
    };
  },

  methods: __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_extends___default()({}, Object(__WEBPACK_IMPORTED_MODULE_4_vuex__["b" /* mapActions */])('auth', ['signOut']), {
    handleMenuSelection: function handleMenuSelection(index) {
      var method = this.menuItems[index].method;

      if (method === 'logout') {
        this.logout();
      }
    },
    logout: function logout() {
      this.signOut();
      this.$router.push('/login');
    },
    toast: function toast(text, type) {
      this.showSnackbar = true;
      this.snackbarType = type;
      this.snackbarText = text;
    },
    navPatients: function navPatients() {
      this.$router.push({
        name: 'PatientsPage'
      });
    },
    navAccount: function navAccount() {
      this.$router.push('/account');
    }
  }),
  computed: __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_extends___default()({}, Object(__WEBPACK_IMPORTED_MODULE_4_vuex__["d" /* mapState */])('patient', ['patient']), Object(__WEBPACK_IMPORTED_MODULE_4_vuex__["d" /* mapState */])('provider', ['partner']), Object(__WEBPACK_IMPORTED_MODULE_4_vuex__["d" /* mapState */])('auth', ['user']), {
    isMobile: function isMobile() {
      return this.$vuetify.breakpoint.smAndDown;
    },
    sizingClass: function sizingClass() {
      if (this.fullWidth) {
        return 'xs12';
      } else {
        return 'xs12 sm8';
      }
    },
    logoSource: function logoSource() {
      return 'https://storage.googleapis.com/onechart-assets/logos/login/default_normalized.png';
    },
    theDisplayedAccount: function theDisplayedAccount() {
      if (this.user) {
        if (this.user.email) {
          return this.user.email;
        } else if (this.user.firstName) {
          return this.user.firstName + ' ' + this.user.lastName;
        } else {
          return 'Account';
        }
      } else {
        return 'Account';
      }
    }
  })
});

/***/ }),
/* 179 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_extends__ = __webpack_require__(1);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_extends___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_extends__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__core_mixins_DialogMixin__ = __webpack_require__(5);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__core_mixins_HelperMixin__ = __webpack_require__(12);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3_vuex__ = __webpack_require__(2);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4__core_helpers_bus__ = __webpack_require__(3);

//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//






/* harmony default export */ __webpack_exports__["a"] = ({
  name: 'EditProfile',
  mixins: [__WEBPACK_IMPORTED_MODULE_1__core_mixins_DialogMixin__["a" /* default */], __WEBPACK_IMPORTED_MODULE_2__core_mixins_HelperMixin__["a" /* default */]],
  data: function data() {
    var _this = this;

    return {
      stage: 1,
      firstNameInput: '',
      lastNameInput: '',
      phoneInput: '',
      birthdateInput: '',
      genderInput: '',
      line1Input: '',
      line2Input: '',
      cityInput: '',
      stateInput: '',
      zipInput: '',
      partner: null,
      accessCode: null,
      newPatientMode: false,
      attributePatientMode: false,
      showSplash: false,
      profileValid: false,
      addressValid: false,
      opened: false,
      phoneMask: 'phone',
      notifications: false,
      sound: true,
      widgets: false,
      date: null,
      menu: false,
      state: null,
      dateTicker: 3,
      stateValidation: ['AL', 'AK', 'AS', 'AZ', 'AR', 'CA', 'CO', 'CT', 'DE', 'DC', 'FM', 'FL', 'GA', 'GU', 'HI', 'ID', 'IL', 'IN', 'IA', 'KS', 'KY', 'LA', 'ME', 'MH', 'MD', 'MA', 'MI', 'MN', 'MS', 'MO', 'MT', 'NE', 'NV', 'NH', 'NJ', 'NM', 'NY', 'NC', 'ND', 'MP', 'OH', 'OK', 'OR', 'PW', 'PA', 'PR', 'RI', 'SC', 'SD', 'TN', 'TX', 'UT', 'VT', 'VI', 'VA', 'WA', 'WV', 'WI', 'WY'],
      firstNameRules: [function (v) {
        return !!v || 'First name is required';
      }],
      lastNameRules: [function (v) {
        return !!v || 'Last name is required';
      }],
      phoneRules: [function (v) {
        return !!v || 'Phone number is required';
      }],
      birthdateRules: [function (v) {
        return !!v || 'Birthdate is required';
      }],
      line1Rules: [function (v) {
        return !!v || 'Street address is required';
      }],
      cityRules: [function (v) {
        return !!v || 'City is required';
      }],
      stateRules: [function (v) {
        return !!v || 'State is required';
      }],
      stateValidationRule: [function (v) {
        return _this.stateValidation.includes(v) || 'Invalid State';
      }],
      zipRules: [function (v) {
        return !!v || 'Zip Code is required';
      }]
    };
  },

  computed: __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_extends___default()({}, Object(__WEBPACK_IMPORTED_MODULE_3_vuex__["d" /* mapState */])('registration', ['type']), Object(__WEBPACK_IMPORTED_MODULE_3_vuex__["d" /* mapState */])('patient', ['patient', 'files', 'requests']), Object(__WEBPACK_IMPORTED_MODULE_3_vuex__["d" /* mapState */])('auth', ['user']), {
    profile: function profile() {
      if (this.patient.gender && !this.newPatientMode) {
        this.profileValid = true;
        this.addressValid = true;
        this.date = this.formatDate(this.patient.birthdate);
        return {
          firstName: this.patient.firstName,
          lastName: this.patient.lastName,
          phone: this.patient.phone,
          birthdate: this.patient.birthdate,
          gender: this.patient.gender,
          address: {
            line1: this.patient.address.line1,
            line2: this.patient.address.line2,
            city: this.patient.address.city,
            state: this.patient.address.state,
            zip: this.patient.address.zip
          }
        };
      }

      return {
        firstName: '',
        lastName: '',
        phone: '',
        birthdate: null,
        gender: '',
        address: {
          line1: '',
          line2: '',
          city: '',
          state: '',
          zip: ''
        }
      };
    }
  }),
  methods: __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_extends___default()({}, Object(__WEBPACK_IMPORTED_MODULE_3_vuex__["b" /* mapActions */])('patient', ['createPatient', 'createPatientWithProvider', 'updatePatient', 'getPatient']), {
    createPatient: function createPatient() {
      this.$router.push({
        name: 'PatientProfilePage',
        query: this.$route.query
      });
    },
    onClose: function onClose() {
      this.opened = false;
    },
    onOpen: function onOpen() {
      this.opened = true;
      if (this.options.newPatientMode) {
        this.newPatientMode = true;
        this.showSplash = false;
        this.date = null;
      } else {
        this.firstNameInput = this.profile.firstName;
        this.lastNameInput = this.profile.lastName;
        this.phoneInput = this.profile.phone;
        this.birthdateInput = this.formatDate(this.profile.birthdate);
        this.genderInput = this.profile.gender;
        this.line1Input = this.profile.address.line1;
        this.line2Input = this.profile.address.line2;
        this.cityInput = this.profile.address.city;
        this.stateInput = this.profile.address.state;
        this.zipInput = this.profile.address.zip;
      }

      if (this.options.partner && this.options.accessCode) {
        this.newPatientMode = true;
        this.attributePatientMode = true;
        this.partner = this.options.partner;
        this.accessCode = this.options.accessCode;
      }

      if (this.options.triggerWelcome) {
        this.showSplash = true;
        this.firstNameInput = this.user.firstName;
        this.lastNameInput = this.user.lastName;
      }
    },
    unixBirthdate: function unixBirthdate(date) {
      if (date !== '') {
        var extractedNumbers = date.replace(/\D/g, '');
        var constructedDate = new Date(extractedNumbers.slice(4, 8), extractedNumbers.slice(0, 2) - 1, extractedNumbers.slice(2, 4));
        if (constructedDate.getTime()) {
          return Date.UTC(constructedDate.getFullYear(), constructedDate.getMonth(), constructedDate.getDate(), 12) / 1000;
        } else {
          this.toast('error', 'Invalid Birthdate');
        }
      }
    },
    formatDate: function formatDate(timestamp) {
      return this.getBirthdateStringFromTimestamp(timestamp);
    },
    createFirstChart: function createFirstChart() {
      this.showSplash = false;
    },
    checkBirthdate: function checkBirthdate(birthdate) {
      var today = Math.floor(Date.now() / 1000);
      if (birthdate) {
        if (birthdate > today + 86400) {
          return false;
        }
        return true;
      } else {
        return false;
      }
    },
    checkInfo: function checkInfo(patient) {
      var patientInfoComplete = true;
      var errorNote = '';
      if (!patient.firstName) {
        patientInfoComplete = false;
        errorNote = 'First name Required';
      }
      if (!patient.lastName) {
        patientInfoComplete = false;
        errorNote = 'Last name Required';
      }
      if (!patient.phone) {
        patientInfoComplete = false;
        errorNote = 'Phone Required';
      }
      if (!patient.birthdate) {
        patientInfoComplete = false;
        errorNote = 'Birthdate Required';
      } else {
        // get today's date and check it against the birthdate. today's date should be after the birthdate
        patientInfoComplete = this.checkBirthdate(patient.birthdate);
        if (!patientInfoComplete) {
          errorNote = 'Invalid Birthdate';
        }
      }
      if (!patient.gender) {
        patientInfoComplete = false;
        errorNote = 'Gender Required';
      }
      if (!patient.address) {
        patientInfoComplete = false;
        errorNote = 'Address Required';
      } else {
        if (!patient.address.line1) {
          patientInfoComplete = false;
          errorNote = 'Street Address Required';
        }
        if (!patient.address.city) {
          patientInfoComplete = false;
          errorNote = 'City Required';
        }
        if (!patient.address.state) {
          patientInfoComplete = false;
          errorNote = 'State Required';
        }
        if (!patient.address.zip) {
          patientInfoComplete = false;
          errorNote = 'Zip Code Required';
        }
      }

      if (!patientInfoComplete) {
        this.toast('error', errorNote);
      }

      return patientInfoComplete;
    },
    submit: function submit() {
      var _this2 = this;

      // this should
      var patient = {};
      if (this.firstNameInput !== this.profile.firstName) {
        patient.firstName = this.firstNameInput;
      }
      if (this.lastNameInput !== this.profile.lastName) {
        patient.lastName = this.lastNameInput;
      }
      if (this.phoneInput !== this.profile.phone) {
        patient.phone = this.phoneInput;
      }
      if (this.birthdateInput !== this.formatDate(this.profile.birthdate)) {
        patient.birthdate = this.unixBirthdate(this.birthdateInput);
      }
      if (this.genderInput !== this.profile.gender) {
        patient.gender = this.genderInput;
      }
      // the address has to be updated together
      var addressChanged = false;
      if (this.line1Input !== this.profile.address.line1) {
        addressChanged = true;
      }
      if (this.line2Input !== this.profile.address.line2) {
        addressChanged = true;
      }
      if (this.cityInput !== this.profile.address.city) {
        addressChanged = true;
        if (patient.address) {
          patient.address.city = this.cityInput;
        } else {
          patient.address = {};
          patient.address.city = this.cityInput;
        }
      }
      if (this.stateInput !== this.profile.address.state) {
        addressChanged = true;
      }
      if (this.zipInput !== this.profile.address.zip) {
        addressChanged = true;
      }

      if (addressChanged) {
        patient.address = {};
        patient.address.line1 = this.line1Input;
        patient.address.line2 = this.line2Input;
        patient.address.city = this.cityInput;
        patient.address.state = this.stateInput;
        patient.address.zip = this.zipInput;
      }
      if (this.partner && this.accessCode) {
        if (this.checkInfo(patient)) {
          // about to create a partner patient
          this.createPatient(patient).then(function (patientCreated) {
            var id = _this2.partner;
            var code = _this2.accessCode;
            var patientID = patientCreated._id;
            _this2.createPatientWithProvider({ patientID: patientID, id: id, code: code }).then(function () {
              _this2.partner = null;
              _this2.accessCode = null;
              var patient = patientID;
              _this2.$router.push({
                name: 'PatientPage',
                params: { id: patient }
              });
              _this2.ok();
            });
          });
        } else {
          console.log('incomplete patient information');
        }
      } else if (this.newPatientMode) {
        if (this.checkInfo(patient)) {
          this.createPatient(patient).then(function (patientCreated) {
            var patientID = patientCreated._id;
            var patient = patientID;
            _this2.$router.push({
              name: 'PatientPage',
              params: { id: patient }
            });
            _this2.ok();
          });
        } else {
          console.log('incomplete patient information');
        }
      } else {
        var birthdateGood = true;
        if (patient.birthdate) {
          birthdateGood = this.checkBirthdate(patient.birthdate);
        }
        if (birthdateGood) {
          this.updatePatient({
            id: this.$route.params.id,
            payload: patient
          }).then(function () {
            _this2.getPatient({ id: _this2.$route.params.id });
            _this2.show = false;
          });
        } else {
          this.toast('error', 'Invalid Birthdate');
        }
      }
    },
    toast: function toast(type, text) {
      __WEBPACK_IMPORTED_MODULE_4__core_helpers_bus__["a" /* default */].$emit('toast', { type: type, text: text });
    }
  }),
  mounted: function mounted() {
    this.$on('open', this.onOpen);
    this.$on('close', this.onClose);
  }
});

/***/ }),
/* 180 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_extends__ = __webpack_require__(1);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_extends___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_extends__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_vuex__ = __webpack_require__(2);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__components_dialogs_UploadFilesDialog__ = __webpack_require__(400);

//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//




/* harmony default export */ __webpack_exports__["a"] = ({
  name: 'GlobalNavigationToolbar',
  components: {
    UploadFilesDialog: __WEBPACK_IMPORTED_MODULE_2__components_dialogs_UploadFilesDialog__["a" /* default */]
  },
  props: {
    drawer: {
      type: Boolean,
      default: true
    }
  },
  data: function data() {
    return {
      miniToolbar: false,
      globalNavigationItems: [],
      recentDocuments: [],
      recentPatients: [],
      recentPatientDisplay: [],
      recentPatientsIDs: [],
      recentPages: []
    };
  },

  computed: __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_extends___default()({}, Object(__WEBPACK_IMPORTED_MODULE_1_vuex__["d" /* mapState */])('patient', ['patient', 'files', 'requests', 'preliminaryPermissions']), {
    isMobile: function isMobile() {
      return this.$vuetify.breakpoint.smAndDown;
    },
    pageNavigationItems: function pageNavigationItems() {
      var items = [];
      items.push({
        title: 'Document Management',
        icon: 'print',
        destination: 'AdminDocumentsPage'
      });
      items.push({
        title: 'Request Management',
        icon: 'send',
        destination: 'AdminRequestsPage'
      });
      // items.push({
      //   title: 'Metrics',
      //   icon: 'trending_up',
      //   destination: 'AdminLandingPage'
      // })
      // items.push({
      //   title: 'Patient Collection',
      //   icon: 'people',
      //   destination: 'AdminPatientsPage'
      // })
      // items.push({
      //   title: 'Provider Collection',
      //   icon: 'local_hospital',
      //   destination: 'AdminProvidersPage'
      // })

      return items;
    },
    pageLocation: function pageLocation() {
      return this.$route.name;
    }
  }),
  mounted: function mounted() {
    var items = [{ title: 'Log Out', icon: 'exit_to_app', method: 'logout()' }];
    this.globalNavigationItems = items;
  },

  watch: {
    patient: function patient() {
      var id = this.patient._id;
      this.getPreliminaryPermissions({ id: id });
    }
    // $route(to, from) {
    //   debugger
    //   console.log(from)

    //   this.recentPage.push({
    //     title: from,
    //     icon: 'import_export',
    //     destination: from
    //   })
    // }

  },
  methods: __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_extends___default()({}, Object(__WEBPACK_IMPORTED_MODULE_1_vuex__["b" /* mapActions */])('auth', ['getUser', 'signOut']), Object(__WEBPACK_IMPORTED_MODULE_1_vuex__["b" /* mapActions */])('patient', ['setThePatient', 'getPreliminaryPermissions']), {
    selectPatient: function selectPatient(patient) {
      var vm = this;
      this.setThePatient(patient).then(function (patient) {
        var pt = patient;
        vm.$router.push({
          name: 'PatientPage',
          params: { id: pt._id }
        });
      });
    },
    goToAbout: function goToAbout() {
      console.log('go to about');
      window.open('https://www.onecharthealth.com/about-1/');
    },
    openShareDialog: function openShareDialog() {
      this.$refs.shareChart.open({});
    },
    openUploadDialog: function openUploadDialog() {
      this.$refs.upload.open({});
    },
    buttonColor: function buttonColor(title) {
      if (title === this.tabToHighlight) {
        return 'primary';
      }
      return null;
    },
    openRequestDialog: function openRequestDialog() {
      this.$refs.request.open({});
    },
    showWelcomeDialog: function showWelcomeDialog() {
      this.$refs.welcomeDialog.open({
        triggerWelcome: true
      });
    },
    menuAction: function menuAction(index) {
      if (this.globalNavigationItems[index].title === 'Add Patient Chart') {
        this.showWelcomeDialog();
      }
      if (this.globalNavigationItems[index].title === 'Log Out') {
        this.signOut();
        this.$router.push('/login');
      }
      if (this.globalNavigationItems[index].title === 'Account Settings') {
        this.account();
      }
    },
    account: function account() {
      this.$router.push({
        name: 'AccountPage'
      });
    },
    goToPage: function goToPage(item) {
      var paramDestinations = ['PatientPage', 'PatientInfoPage'];
      var patient = this.patient._id;
      if (item.destination.includes('Admin') || item.destination.includes('Account')) {
        this.$router.push({
          name: item.destination
        });
      } else if (paramDestinations.includes(item.destination)) {
        this.$router.push({
          name: item.destination,
          params: { id: patient }
        });
      } else {
        this.$router.push({
          name: item.destination,
          query: { patient: patient }
        });
      }
    },
    navPatients: function navPatients() {
      this.setThePatient({});
      this.$router.push({
        name: 'PatientsPage'
      });
    }
  })
});

/***/ }),
/* 181 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_get_iterator__ = __webpack_require__(113);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_get_iterator___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_get_iterator__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_babel_runtime_core_js_array_from__ = __webpack_require__(411);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_babel_runtime_core_js_array_from___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_1_babel_runtime_core_js_array_from__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_babel_runtime_helpers_extends__ = __webpack_require__(1);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_babel_runtime_helpers_extends___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_2_babel_runtime_helpers_extends__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3__core_mixins_DialogMixin__ = __webpack_require__(5);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4__core_mixins_HelperMixin__ = __webpack_require__(12);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_5_vuex__ = __webpack_require__(2);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_6__core_helpers_bus__ = __webpack_require__(3);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_7_vue2_dropzone__ = __webpack_require__(189);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_7_vue2_dropzone___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_7_vue2_dropzone__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_8_vue2_dropzone_dist_vue2Dropzone_min_css__ = __webpack_require__(190);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_8_vue2_dropzone_dist_vue2Dropzone_min_css___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_8_vue2_dropzone_dist_vue2Dropzone_min_css__);



//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//








/* harmony default export */ __webpack_exports__["a"] = ({
  name: 'UploadRecordsDialog',
  mixins: [__WEBPACK_IMPORTED_MODULE_3__core_mixins_DialogMixin__["a" /* default */], __WEBPACK_IMPORTED_MODULE_4__core_mixins_HelperMixin__["a" /* default */]],
  components: {
    vueDropzone: __WEBPACK_IMPORTED_MODULE_7_vue2_dropzone___default.a
  },
  data: function data() {
    return {
      recordTypes: ['PRE_OP_NOTE', 'POST_OP_NOTE', 'OP_NOTE', 'OFFICE_VISIT', 'MESSAGE', 'MRI', 'IMAGE_READ', 'XRAY', 'OTHER_IMAGING', 'LAB_RESULT', 'PROGRESS_NOTE', 'DIAGNOSTIC_REPORT', 'REFERRAL', 'COMPLETED_PRIOR_AUTH'],
      providerIDForSubmission: null,
      providersToDisplay: [],
      providerInputValue: '',
      dateInput: '',
      typeInput: 'OFFICE_VISIT',
      uploadProviderSearchInput: null,
      searchType: { title: 'Individuals', value: 'idv' },
      searchTypes: [{ title: 'Individuals', value: 'idv' }, { title: 'Organization', value: 'org' }],
      dropzoneOptions: {
        url: 'google.com',
        method: 'put',
        headers: { 'Access-Control-Allow-Origin': '*' },
        thumbnailWidth: '100',
        thumbnailHeight: '100',
        autoProcessQueue: false,
        timeout: 500000,
        dictDefaultMessage: "<i class='fa fa-cloud-upload'></i>UPLOAD ME",
        acceptedFiles: '.pdf'
      },
      files: null,
      uploadQ: [],
      errorList: []
    };
  },

  computed: __WEBPACK_IMPORTED_MODULE_2_babel_runtime_helpers_extends___default()({}, Object(__WEBPACK_IMPORTED_MODULE_5_vuex__["d" /* mapState */])('provider', ['searchResults']), Object(__WEBPACK_IMPORTED_MODULE_5_vuex__["d" /* mapState */])('patient', ['patient']), Object(__WEBPACK_IMPORTED_MODULE_5_vuex__["d" /* mapState */])('auth', ['currentUserGroups']), Object(__WEBPACK_IMPORTED_MODULE_5_vuex__["d" /* mapState */])('upload', ['uploadInfo', 'uploadPatientURL']), {
    transition: function transition() {
      return this.$vuetify.breakpoint.xsOnly ? 'dialog-bottom-transition' : 'scale-transition';
    },
    showBuilding: function showBuilding() {
      return this.options.unit && this.options.building;
    }
  }),
  mounted: function mounted() {
    this.$on('open', this.onOpen);
  },

  methods: __WEBPACK_IMPORTED_MODULE_2_babel_runtime_helpers_extends___default()({}, Object(__WEBPACK_IMPORTED_MODULE_5_vuex__["b" /* mapActions */])('patient', ['getPatient']), Object(__WEBPACK_IMPORTED_MODULE_5_vuex__["b" /* mapActions */])('auth', ['getUserGroups']), Object(__WEBPACK_IMPORTED_MODULE_5_vuex__["b" /* mapActions */])('provider', ['search', 'getProviderIDFromNPI', 'multipleShareFiles', 'getProviderAuth']), Object(__WEBPACK_IMPORTED_MODULE_5_vuex__["b" /* mapActions */])('upload', ['getUploadInfo', 'getPatientUploadURL', 'initUploadGoogleStorage', 'uploadFile', 'getUploadFailPosition', 'resumeUpload']), {
    formatDate: function formatDate(timestamp) {
      return this.getBirthdateStringFromTimestamp(timestamp);
    },
    bestGuessProvider: function bestGuessProvider() {
      // this method will get any provider associated with the user
      // and insert that provider into the medical provider list.
      // it should fetch the first member of the care team if the user is not associated with anybody.
      this.getUserGroups();
    },
    uploadFiles: function uploadFiles() {
      // must get the file ids.
      console.log(this.providerIDForSubmission);
      var theDateToUse = this.unixDate(this.dateInput);
      console.log(theDateToUse);
      console.log(this.typeInput);
    },
    unixDate: function unixDate(date) {
      if (date !== '') {
        var formatDate = date.slice(4, 8) + '.' + date.slice(0, 2) + '.' + date.slice(2, 4);
        // Format: '2012.08.10'
        return new Date(formatDate).getTime() / 1000;
      }
    },
    close: function close() {
      this.providersToDisplay = [];
      this.providerInputValue = '';
      this.uploadProviderSearchInput = null;
      this.files = null;
      this.$refs.dropzone.removeAllFiles();
      this.cancel();
    },
    onOpen: function onOpen() {
      this.recipients = [];
      this.emails = [];
      this.providers = [];
      this.careTeamOptions = [];
      this.bestGuessProvider();
      var today = new Date();

      var todayStamp = today.getTime() / 1000;
      this.dateInput = this.formatDate(todayStamp);
    },
    toast: function toast(type, text) {
      __WEBPACK_IMPORTED_MODULE_6__core_helpers_bus__["a" /* default */].$emit('toast', { type: type, text: text });
    },
    changeURL: function changeURL(file, xhr) {
      console.log('changing the url, so in theory we are moving on to the next one');
      this.uploadQ.shift();
      this.$refs.dropzone.setOption('url', this.uploadQ[0]);

      var _send = xhr.send;
      xhr.send = function () {
        _send.call(xhr, file);
      };
    },
    fileAdded: function fileAdded(file) {
      var _this = this;

      var patient = this.$route.params.id;
      console.log();
      console.log(patient);
      // Rendering provider, optional
      // Encounter date, optional
      // Record Type, optional
      // Mimetype
      var mimetype = void 0;

      if (!(patient && file)) {
        return;
      } else {
        mimetype = file.type;
      }
      // renderingProvider: null, encounterDate: null, recordType: null,
      this.getPatientUploadURL({
        patient: patient,
        renderingProvider: this.providerIDForSubmission,
        encounterDate: this.unixDate(this.dateInput),
        recordType: this.typeInput,
        mimetype: mimetype
      }).then(function (data) {
        _this.initUploadGoogleStorage({
          url: data.url,
          type: file.type
        }).then(function (data) {
          var headers = __WEBPACK_IMPORTED_MODULE_1_babel_runtime_core_js_array_from___default()(data.headers.entries());

          var locationToPass = '';

          var _iteratorNormalCompletion = true;
          var _didIteratorError = false;
          var _iteratorError = undefined;

          try {
            for (var _iterator = __WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_get_iterator___default()(data.headers.entries()), _step; !(_iteratorNormalCompletion = (_step = _iterator.next()).done); _iteratorNormalCompletion = true) {
              var item = _step.value;

              if (item[0] === 'location') {
                locationToPass = item[1];
                break;
              }
            }
          } catch (err) {
            _didIteratorError = true;
            _iteratorError = err;
          } finally {
            try {
              if (!_iteratorNormalCompletion && _iterator.return) {
                _iterator.return();
              }
            } finally {
              if (_didIteratorError) {
                throw _iteratorError;
              }
            }
          }

          console.log('data returned from init');
          console.log(headers);
          _this.uploadQ.push(locationToPass);
          console.log('adding something to upload q');
          console.log(_this.uploadQ);
          _this.errorList.push({ file: file, url: locationToPass });
        });
      });
    },
    allFilesCompleted: function allFilesCompleted() {
      this.close();
      this.toast('success', 'Files Uploaded');
    },
    filesAdded: function filesAdded(files) {
      for (var i = 0; i <= files.length; i++) {
        this.fileAdded(files[i]);
      }
    },
    submitFiles: function submitFiles() {
      var dropzone = this.$refs.dropzone;

      if (this.optionalDescription) {
        var _iteratorNormalCompletion2 = true;
        var _didIteratorError2 = false;
        var _iteratorError2 = undefined;

        try {
          for (var _iterator2 = __WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_get_iterator___default()(this.$refs.dropzone.dropzone.files), _step2; !(_iteratorNormalCompletion2 = (_step2 = _iterator2.next()).done); _iteratorNormalCompletion2 = true) {
            var file = _step2.value;

            file.description = this.optionalDescription;
          }
        } catch (err) {
          _didIteratorError2 = true;
          _iteratorError2 = err;
        } finally {
          try {
            if (!_iteratorNormalCompletion2 && _iterator2.return) {
              _iterator2.return();
            }
          } finally {
            if (_didIteratorError2) {
              throw _iteratorError2;
            }
          }
        }
      }

      if (this.uploadQ.length > 0) {
        console.log('upload submitted');
        console.log(this.uploadQ);
        dropzone.setOption('url', this.uploadQ[0]);
        dropzone.processQueue();
      }
    },
    errorOccured: function errorOccured(file, message, xhr) {
      var errorObj = this.errorList.filter(function (obj) {
        return obj.file === file;
      });
      errorObj = errorObj[0];
      if (errorObj) {
        this.getFailPosition(errorObj);
      } else {
        console.log('failed to find object');
      }
    },
    getFailPosition: function getFailPosition(errorObj) {
      var _this2 = this;

      this.getUploadFailPosition({
        url: errorObj.url,
        uploadSize: errorObj.file.size
      }).catch(function (error) {
        var range = 0;
        if (error.response.status === 308) {
          range = error.response.headers.range;
          range = parseInt(range.split('-')[1]) + 1;

          errorObj.file.status = 'queued';
          errorObj.file.accepted = undefined;
          _this2.$refs.dropzone.removeFile(errorObj.file);
          _this2.$refs.dropzone.addFile(errorObj.file);
          _this2.$refs.dropzone.setOption('url', errorObj.url);
          _this2.$refs.dropzone.setOption('Content-Length', errorObj.file.size);
          _this2.$refs.dropzone.setOption('Content-Range', range);

          _this2.$refs.dropzone.processQueue();
        }
      });
    }
  }),
  watch: {
    currentUserGroups: function currentUserGroups(val) {
      var _this3 = this;

      console.log('currentUserGroups');
      var ids = [];

      val.groups.forEach(function (group) {
        if (group.provider) {
          // go get the provider information.
          ids.push(group.provider);
        }
      });

      if (ids.length > 0) {
        this.providersToDisplay = [];
        this.getProviderAuth({ ids: ids }).then(function (providersList) {
          providersList.forEach(function (provider) {
            var displayName = _this3.providerDisplayNameFromProviderObject(provider);

            var id = provider._id;
            if (_this3.providerInputValue === '') {
              _this3.providerInputValue = { displayName: displayName, id: id };
              _this3.providerIDForSubmission = id;
            }
            _this3.providersToDisplay.push({
              displayName: displayName,
              id: id,
              icon: 'local_hospital'
            });
          });
        });
      }
    },
    providerIDForSubmission: function providerIDForSubmission(val) {
      console.log('setting provideridforsubmission');
      console.log(val);
    },
    providerInputValue: function providerInputValue(val) {
      var _this4 = this;

      console.log('updated doc');
      console.log(val);
      var selection = val;
      // set the id of the doc. if the provider input is an object that already contains one of our ids, just set the id. if not, fetch the id.
      if (selection.id) {
        this.providerIDForSubmission = selection.id;
      } else {
        // go fetch the id from our system using the npi
        this.getProviderIDFromNPI({ npis: [val.npi] }).then(function (providerReturn) {
          var providerReturned = providerReturn[0];
          console.log('returned provider from back end');
          console.log(providerReturned);
          if (providerReturned) {
            console.log('only if provider returned is correct');
            _this4.providerIDForSubmission = providerReturned._id;
            console.log(_this4.providerIDForSubmission);
          }
        });
      }
    },
    uploadProviderSearchInput: function uploadProviderSearchInput(val) {
      this.search({ type: 'individual', terms: val });
    },
    searchResults: function searchResults(val) {
      var _this5 = this;

      val.forEach(function (element) {
        _this5.providersToDisplay.push(element);
      });
    }
  }
});

/***/ }),
/* 182 */,
/* 183 */,
/* 184 */,
/* 185 */,
/* 186 */,
/* 187 */,
/* 188 */,
/* 189 */,
/* 190 */
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ }),
/* 191 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__core_mixins_DialogMixin__ = __webpack_require__(5);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__components_cards_BrandingHeaderCard__ = __webpack_require__(192);
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//




/* harmony default export */ __webpack_exports__["a"] = ({
  components: {
    BrandingHeaderCard: __WEBPACK_IMPORTED_MODULE_1__components_cards_BrandingHeaderCard__["a" /* default */]
  },
  name: 'IdleDialog',
  mixins: [__WEBPACK_IMPORTED_MODULE_0__core_mixins_DialogMixin__["a" /* default */]],
  data: function data() {
    return {
      timer: null,
      seconds: 60,
      className: 'Confirm',
      defaultOptions: {
        okLabel: 'Confirm'
      }
    };
  },

  methods: {
    countdown: function countdown() {
      this.seconds--;
      if (this.seconds <= 0) {
        this.ok();
      }
    },
    onOpen: function onOpen() {
      this.seconds = 60;
      if (!this.timer) {
        this.timer = window.setInterval(this.countdown, 1000);
      }
    },
    onClose: function onClose() {
      if (this.timer) {
        window.clearInterval(this.timer);
      }
      this.timer = null;
    }
  },
  mounted: function mounted() {
    this.$on('open', this.onOpen);
    this.$on('close', this.onClose);
  }
});

/***/ }),
/* 192 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_vue_loader_lib_selector_type_script_index_0_BrandingHeaderCard_vue__ = __webpack_require__(193);
/* unused harmony namespace reexport */
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__node_modules_vue_loader_lib_template_compiler_index_id_data_v_20c341be_hasScoped_true_transformToRequire_video_src_poster_source_src_img_src_image_xlink_href_buble_transforms_node_modules_vue_loader_lib_selector_type_template_index_0_BrandingHeaderCard_vue__ = __webpack_require__(420);
function injectStyle (ssrContext) {
  __webpack_require__(419)
}
var normalizeComponent = __webpack_require__(0)
/* script */


/* template */

/* template functional */
var __vue_template_functional__ = false
/* styles */
var __vue_styles__ = injectStyle
/* scopeId */
var __vue_scopeId__ = "data-v-20c341be"
/* moduleIdentifier (server only) */
var __vue_module_identifier__ = null
var Component = normalizeComponent(
  __WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_vue_loader_lib_selector_type_script_index_0_BrandingHeaderCard_vue__["a" /* default */],
  __WEBPACK_IMPORTED_MODULE_1__node_modules_vue_loader_lib_template_compiler_index_id_data_v_20c341be_hasScoped_true_transformToRequire_video_src_poster_source_src_img_src_image_xlink_href_buble_transforms_node_modules_vue_loader_lib_selector_type_template_index_0_BrandingHeaderCard_vue__["a" /* default */],
  __vue_template_functional__,
  __vue_styles__,
  __vue_scopeId__,
  __vue_module_identifier__
)

/* harmony default export */ __webpack_exports__["a"] = (Component.exports);


/***/ }),
/* 193 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__core_components_Avatar__ = __webpack_require__(20);
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//



/* harmony default export */ __webpack_exports__["a"] = ({
  name: 'OnePatientCard',
  components: {
    Avatar: __WEBPACK_IMPORTED_MODULE_0__core_components_Avatar__["a" /* default */]
  },
  props: {
    recordShare: {
      type: Boolean,
      default: false
    },
    providerLanding: {
      type: Boolean,
      default: false
    }
  },
  data: function data() {
    return {
      showCobranding: false
    };
  },

  computed: {
    correctLogoURL: function correctLogoURL() {
      return 'https://storage.googleapis.com/onechart-assets/logos/login/default_normalized.png';
    },
    standardLogo: function standardLogo() {
      return 'https://storage.googleapis.com/onechart-assets/logos/login/default_normalized.png';
    }
  },
  methods: {
    textSwitch: function textSwitch() {}
  }
});

/***/ }),
/* 194 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_vue_loader_lib_selector_type_script_index_0_RequestLogs_vue__ = __webpack_require__(195);
/* unused harmony namespace reexport */
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__node_modules_vue_loader_lib_template_compiler_index_id_data_v_a282b1c2_hasScoped_false_transformToRequire_video_src_poster_source_src_img_src_image_xlink_href_buble_transforms_node_modules_vue_loader_lib_selector_type_template_index_0_RequestLogs_vue__ = __webpack_require__(435);
function injectStyle (ssrContext) {
  __webpack_require__(422)
}
var normalizeComponent = __webpack_require__(0)
/* script */


/* template */

/* template functional */
var __vue_template_functional__ = false
/* styles */
var __vue_styles__ = injectStyle
/* scopeId */
var __vue_scopeId__ = null
/* moduleIdentifier (server only) */
var __vue_module_identifier__ = null
var Component = normalizeComponent(
  __WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_vue_loader_lib_selector_type_script_index_0_RequestLogs_vue__["a" /* default */],
  __WEBPACK_IMPORTED_MODULE_1__node_modules_vue_loader_lib_template_compiler_index_id_data_v_a282b1c2_hasScoped_false_transformToRequire_video_src_poster_source_src_img_src_image_xlink_href_buble_transforms_node_modules_vue_loader_lib_selector_type_template_index_0_RequestLogs_vue__["a" /* default */],
  __vue_template_functional__,
  __vue_styles__,
  __vue_scopeId__,
  __vue_module_identifier__
)

/* harmony default export */ __webpack_exports__["a"] = (Component.exports);


/***/ }),
/* 195 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_extends__ = __webpack_require__(1);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_extends___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_extends__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_vuex__ = __webpack_require__(2);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_date_fns_format__ = __webpack_require__(59);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_date_fns_format___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_2_date_fns_format__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3__core_helpers_bus__ = __webpack_require__(3);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4__core_mixins_HelperMixin__ = __webpack_require__(12);

//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//






/* harmony default export */ __webpack_exports__["a"] = ({
  mixins: [__WEBPACK_IMPORTED_MODULE_4__core_mixins_HelperMixin__["a" /* default */]],
  methods: __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_extends___default()({}, Object(__WEBPACK_IMPORTED_MODULE_1_vuex__["b" /* mapActions */])('admin', ['getPatientList', 'getUserList', 'getRequest', 'getRequestProvider', 'setStatus', 'sendRequest', 'getRequestOverrides', 'submitRequestOverrides', 'submitRequestNote', 'getDocumentFiles']), {
    pullRequest: function pullRequest() {
      var vm = this;
      vm.getRequest(vm.$route.params.id).then(function () {
        vm.$refs.chatScroll.scrollTop = vm.$refs.chatScroll.scrollHeight;
      });
    },
    toast: function toast(type, text) {
      __WEBPACK_IMPORTED_MODULE_3__core_helpers_bus__["a" /* default */].$emit('toast', { type: type, text: text });
    },
    submitLogEntry: function submitLogEntry() {
      var _this = this;

      this.updatingLog = true;
      var email = '';
      if (this.user) {
        if (this.user.email) {
          email = '(' + this.user.email + ')';
        }
      }
      var unix = Math.round(+new Date() / 1000);
      if (this.logEntryInput !== '' && this.logEntryInput !== null) {
        this.submitRequestNote({
          id: this.$route.params.id,
          notes: this.request.log,
          note: { timestamp: unix, message: this.logEntryInput + ' ' + email }
        }).then(function (data) {
          _this.updatingLog = false;
          _this.logEntryInput = null;
          _this.publicNote = false;
          _this.getRequest(_this.$route.params.id);
          _this.toast('success', 'Note submitted');
          var vm = _this;
          vm.$refs.chatScroll.scrollTop = vm.$refs.chatScroll.scrollHeight;
        });
      } else {
        this.updatingLog = false;
        this.toast('error', 'Note not submitted');
      }
    },
    parseTimestamp: function parseTimestamp(timestamp) {
      var ts = new Date(parseInt(timestamp) * 1000);
      return __WEBPACK_IMPORTED_MODULE_2_date_fns_format___default()(ts, 'MMM D YYYY HH:MM:ss Z');
    },
    alternatingColors: function alternatingColors(index) {
      if (index % 2 === 0) {
        return 'whiteAlternate';
      } else {
        return 'grayAlternate';
      }
    }
  }),
  data: function data() {
    return {
      logEntryInput: null,
      updatingLog: false,
      showNav: false
    };
  },

  watch: {
    $route: function $route(val) {
      console.log(val);
    },
    request: function request(val) {
      console.log('request is back');
      if (val && this.$refs.chatScroll) {
        var vm = this;
        vm.$refs.chatScroll.scrollTop = vm.$refs.chatScroll.scrollHeight;
      }
    }
  },
  computed: __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_extends___default()({}, Object(__WEBPACK_IMPORTED_MODULE_1_vuex__["d" /* mapState */])('admin', ['patientSearchResults', 'userSearchResults', 'request', 'files']), Object(__WEBPACK_IMPORTED_MODULE_1_vuex__["d" /* mapState */])('auth', ['user'])),
  mounted: function mounted() {
    var _this2 = this;

    var vm = this;
    vm.getRequest(this.$route.params.id).then(function () {
      vm.$refs.chatScroll.scrollTop = vm.$refs.chatScroll.scrollHeight;
      _this2.showNav = true;
    });
  }
});

/***/ }),
/* 196 */,
/* 197 */,
/* 198 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_extends__ = __webpack_require__(1);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_extends___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_extends__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_vue__ = __webpack_require__(48);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_vue_router__ = __webpack_require__(437);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3__pages_auth_LoginPage__ = __webpack_require__(438);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4__pages_auth_ForgotPasswordPage__ = __webpack_require__(441);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_5__pages_auth_ResetPasswordPage__ = __webpack_require__(447);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_6__pages_admin_AdminLandingPage__ = __webpack_require__(450);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_7__pages_admin_AdminProvidersPage__ = __webpack_require__(453);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_8__pages_admin_AdminUploadsPage__ = __webpack_require__(466);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_9__pages_admin_AdminPatientsPage__ = __webpack_require__(472);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_10__pages_admin_AdminFileUploadPage__ = __webpack_require__(475);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_11__pages_admin_AdminRequestsPage__ = __webpack_require__(607);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_12__pages_admin_AdminRequestDetailPage__ = __webpack_require__(617);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_13__pages_admin_AdminDocumentsPage__ = __webpack_require__(629);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_14__pages_admin_AdminDocumentPage__ = __webpack_require__(632);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_15__pages_admin_AdminUserGroupsPage__ = __webpack_require__(644);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_16__router_guards__ = __webpack_require__(653);




// Auth




// Admin (Not being used)





// Admin Requests


// Admin Documents


// Admin User-groups


// Guards


__WEBPACK_IMPORTED_MODULE_1_vue__["default"].use(__WEBPACK_IMPORTED_MODULE_2_vue_router__["a" /* default */]);

/* harmony default export */ __webpack_exports__["a"] = (new __WEBPACK_IMPORTED_MODULE_2_vue_router__["a" /* default */]({
  // mode: 'history',
  scrollBehavior: function scrollBehavior() {
    return { x: 0, y: 0 };
  },

  routes: [__WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_extends___default()({
    path: '/',
    name: 'HomePage',
    component: __WEBPACK_IMPORTED_MODULE_6__pages_admin_AdminLandingPage__["a" /* default */]
  }, __WEBPACK_IMPORTED_MODULE_16__router_guards__["a" /* default */]), {
    path: '/login',
    name: 'LoginPage',
    component: __WEBPACK_IMPORTED_MODULE_3__pages_auth_LoginPage__["a" /* default */],
    meta: {
      hideHeader: true,
      replaceHeader: true
    },
    beforeEnter: function beforeEnter(to, from, next) {
      if (from.name === 'UploadFilePage') {
        to = from;
        return;
      }
      next();
    }
  }, {
    path: '/forgot-password',
    name: 'ForgotPasswordPage',
    component: __WEBPACK_IMPORTED_MODULE_4__pages_auth_ForgotPasswordPage__["a" /* default */],
    meta: {
      hideHeader: true
    }
  }, __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_extends___default()({
    path: '/reset-password',
    name: 'ResetPasswordPage',
    component: __WEBPACK_IMPORTED_MODULE_5__pages_auth_ResetPasswordPage__["a" /* default */],
    meta: {
      hideHeader: false
    }
  }, __WEBPACK_IMPORTED_MODULE_16__router_guards__["a" /* default */]), __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_extends___default()({
    path: '/admin',
    name: 'AdminLandingPage',
    component: __WEBPACK_IMPORTED_MODULE_6__pages_admin_AdminLandingPage__["a" /* default */]
  }, __WEBPACK_IMPORTED_MODULE_16__router_guards__["a" /* default */]), __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_extends___default()({
    path: '/admin/requests',
    name: 'AdminRequestsPage',
    component: __WEBPACK_IMPORTED_MODULE_11__pages_admin_AdminRequestsPage__["a" /* default */],
    meta: {
      displayName: 'Pending Requests'
    }
  }, __WEBPACK_IMPORTED_MODULE_16__router_guards__["a" /* default */]), __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_extends___default()({
    path: '/admin/providers',
    name: 'AdminProvidersPage',
    component: __WEBPACK_IMPORTED_MODULE_7__pages_admin_AdminProvidersPage__["a" /* default */]
  }, __WEBPACK_IMPORTED_MODULE_16__router_guards__["a" /* default */]), __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_extends___default()({
    path: '/admin/patients',
    name: 'AdminPatientsPage',
    component: __WEBPACK_IMPORTED_MODULE_9__pages_admin_AdminPatientsPage__["a" /* default */]
  }, __WEBPACK_IMPORTED_MODULE_16__router_guards__["a" /* default */]), __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_extends___default()({
    path: '/admin/request/:id',
    name: 'AdminRequestDetailPage',
    component: __WEBPACK_IMPORTED_MODULE_12__pages_admin_AdminRequestDetailPage__["a" /* default */],
    meta: {
      replaceHeader: true,
      sidebarContent: true
    }
  }, __WEBPACK_IMPORTED_MODULE_16__router_guards__["a" /* default */]), __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_extends___default()({
    path: '/admin/uploads',
    name: 'AdminUploadsPage',
    component: __WEBPACK_IMPORTED_MODULE_8__pages_admin_AdminUploadsPage__["a" /* default */]
  }, __WEBPACK_IMPORTED_MODULE_16__router_guards__["a" /* default */]), __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_extends___default()({
    path: '/admin/fileupload',
    name: 'AdminFileUploadPage',
    component: __WEBPACK_IMPORTED_MODULE_10__pages_admin_AdminFileUploadPage__["a" /* default */]
  }, __WEBPACK_IMPORTED_MODULE_16__router_guards__["a" /* default */]), __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_extends___default()({
    path: '/admin/documents',
    name: 'AdminDocumentsPage',
    component: __WEBPACK_IMPORTED_MODULE_13__pages_admin_AdminDocumentsPage__["a" /* default */],
    meta: {
      displayName: 'Inbound Faxes'
    }
  }, __WEBPACK_IMPORTED_MODULE_16__router_guards__["a" /* default */]), __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_extends___default()({
    path: '/admin/documents/:id',
    name: 'AdminDocumentPage',
    component: __WEBPACK_IMPORTED_MODULE_14__pages_admin_AdminDocumentPage__["a" /* default */],
    meta: {
      replaceHeader: true,
      sidebarContent: true
    }
  }, __WEBPACK_IMPORTED_MODULE_16__router_guards__["a" /* default */]), __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_extends___default()({
    path: '/admin/user-groups',
    name: 'AdminUserGroupsPage',
    component: __WEBPACK_IMPORTED_MODULE_15__pages_admin_AdminUserGroupsPage__["a" /* default */]
  }, __WEBPACK_IMPORTED_MODULE_16__router_guards__["a" /* default */]), {
    path: '*',
    redirect: '/',
    beforeEnter: function beforeEnter(to, from, next) {
      console.log('%c ERROR:', 'color:white;background:red', 'Route not found', to.name);
      next();
    }
  }]
}));

/***/ }),
/* 199 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_extends__ = __webpack_require__(1);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_extends___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_extends__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_vuex__ = __webpack_require__(2);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__core_helpers_bus__ = __webpack_require__(3);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3__components_cards_BrandingHeaderCard__ = __webpack_require__(192);

//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//





/* harmony default export */ __webpack_exports__["a"] = ({
  components: {
    BrandingHeaderCard: __WEBPACK_IMPORTED_MODULE_3__components_cards_BrandingHeaderCard__["a" /* default */]
  },
  data: function data() {
    return {
      loadingLogin: false,
      loading: false,
      email: '',
      password: '',
      isPassVisible: false
    };
  },

  computed: __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_extends___default()({}, Object(__WEBPACK_IMPORTED_MODULE_1_vuex__["d" /* mapState */])('auth', ['user', 'authUser', 'redirect']), {
    signInButtonText: function signInButtonText() {
      return 'Sign In';
    }
  }),
  methods: __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_extends___default()({}, Object(__WEBPACK_IMPORTED_MODULE_1_vuex__["b" /* mapActions */])('auth', ['signIn']), {
    enterPressed: function enterPressed(e) {
      // Enter is pressed
      if (e.keyCode === 13) {
        this.submit();
      }
    },
    submit: function submit() {
      this.loadingLogin = true;
      var credentials = {
        email: this.email,
        password: this.password
      };
      this.login(credentials);
    },
    login: function login(credentials) {
      var _this = this;

      var vm = this;

      vm.signIn(credentials).then(function () {
        vm.$ga.event('login', 'sign-in', credentials.email);
        vm.$router.push({ name: 'HomePage' });
      }, function () {
        vm.$ga.event('login', 'failed-sign-in', credentials.email);

        __WEBPACK_IMPORTED_MODULE_2__core_helpers_bus__["a" /* default */].$emit('stopLoading');
        _this.loadingLogin = false;
        vm.toast('error', 'Credentials invalid');
      });
    },
    toast: function toast(type, text) {
      __WEBPACK_IMPORTED_MODULE_2__core_helpers_bus__["a" /* default */].$emit('toast', { type: type, text: text });
    }
  }),
  created: function created() {
    if (this.user) {
      return location.reload();
    }
  }
});

/***/ }),
/* 200 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_extends__ = __webpack_require__(1);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_extends___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_extends__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_vuex__ = __webpack_require__(2);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__components_cards_LogoHeaderCard__ = __webpack_require__(443);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3__core_helpers_bus__ = __webpack_require__(3);

//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//





/* harmony default export */ __webpack_exports__["a"] = ({
  components: {
    LogoHeaderCard: __WEBPACK_IMPORTED_MODULE_2__components_cards_LogoHeaderCard__["a" /* default */]
  },
  data: function data() {
    return {
      valid: false,

      email: '',
      emailRules: [function (v) {
        return !!v || 'E-mail is required';
      }, function (v) {
        return (/^\w+([.-]?\w+)*@\w+([.-]?\w+)*(\.\w{2,3})+$/.test(v) || 'E-mail must be valid'
        );
      }]
    };
  },

  computed: {
    showSpecialtyLogo: function showSpecialtyLogo() {
      if (window.location.host.includes('smartchoice')) {
        return 'https://storage.googleapis.com/onechart-assets/sclogo.png';
      } else if (window.location.host.includes('grayhawk')) {
        return 'https://storage.googleapis.com/onechart-assets/logos/1699131904.png';
      } else {
        return null;
      }
    }
  },
  methods: __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_extends___default()({}, Object(__WEBPACK_IMPORTED_MODULE_1_vuex__["b" /* mapActions */])('auth', ['resetPassword']), {
    doResetPassword: function doResetPassword() {
      console.log(this.email);
      this.resetPassword({ email: this.email });
      this.toast('success', 'Password reset link sent');
      this.$router.push({ name: 'home' });
    },
    toast: function toast(type, text) {
      __WEBPACK_IMPORTED_MODULE_3__core_helpers_bus__["a" /* default */].$emit('toast', { type: type, text: text });
    }
  })
});

/***/ }),
/* 201 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__core_components_Avatar__ = __webpack_require__(20);
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//



/* harmony default export */ __webpack_exports__["a"] = ({
  name: 'OnePatientCard',
  components: {
    Avatar: __WEBPACK_IMPORTED_MODULE_0__core_components_Avatar__["a" /* default */]
  },
  props: {
    recordShare: {
      type: Boolean,
      default: false
    },
    providerLanding: {
      type: Boolean,
      default: false
    }
  },
  computed: {
    showLogo: function showLogo() {
      if (this.$subdomainPartner !== 'default') {
        return 'https://storage.googleapis.com/onechart-assets/logos/login/' + this.$subdomainPartner + '.png';
      } else {
        return null;
      }
    },
    standardLogo: function standardLogo() {
      return 'https://storage.googleapis.com/onechart-assets/logos/login/default_normalized.png';
    },
    loginDetailText: function loginDetailText() {
      if (this.providerLanding) {
        return false;
      }
      if (this.recordShare) {
        return 'View Shared Records';
      } else {
        if (this.$subdomainPartner === '5a4fa82c8e4b74e028665d04') {
          return 'Login below to quickly access and share your Smart Choice MRI health records';
        } else if (this.$subdomainPartner === 'default') {
          return 'Securely store, access, and share your health information anywhere.';
        } else {
          return false;
        }
      }
    }
  },
  methods: {
    textSwitch: function textSwitch() {
      console.log('textSwitch');
    }
  }
});

/***/ }),
/* 202 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_extends__ = __webpack_require__(1);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_extends___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_extends__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_vuex__ = __webpack_require__(2);

//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//



/* harmony default export */ __webpack_exports__["a"] = ({
  data: function data() {
    return {
      sending: false,
      sent: false
    };
  },

  computed: __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_extends___default()({}, Object(__WEBPACK_IMPORTED_MODULE_1_vuex__["d" /* mapState */])('auth', ['authUser']), {
    showSpecialtyLogo: function showSpecialtyLogo() {
      if (window.location.host.includes('smartchoice')) {
        return 'https://storage.googleapis.com/onechart-assets/sclogo.png';
      } else if (window.location.host.includes('grayhawk')) {
        return 'https://storage.googleapis.com/onechart-assets/logos/1699131904.png';
      } else {
        return null;
      }
    }
  }),
  methods: __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_extends___default()({}, Object(__WEBPACK_IMPORTED_MODULE_1_vuex__["b" /* mapActions */])('auth', ['resetPassword']), {
    reset: function reset() {
      var _this = this;

      this.sending = true;
      this.resetPassword({
        email: this.authUser.email
      }).then(function () {
        _this.sent = true;
        _this.sending = false;
      });
    }
  })
});

/***/ }),
/* 203 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_extends__ = __webpack_require__(1);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_extends___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_extends__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_vuex__ = __webpack_require__(2);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__core_mixins_HelperMixin__ = __webpack_require__(12);

//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//




/* harmony default export */ __webpack_exports__["a"] = ({
  mixins: [__WEBPACK_IMPORTED_MODULE_2__core_mixins_HelperMixin__["a" /* default */]],
  components: {},
  data: function data() {
    return {
      rowsPerPageItems: [4],
      pagination: {
        rowsPerPage: 4
      },
      items: [{
        value: false,
        name: 'OneChart Overview',
        totalPatients: 0,
        newUsersToday: 0,
        newPatientsToday: 0,
        newPatientsThisMonth: 0,
        newPatientsLastMonth: 0
      }, {
        value: false,
        name: 'Smart Choice',
        totalPatients: 0,
        newUsersToday: 0,
        newPatientsToday: 0,
        newPatientsThisMonth: 0,
        newPatientsLastMonth: 0
      }, {
        value: false,
        name: 'Imagine MD',
        totalPatients: 0,
        newUsersToday: 0,
        newPatientsToday: 0,
        newPatientsThisMonth: 0,
        newPatientsLastMonth: 0
      }, {
        value: false,
        name: 'Grayhawk',
        totalPatients: 0,
        newUsersToday: 0,
        newPatientsToday: 0,
        newPatientsThisMonth: 0,
        newPatientsLastMonth: 0
      }]
    };
  },

  methods: __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_extends___default()({}, Object(__WEBPACK_IMPORTED_MODULE_1_vuex__["b" /* mapActions */])('admin', ['getPatientList', 'getUserList', 'getSmartChoicePatientList']), {
    exportDataSet: function exportDataSet(dataSet) {
      var csvContent = 'data:text/csv;charset=utf-8,';
      csvContent += dataSet.join(',\n');
      var encodedUri = encodeURI(csvContent);
      window.open(encodedUri);
    },
    createUserPatientMatch: function createUserPatientMatch() {
      var _this = this;

      if (this.userSearchResults && this.userIDsOfCreatorsOfPatients.length > 0) {
        this.userSearchResults.forEach(function (user) {
          if (!_this.userIDsOfCreatorsOfPatients.includes(user.id)) {
            if (!_this.patientCreatorUsers.includes(user)) {
              _this.patientCreatorUsers.push(user);
            }
          } else {
            if (!_this.nonPatientCreatorUsers.includes(user)) {
              _this.nonPatientCreatorUsers.push(user);
            }
          }
        });
      }
    }
  }),
  computed: __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_extends___default()({}, Object(__WEBPACK_IMPORTED_MODULE_1_vuex__["d" /* mapState */])('admin', ['patientSearchResults', 'userSearchResults'])),
  watch: {
    userSearchResults: function userSearchResults() {
      var _this2 = this;

      if (!this.userPatientMatch.length > 0) {
        this.createUserPatientMatch();
      }
      this.oneChartUsers = this.userSearchResults.length;
      this.items[0].totalUsers = this.userSearchResults.length;

      var todayCuttoffDate = new Date();
      todayCuttoffDate.setHours(0, 0, 0, 0);
      var todayCuttoff = todayCuttoffDate.getTime() / 1000;

      var newUsersToday = 0;
      this.userSearchResults.forEach(function (user) {
        // is this user from today?
        if (user.created > todayCuttoff) {
          newUsersToday = newUsersToday + 1;
        }
        _this2.items[0].newUsersToday = newUsersToday;
      });
    },
    patientSearchResults: function patientSearchResults() {
      var _this3 = this;

      this.items[0].name = 'OneChart Patient Population';
      this.items[0].totalPatients = this.patientSearchResults.length;

      // divide the patients by day this week and this month.

      var todayCuttoffDate = new Date();
      todayCuttoffDate.setHours(0, 0, 0, 0);
      var todayCuttoff = todayCuttoffDate.getTime() / 1000;

      var thisMonthCutOff = this.getTimestampOfStartOfThisMonth();

      var previousMonthCutOff = this.getTimestampOfStartOfPreviousMonth();
      console.log('this month cutoff');
      console.log(thisMonthCutOff);

      var newPatientsToday = 0;
      var newPatientsThisMonth = 0;
      var newPatientsLastMonth = 0;

      var smartChoiceNewPatientsToday = 0;
      var smartChoiceOverallNewPatients = 0;
      var smartChoiceNewPatientsThisMonth = 0;
      var smartChoiceNewPatientsLastMonth = 0;

      var imagineMDNewPatientsToday = 0;
      var imagineMDOverallNewPatients = 0;
      var imagineMDNewPatientsThisMonth = 0;
      var imagineMDNewPatientsLastMonth = 0;

      var grayhawkNewPatientsToday = 0;
      var grayhawkOverallNewPatients = 0;
      var grayhawkNewPatientsThisMonth = 0;
      var grayhawkNewPatientsLastMonth = 0;

      this.patientSearchResults.forEach(function (patient) {
        // is this patient from today?
        // who does this patient belong to?
        if (patient.partner) {
          if (patient.partner.id) {
            if (patient.partner.id === '5a4fa82c8e4b74e028665d04') {
              // this is a smart choice affiliated patient
              smartChoiceOverallNewPatients = smartChoiceOverallNewPatients + 1;
            }
            if (patient.partner.id === '5acb94000495d7065c909bc2') {
              // this is a grayhawk affiliated patient
              grayhawkOverallNewPatients = grayhawkOverallNewPatients + 1;
            }
            if (patient.partner.id === '5b73507c4aef2028740f662b') {
              // this is a imaginemd affiliated patient
              imagineMDOverallNewPatients = imagineMDOverallNewPatients + 1;
            }
          }
        }
        if (patient.created > todayCuttoff) {
          newPatientsToday = newPatientsToday + 1;
          if (patient.partner) {
            if (patient.partner.id) {
              if (patient.partner.id === '5a4fa82c8e4b74e028665d04') {
                // this is a smart choice affiliated patient
                smartChoiceNewPatientsToday = smartChoiceNewPatientsToday + 1;
              }
              if (patient.partner.id === '5acb94000495d7065c909bc2') {
                // this is a grayhawk affiliated patient
                grayhawkNewPatientsToday = grayhawkNewPatientsToday + 1;
              }
              if (patient.partner.id === '5b73507c4aef2028740f662b') {
                // this is a imaginemd affiliated patient
                imagineMDNewPatientsToday = imagineMDNewPatientsToday + 1;
              }
            }
          }
        }

        if (patient.created > thisMonthCutOff) {
          newPatientsThisMonth = newPatientsThisMonth + 1;
          if (patient.partner) {
            if (patient.partner.id) {
              if (patient.partner.id === '5a4fa82c8e4b74e028665d04') {
                // this is a smart choice affiliated patient
                smartChoiceNewPatientsThisMonth = smartChoiceNewPatientsThisMonth + 1;
              }
              if (patient.partner.id === '5acb94000495d7065c909bc2') {
                // this is a grayhawk affiliated patient
                grayhawkNewPatientsThisMonth = grayhawkNewPatientsThisMonth + 1;
              }
              if (patient.partner.id === '5b73507c4aef2028740f662b') {
                // this is a imaginemd affiliated patient
                imagineMDNewPatientsThisMonth = imagineMDNewPatientsThisMonth + 1;
              }
            }
          }
        } else if (patient.created > previousMonthCutOff) {
          newPatientsLastMonth = newPatientsLastMonth + 1;
          if (patient.partner) {
            if (patient.partner.id) {
              if (patient.partner.id === '5a4fa82c8e4b74e028665d04') {
                // this is a smart choice affiliated patient
                smartChoiceNewPatientsLastMonth = smartChoiceNewPatientsLastMonth + 1;
              }
              if (patient.partner.id === '5acb94000495d7065c909bc2') {
                // this is a grayhawk affiliated patient
                grayhawkNewPatientsLastMonth = grayhawkNewPatientsLastMonth + 1;
              }
              if (patient.partner.id === '5b73507c4aef2028740f662b') {
                // this is a imaginemd affiliated patient
                imagineMDNewPatientsLastMonth = imagineMDNewPatientsLastMonth + 1;
              }
            }
          }
        }

        _this3.items[0].newPatientsToday = newPatientsToday;
        _this3.items[0].newPatientsThisMonth = newPatientsThisMonth;
        _this3.items[0].newPatientsLastMonth = newPatientsLastMonth;

        _this3.items[1].totalPatients = smartChoiceOverallNewPatients;
        _this3.items[1].newPatientsToday = smartChoiceNewPatientsToday;
        _this3.items[1].newPatientsThisMonth = smartChoiceNewPatientsThisMonth;
        _this3.items[1].newPatientsLastMonth = smartChoiceNewPatientsLastMonth;

        _this3.items[2].totalPatients = imagineMDOverallNewPatients;
        _this3.items[2].newPatientsToday = imagineMDNewPatientsToday;
        _this3.items[2].newPatientsThisMonth = imagineMDNewPatientsThisMonth;
        _this3.items[2].newPatientsLastMonth = imagineMDNewPatientsLastMonth;

        _this3.items[3].totalPatients = grayhawkOverallNewPatients;
        _this3.items[3].newPatientsToday = grayhawkNewPatientsToday;
        _this3.items[3].newPatientsThisMonth = grayhawkNewPatientsThisMonth;
        _this3.items[3].newPatientsLastMonth = grayhawkNewPatientsLastMonth;
      });
    }
  },
  created: function created() {
    this.$router.push({
      name: 'AdminDocumentsPage'
    });

    this.getPatientList();
    this.getUserList();
  }
});

/***/ }),
/* 204 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_extends__ = __webpack_require__(1);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_extends___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_extends__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_vuex__ = __webpack_require__(2);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__components_Titlebar__ = __webpack_require__(40);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3__core_mixins_HelperMixin__ = __webpack_require__(12);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4__components_dialogs_AddEditProviderDialog__ = __webpack_require__(206);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_5__core_helpers_bus__ = __webpack_require__(3);

//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//







/* harmony default export */ __webpack_exports__["a"] = ({
  mixins: [__WEBPACK_IMPORTED_MODULE_3__core_mixins_HelperMixin__["a" /* default */]],
  components: {
    Titlebar: __WEBPACK_IMPORTED_MODULE_2__components_Titlebar__["a" /* default */],
    AddEditProviderDialog: __WEBPACK_IMPORTED_MODULE_4__components_dialogs_AddEditProviderDialog__["a" /* default */]
  },
  data: function data() {
    return {
      search: '',
      headers: [{
        text: 'Provider ID',
        align: 'left',
        sortable: false,
        value: 'id'
      }, { text: 'NPI',
        sortable: false,
        value: 'npi',
        align: 'left' }, { text: 'Provider Name',
        sortable: true,
        value: 'lastName',
        align: 'left' }, { text: 'Organization',
        sortable: true,
        value: 'organizationName',
        align: 'left' }, { text: 'Zip Code',
        align: 'left',
        sortable: true,
        value: 'address.zip'
      }]
    };
  },

  methods: __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_extends___default()({}, Object(__WEBPACK_IMPORTED_MODULE_1_vuex__["b" /* mapActions */])('admin', ['getPatientList', 'getUserList', 'getProvidersList', 'sendProviderInvite']), {
    sendInviteFax: function sendInviteFax(provider) {
      var _this = this;

      if (provider.fax) {
        this.sendProviderInvite({ id: provider.id }).then(function (response) {
          _this.toast('success', 'Fax Sent');
        });
      } else {
        this.toast('error', 'Missing Fax');
      }
    },
    toast: function toast(type, text) {
      __WEBPACK_IMPORTED_MODULE_5__core_helpers_bus__["a" /* default */].$emit('toast', { type: type, text: text });
    },
    editProvider: function editProvider(provider) {
      this.$refs.addEditProviderDialog.open({ id: provider.id, provider: provider });
    },
    reloadOnReturn: function reloadOnReturn() {
      this.providerSearchResults = null;
      this.getProvidersList();
    },
    filterImagineMD: function filterImagineMD() {
      this.search = '5b73507c4aef2028740f662b';
    },
    filterSmartChoice: function filterSmartChoice() {
      this.search = '5a4fa82c8e4b74e028665d04';
    },
    filterGrayhawk: function filterGrayhawk() {
      this.search = '5acb94000495d7065c909bc2';
    },
    convertDate: function convertDate(timestamp) {
      var d = new Date(timestamp * 1000);
      return d.getMonth() + 1 + '/' + d.getDate() + '/' + d.getFullYear();
    },
    formatGooglePlacesLink: function formatGooglePlacesLink(item) {
      return 'https://www.google.com/maps/search/?api=1&query=Google&query_place_id=' + item.googlePlaceID;
    },
    formatSecureAffiliateLink: function formatSecureAffiliateLink(item) {
      return 'https://patient.onecharthealth.com/#/login?provider=' + item.id + '&affiliateCode=' + item.affiliateCode;
    },
    formatCreatorEmail: function formatCreatorEmail(item) {
      if (item.creator) {
        if (item.creator.email) {
          return item.creator.email;
        } else {
          return 'No Email';
        }
      } else {
        return 'No Creator';
      }
    },
    formatNPI: function formatNPI(item) {
      if (item.npi) {
        return item.npi;
      } else {
        return '-';
      }
    },
    formatPartnerName: function formatPartnerName(item) {
      console.log(item);
      if (item.partner) {
        return this.transformPartnerIDToHumanReadableName(item.partner.id);
      } else {
        return 'Consumer';
      }
    },
    formatProviderName: function formatProviderName(item) {
      if (item.lastName) {
        if (item.firstName) {
          return item.firstName + ' ' + item.lastName + ' ' + item.credentials;
        } else {
          return '-';
        }
      } else {
        return '-';
      }
    },
    formatOrigin: function formatOrigin(item) {
      if (item.googlePlaceID && item.npi) {
        return 'Google Data and NPI Registry';
      }
      if (item.googlePlaceID) {
        return 'Google Data';
      } else if (item.npi) {
        return 'NPI Registry';
      } else {
        return 'Origin Unknown';
      }
    },
    formatProviderNameForCard: function formatProviderNameForCard(item) {
      if (item.lastName) {
        if (item.firstName) {
          return item.firstName + ' ' + item.lastName + ' ' + item.credentials;
        } else {
          return item.lastName + ' ' + item.credentials;
        }
      } else if (item.organizationName) {
        return item.organizationName;
      } else if (item.googlePlaceID) {
        return item.googlePlaceID;
      } else {
        return 'Missing Provider Name';
      }
    },
    formatZip: function formatZip(item) {
      if (item.address) {
        if (item.address.zip) {
          return item.address.zip;
        } else {
          return '-';
        }
      } else {
        return '-';
      }
    },
    formatOrgName: function formatOrgName(item) {
      if (item.organizationName) {
        return item.organizationName;
      } else {
        return '-';
      }
    },
    formatPlaceID: function formatPlaceID(item) {
      if (item.googlePlaceID) {
        return 'Yes';
      } else {
        return '-';
      }
    },
    formatCreatorName: function formatCreatorName(item) {
      if (item.creator) {
        if (item.creator.lastName) {
          if (item.creator.firstName) {
            return item.creator.firstName + ' ' + item.creator.lastName;
          } else {
            return 'Missing Patient';
          }
        } else {
          return 'Missing patient';
        }
      }
    },
    formatDate: function formatDate(timestamp) {
      if (timestamp != null) {
        var d = new Date(timestamp * 1000);
        var MyDateString = ('0' + (d.getMonth() + 1)).slice(-2) + '/' + ('0' + d.getDate()).slice(-2) + '/' + d.getFullYear();
        return MyDateString;
      }
      return '';
    },
    adminHome: function adminHome() {
      this.$router.push({
        name: 'AdminLandingPage'
      });
    }
  }),
  computed: __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_extends___default()({}, Object(__WEBPACK_IMPORTED_MODULE_1_vuex__["d" /* mapState */])('admin', ['requests', 'patient', 'request', 'patientSearchResults', 'userSearchResults', 'providerSearchResults'])),
  created: function created() {
    this.getProvidersList();
  },

  watch: {
    patientSearchResults: function patientSearchResults() {
      console.log(this.patientSearchResults);
    },
    providerSearchResults: function providerSearchResults() {
      console.log(this.providerSearchResults);
    }
  }
});

/***/ }),
/* 205 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//

/* harmony default export */ __webpack_exports__["a"] = ({
  name: 'OneTitlebar',
  props: {
    title: {
      type: String,
      default: ''
    },
    small: {
      type: Boolean,
      default: false
    }
  }
});

/***/ }),
/* 206 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_vue_loader_lib_selector_type_script_index_0_AddEditProviderDialog_vue__ = __webpack_require__(207);
/* unused harmony namespace reexport */
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__node_modules_vue_loader_lib_template_compiler_index_id_data_v_83f559d4_hasScoped_true_transformToRequire_video_src_poster_source_src_img_src_image_xlink_href_buble_transforms_node_modules_vue_loader_lib_selector_type_template_index_0_AddEditProviderDialog_vue__ = __webpack_require__(464);
function injectStyle (ssrContext) {
  __webpack_require__(457)
}
var normalizeComponent = __webpack_require__(0)
/* script */


/* template */

/* template functional */
var __vue_template_functional__ = false
/* styles */
var __vue_styles__ = injectStyle
/* scopeId */
var __vue_scopeId__ = "data-v-83f559d4"
/* moduleIdentifier (server only) */
var __vue_module_identifier__ = null
var Component = normalizeComponent(
  __WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_vue_loader_lib_selector_type_script_index_0_AddEditProviderDialog_vue__["a" /* default */],
  __WEBPACK_IMPORTED_MODULE_1__node_modules_vue_loader_lib_template_compiler_index_id_data_v_83f559d4_hasScoped_true_transformToRequire_video_src_poster_source_src_img_src_image_xlink_href_buble_transforms_node_modules_vue_loader_lib_selector_type_template_index_0_AddEditProviderDialog_vue__["a" /* default */],
  __vue_template_functional__,
  __vue_styles__,
  __vue_scopeId__,
  __vue_module_identifier__
)

/* harmony default export */ __webpack_exports__["a"] = (Component.exports);


/***/ }),
/* 207 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_slicedToArray__ = __webpack_require__(458);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_slicedToArray___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_slicedToArray__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_babel_runtime_helpers_extends__ = __webpack_require__(1);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_babel_runtime_helpers_extends___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_1_babel_runtime_helpers_extends__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_vuex__ = __webpack_require__(2);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3__core_mixins_DialogMixin__ = __webpack_require__(5);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4__core_components_FormTextarea__ = __webpack_require__(117);


//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//






/* harmony default export */ __webpack_exports__["a"] = ({
  mixins: [__WEBPACK_IMPORTED_MODULE_3__core_mixins_DialogMixin__["a" /* default */]],
  components: {
    FormTextarea: __WEBPACK_IMPORTED_MODULE_4__core_components_FormTextarea__["a" /* default */]
  },
  data: function data() {
    var _this = this;

    return {
      profileValid: false,
      addressValid: false,
      formTitle: 'Edit Provider',
      notesInput: '',
      formInput: '',
      firstNameInput: '',
      credentialsInput: '',
      lastNameInput: '',
      phoneInput: '',
      emailInput: '',
      line1Input: '',
      line2Input: '',
      cityInput: '',
      stateInput: '',
      zipInput: '',
      faxInput: '',
      orgNameInput: '',
      selectedAllergy: '',
      date: null,
      dateFormatted: null,
      phoneMask: 'phone',
      menu: false,
      dateRule: [function (v) {
        return !!v || 'Start date is required';
      }],
      valid: false,
      stateValidation: ['AL', 'AK', 'AS', 'AZ', 'AR', 'CA', 'CO', 'CT', 'DE', 'DC', 'FM', 'FL', 'GA', 'GU', 'HI', 'ID', 'IL', 'IN', 'IA', 'KS', 'KY', 'LA', 'ME', 'MH', 'MD', 'MA', 'MI', 'MN', 'MS', 'MO', 'MT', 'NE', 'NV', 'NH', 'NJ', 'NM', 'NY', 'NC', 'ND', 'MP', 'OH', 'OK', 'OR', 'PW', 'PA', 'PR', 'RI', 'SC', 'SD', 'TN', 'TX', 'UT', 'VT', 'VI', 'VA', 'WA', 'WV', 'WI', 'WY'],
      phoneRules: [function (v) {
        return !!v || 'Phone number is required';
      }],
      birthdateRules: [function (v) {
        return !!v || 'Birthdate is required';
      }],
      line1Rules: [function (v) {
        return !!v || 'Street address is required';
      }],
      cityRules: [function (v) {
        return !!v || 'City is required';
      }],
      stateRules: [function (v) {
        return !!v || 'State is required';
      }],
      stateValidationRule: [function (v) {
        return _this.stateValidation.includes(v) || 'Invalid State';
      }],
      zipRules: [function (v) {
        return !!v || 'Zip Code is required';
      }]
    };
  },

  computed: __WEBPACK_IMPORTED_MODULE_1_babel_runtime_helpers_extends___default()({}, Object(__WEBPACK_IMPORTED_MODULE_2_vuex__["d" /* mapState */])('patient', ['patient']), {
    results: function results() {
      if (this.formInput) {
        return this.allergyList.filter(this.allergyMatch).slice(0, 5);
      } else {
        return [];
      }
    }
  }),
  methods: __WEBPACK_IMPORTED_MODULE_1_babel_runtime_helpers_extends___default()({}, Object(__WEBPACK_IMPORTED_MODULE_2_vuex__["b" /* mapActions */])('provider', ['getInvidualProvider', 'getProviderAuth']), Object(__WEBPACK_IMPORTED_MODULE_2_vuex__["b" /* mapActions */])('admin', ['getPatient', 'setStatus', 'setProviderInfo', 'createProvider']), {
    allergyMatch: function allergyMatch(allergy) {
      return allergy.toLowerCase().includes(this.formInput.toLowerCase());
    },
    parseDate: function parseDate(date) {
      if (!date) return null;

      var _date$split = date.split('/'),
          _date$split2 = __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_slicedToArray___default()(_date$split, 3),
          month = _date$split2[0],
          day = _date$split2[1],
          year = _date$split2[2];

      return year + '-' + month.padStart(2, '0') + '-' + day.padStart(2, '0');
    },
    formatDate: function formatDate(date) {
      if (!date) return null;

      var _date$split3 = date.split('-'),
          _date$split4 = __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_slicedToArray___default()(_date$split3, 3),
          year = _date$split4[0],
          month = _date$split4[1],
          day = _date$split4[2];

      return month + '/' + day + '/' + year;
    },
    submit: function submit() {
      var _this2 = this;

      if (this.options.id) {
        // get what is different, and update it.
        var provider = {};
        if (this.firstNameInput !== this.options.provider.firstName) {
          provider.firstName = this.firstNameInput;
          provider.type = 'INDIVIDUAL';
        }
        if (this.lastNameInput !== this.options.provider.lastName) {
          provider.lastName = this.lastNameInput;
          provider.type = 'INDIVIDUAL';
        }

        if (this.orgNameInput !== this.options.provider.organizationName) {
          provider.organizationName = this.orgNameInput;
          if (!this.options.provider.lastName && this.lastNameInput === '') {
            provider.type = 'ORGANIZATION';
          }
        }

        if (this.credentialsInput !== this.options.provider.credentials) {
          provider.credentials = this.credentialsInput;
        }

        if (this.notesInput !== this.options.provider.notes) {
          provider.notes = this.notesInput;
        }

        if (this.phoneInput !== this.options.provider.phone) {
          if (this.phoneInput !== '') {
            provider.phone = parseInt(this.phoneInput);
          }
        }
        if (this.faxInput !== this.options.provider.fax) {
          if (this.faxInput !== '') {
            provider.fax = parseInt(this.faxInput);
          }
        }
        if (this.emailInput !== this.options.provider.email) {
          provider.email = this.emailInput;
        }
        // the address has to be updated together
        var addressChanged = false;
        if (this.options.provider.address) {
          if (this.line1Input !== this.options.provider.address.line1) {
            addressChanged = true;
          }
          if (this.line2Input !== this.options.provider.address.line2) {
            addressChanged = true;
          }
          if (this.cityInput !== this.options.provider.address.city) {
            addressChanged = true;
            if (provider.address) {
              provider.address.city = this.cityInput;
            } else {
              provider.address = {};
              provider.address.city = this.cityInput;
            }
          }
          if (this.stateInput !== this.options.provider.address.state) {
            addressChanged = true;
          }
          if (this.zipInput !== this.options.provider.address.zip) {
            addressChanged = true;
          }
        } else {
          addressChanged = true;
        }
        if (addressChanged) {
          provider.address = {};
          provider.address.line1 = this.line1Input;
          provider.address.line2 = this.line2Input;
          provider.address.city = this.cityInput;
          provider.address.state = this.stateInput;
          provider.address.zip = this.zipInput;
        }
        var info = provider;
        this.setProviderInfo({
          id: this.options.provider.id,
          info: info
        }).then(function () {
          _this2.$emit('providerUpdated');
        });
      } else {}
      this.ok();
    },
    cancelDialog: function cancelDialog() {
      this.formInput = '';
      this.selectedAllergy = '';
      this.cancel();
    },
    convertToUnix: function convertToUnix(date) {
      if (date !== '') {
        var splitDate = date.toString().split('/');
        var formatDate = splitDate[0] + '.' + splitDate[1] + '.' + splitDate[2];
        // Format: '2012.08.10'
        return new Date(formatDate).getTime() / 1000;
      }
    },
    onClose: function onClose() {
      this.opened = false;
    },
    onOpen: function onOpen() {
      console.log('opening');
      if (this.options.id) {
        // get the provider.
        this.firstNameInput = this.options.provider.firstName;
        this.lastNameInput = this.options.provider.lastName;
        this.orgNameInput = this.options.provider.organizationName;
        this.phoneInput = this.options.provider.phone;
        this.faxInput = this.options.provider.fax;
        this.emailInput = this.options.provider.email;
        this.notesInput = this.options.provider.notes;
        this.credentialsInput = this.options.provider.credentials;
        if (this.options.provider.address) {
          this.stateInput = this.options.provider.address.state;
          this.zipInput = this.options.provider.address.zip;
          this.line1Input = this.options.provider.address.line1;
          this.line2Input = this.options.provider.address.line2;
          this.cityInput = this.options.provider.address.city;
        }
      } else {
        console.log('this is a brand new doc');
        this.formTitle = 'Add New Provider';
      }
    }
  }),
  watch: {
    formInput: function formInput(val) {
      if (this.formInput !== '') {
        this.selectedAllergy = '';
      }
    },
    date: function date(val) {
      this.dateFormatted = this.formatDate(this.date);
    }
  },
  mounted: function mounted() {
    this.$on('open', this.onOpen);
    this.$on('close', this.onClose);
  }
});

/***/ }),
/* 208 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//

/* harmony default export */ __webpack_exports__["a"] = ({
  name: 'formTextarea',
  props: {
    value: String,
    placeholder: ''
  },
  methods: {
    focus: function focus() {
      this.$refs.textarea.focus();
      this.$refs.textarea.select();
    }
  }
});

/***/ }),
/* 209 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_extends__ = __webpack_require__(1);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_extends___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_extends__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_vuex__ = __webpack_require__(2);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__components_Titlebar__ = __webpack_require__(40);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3__components_dialogs_UploadDialog__ = __webpack_require__(468);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4__core_helpers_bus__ = __webpack_require__(3);

//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//






/* harmony default export */ __webpack_exports__["a"] = ({
  components: {
    Titlebar: __WEBPACK_IMPORTED_MODULE_2__components_Titlebar__["a" /* default */],
    UploadDialog: __WEBPACK_IMPORTED_MODULE_3__components_dialogs_UploadDialog__["a" /* default */]
  },
  data: function data() {
    return {
      search: '',
      showTable: false,
      filesToDisplay: [],
      headers: [{
        text: 'File ID',
        align: 'left',
        sortable: false,
        value: 'id'
      }, {
        text: 'Patient',
        align: 'left',
        sortable: false,
        value: 'patient.lastName'
      }, {
        text: 'Encounter Date',
        sortable: false,
        value: 'encounterDate',
        align: 'left'
      }, {
        text: 'Provider',
        sortable: false,
        value: 'provider.id',
        align: 'left'
      }, {
        text: 'Record Type',
        sortable: false,
        value: 'recordType',
        align: 'left'
      }, {
        text: 'Created Date',
        sortable: true,
        value: 'created',
        align: 'left'
      }]
    };
  },

  methods: __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_extends___default()({}, Object(__WEBPACK_IMPORTED_MODULE_1_vuex__["b" /* mapActions */])('admin', ['getUploads', 'getPatient', 'getFiles']), {
    convertDate: function convertDate(timestamp) {
      var d = new Date(timestamp * 1000);
      return d.getMonth() + 1 + '/' + d.getDate() + '/' + d.getFullYear();
    },
    displayPatientName: function displayPatientName(item) {
      if (item.patient) {
        if (item.patient.lastName) {
          if (item.patient.firstName) {
            return item.patient.lastName + ', ' + item.patient.firstName;
          }
          return item.patient.lastName;
        }
      }
      return '';
    },
    displayProvider: function displayProvider(item) {
      console.log(item);
      if (item.renderingProvider) {
        return item.renderingProvider.id;
      }
      return '';
    },
    formatDate: function formatDate(timestamp) {
      if (timestamp != null) {
        var d = new Date(timestamp * 1000);
        var MyDateString = ('0' + (d.getMonth() + 1)).slice(-2) + '/' + ('0' + d.getDate()).slice(-2) + '/' + d.getFullYear();
        return MyDateString;
      }
      return '';
    },
    adminHome: function adminHome() {
      this.$router.push({
        name: 'AdminLandingPage'
      });
    },
    setFileInfo: function setFileInfo(fileId) {
      this.$router.push({
        name: 'AdminFileUploadPage',
        query: { file: fileId }
      });
    },
    reduceFileCount: function reduceFileCount() {
      var newFiles = [];

      this.files.forEach(function (file) {
        // check to see if it has a patient. if it does, check for last name. if it is null, throw it out
        // check to see if if has an encounter date, provider, type and patient. if it does, throw it out.
        var include = false;

        if (file.encounterDate) {
          // do nothing
        } else {
          include = true;
        }

        if (file.renderingProvider) {
          // do nothing
        } else {
          include = true;
        }

        if (file.recordType) {
          // do nothing
        } else {
          include = true;
        }

        if (file.patient) {
          if (!file.patient.lastName) {
            include = false;
          }
        } else {
          include = true;
        }

        if (include) {
          newFiles.push(file);
        }
      });
      this.showTable = true;
      this.filesToDisplay = newFiles;
    }
  }),
  computed: __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_extends___default()({}, Object(__WEBPACK_IMPORTED_MODULE_1_vuex__["d" /* mapState */])('admin', ['uploads', 'patient', 'upload', 'files']), Object(__WEBPACK_IMPORTED_MODULE_1_vuex__["d" /* mapState */])('patient', ['providerAuthInfo'])),
  created: function created() {
    // this.getRequests()
    // this.getUploads()
    // this.getFiles()
    // bus.$emit('startPageLoading')
  },

  // TODO:
  watch: {
    files: function files() {
      __WEBPACK_IMPORTED_MODULE_4__core_helpers_bus__["a" /* default */].$emit('stopPageLoading');
      this.reduceFileCount();
    },
    request: function request() {
      var _this = this;

      this.requests.find(function (r, i) {
        if (r._id === _this.request.id) {
          _this.requests[i].status = _this.request.status.status;
          return true;
        }
      });
    }
  }
});

/***/ }),
/* 210 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_extends__ = __webpack_require__(1);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_extends___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_extends__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__core_components_Avatar__ = __webpack_require__(20);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__core_mixins_DialogMixin__ = __webpack_require__(5);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3__core_components_FormTextarea__ = __webpack_require__(117);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4_vuex__ = __webpack_require__(2);

//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//






/* harmony default export */ __webpack_exports__["a"] = ({
  name: 'OneConfirmDialog',
  mixins: [__WEBPACK_IMPORTED_MODULE_2__core_mixins_DialogMixin__["a" /* default */]],
  components: {
    Avatar: __WEBPACK_IMPORTED_MODULE_1__core_components_Avatar__["a" /* default */],
    FormTextarea: __WEBPACK_IMPORTED_MODULE_3__core_components_FormTextarea__["a" /* default */]
  },
  data: function data() {
    return {
      upload: null,
      edit: false,
      status: null,
      patient: null,
      statuses: ['NOT_RECEIVED', 'RECEIVED', 'RENDERING_DICOM_READ', 'NEEDS_ASSIGNMENT', 'ERROR', 'DONE'],
      memo: null,
      fax: null,
      phone: null
    };
  },

  methods: __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_extends___default()({}, Object(__WEBPACK_IMPORTED_MODULE_4_vuex__["b" /* mapActions */])('admin', ['getPatient', 'setStatus', 'setProviderInfo']), {
    convertDate: function convertDate(timestamp) {
      var d = new Date(timestamp * 1000);
      return d.getMonth() + 1 + '/' + d.getDate() + '/' + d.getFullYear();
    },
    submit: function submit() {
      this.edit = !this.edit;

      if (this.status !== this.options.upload.status) {
        this.setStatus({
          id: this.options.upload._id,
          status: { status: this.options.upload.status }
        });
      }
    },
    cancelEdit: function cancelEdit() {
      this.edit = !this.edit;
      this.options.upload.status = this.status;
    },
    clickEdit: function clickEdit() {
      this.edit = !this.edit;
      this.status = this.options.upload.status;
    },
    onClose: function onClose() {
      this.edit = false;
    }
  }),
  computed: {
    showBuilding: function showBuilding() {
      return this.options.unit && this.options.building;
    }
  },
  created: function created() {
    this.$on('close', this.onClose);
  }
});

/***/ }),
/* 211 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_extends__ = __webpack_require__(1);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_extends___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_extends__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_vuex__ = __webpack_require__(2);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__components_Titlebar__ = __webpack_require__(40);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3__core_mixins_HelperMixin__ = __webpack_require__(12);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4__core_helpers_bus__ = __webpack_require__(3);

//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//






/* harmony default export */ __webpack_exports__["a"] = ({
  mixins: [__WEBPACK_IMPORTED_MODULE_3__core_mixins_HelperMixin__["a" /* default */]],
  components: {
    Titlebar: __WEBPACK_IMPORTED_MODULE_2__components_Titlebar__["a" /* default */]
  },
  data: function data() {
    return {
      search: '',
      headers: [{
        text: 'Partner',
        align: 'left',
        sortable: true,
        value: 'partner.id'
      }, { text: 'PatientID',
        sortable: true,
        value: 'id',
        align: 'left' }, { text: 'Chart Created',
        align: 'left',
        sortable: true,
        value: 'created'
      }, { text: 'Patient Name',
        sortable: true,
        value: 'lastName',
        align: 'left' }, { text: 'DOB',
        sortable: true,
        value: 'birthdate',
        align: 'left' }, { text: 'Creator Email',
        sortable: true,
        value: 'creator.email',
        align: 'left' }]
    };
  },

  methods: __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_extends___default()({}, Object(__WEBPACK_IMPORTED_MODULE_1_vuex__["b" /* mapActions */])('admin', ['getPatientList', 'getUserList']), Object(__WEBPACK_IMPORTED_MODULE_1_vuex__["b" /* mapActions */])('auth', ['resetPassword']), {
    doResetPassword: function doResetPassword(item) {
      if (item.creator) {
        if (item.creator.email) {
          this.resetPassword({ email: item.creator.email });
          this.toast('success', 'Password Reset Sent');
        } else {
          this.toast('error', 'Missing Email');
        }
      } else {
        this.toast('error', 'Missing User');
      }
    },
    toast: function toast(type, text) {
      __WEBPACK_IMPORTED_MODULE_4__core_helpers_bus__["a" /* default */].$emit('toast', { type: type, text: text });
    },
    filterImagineMD: function filterImagineMD() {
      this.search = '5b73507c4aef2028740f662b';
    },
    filterSmartChoice: function filterSmartChoice() {
      this.search = '5a4fa82c8e4b74e028665d04';
    },
    filterGrayhawk: function filterGrayhawk() {
      this.search = '5acb94000495d7065c909bc2';
    },
    convertDate: function convertDate(timestamp) {
      var d = new Date(timestamp * 1000);
      return d.getMonth() + 1 + '/' + d.getDate() + '/' + d.getFullYear();
    },
    formatCreatorEmail: function formatCreatorEmail(item) {
      if (item.creator) {
        if (item.creator.email) {
          return item.creator.email;
        } else {
          return 'No Email';
        }
      } else {
        return 'No Creator';
      }
    },
    formatPartnerName: function formatPartnerName(item) {
      console.log(item);
      if (item.partner) {
        return this.transformPartnerIDToHumanReadableName(item.partner.id);
      } else {
        return 'Consumer';
      }
    },
    formatPatientName: function formatPatientName(item) {
      if (item.lastName) {
        if (item.firstName) {
          return item.firstName + ' ' + item.lastName;
        } else {
          return 'Missing Patient';
        }
      } else {
        return 'Missing patient';
      }
    },
    formatCreatorName: function formatCreatorName(item) {
      if (item.creator) {
        if (item.creator.lastName) {
          if (item.creator.firstName) {
            return item.creator.firstName + ' ' + item.creator.lastName;
          } else {
            return 'Missing Patient';
          }
        } else {
          return 'Missing patient';
        }
      }
    },
    formatDate: function formatDate(timestamp) {
      if (timestamp != null) {
        var d = new Date(timestamp * 1000);
        var MyDateString = ('0' + (d.getMonth() + 1)).slice(-2) + '/' + ('0' + d.getDate()).slice(-2) + '/' + d.getFullYear();
        return MyDateString;
      }
      return '';
    },
    adminHome: function adminHome() {
      this.$router.push({
        name: 'AdminLandingPage'
      });
    }
  }),
  computed: __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_extends___default()({}, Object(__WEBPACK_IMPORTED_MODULE_1_vuex__["d" /* mapState */])('admin', ['requests', 'patient', 'request', 'patientSearchResults', 'userSearchResults'])),
  created: function created() {
    this.getPatientList();
    this.getUserList();
  },

  watch: {
    patientSearchResults: function patientSearchResults() {
      console.log(this.patientSearchResults);
    }
  }
});

/***/ }),
/* 212 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_extends__ = __webpack_require__(1);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_extends___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_extends__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_vuex__ = __webpack_require__(2);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__components_Titlebar__ = __webpack_require__(40);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3__components_dialogs_ProviderSelectorDialog__ = __webpack_require__(477);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4__components_dialogs_AdvancedPatientSearchAdmin__ = __webpack_require__(216);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_5__components_dialogs_FileDialog__ = __webpack_require__(218);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_6_vue2_dropzone__ = __webpack_require__(189);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_6_vue2_dropzone___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_6_vue2_dropzone__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_7_vue2_dropzone_dist_vue2Dropzone_min_css__ = __webpack_require__(190);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_7_vue2_dropzone_dist_vue2Dropzone_min_css___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_7_vue2_dropzone_dist_vue2Dropzone_min_css__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_8__core_mixins_HelperMixin__ = __webpack_require__(12);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_9__core_helpers_bus__ = __webpack_require__(3);

//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//











/* harmony default export */ __webpack_exports__["a"] = ({
  mixins: [__WEBPACK_IMPORTED_MODULE_8__core_mixins_HelperMixin__["a" /* default */]],
  components: {
    Titlebar: __WEBPACK_IMPORTED_MODULE_2__components_Titlebar__["a" /* default */],
    ProviderSelectorDialog: __WEBPACK_IMPORTED_MODULE_3__components_dialogs_ProviderSelectorDialog__["a" /* default */],
    vueDropzone: __WEBPACK_IMPORTED_MODULE_6_vue2_dropzone___default.a,
    FileDialog: __WEBPACK_IMPORTED_MODULE_5__components_dialogs_FileDialog__["a" /* default */],
    AdvancedPatientSearchAdmin: __WEBPACK_IMPORTED_MODULE_4__components_dialogs_AdvancedPatientSearchAdmin__["a" /* default */]
  },
  data: function data() {
    return {
      recordTypes: ['PRE_OP_NOTE', 'POST_OP_NOTE', 'OP_NOTE', 'OFFICE_VISIT', 'MESSAGE', 'MRI', 'IMAGE_READ', 'XRAY', 'OTHER_IMAGING', 'LAB_RESULT', 'PROGRESS_NOTE', 'DIAGNOSTIC_REPORT', 'REFERRAL', 'COMPLETED_PRIOR_AUTH'],
      typeInput: null,
      menuProvider: false,
      menuPatient: false,
      providerName: null,
      providerID: null,
      providerNameResult: null,
      date: null,
      encounterType: null,
      provider: null,
      patient: null,
      patientName: null,
      patientID: '',
      fileId: null,
      encounterTypes: ['PRE_OP_NOTE', 'POST_OP_NOTE', 'OP_NOTE', 'OFFICE_VISIT', 'MESSAGE', 'MRI', 'IMAGE_READ', 'XRAY', 'OTHER_IMAGING', 'LAB_RESULT', 'PROGRESS_NOTE', 'DIAGNOSTIC_REPORT'],
      files: null,
      optionalDescription: '',

      dropzoneOptions: {
        url: 'https://httpbin.org/post',
        thumbnailWidth: 300,
        thumbnailHeight: 100,
        maxFilesize: 0.5,
        headers: { 'My-Awesome-Header': 'header value' }
      }
    };
  },

  methods: __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_extends___default()({}, Object(__WEBPACK_IMPORTED_MODULE_1_vuex__["b" /* mapActions */])('admin', ['getUploads', 'getPatient', 'getFile', 'setFileInfo', 'searchForPatient', 'getProviderByID']), Object(__WEBPACK_IMPORTED_MODULE_1_vuex__["b" /* mapActions */])('provider', ['search', 'getProviderIDFromNPI', 'multipleShareFiles']), {
    toast: function toast(type, text) {
      __WEBPACK_IMPORTED_MODULE_9__core_helpers_bus__["a" /* default */].$emit('toast', { type: type, text: text });
    },
    showPatientSearch: function showPatientSearch() {
      this.$refs.patientSearchDialog.open({});
    },
    unixEncounterDate: function unixEncounterDate(date) {
      if (date !== '') {
        var formatDate = date.slice(4, 8) + '.' + date.slice(0, 2) + '.' + date.slice(2, 4);
        // Format: '2012.08.10'
        return new Date(formatDate).getTime() / 1000;
      }
    },
    convertDate: function convertDate(timestamp) {
      var d = new Date(timestamp * 1000);
      return d.getMonth() + 1 + '/' + d.getDate() + '/' + d.getFullYear();
    },
    adminHome: function adminHome() {
      this.$router.push({
        name: 'AdminLandingPage'
      });
    },
    documentsHome: function documentsHome() {
      this.$router.push({
        name: 'AdminUploadsPage'
      });
    },
    uploadRecord: function uploadRecord() {
      var file = {};
      if (this.providerID) {
        file.renderingProvider = this.providerID;
      }
      if (this.patientID) {
        file.patient = this.patientID;
      }
      if (this.date) {
        file.encounterDate = this.unixEncounterDate(this.date);
      }
      if (this.typeInput) {
        file.recordType = this.typeInput;
      }

      var vm = this;
      this.setFileInfo({ file: file, id: this.file[0].id });
      vm.toast('success', 'File Assigned');
      this.$router.push({
        name: 'AdminUploadsPage'
      });
    },
    selectEncounterType: function selectEncounterType(theType) {
      this.encounterType = theType;
    },
    selectProvider: function selectProvider(provider) {
      var _this = this;

      this.providerName = provider.displayNameIndividual + ' ' + provider.displayAddressIndividual;
      this.getProviderIDFromNPI({ npis: [provider.npi] }).then(function (providerReturn) {
        var providerReturned = providerReturn[0];
        _this.providerID = providerReturned._id;
      });
    },
    selectPatient: function selectPatient(patient) {
      console.log('selected Patient');
      this.patientName = patient.firstName + ' ' + patient.lastName;
      this.patientID = patient.id;
    },
    showMoreInfo: function showMoreInfo(upload) {
      var _this2 = this;

      this.getPatient({ id: upload.patient }).then(function (data) {
        var patient = data;
        if (upload.provider) {
          _this2.getProviderAuth({ ids: upload.provider }).then(function () {
            var provider = _this2.providerAuthInfo;

            _this2.$refs.uploadDialog.open({
              upload: upload,
              provider: provider,
              patient: patient
            });
          });
        } else {
          _this2.$refs.uploadDialog.open({
            upload: upload,
            patient: patient
          });
        }
      });
    },
    openFile: function openFile(file) {
      this.$refs.fileDialog.open({
        file: file
      });
    },
    searchPatient: function searchPatient() {
      // Get rid of spaces
      var patientName = this.patientName.replace(/\s+/g, '');
      // Split out first and last name
      var patientTerms = patientName.split(',');

      if (patientTerms.length > 1) {
        // Capitialize the first and last name
        patientTerms[0] = patientTerms[0].charAt(0).toUpperCase() + patientTerms[0].slice(1);
        patientTerms[1] = patientTerms[1].charAt(0).toUpperCase() + patientTerms[1].slice(1);

        this.searchForPatient({
          firstName: patientTerms[1],
          lastName: patientTerms[0]
        });
      }
    },
    formatDate: function formatDate(timestamp) {
      var d = new Date(timestamp * 1000);
      var MyDateString = ('0' + (d.getMonth() + 1)).slice(-2) + '/' + ('0' + d.getDate()).slice(-2) + '/' + d.getFullYear();
      return MyDateString;
    },
    patientHint: function patientHint() {
      if (this.patientID) {
        return this.patientID;
      } else {
        return 'Format required: lastName,firstName';
      }
    },
    convertToUnix: function convertToUnix(date) {
      if (typeof date === 'number') {
        return date;
      }

      if (date !== '') {
        var splitDate = date.toString().split('-');
        var formatDate = splitDate[0] + '.' + splitDate[1] + '.' + splitDate[2];
        // Format: '2012.08.10'
        return new Date(formatDate).getTime() / 1000;
      }
    }
  }),
  computed: __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_extends___default()({}, Object(__WEBPACK_IMPORTED_MODULE_1_vuex__["d" /* mapState */])('admin', ['uploads', 'patient', 'upload', 'file', 'patientSearchResults']), Object(__WEBPACK_IMPORTED_MODULE_1_vuex__["d" /* mapState */])('provider', ['searchResults']), Object(__WEBPACK_IMPORTED_MODULE_1_vuex__["d" /* mapState */])('patient', ['providerAuthInfo']), Object(__WEBPACK_IMPORTED_MODULE_1_vuex__["d" /* mapState */])('auth', ['authToken']), {
    patientName: function patientName() {
      if (this.patient) {
        return this.provider._id;
      }
      return '';
    }
  }),
  created: function created() {
    var _this3 = this;

    if (this.$route.query.file) {
      this.fileId = this.$route.query.file;
      this.getFile(this.fileId).then(function () {
        var file = _this3.file[0];
        console.log(file);
        if (file.ocr) {
          var str = window.nlp(file.ocr).people().out('topk');
          console.log('NLP USAGE');
          console.log(str);
        }
        if (file.renderingProvider) {
          if (file.renderingProvider.firstName) {
            _this3.providerName = file.renderingProvider.firstName + ' ' + file.renderingProvider.lastName + ' ' + file.renderingProvider.credentials;
          } else if (file.renderingProvider.organizationName) {
            _this3.providerName = _this3.providerDisplayNameFromProviderObject(file.renderingProvider);
          }
          _this3.providerID = file.renderingProvider.id;
        }
        if (file.patient) {
          _this3.patientName = file.patient.firstName + ' ' + file.patient.lastName;
          _this3.patientID = file.patient.id;
        }
        if (file.encounterDate) {
          _this3.date = _this3.formatDate(file.encounterDate);
        }
        if (file.recordType) {
          _this3.typeInput = file.recordType;
        }
      });
    }

    // this.getRequests()
    // this.getUploads()
  },

  // TODO:
  watch: {
    providerName: function providerName(val) {
      this.search({ type: 'individual', terms: val });
    },
    request: function request() {
      var _this4 = this;

      this.requests.find(function (r, i) {
        if (r._id === _this4.request.id) {
          _this4.requests[i].status = _this4.request.status.status;
          return true;
        }
      });
    },
    patientName: function patientName() {
      this.searchPatient();
    }
  }
});

/***/ }),
/* 213 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_extends__ = __webpack_require__(1);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_extends___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_extends__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__components_cards_ProviderCard__ = __webpack_require__(214);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__core_mixins_DialogMixin__ = __webpack_require__(5);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3_vuex__ = __webpack_require__(2);

//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//





/* harmony default export */ __webpack_exports__["a"] = ({
  name: 'OneProviderInfoDialog',
  mixins: [__WEBPACK_IMPORTED_MODULE_2__core_mixins_DialogMixin__["a" /* default */]],
  components: {
    ProviderCard: __WEBPACK_IMPORTED_MODULE_1__components_cards_ProviderCard__["a" /* default */]
  },
  data: function data() {
    return {
      loadingShare: false,
      formInput: '',
      searchType: { title: 'Individuals', value: 'idv' },
      searchTypes: [{ title: 'Individuals', value: 'idv' }, { title: 'Organization', value: 'org' }],
      className: 'Confirm',
      defaultOptions: {
        okLabel: 'Confirm',
        cancelLabel: 'Cancel',
        showOk: true,
        showCancel: false
      }
    };
  },

  computed: __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_extends___default()({}, Object(__WEBPACK_IMPORTED_MODULE_3_vuex__["d" /* mapState */])('provider', ['searchResults']), {
    transition: function transition() {
      return this.$vuetify.breakpoint.xsOnly ? 'dialog-bottom-transition' : 'scale-transition';
    },
    showBuilding: function showBuilding() {
      return this.options.unit && this.options.building;
    }
  }),
  mounted: function mounted() {
    this.$on('open', this.onOpen);
  },

  methods: __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_extends___default()({}, Object(__WEBPACK_IMPORTED_MODULE_3_vuex__["b" /* mapActions */])('patient', ['getPatient']), Object(__WEBPACK_IMPORTED_MODULE_3_vuex__["b" /* mapActions */])('provider', ['search', 'getProviderIDFromNPI']), {
    selectFilter: function selectFilter(filter) {
      this.searchType = filter;
    },
    selectProvider: function selectProvider(provider) {
      var _this = this;

      this.loadingShare = true;
      this.getProviderIDFromNPI({ npis: [provider.npi] }).then(function (providerReturn) {
        var providerReturned = providerReturn[0];
        var vm = _this;
        vm.$emit('emitProvider', providerReturned);
        _this.loadingShare = false;
        vm.formInput = '';
        vm.ok();
      });
    },
    close: function close() {
      this.cancel();
    },
    onOpen: function onOpen() {
      var _this2 = this;

      this.$nextTick(function () {
        _this2.$refs.input.focus();
      });
    }
  }),
  watch: {
    formInput: function formInput(val) {
      this.search({ type: 'individual', terms: val });
    }
  }
});

/***/ }),
/* 214 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_vue_loader_lib_selector_type_script_index_0_ProviderCard_vue__ = __webpack_require__(215);
/* unused harmony namespace reexport */
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__node_modules_vue_loader_lib_template_compiler_index_id_data_v_608627ff_hasScoped_true_transformToRequire_video_src_poster_source_src_img_src_image_xlink_href_buble_transforms_node_modules_vue_loader_lib_selector_type_template_index_0_ProviderCard_vue__ = __webpack_require__(480);
function injectStyle (ssrContext) {
  __webpack_require__(479)
}
var normalizeComponent = __webpack_require__(0)
/* script */


/* template */

/* template functional */
var __vue_template_functional__ = false
/* styles */
var __vue_styles__ = injectStyle
/* scopeId */
var __vue_scopeId__ = "data-v-608627ff"
/* moduleIdentifier (server only) */
var __vue_module_identifier__ = null
var Component = normalizeComponent(
  __WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_vue_loader_lib_selector_type_script_index_0_ProviderCard_vue__["a" /* default */],
  __WEBPACK_IMPORTED_MODULE_1__node_modules_vue_loader_lib_template_compiler_index_id_data_v_608627ff_hasScoped_true_transformToRequire_video_src_poster_source_src_img_src_image_xlink_href_buble_transforms_node_modules_vue_loader_lib_selector_type_template_index_0_ProviderCard_vue__["a" /* default */],
  __vue_template_functional__,
  __vue_styles__,
  __vue_scopeId__,
  __vue_module_identifier__
)

/* harmony default export */ __webpack_exports__["a"] = (Component.exports);


/***/ }),
/* 215 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__core_components_Avatar__ = __webpack_require__(20);
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//



/* harmony default export */ __webpack_exports__["a"] = ({
  name: 'OneProviderCard',
  components: {
    Avatar: __WEBPACK_IMPORTED_MODULE_0__core_components_Avatar__["a" /* default */]
  },
  props: {
    provider: {
      type: Object,
      default: function _default() {
        return {
          name: 'No provider',
          email: 'No email',
          phone: 'No phone',
          address: 'No address'
        };
      }
    },
    showRemove: {
      type: Boolean,
      default: true
    },
    showEdit: {
      type: Boolean,
      default: true
    },
    actionLabel: {
      type: String,
      default: 'Invite'
    }
  },
  computed: {
    name: function name() {
      var provider = this.provider;
      if (provider && provider.npi && provider.name) {
        return provider.name.toLowerCase();
      }
      return '';
    },
    providerTitle: function providerTitle() {
      var provider = this.provider;
      if (provider.firstName) {
        return provider.firstName + ' ' + provider.lastName + ' ' + provider.credentials;
      } else if (provider.organizationName) {
        return provider.organizationName;
      } else if (provider.displayNameIndividual) {
        return provider.displayNameIndividual;
      } else if (provider.coveredEntityName) {
        return provider.coveredEntityName;
      }
      return 'Missing Provider Name';
    },
    phone: function phone() {
      return this.provider.phone;
    },
    address: function address() {
      var address = this.provider.address;
      return address.line1 + ' ' + address.line2 + ' ' + address.city + ', ' + address.state + ' ' + address.zip;
    },
    fax: function fax() {
      return this.provider.fax;
    },
    avatarSize: function avatarSize() {
      return 48;
    },
    avatarString: function avatarString() {
      var provider = this.provider;
      if (provider.npi) {
        if (provider.name) {
          return provider.name;
        } else {
          return provider.first + ' ' + provider.last;
        }
      }
      return '';
    }
  },
  methods: {
    onRemove: function onRemove() {
      this.$emit('remove');
    },
    onEdit: function onEdit() {
      this.$emit('edit');
    },
    onAction: function onAction() {
      this.$emit('action');
    }
  }
});

/***/ }),
/* 216 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_vue_loader_lib_selector_type_script_index_0_AdvancedPatientSearchAdmin_vue__ = __webpack_require__(217);
/* unused harmony namespace reexport */
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__node_modules_vue_loader_lib_template_compiler_index_id_data_v_02ddc495_hasScoped_true_transformToRequire_video_src_poster_source_src_img_src_image_xlink_href_buble_transforms_node_modules_vue_loader_lib_selector_type_template_index_0_AdvancedPatientSearchAdmin_vue__ = __webpack_require__(483);
function injectStyle (ssrContext) {
  __webpack_require__(482)
}
var normalizeComponent = __webpack_require__(0)
/* script */


/* template */

/* template functional */
var __vue_template_functional__ = false
/* styles */
var __vue_styles__ = injectStyle
/* scopeId */
var __vue_scopeId__ = "data-v-02ddc495"
/* moduleIdentifier (server only) */
var __vue_module_identifier__ = null
var Component = normalizeComponent(
  __WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_vue_loader_lib_selector_type_script_index_0_AdvancedPatientSearchAdmin_vue__["a" /* default */],
  __WEBPACK_IMPORTED_MODULE_1__node_modules_vue_loader_lib_template_compiler_index_id_data_v_02ddc495_hasScoped_true_transformToRequire_video_src_poster_source_src_img_src_image_xlink_href_buble_transforms_node_modules_vue_loader_lib_selector_type_template_index_0_AdvancedPatientSearchAdmin_vue__["a" /* default */],
  __vue_template_functional__,
  __vue_styles__,
  __vue_scopeId__,
  __vue_module_identifier__
)

/* harmony default export */ __webpack_exports__["a"] = (Component.exports);


/***/ }),
/* 217 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_extends__ = __webpack_require__(1);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_extends___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_extends__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__core_components_Avatar__ = __webpack_require__(20);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__core_mixins_DialogMixin__ = __webpack_require__(5);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3__core_mixins_HelperMixin__ = __webpack_require__(12);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4_vuex__ = __webpack_require__(2);

//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//






/* harmony default export */ __webpack_exports__["a"] = ({
  name: 'OneConfirmDialog',
  mixins: [__WEBPACK_IMPORTED_MODULE_2__core_mixins_DialogMixin__["a" /* default */], __WEBPACK_IMPORTED_MODULE_3__core_mixins_HelperMixin__["a" /* default */]],
  components: {
    Avatar: __WEBPACK_IMPORTED_MODULE_1__core_components_Avatar__["a" /* default */]
  },
  data: function data() {
    return {
      isLoading: false,
      accessRequestingGroup: null,
      showEmptyResults: false,
      searchBanner: false,
      dateFormatted: '',
      patientFirstName: '',
      patientLastName: '',
      patientSearchResultsCleaned: [],
      requestingOrganizations: ['Foo', 'Bar', 'Fizz', 'Buzz'],
      link: 'this',
      className: 'Confirm',
      defaultOptions: {
        okLabel: 'Confirm',
        cancelLabel: 'Cancel',
        showOk: true,
        showCancel: false
      }
    };
  },

  methods: __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_extends___default()({}, Object(__WEBPACK_IMPORTED_MODULE_4_vuex__["b" /* mapActions */])('provider', ['search', 'getProviderIDFromNPI', 'multipleShareFiles', 'getProviderAuth']), Object(__WEBPACK_IMPORTED_MODULE_4_vuex__["b" /* mapActions */])('admin', ['getPatient', 'fuzzySearchForPatient']), {
    selectPatient: function selectPatient(patient) {
      var vm = this;
      vm.$emit('emitPatient', patient);
      this.close();
    },
    queryMode: function queryMode() {
      this.searchBanner = false;
    },
    formatDate: function formatDate(timestamp) {
      var d = new Date(timestamp * 1000);
      var MyDateString = ('0' + (d.getMonth() + 1)).slice(-2) + '/' + ('0' + d.getDate()).slice(-2) + '/' + d.getFullYear();
      return MyDateString;
    },
    close: function close() {
      this.patientFirstName = null;
      this.patientLastName = null;
      this.dateFormatted = '';
      this.patientSearchResultsCleaned = [];
      this.searchBanner = false;
      this.cancel();
    },
    searchPatientPopulation: function searchPatientPopulation() {
      this.isLoading = true;
      this.showEmptyResults = false;
      this.patientSearchResultsCleaned = [];
      console.log('going to search the patient population');
      var nameToSearchWith = this.patientFirstName + ' ' + this.patientLastName;
      console.log(nameToSearchWith);
      this.searchBanner = true;
      this.fuzzySearchForPatient({
        firstName: this.patientFirstName,
        lastName: this.patientLastName
      });
    }
  }),
  watch: {
    patientSearchResults: function patientSearchResults(val) {
      var _this = this;

      this.patientSearchResultsCleaned = [];
      this.isLoading = false;
      val.forEach(function (result) {
        if (result.firstName.toLowerCase().includes(_this.patientFirstName.toLowerCase())) {
          // passed first name
          // birthdateStringforComparison
          console.log(' at the point of comparison: ');
          console.log(result.birthdateString);
          console.log(_this.dateFormatted);
          var birthdateComparisonString = result.birthdateString.replace(/\//g, '');
          if (birthdateComparisonString.includes(_this.dateFormatted)) {
            _this.patientSearchResultsCleaned.push(result);
          }
        }
      });
      if (!this.patientSearchResultsCleaned.length > 0) {
        this.showEmptyResults = true;
      }
    }
  },
  computed: __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_extends___default()({}, Object(__WEBPACK_IMPORTED_MODULE_4_vuex__["d" /* mapState */])('auth', ['currentUserGroups']), Object(__WEBPACK_IMPORTED_MODULE_4_vuex__["d" /* mapState */])('admin', ['patientSearchResults']), {
    searchQuery: function searchQuery() {
      return this.patientLastName + ', ' + this.patientFirstName + ' ' + this.dateFormatted;
    },
    headers: function headers() {
      return [{
        text: 'Name',
        align: 'left',
        sortable: false,
        value: 'fullName'
      }, {
        text: 'Gender',
        align: 'left',
        sortable: false,
        value: 'gender'
      }, {
        text: 'Birthdate',
        align: 'right',
        sortable: false,
        value: 'birthdateString'
      }];
    },
    groupList: function groupList() {
      console.log('currentUserGroups');
      var ids = [];
      var names = [];
      console.log(this.currentUserGroups);

      this.currentUserGroups.groups.forEach(function (group) {
        if (group.provider) {
          // go get the provider information.
          ids.push(group.provider);
          names.push(group.name);
        }
      });
      return names;
    },
    canSearch: function canSearch() {
      if (this.patientFirstName === '' || this.patientLastName === '' || this.dateFormatted === '') {
        return false;
      }
      return true;
    },
    showBuilding: function showBuilding() {
      return this.options.unit && this.options.building;
    }
  })
});

/***/ }),
/* 218 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_vue_loader_lib_selector_type_script_index_0_FileDialog_vue__ = __webpack_require__(219);
/* unused harmony namespace reexport */
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__node_modules_vue_loader_lib_template_compiler_index_id_data_v_54c9fc71_hasScoped_true_transformToRequire_video_src_poster_source_src_img_src_image_xlink_href_buble_transforms_node_modules_vue_loader_lib_selector_type_template_index_0_FileDialog_vue__ = __webpack_require__(605);
function injectStyle (ssrContext) {
  __webpack_require__(484)
}
var normalizeComponent = __webpack_require__(0)
/* script */


/* template */

/* template functional */
var __vue_template_functional__ = false
/* styles */
var __vue_styles__ = injectStyle
/* scopeId */
var __vue_scopeId__ = "data-v-54c9fc71"
/* moduleIdentifier (server only) */
var __vue_module_identifier__ = null
var Component = normalizeComponent(
  __WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_vue_loader_lib_selector_type_script_index_0_FileDialog_vue__["a" /* default */],
  __WEBPACK_IMPORTED_MODULE_1__node_modules_vue_loader_lib_template_compiler_index_id_data_v_54c9fc71_hasScoped_true_transformToRequire_video_src_poster_source_src_img_src_image_xlink_href_buble_transforms_node_modules_vue_loader_lib_selector_type_template_index_0_FileDialog_vue__["a" /* default */],
  __vue_template_functional__,
  __vue_styles__,
  __vue_scopeId__,
  __vue_module_identifier__
)

/* harmony default export */ __webpack_exports__["a"] = (Component.exports);


/***/ }),
/* 219 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__core_mixins_DialogMixin__ = __webpack_require__(5);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_vue_pdf__ = __webpack_require__(485);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__core_helpers_bus__ = __webpack_require__(3);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3__components_dialogs_DownloadImagesDialog__ = __webpack_require__(602);
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//






/* harmony default export */ __webpack_exports__["a"] = ({
  name: 'OneFileDialog',
  mixins: [__WEBPACK_IMPORTED_MODULE_0__core_mixins_DialogMixin__["a" /* default */]],
  components: {
    pdf: __WEBPACK_IMPORTED_MODULE_1_vue_pdf__["a" /* default */],
    DownloadImagesDialog: __WEBPACK_IMPORTED_MODULE_3__components_dialogs_DownloadImagesDialog__["a" /* default */]
  },
  data: function data() {
    return {
      defaultOptions: {
        okLabel: 'Confirm',
        cancelLabel: 'Cancel',
        showOk: true,
        showCancel: false
      },
      isOpen: false,
      revealPDF: false,
      src: undefined,
      numPages: undefined,
      loaded: false,
      showPDF: false,
      isPDF: false
    };
  },

  props: {
    imageSet: {
      type: Array,
      default: function _default() {
        return [];
      }
    }
  },
  computed: {
    source: function source() {
      var url = this.options.file.downloadURL + '?alt=media&token=' + this.options.file.accessToken;
      var fileUrl = "https://onechart-pdf-viewer.firebaseapp.com/" + '?file=' + encodeURIComponent(url);
      if (this.options.currentPage) {
        fileUrl += '#page=' + this.options.currentPage;
      }
      // TODO: Emit the file URL
      return fileUrl;
    },
    isDesktop: function isDesktop() {
      return this.$vuetify.breakpoint.smAndUp;
    }
  },
  watch: {
    loaded: function loaded() {
      this.displayRecord();
    }
  },
  methods: {
    onOpen: function onOpen() {
      this.isOpen = true;
      this.showPDF = false;
      this.loaded = false;
      console.log('the url that has been submitted');
      console.log(this.options.fileLocation);

      switch (this.options.file.mimetype) {
        case 'application/pdf':
          this.isPDF = true;
          this.loadThePDF();
          break;
      }
    },

    error: function error(err) {
      console.log(err);
    },
    loadingTask: function loadingTask() {
      return __WEBPACK_IMPORTED_MODULE_1_vue_pdf__["a" /* default */].createLoadingTask(this.options.file.downloadURL + '?alt=media&token=' + this.options.file.accessToken);
    },
    loadThePDF: function loadThePDF() {
      var _this = this;

      this.src = this.loadingTask();
      this.src.then(function (pdf) {
        _this.numPages = pdf.numPages;
        _this.loaded = true;
      });
    },
    displayRecord: function displayRecord() {
      if (this.isOpen) {
        if (this.isPDF) {
          this.showPDF = true;
        }
      }
    },
    onClose: function onClose() {
      this.isOpen = false;
      this.revealPDF = false;
      this.loaded = false;
      this.showPDF = false;
      this.isPDF = false;
      this.cancel();
    },
    download: function download() {
      window.open(this.options.file.downloadURL + '?alt=media&token=' + this.options.file.accessToken);
    },
    showDownloadDialog: function showDownloadDialog() {
      var forwardedImages = this.options.imageSet;
      this.$refs.downloadImagesDialog.open({
        forwardedImages: forwardedImages
      });
    },
    getfileURL: function getfileURL() {
      var vm = this;
      console.log('#PROCESS', "https://onechart-pdf-viewer.firebaseapp.com/");
      console.log('#URL', this.options.file.downloadURL + '?alt=media&token=' + this.options.file.accessToken);

      var url = this.options.file.downloadURL + '?alt=media&token=' + this.options.file.accessToken;

      switch (vm.options.file.mimetype) {
        case 'application/pdf':
          console.log("https://onechart-pdf-viewer.firebaseapp.com/" + '?file=' + encodeURIComponent(url));
          return "https://onechart-pdf-viewer.firebaseapp.com/" + '?file=' + encodeURIComponent(url);
      }
    },
    goToPagePDF: function goToPagePDF() {}
  },
  created: function created() {
    var _this2 = this;

    this.goToPagePDF();
    __WEBPACK_IMPORTED_MODULE_2__core_helpers_bus__["a" /* default */].$on('page-loaded', function () {
      _this2.loaded = true;
    });
  }
});

/***/ }),
/* 220 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__componentFactory_js__ = __webpack_require__(487);
//




if (Object({"NODE_ENV":"production","SERVICES_URL":"https://api-dot-onechart-prod.appspot.com","PDF_VIEWER_URL":"https://onechart-pdf-viewer.firebaseapp.com/","DICOM_VIEWER_URL":"https://onechart-image-viewer.firebaseapp.com/","FIREBASE_CONFIG":{
    apiKey: 'AIzaSyBhHTQWfKsJSMkk8Be_ajV6oAbwCy79PlU',
    authDomain: 'onechart-prod.firebaseapp.com',
    databaseURL: 'https://onechart-prod.firebaseio.com',
    projectId: 'onechart-prod',
    storageBucket: 'onechart-prod.appspot.com',
    messagingSenderId: '530093705162'
  }}).VUE_ENV === 'server') {

	var component = Object(__WEBPACK_IMPORTED_MODULE_0__componentFactory_js__["a" /* default */])({});
} else {

	var pdfjsWrapper = __webpack_require__(490).default;
	var PDFJS = __webpack_require__(596);
	var component = Object(__WEBPACK_IMPORTED_MODULE_0__componentFactory_js__["a" /* default */])(pdfjsWrapper(PDFJS));
}

/* harmony default export */ __webpack_exports__["a"] = (component);

/***/ }),
/* 221 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
//
//
//
//
//
//



/* harmony default export */ __webpack_exports__["a"] = ({

	// thanks to https://github.com/marcj/css-element-queries
	props: {
		initial: {
			type: Boolean,
			default: false
		}
	},
	data: function () {
		return {
			size: {
				width: -1,
				height: -1
			}
		};
	},
	methods: {
		reset: function () {

			var expand = this.$el.firstChild;
			var shrink = this.$el.lastChild;
			expand.scrollLeft = 100000;
			expand.scrollTop = 100000;
			shrink.scrollLeft = 100000;
			shrink.scrollTop = 100000;
		},
		update: function () {

			this.size.width = this.$el.offsetWidth;
			this.size.height = this.$el.offsetHeight;
		}
	},
	watch: {
		size: {
			deep: true,
			handler: function (size) {

				this.reset();
				this.$emit('resize', { width: this.size.width, height: this.size.height });
			}
		}
	},
	render: function (create) {

		var style = 'position: absolute; left: 0; top: 0; right: 0; bottom: 0; overflow: hidden; z-index: -1; visibility: hidden;';
		var styleChild = 'position: absolute; left: 0; top: 0;';

		return create('div', {
			style: style + 'animation-name: resizeSensorVisibility;',
			on: {
				'~animationstart': this.update
			}
		}, [create('div', {
			style: style,
			on: {
				scroll: this.update
			}
		}, [create('div', {
			style: styleChild + 'width: 100000px; height: 100000px;'
		})]), create('div', {
			style: style,
			on: {
				scroll: this.update
			}
		}, [create('div', {
			style: styleChild + 'width: 200%; height: 200%;'
		})])]);
	},
	beforeDestroy: function () {

		this.$emit('resize', { width: 0, height: 0 });
		this.$emit('resizeSensorBeforeDestroy');
	},
	mounted: function () {

		if (this.initial === true) this.$nextTick(this.update);

		if (this.$el.offsetParent !== this.$el.parentNode) this.$el.parentNode.style.position = 'relative';

		if ('attachEvent' in this.$el && !('AnimationEvent' in window)) {

			var onresizeHandler = function () {

				this.update();
				removeOnresizeEvent();
			}.bind(this);

			var removeOnresizeEvent = function () {

				this.$el.detachEvent('onresize', onresizeHandler);
				this.$off('resizeSensorBeforeDestroy', removeOnresizeEvent);
			}.bind(this);

			this.$el.attachEvent('onresize', onresizeHandler);
			this.$on('resizeSensorBeforeDestroy', removeOnresizeEvent);
			this.reset();
		}
	}
});

/***/ }),
/* 222 */,
/* 223 */,
/* 224 */,
/* 225 */,
/* 226 */,
/* 227 */,
/* 228 */,
/* 229 */,
/* 230 */,
/* 231 */,
/* 232 */,
/* 233 */,
/* 234 */,
/* 235 */,
/* 236 */,
/* 237 */,
/* 238 */,
/* 239 */,
/* 240 */,
/* 241 */,
/* 242 */,
/* 243 */,
/* 244 */,
/* 245 */,
/* 246 */,
/* 247 */,
/* 248 */,
/* 249 */,
/* 250 */,
/* 251 */,
/* 252 */,
/* 253 */,
/* 254 */,
/* 255 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_get_iterator__ = __webpack_require__(113);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_get_iterator___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_get_iterator__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_babel_runtime_helpers_extends__ = __webpack_require__(1);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_babel_runtime_helpers_extends___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_1_babel_runtime_helpers_extends__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__core_mixins_DialogMixin__ = __webpack_require__(5);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3_vuex__ = __webpack_require__(2);


//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//




/* harmony default export */ __webpack_exports__["a"] = ({
  mixins: [__WEBPACK_IMPORTED_MODULE_2__core_mixins_DialogMixin__["a" /* default */]],
  computed: __WEBPACK_IMPORTED_MODULE_1_babel_runtime_helpers_extends___default()({}, Object(__WEBPACK_IMPORTED_MODULE_3_vuex__["d" /* mapState */])('auth', ['authToken'])),
  methods: __WEBPACK_IMPORTED_MODULE_1_babel_runtime_helpers_extends___default()({}, Object(__WEBPACK_IMPORTED_MODULE_3_vuex__["b" /* mapActions */])('file', ['downloadBundle']), {
    onOpen: function onOpen() {
      console.log(this.options);
    },
    download: function download(item) {
      window.open(item.downloadURL + '?alt=media&token=' + item.accessToken);
    },
    _downloadBundle: function _downloadBundle() {
      var fileIds = [];
      var _iteratorNormalCompletion = true;
      var _didIteratorError = false;
      var _iteratorError = undefined;

      try {
        for (var _iterator = __WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_get_iterator___default()(this.options.forwardedImages), _step; !(_iteratorNormalCompletion = (_step = _iterator.next()).done); _iteratorNormalCompletion = true) {
          var file = _step.value;

          fileIds.push(file._id);
        }
      } catch (err) {
        _didIteratorError = true;
        _iteratorError = err;
      } finally {
        try {
          if (!_iteratorNormalCompletion && _iterator.return) {
            _iterator.return();
          }
        } finally {
          if (_didIteratorError) {
            throw _iteratorError;
          }
        }
      }

      this.downloadBundle(fileIds);
    },
    cancelDialog: function cancelDialog() {
      this.formInput = '';
      this.selectedAllergy = '';
      this.cancel();
    },
    convertToUnix: function convertToUnix(date) {
      if (date !== '') {
        var splitDate = date.toString().split('/');
        var formatDate = splitDate[0] + '.' + splitDate[1] + '.' + splitDate[2];
        // Format: '2012.08.10'
        return new Date(formatDate).getTime() / 1000;
      }
    }
  }),
  mounted: function mounted() {
    this.$on('open', this.onOpen);
  }
});

/***/ }),
/* 256 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_extends__ = __webpack_require__(1);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_extends___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_extends__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_vuex__ = __webpack_require__(2);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__components_Titlebar__ = __webpack_require__(40);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3__components_dialogs_RequestInfoDialog__ = __webpack_require__(609);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4__core_mixins_HelperMixin__ = __webpack_require__(12);

//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//






/* harmony default export */ __webpack_exports__["a"] = ({
  mixins: [__WEBPACK_IMPORTED_MODULE_4__core_mixins_HelperMixin__["a" /* default */]],
  components: {
    Titlebar: __WEBPACK_IMPORTED_MODULE_2__components_Titlebar__["a" /* default */],
    RequestInfoDialog: __WEBPACK_IMPORTED_MODULE_3__components_dialogs_RequestInfoDialog__["a" /* default */]
  },
  data: function data() {
    return {
      // Search fields
      searchText: null,
      searchFields: {
        patient: {
          firstName: '',
          lastName: ''
        },
        provider: {
          firstName: '',
          lastName: ''
        }
      },
      patientSearchArray: null,
      providerSearchArray: null,
      searchState: 0,

      headers: [{
        text: 'Provider',
        align: 'left',
        sortable: false,
        value: 'providerID'
      }, {
        text: 'Patient',
        sortable: true,
        value: 'patientID',
        align: 'left'
      }, { text: 'Status', sortable: true, value: 'status', align: 'left' }, { text: 'Created', sortable: true, value: 'created', align: 'left' }, {
        text: 'Last Note',
        sortable: true,
        value: 'note.message',
        align: 'left'
      }],
      formattedRequests: null,

      // Pagination
      rowsPerPageItems: [25, 50, 100],
      currentPagination: {
        rowsPerPage: 25
      },
      lastOrder: false,
      lastSortBy: ''
    };
  },

  methods: __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_extends___default()({}, Object(__WEBPACK_IMPORTED_MODULE_1_vuex__["b" /* mapActions */])('admin', ['getRequests', 'getPatient', 'getPatients']), Object(__WEBPACK_IMPORTED_MODULE_1_vuex__["b" /* mapActions */])('provider', ['getInvidualProvider', 'getProviderAuth', 'search']), {
    alternatingColors: function alternatingColors(index) {
      if (index % 2 === 0) {
        return 'whiteAlternate';
      } else {
        return 'grayAlternate';
      }
    },
    filter: function filter(payload) {
      console.log('filtering');
      console.log(payload);
      return true;
    },
    updatePagination: function updatePagination(pag) {
      var requestOrder = '';
      if (this.lastOrder && pag.sortBy === this.lastSortBy) {
        requestOrder = '-' + pag.sortBy;
        this.lastOrder = false;
      } else {
        requestOrder = pag.sortBy;
        this.lastOrder = true;
      }
      this.lastSortBy = pag.sortBy;

      var requestOptions = {
        limit: this.currentPagination.rowsPerPage,
        offset: (pag.page - 1) * pag.rowsPerPage,
        order: requestOrder
      };
      if (this.patientSearchArray) {
        requestOptions['patients'] = this.patientSearchArray;
      }
      this.getRequests(requestOptions);
    },
    convertDate: function convertDate(timestamp) {
      var d = new Date(timestamp * 1000);
      return d.getMonth() + 1 + '/' + d.getDate() + '/' + d.getFullYear();
    },
    convertDateToDaysInProgress: function convertDateToDaysInProgress(timestamp) {
      var d = new Date(timestamp * 1000);
      var oneDay = 24 * 60 * 60 * 1000; // hours*minutes*seconds*milliseconds
      var firstDate = d;
      var secondDate = new Date();

      var diffDays = Math.round(Math.abs((firstDate.getTime() - secondDate.getTime()) / oneDay));

      return diffDays;
    },
    formatProviderName: function formatProviderName(item) {
      return 'Provider Error';
    },
    formatProviderFax: function formatProviderFax(item) {
      return 'Provider Error';
    },
    formatProviderPhone: function formatProviderPhone(item) {
      return 'provider phone';
    },
    formatPartnerName: function formatPartnerName(item) {
      return 'error';
    },
    getLastNote: function getLastNote(item) {
      if (item.log) {
        if (item.log.length > 0) {
          return item.log[0].message;
        }
      }
      return '';
    },
    formatPatientName: function formatPatientName(item) {
      if (item.patient) {
        if (item.patient.firstName) {
          return item.patient.firstName + ' ' + item.patient.lastName + ' DOB: ' + this.convertDate(item.patient.birthdate);
        } else {
          return 'Missing Patient';
        }
      } else {
        return 'Missing patient';
      }
    },
    formatDate: function formatDate(timestamp) {
      if (timestamp != null) {
        var d = new Date(timestamp * 1000);
        var MyDateString = ('0' + (d.getMonth() + 1)).slice(-2) + '/' + ('0' + d.getDate()).slice(-2) + '/' + d.getFullYear();
        return MyDateString;
      }
      return '';
    },
    adminHome: function adminHome() {
      this.$router.push({
        name: 'AdminLandingPage'
      });
    },
    showMoreInfo: function showMoreInfo(request) {
      console.log(request);
      var vm = this;
      vm.$router.push({
        name: 'AdminRequestDetailPage',
        params: { id: request.id }
      });
      // this.getInvidualProvider({ npi: request.provider }).then(() => {
      //   const provider = this.provider
    },
    searchRequest: function searchRequest() {
      var _this = this;

      if (this.searchFields.provider.firstName || this.searchFields.provider.lastName) {
        this.searchState++;
        this.search({
          type: 'individual',
          terms: this.searchFields.provider.firstName + this.searchFields.provider.lastName
        }).then(function (results) {});
      }
      // TODO: Get a list of providers, same way as the patients

      if (this.searchFields.patient.firstName || this.searchFields.patient.lastName) {
        this.searchState++;
        // Fetch list of patients to include in list of id on request search
        this.getPatients({
          firstName: this.searchFields.patient.firstName,
          lastName: this.searchFields.patient.lastName
        }).then(function (patients) {
          _this.searchState--;
          // Format array being sent to the request search
          var patientSearchArray = [];
          for (var i in patients) {
            patientSearchArray.push(patients[i].id);
          }
          patientSearchArray = '["' + patientSearchArray.join('","') + '"]';
          _this.patientSearchArray = patientSearchArray;
        });
      }

      if (this.searchFields.patient.firstName === '' && this.searchFields.patient.lastName === '' && this.searchFields.provider.firstName === '' && this.searchFields.provider.lastName === '') {
        this.getRequests({ limit: this.currentPagination.rowsPerPage });
      }
    }
  }),
  computed: __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_extends___default()({}, Object(__WEBPACK_IMPORTED_MODULE_1_vuex__["d" /* mapState */])('admin', ['requests', 'patient', 'request', 'requestsPageInfo', 'patients', 'loadingRequests']), Object(__WEBPACK_IMPORTED_MODULE_1_vuex__["d" /* mapState */])('provider', ['provider', 'providerAuthInfo']), {
    activeRequests: function activeRequests() {
      var onlyTheActive = [];
      if (this.requests) {
        this.requests.forEach(function (element) {
          if (element.status !== 'CANCELLED' && element.status !== 'COMPLETED') {
            onlyTheActive.push(element);
          }
        });
      }
      return onlyTheActive;
    }
  }),
  created: function created() {
    this.getRequests({ limit: this.currentPagination.rowsPerPage });
  },

  watch: {
    request: function request() {
      var _this2 = this;

      this.requests.find(function (r, i) {
        if (r._id === _this2.request.id) {
          _this2.requests[i].status = _this2.request.status.status;
          return true;
        }
      });
    },
    searchState: function searchState() {
      if (this.searchState === 0) {
        this.getRequests({
          limit: this.currentPagination.rowsPerPage,
          patients: this.patientSearchArray
        });
      }
    }
  }
});

/***/ }),
/* 257 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_object_keys__ = __webpack_require__(611);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_object_keys___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_object_keys__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_babel_runtime_helpers_extends__ = __webpack_require__(1);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_babel_runtime_helpers_extends___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_1_babel_runtime_helpers_extends__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__core_components_Avatar__ = __webpack_require__(20);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3__core_mixins_DialogMixin__ = __webpack_require__(5);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4__core_components_FormTextarea__ = __webpack_require__(117);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_5_vuex__ = __webpack_require__(2);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_6_date_fns_format__ = __webpack_require__(59);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_6_date_fns_format___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_6_date_fns_format__);


//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//







/* harmony default export */ __webpack_exports__["a"] = ({
  name: 'OneConfirmDialog',
  mixins: [__WEBPACK_IMPORTED_MODULE_3__core_mixins_DialogMixin__["a" /* default */]],
  components: {
    Avatar: __WEBPACK_IMPORTED_MODULE_2__core_components_Avatar__["a" /* default */],
    FormTextarea: __WEBPACK_IMPORTED_MODULE_4__core_components_FormTextarea__["a" /* default */]
  },
  data: function data() {
    return {
      nextFollowUpDate: null,
      shouldShowProviderNotes: false,
      standardEditViewMode: false,
      providerEditViewMode: false,
      completedMode: false,
      standardUpdate: false,
      showFullProviderEdit: false,
      suggestedProviderValid: false,
      proposeSuggestedProviderMode: false,
      contentSet: false,
      request: null,
      edit: false,
      start: null,
      end: null,
      log: [],
      editPhone: null,
      editFax: null,
      editEmail: null,
      editProviderNote: null,
      providerNoteHasBeenEdited: false,
      editStatus: null,
      status: null,
      patient: null,
      statuses: ['SENDING', 'SENT', 'MISSING_PROVIDER', 'NEEDS_FAX_NUMBER', 'CANCELLED', 'REJECTED', 'COMPLETED'],
      memo: null,
      fax: null,
      phone: null,
      backEndProviderObject: null,
      suggestedProvider: {
        googlePlaceID: '',
        type: '',
        firstName: '',
        lastName: '',
        credentials: '',
        specialization: '',
        organizationName: '',
        coveredEntityName: '',
        address: {
          line1: '',
          line2: '',
          city: '',
          state: '',
          zip: ''
        },
        phone: '',
        fax: '',
        email: '',
        notes: ''
      }
    };
  },

  watch: {
    editStatus: function editStatus() {
      if (this.editStatus !== this.options.request.status) {
        this.edit = true;
      }
    },
    editPhone: function editPhone() {
      if (this.editPhone !== this.options.provider[0].phone) {
        this.edit = true;
      }
    },
    editFax: function editFax() {
      if (this.editFax !== this.options.provider[0].fax) {
        this.edit = true;
      }
    },
    editEmail: function editEmail() {
      if (this.editEmail !== this.options.provider[0].email) {
        this.edit = true;
      }
    },
    memo: function memo() {
      this.edit = true;
    },
    editProviderNote: function editProviderNote() {
      if (this.editProviderNote !== this.options.provider[0].notes) {
        this.providerNoteHasBeenEdited = true;
      }
    }
  },
  methods: __WEBPACK_IMPORTED_MODULE_1_babel_runtime_helpers_extends___default()({}, Object(__WEBPACK_IMPORTED_MODULE_5_vuex__["b" /* mapActions */])('admin', ['getPatient', 'setStatus', 'setProviderInfo', 'createProvider']), Object(__WEBPACK_IMPORTED_MODULE_5_vuex__["b" /* mapActions */])('provider', ['getProviderIDFromGooglePlacesID', 'getProviderInfo']), {
    cancelRequest: function cancelRequest() {
      this.options.status = 'CANCELLED';
      this.setStatus({
        id: this.options.request._id,
        status: {
          status: this.options.status
        }
      });
      this.ok();
    },
    addUpdateProvider: function addUpdateProvider() {
      var _this = this;

      var removedBlankValues = {};
      removedBlankValues.address = {};
      if (this.suggestedProvider.address.line1 !== '') {
        removedBlankValues.address.line1 = this.suggestedProvider.address.line1;
      }

      if (this.suggestedProvider.address.line2 !== '') {
        removedBlankValues.address.line2 = this.suggestedProvider.address.line2;
      }

      if (this.suggestedProvider.address.city !== '') {
        removedBlankValues.address.city = this.suggestedProvider.address.city;
      }

      if (this.suggestedProvider.address.state !== '') {
        removedBlankValues.address.state = this.suggestedProvider.address.state;
      }

      if (this.suggestedProvider.address.zip !== '') {
        removedBlankValues.address.zip = this.suggestedProvider.address.zip;
      }

      var vm = this;

      __WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_object_keys___default()(this.suggestedProvider).forEach(function (key) {
        var value = vm.suggestedProvider[key];
        if (value !== '' && key !== 'address') {
          if (key === '_id' || key === 'googlePlaceID' || key === 'googlePlacesID' || key === 'affiliateCode' || key === 'coveredEntityName' || key === 'created' || key === 'modified' || key === 'notes' || key === 'modified' || key === 'npi') {
            // do nothing
          } else {
            if (value && value !== null && value !== 'undefined') {
              removedBlankValues[key] = value;
            }
          }
        }
      });

      this.setProviderInfo({
        id: this.backEndProviderObject._id,
        info: removedBlankValues
      }).then(function () {
        _this.getProviderInfo({ ids: [_this.backEndProviderObject._id] }).then(function (providersList) {
          console.log(providersList);
          _this.options.provider = providersList;
        });
      });

      var statusHere = 'NEEDS_FAX_NUMBER';
      this.options.request.status = statusHere;
      this.setStatus({
        id: this.options.request._id,
        status: {
          status: this.options.request.status,
          provider: this.backEndProviderObject._id
        }
      });

      this.backToStandardMode();
      // now update the provider
    },
    submitProviderNote: function submitProviderNote() {
      // this should patch the provider with just the notes field
      this.setProviderInfo({
        id: this.options.provider[0]._id,
        info: {
          notes: this.editProviderNote
        }
      });
      this.options.provider[0].notes = this.editProviderNote;

      this.providerNoteHasBeenEdited = false;
    },
    submitNotes: function submitNotes() {
      var userStamp = '';

      if (this.user) {
        userStamp = this.user.email;
      }

      var unix = Math.round(+new Date() / 1000);
      if (this.memo !== '' && this.memo !== null) {
        this.options.request.log.push({ timestamp: unix, message: userStamp + ': ' + this.memo });
      }
      this.memo = null;

      this.setStatus({
        id: this.options.request._id,
        status: {
          status: this.options.request.status,
          log: this.options.request.log
        }
      });
    },
    editCurrentProvider: function editCurrentProvider() {
      console.log('editing current provider');
      if (this.options.provider) {
        console.log(this.options);
        this.suggestedProvider = this.options.provider[0];
        this.providerEditViewMode = true;
        this.standardEditViewMode = false;
      }
    },
    addGoogleProvider: function addGoogleProvider() {
      if (this.suggestedProvider) {
        this.providerEditViewMode = true;
        this.standardEditViewMode = false;
      }
    },
    backToStandardMode: function backToStandardMode() {
      this.providerEditViewMode = false;
      this.standardEditViewMode = true;
    },
    placesIDLookup: function placesIDLookup(placesID) {
      var placeToPutThis = this.$refs.myDiv;
      var google = window.google;
      var request = {
        placeId: placesID
      };
      var vm = this;
      var callback = function callback(place, status) {
        if (status === google.maps.places.PlacesServiceStatus.OK) {
          console.log(place);
          var streetNumber = '';
          var streetName = '';
          var city = '';
          var state = '';
          var postalCode = '';
          var name = place.name;
          place.address_components.forEach(function (component) {
            // is this type a street address?
            if (component.types[0] === 'street_number') {
              streetNumber = component.long_name;
            }
            if (component.types[0] === 'route') {
              streetName = component.long_name;
            }
            if (component.types[0] === 'locality') {
              city = component.long_name;
            }
            if (component.types[0] === 'administrative_area_level_1') {
              state = component.short_name;
            }
            if (component.types[0] === 'locality') {
              city = component.long_name;
            }
            if (component.types[0] === 'postal_code') {
              postalCode = component.long_name;
            }
          });

          var purePhone = place.formatted_phone_number.replace(/\D/g, '');

          vm.suggestedProvider.googlePlaceID = place.place_id;
          vm.suggestedProvider.phone = purePhone;
          vm.suggestedProvider.type = 'ORGANIZATION';
          vm.suggestedProvider.organizationName = name;
          vm.suggestedProvider.address.line1 = streetNumber + ' ' + streetName;
          vm.suggestedProvider.address.city = city;
          vm.suggestedProvider.address.state = state;
          vm.suggestedProvider.address.zip = postalCode;
          vm.updateSuggestedProviderFromBackEnd();
        }
      };
      var service = new google.maps.places.PlacesService(placeToPutThis);
      service.getDetails(request, callback);
    },
    updateSuggestedProviderFromBackEnd: function updateSuggestedProviderFromBackEnd() {
      var _this2 = this;

      this.getProviderIDFromGooglePlacesID({ googlePlaceIDs: [this.suggestedProvider.googlePlaceID] }).then(function (data) {
        // now call get provider
        var vm2 = _this2;
        _this2.getProviderInfo({ ids: [data[0]._id] }).then(function (providersList) {
          vm2.backEndProviderObject = providersList[0];
          // reconcile the google data with the provider data.
          // back end should be preferred.
          // only for data where the google data is more complete

          var vm = vm2;
          // replace everything in the suggested provider with the back end info
          __WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_object_keys___default()(_this2.backEndProviderObject).forEach(function (key) {
            var value = vm.backEndProviderObject[key];
            if (value !== '' && value !== null && key !== 'address') {
              vm.suggestedProvider[key] = value;
            }
          });

          if (_this2.backEndProviderObject.address) {
            if (_this2.backEndProviderObject.address.line1 !== '') {
              _this2.suggestedProvider.address.line1 = _this2.backEndProviderObject.address.line1;
            }

            if (_this2.backEndProviderObject.address.line2 !== '') {
              _this2.suggestedProvider.address.line2 = _this2.backEndProviderObject.address.line2;
            }

            if (_this2.backEndProviderObject.address.city !== '') {
              _this2.suggestedProvider.address.city = _this2.backEndProviderObject.address.city;
            }

            if (_this2.backEndProviderObject.address.state !== '') {
              _this2.suggestedProvider.address.state = _this2.backEndProviderObject.address.state;
            }

            if (_this2.backEndProviderObject.address.zip !== '') {
              _this2.suggestedProvider.address.zip = _this2.backEndProviderObject.address.zip;
            }
          }
        });
      });
    },
    returnProviderDisplayName: function returnProviderDisplayName() {
      if (this.options) {
        if (this.options.provider) {
          if (this.options.provider[0].firstName) {
            return this.options.provider[0].firstName + ' ' + this.options.provider[0].lastName + ' ' + this.options.provider[0].credentials;
          }

          if (this.options.provider[0].coveredEntityName) {
            return this.options.provider[0].coveredEntityName;
          }

          if (this.options.provider[0].organizationName) {
            return this.options.provider[0].organizationName;
          }
        }
      }
    },
    convertDate: function convertDate(timestamp) {
      var d = new Date(timestamp * 1000);
      return d.getMonth() + 1 + '/' + d.getDate() + '/' + d.getFullYear();
    },
    unixDate: function unixDate(date) {
      if (date !== '') {
        var formatDate = date.slice(4, 8) + '.' + date.slice(0, 2) + '.' + date.slice(2, 4);
        // Format: '2012.08.10'
        return new Date(formatDate).getTime() / 1000;
      }
    },
    submit: function submit() {
      // this is a catch all for updating the request. this should handle updating emails, updating phone numbers, and updating fax numbers.
      // if a fax number is updated, the request should return to a "sending"
      // did the fax number change? if so, update the status

      if (this.editFax !== this.options.provider[0].fax || this.options.request.status === 'NEEDS_FAX_NUMBER') {
        // the fax number changed. the provider should be updated as well as the status should be changed
        this.options.request.status = 'SENDING';
      }

      this.edit = !this.edit;
      var unix = Math.round(+new Date() / 1000);

      if (this.options.provider[0].fax !== this.editFax || this.options.provider[0].phone !== this.editPhone || this.options.provider[0].email !== this.editEmail) {
        console.log(this.editEmail);
        var infoToSend = {};
        if (this.editFax) {
          infoToSend.fax = Number(this.editFax);
        }
        if (this.editEmail) {
          infoToSend.email = this.editEmail;
        }
        if (this.editPhone) {
          infoToSend.phone = Number(this.editPhone);
        }
        if (this.nextFollowUpDate) {
          infoToSend.nextFollowUp = this.unixDate(this.nextFollowUpDate);
        }
        var info = infoToSend;
        this.options.request.log.push({ timestamp: unix, message: 'Updating provider information' });
        this.setProviderInfo({
          id: this.options.provider[0]._id,
          info: info
        });
      }

      this.setStatus({
        id: this.options.request._id,
        status: {
          status: this.options.request.status,
          log: this.options.request.log
        }
      });
    },
    cancelEdit: function cancelEdit() {
      this.edit = !this.edit;

      if (this.options.provider) {
        this.options.provider[0].fax = this.fax;
        this.options.provider[0].phone = this.phone;
      }
      this.options.request.status = this.status;
    },
    clickEdit: function clickEdit() {
      this.edit = !this.edit;

      if (this.options.provider) {
        this.fax = this.options.provider[0].fax;
        this.phone = this.options.provider[0].phone;
      }
      this.status = this.options.request.status;
    },
    onClose: function onClose() {
      this.edit = false;
    },
    formatDate: function formatDate(timestamp) {
      var d = new Date(timestamp * 1000);
      var month = d.getMonth() + 1;
      var day = d.getDate();
      var year = d.getFullYear();

      if (month < 10) {
        month = '0' + month;
      }
      if (day < 10) {
        day = '0' + day;
      }
      return month + day + year;
    },
    onOpen: function onOpen() {
      this.memo = null;
      this.standardEditViewMode = true;
      this.providerEditViewMode = false;
      this.completedMode = false;
      this.proposeSuggestedProviderMode = false;
      if (this.options) {
        console.log('this is the selected element');
        console.log(this.options);
        if (this.options.request) {
          if (this.options.request.missingProviderInfo && !this.options.provider) {
            if (this.options.request.missingProviderInfo.includes(':')) {
              var placesIDArray = this.options.request.missingProviderInfo.split(':');
              var placesID = placesIDArray[1];
              this.placesIDLookup(placesID);
              // this should return a suggested provider
              this.proposeSuggestedProviderMode = true;
            }
          }
          if (this.options.request.nextFollowUp) {
            this.nextFollowUpDate = this.formatDate(this.options.request.nextFollowUp);
          }
        }
      }

      if (this.options.provider) {
        this.standardEditViewMode = true;
        this.providerEditViewMode = false;
        this.editFax = this.options.provider[0].fax;
        this.editPhone = this.options.provider[0].phone;
        this.editEmail = this.options.provider[0].email;
        this.editProviderNote = this.options.provider[0].notes;
      }

      if (this.options.request.status === 'COMPLETED') {
        this.standardEditViewMode = true;
        this.providerEditViewMode = false;
        this.completedMode = true;
      }

      this.editStatus = this.options.request.status;
      this.contentSet = true;
    },
    sortByDates: function sortByDates(a, b) {
      var dateA = a.timestamp;
      var dateB = b.timestamp;
      if (dateA > dateB) {
        return 1;
      }
      if (dateA < dateB) {
        return -1;
      }
      return 0;
    }
  }),
  computed: __WEBPACK_IMPORTED_MODULE_1_babel_runtime_helpers_extends___default()({}, Object(__WEBPACK_IMPORTED_MODULE_5_vuex__["d" /* mapState */])('auth', ['user']), {
    showBuilding: function showBuilding() {
      return this.options.unit && this.options.building;
    },
    suggestedAction: function suggestedAction() {
      if (this.options.request.status === 'MISSING_PROVIDER') {
        return 'Add Provider';
      }
      if (this.options.provider && this.showFullProviderEdit) {
        return 'Editing Provider';
      }
      if (this.options.request.status === 'SENT') {
        return 'Verify Delivery';
      }
      if (this.options.request.status === 'NEEDS_FAX_NUMBER') {
        return 'Update Fax';
      }
      if (this.options.request.status === 'COMPLETED') {
        return 'Completed';
      }
      return '';
    },
    logStamps: function logStamps() {
      var logStrings = [];
      var sortedLogs = this.options.request.log;

      sortedLogs.sort(function (a, b) {
        a = new Date(parseInt(a.timestamp) * 1000);
        b = new Date(parseInt(b.timestamp) * 1000);
        return a > b ? -1 : a < b ? 1 : 0;
      });
      sortedLogs.forEach(function (element) {
        var stamp = element.timestamp;
        var ts = new Date(parseInt(stamp) * 1000);
        var stampString = __WEBPACK_IMPORTED_MODULE_6_date_fns_format___default()(ts, 'MMM D YYYY HH:MM:ss Z');
        var message = element.message;

        var author = ' ';

        var messageHere = message;

        if (message.includes(':')) {
          var messageArray = message.split(':');
          var username = messageArray[0];

          if (username.includes('@')) {
            author = ' (' + username + '): ';
            messageHere = messageArray[1];
          }
        }

        var fullString = stampString + author + messageHere;
        logStrings.push(fullString);
      });
      return logStrings;
    }
  }),
  mounted: function mounted() {
    this.$on('close', this.onClose);
    this.$on('open', this.onOpen);
  }
});

/***/ }),
/* 258 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_extends__ = __webpack_require__(1);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_extends___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_extends__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__components_Titlebar__ = __webpack_require__(40);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_vuex__ = __webpack_require__(2);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3__components_cards_DataCard__ = __webpack_require__(619);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4__components_cards_InformationCard__ = __webpack_require__(622);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_5__core_mixins_HelperMixin__ = __webpack_require__(12);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_6__components_dialogs_AddEditProviderDialog__ = __webpack_require__(206);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_7_date_fns_format__ = __webpack_require__(59);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_7_date_fns_format___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_7_date_fns_format__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_8__core_helpers_bus__ = __webpack_require__(3);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_9__components_dialogs_ResendRequestDialog__ = __webpack_require__(625);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_10__components_RequestLogs__ = __webpack_require__(194);

//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//












/* harmony default export */ __webpack_exports__["a"] = ({
  mixins: [__WEBPACK_IMPORTED_MODULE_5__core_mixins_HelperMixin__["a" /* default */]],
  components: {
    Titlebar: __WEBPACK_IMPORTED_MODULE_1__components_Titlebar__["a" /* default */],
    DataCard: __WEBPACK_IMPORTED_MODULE_3__components_cards_DataCard__["a" /* default */],
    AddEditProviderDialog: __WEBPACK_IMPORTED_MODULE_6__components_dialogs_AddEditProviderDialog__["a" /* default */],
    InformationCard: __WEBPACK_IMPORTED_MODULE_4__components_cards_InformationCard__["a" /* default */],
    ResendRequestDialog: __WEBPACK_IMPORTED_MODULE_9__components_dialogs_ResendRequestDialog__["a" /* default */],
    RequestLogs: __WEBPACK_IMPORTED_MODULE_10__components_RequestLogs__["a" /* default */]
  },
  data: function data() {
    var _this = this;

    return {
      logEntryInput: null,
      updatingLog: false,
      publicNote: false,
      requestID: null,
      placesID: null,
      suggestedProvider: {
        googlePlaceID: '',
        type: '',
        firstName: '',
        lastName: '',
        credentials: '',
        specialization: '',
        organizationName: '',
        coveredEntityName: '',
        address: {
          line1: '',
          line2: '',
          city: '',
          state: '',
          zip: ''
        },
        phone: '',
        fax: '',
        email: '',
        notes: ''
      },
      numberOfPatients: null,
      smartChoiceCount: null,
      grayhawkCount: null,
      imagineMDCount: null,
      smartChoiceToday: null,
      smartChoice7Days: null,
      smartChoiceThisMonth: null,
      smartChoiceUserCount: null,
      smartChoiceUsersThisMonth: [],
      smartChoiceUsers: [],
      oneChartUsers: [],
      oneChartPatients: [],
      nonPartnerPatients: [],
      userCreatorsOfNonPartnerPatients: [],
      userPatientMatch: [],
      userIDsOfCreatorsOfPatients: [],
      patientCreatorUsers: [],
      nonPatientCreatorUsers: [],
      smartChoiceUsersLastMonth: [],
      smartChoiceUsersLastWeek: [],

      // Request field values
      requestField: {
        line1: {
          input: null,
          rules: [function (v) {
            return !!v || 'Street Address is required';
          }],
          label: 'Street Address'
        },
        line2: {
          input: null,
          label: 'PO Box, Apt'
        },
        city: {
          input: null,
          rules: [function (v) {
            return !!v || 'City is required';
          }],
          label: 'City'
        },
        state: {
          input: null,
          rules: [function (v) {
            return _this.stateValidation.includes(v) || 'Invalid State';
          }],
          label: 'State',
          mask: 'AA'
        },
        zip: {
          input: null,
          rules: [function (v) {
            return !!v || 'Zip Code is required';
          }],
          label: 'Zip'
        },
        fax: {
          input: null,
          label: 'Fax Number',
          mask: '(###) ###-####'
        },
        phone: {
          input: null,
          label: 'Phone Number',
          mask: '(###) ###-####'
        },
        email: {
          input: null,
          label: 'Email Address'
        }
      },

      // Provider field values
      providerField: {
        name: null
      },

      stateValidation: ['AL', 'AK', 'AS', 'AZ', 'AR', 'CA', 'CO', 'CT', 'DE', 'DC', 'FM', 'FL', 'GA', 'GU', 'HI', 'ID', 'IL', 'IN', 'IA', 'KS', 'KY', 'LA', 'ME', 'MH', 'MD', 'MA', 'MI', 'MN', 'MS', 'MO', 'MT', 'NE', 'NV', 'NH', 'NJ', 'NM', 'NY', 'NC', 'ND', 'MP', 'OH', 'OK', 'OR', 'PW', 'PA', 'PR', 'RI', 'SC', 'SD', 'TN', 'TX', 'UT', 'VT', 'VI', 'VA', 'WA', 'WV', 'WI', 'WY']
    };
  },

  methods: __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_extends___default()({}, Object(__WEBPACK_IMPORTED_MODULE_2_vuex__["b" /* mapActions */])('admin', ['getPatientList', 'getUserList', 'getRequest', 'getRequestProvider', 'setStatus', 'sendRequest', 'getRequestOverrides', 'submitRequestOverrides', 'submitRequestNote', 'getDocumentFiles']), {
    goToHelp: function goToHelp() {
      window.open('https://docs.google.com/document/d/1CfJaWj19kJcKLPTLPNvOU-2uveJkTth6vxcqNZ8Z7dk/edit?usp=sharing');
    }
  }, Object(__WEBPACK_IMPORTED_MODULE_2_vuex__["b" /* mapActions */])('provider', ['getProviderIDFromGooglePlacesID']), {
    toast: function toast(type, text) {
      __WEBPACK_IMPORTED_MODULE_8__core_helpers_bus__["a" /* default */].$emit('toast', { type: type, text: text });
    },
    viewProvider: function viewProvider() {
      console.log(this.request);
    },
    viewNPIDetails: function viewNPIDetails() {
      window.open('https://api.pverify.com/NPILOOKUP/NPI/NPIDetails/' + this.formatProviderNPI(this.request));
    },
    viewInGoogleMaps: function viewInGoogleMaps() {
      window.open('https://www.google.com/maps/place/?q=place_id:' + this.formatProviderGooglePlacesURL(this.request));
    },
    viewPatient: function viewPatient() {
      window.open('https://patient.onecharthealth.com/#/patients/' + this.request.patient);
    },
    viewRequest: function viewRequest() {
      window.open('https://api.onecharthealth.com/requests/' + this.requestID + '?alt=media');
    },
    publicNoteToggle: function publicNoteToggle() {
      if (this.publicNote) {
        this.publicNote = false;
      } else {
        this.publicNote = true;
      }
    },
    populateProviderFields: function populateProviderFields() {
      var address = this.requestProviderOverrides.providerAddressOverride;
      for (var key in this.requestField) {
        if (!this.requestField.hasOwnProperty(key)) continue;
        this.requestField[key].input = address[key];
      }

      this.requestField.email.input = this.requestProviderOverrides.providerEmailOverride;
      this.requestField.fax.input = this.requestProviderOverrides.providerFaxOverride;
      this.requestField.phone.input = this.requestProviderOverrides.providerPhoneOverride;
      this.providerField.name = this.requestProviderOverrides.providerNameOverride;
    },
    submitRequestChanges: function submitRequestChanges() {
      var _this2 = this;

      if (this.requestProviderOverrides.providerEmailOverride !== this.requestField.email.input) {
        if (this.requestField.email.input !== null && this.requestField.email.input.length === 0) {
          this.requestField.email.input = null;
        }
      }
      if (this.requestProviderOverrides.providerFaxOverride !== this.requestField.fax.input) {
        if (this.requestField.fax.input !== null && this.requestField.fax.input.length === 0) {
          this.requestField.fax.input = null;
        }
      }
      if (this.requestProviderOverrides.providerPhoneOverride !== this.requestField.phone.input) {
        if (this.requestField.phone.input !== null && this.requestField.phone.input.length === 0) {
          this.requestField.phone.input = null;
        }
      }

      var prov = {
        name: this.providerField.name,
        address: {
          line1: this.requestField.line1.input,
          line2: this.requestField.line2.input,
          city: this.requestField.city.input,
          state: this.requestField.state.input,
          zip: this.requestField.zip.input
        },
        email: this.requestField.email.input,
        fax: this.requestField.fax.input,
        phone: this.requestField.phone.input
      };
      this.submitRequestOverrides({ id: this.requestID, provider: prov }).then(function () {
        _this2.toast('success', 'Request Updated');
        if (_this2.checkIfRequestInformationComplete()) {
          _this2.setStatus({
            id: _this2.request.id,
            status: {
              status: 'SENDING'
            }
          }).then(function () {
            _this2.getRequest(_this2.requestID);
          });
        }
      }).catch(function (error) {
        _this2.toast('error', error);
        return error;
      });
    },
    checkNeedsNull: function checkNeedsNull(key, changedVal) {
      if (changedVal !== this.requestField[key].input) {
        if (this.requestField && this.requestField[key] && this.requstField[key].input && this.requestField[key].input.length === 0) {
          this.requestField[key].input = null;
        }
      }
    },
    updateProvider: function updateProvider() {
      var _this3 = this;

      var vm = this;
      vm.getRequestProvider(vm.requestID).then(function () {
        _this3.toast('success', 'Provider Updated');
      });
    },
    openPlacesID: function openPlacesID() {
      var url = 'https://www.google.com/maps/search/?api=1&query=Google&query_place_id=' + this.placesID;
      window.open(url);
    },
    editProvider: function editProvider() {
      this.$refs.addEditProviderDialog.open({
        id: this.request.provider.id,
        provider: this.request.provider
      });
    },
    convertDate: function convertDate(timestamp) {
      var d = new Date(timestamp * 1000);
      return d.getMonth() + 1 + '/' + d.getDate() + '/' + d.getFullYear();
    },
    cancelRequest: function cancelRequest() {
      var _this4 = this;

      this.setStatus({
        id: this.request.id,
        status: {
          status: 'CANCELLED'
        }
      }).then(function (data) {
        _this4.getRequest(_this4.requestID);
        _this4.toast('success', 'Request Cancelled');
      }).catch(function (error) {
        _this4.toast('error', error);
        return error;
      });
    },
    markError: function markError() {
      var _this5 = this;

      this.setStatus({
        id: this.request.id,
        status: {
          status: 'ERROR'
        }
      }).then(function (data) {
        _this5.getRequest(_this5.requestID);
        _this5.toast('success', 'Request Errored');
      }).catch(function (error) {
        _this5.toast('error', error);
        return error;
      });
    },
    completeRequest: function completeRequest() {
      var _this6 = this;

      this.setStatus({
        id: this.request.id,
        status: {
          status: 'COMPLETED'
        }
      }).then(function (data) {
        _this6.getRequest(_this6.requestID);
        _this6.toast('success', 'Request Completed');
      }).catch(function (error) {
        _this6.toast('error', error);
        return error;
      });
    },
    resendRequest: function resendRequest() {
      this.$refs.resendRequest.open({
        request: this.request
      });
    },
    resendRequestActual: function resendRequestActual() {
      var _this7 = this;

      if (this.requestProviderOverrides.providerFaxOverride || this.requestProviderOverrides.providerEmailOverride) {
        this.sendRequest({ id: this.requestID }).then(function (data) {
          _this7.setStatus({
            id: _this7.requestID,
            status: {
              status: 'SENDING'
            }
          }).then(function () {
            _this7.getRequest(_this7.requestID);
            _this7.toast('success', 'Request Sent');
          }).catch(function (error) {
            _this7.toast('error', error);
            return error;
          });
        });
      }
    },
    submitLogEntry: function submitLogEntry() {
      var _this8 = this;

      this.updatingLog = true;
      var email = '';
      if (this.user) {
        if (this.user.email) {
          email = '(' + this.user.email + ')';
        }
      }
      var unix = Math.round(+new Date() / 1000);
      if (this.logEntryInput !== '' && this.logEntryInput !== null) {
        this.submitRequestNote({
          id: this.requestID,
          notes: this.request.log,
          note: { timestamp: unix, message: this.logEntryInput + ' ' + email }
        }).then(function (data) {
          _this8.updatingLog = false;
          _this8.logEntryInput = null;
          _this8.publicNote = false;
          _this8.getRequest(_this8.requestID);
          _this8.toast('success', 'Note Submitted');
        });
      } else {
        this.updatingLog = false;
        this.toast('error', 'Note not Submitted');
      }
    },
    convertDateToDaysInProgress: function convertDateToDaysInProgress(timestamp) {
      var d = new Date(timestamp * 1000);
      var oneDay = 24 * 60 * 60 * 1000; // hours*minutes*seconds*milliseconds
      var firstDate = d;
      var secondDate = new Date();

      var diffDays = Math.round(Math.abs((firstDate.getTime() - secondDate.getTime()) / oneDay));

      return diffDays;
    },
    formatGoogleProviderName: function formatGoogleProviderName(provider) {
      if (provider) {
        if (provider.firstName) {
          return provider.firstName + ' ' + provider.lastName + ' ' + provider.credentials;
        } else if (provider.organizationName) {
          return provider.organizationName;
        }
      } else {
        return 'Provider Error';
      }
    },
    formatGoogleProviderAddress: function formatGoogleProviderAddress(provider) {
      if (provider) {
        if (provider.address) {
          return provider.address.line1 + ' ' + provider.address.city + ' ' + provider.address.state + ' ' + provider.address.zip;
        }
      } else {
        return 'Provider Error';
      }
    },
    formatProviderName: function formatProviderName(item) {
      if (item.provider) {
        if (item.provider.firstName) {
          return item.provider.firstName + ' ' + item.provider.lastName + ' ' + item.provider.credentials;
        } else if (item.provider.organizationName) {
          return item.provider.organizationName;
        }
      } else if (item.missingProviderInfo) {
        return 'Needs Attention';
      } else {
        return 'Provider Error';
      }
    },
    formatProviderAddress: function formatProviderAddress(item) {
      if (item.provider) {
        if (item.provider.address) {
          return item.provider.address.line1 + ' ' + item.provider.address.city + ' ' + item.provider.address.state + ' ' + item.provider.address.zip;
        }
      } else if (item.missingProviderInfo) {
        return 'Needs Attention';
      } else {
        return 'Provider Error';
      }
    },
    formatPatientAddress: function formatPatientAddress(item) {
      if (item.patient) {
        if (item.patient.address) {
          if (!item.patient.address.line2) {
            return item.patient.address.line1 + ' ' + item.patient.address.city + ' ' + item.patient.address.state + ' ' + item.patient.address.zip;
          } else {
            return item.patient.address.line1 + ' ' + item.patient.address.line2 + ' ' + item.patient.address.city + ' ' + item.patient.address.state + ' ' + item.patient.address.zip;
          }
        }
      } else if (item.missingProviderInfo) {
        return 'Needs Attention';
      } else {
        return 'Provider Error';
      }
    },
    formatProviderFax: function formatProviderFax(item) {
      if (item.provider) {
        if (item.provider.fax) {
          return item.provider.fax;
        } else {
          return '';
        }
      } else {
        return '';
      }
    },
    formatProviderEmail: function formatProviderEmail(item) {
      if (item.provider) {
        if (item.provider.email) {
          return item.provider.email;
        } else {
          return '';
        }
      } else {
        return '';
      }
    },
    formatProviderPhone: function formatProviderPhone(item) {
      if (item.provider) {
        if (item.provider.phone) {
          return item.provider.phone;
        } else {
          return '';
        }
      } else {
        return '';
      }
    },
    formatProviderNPI: function formatProviderNPI(item) {
      if (item.provider) {
        if (item.provider.npi) {
          if (item.provider.npi != null) {
            return item.provider.npi;
          }
        }
      }
      return null;
    },
    formatProviderGooglePlacesURL: function formatProviderGooglePlacesURL(item) {
      if (item.provider) {
        if (item.provider.googlePlaceID) {
          if (item.provider.googlePlaceID != null) {
            return item.provider.googlePlaceID;
          }
        }
      }
      return null;
    },
    formatPartnerName: function formatPartnerName(item) {
      if (item.partner) {
        return item.partner;
      } else {
        return 'Consumer';
      }
    },
    formatPatientName: function formatPatientName(item) {
      if (item.patient) {
        if (item.patient.firstName) {
          return item.patient.firstName + ' ' + item.patient.lastName;
        } else {
          return 'Click View Patient';
        }
      } else {
        return 'Click View Patient';
      }
    },
    formatPatientBirthdate: function formatPatientBirthdate(item) {
      if (item.patient) {
        if (item.patient.birthdate) {
          return this.convertDate(item.patient.birthdate);
        } else {
          return 'Click View Patient';
        }
      } else {
        return 'Click View Patient';
      }
    },
    exportDataSet: function exportDataSet(dataSet) {
      var csvContent = 'data:text/csv;charset=utf-8,';
      csvContent += dataSet.join(',\n');
      var encodedUri = encodeURI(csvContent);
      window.open(encodedUri);
    },
    createUserPatientMatch: function createUserPatientMatch() {
      var _this9 = this;

      if (this.userSearchResults && this.userIDsOfCreatorsOfPatients.length > 0) {
        this.userSearchResults.forEach(function (user) {
          if (!_this9.userIDsOfCreatorsOfPatients.includes(user.id)) {
            if (!_this9.patientCreatorUsers.includes(user)) {
              _this9.patientCreatorUsers.push(user);
            }
          } else {
            if (!_this9.nonPatientCreatorUsers.includes(user)) {
              _this9.nonPatientCreatorUsers.push(user);
            }
          }
        });
      }
    },
    goToDocumentPage: function goToDocumentPage(id) {
      this.$router.push({
        name: 'AdminDocumentPage',
        params: { id: id }
      });
    },
    checkIfRequestInformationComplete: function checkIfRequestInformationComplete() {
      if (this.request.status === 'MISSING_INFO') {
        // Checking if the provider has a name, address info, and either email or fax
        if (this.request.provider && this.request.provider.firstName && this.request.provider.lastName && this.request.provider.address && this.request.provider.address.city && this.request.provider.address.line1 && this.request.provider.address.state && this.request.provider.address.zip && (this.request.provider.email || this.request.provider.fax)) {
          // Fields are valid to send
          return true;
        }
        // If the fields are not valid
        return false;
      }
      // If the status is not MISSING_INFO continue
      return true;
    },
    TEST_SET_BROKEN_REQUEST: function TEST_SET_BROKEN_REQUEST() {
      var _this10 = this;

      var prov = {
        name: this.providerField.firstName + ' ' + this.providerField.lastName,
        address: {
          line1: this.requestField.line1.input,
          line2: this.requestField.line2.input,
          city: this.requestField.city.input,
          state: this.requestField.state.input,
          zip: this.requestField.zip.input
        },
        email: this.requestField.email.input,
        fax: null,
        phone: this.requestField.phone.input
      };
      this.submitRequestOverrides({ id: this.requestID, provider: prov }).then(function () {
        _this10.toast('success', 'Request Updated');
      }).catch(function (error) {
        _this10.toast('error', error);
        return error;
      });

      this.setStatus({
        id: this.request.id,
        status: {
          status: 'MISSING_INFO'
        }
      });
    },
    parseTimestamp: function parseTimestamp(timestamp) {
      var ts = new Date(parseInt(timestamp) * 1000);
      return __WEBPACK_IMPORTED_MODULE_7_date_fns_format___default()(ts, 'MMM D YYYY HH:MM:ss Z');
    },
    alternatingColors: function alternatingColors(index) {
      if (index % 2 === 0) {
        return 'whiteAlternate';
      } else {
        return 'grayAlternate';
      }
    }
  }),
  computed: __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_extends___default()({}, Object(__WEBPACK_IMPORTED_MODULE_2_vuex__["d" /* mapState */])('admin', ['patientSearchResults', 'userSearchResults', 'request', 'files']), Object(__WEBPACK_IMPORTED_MODULE_2_vuex__["d" /* mapState */])('auth', ['user']), {
    requestURL: function requestURL() {
      return 'https://api.onecharthealth.com/requests/' + this.requestID + '?alt=media';
    },
    requestProviderOverrides: function requestProviderOverrides() {
      // this is a replacement for the call
      var objectToReturn = {
        id: this.request.id,
        providerAddressOverride: this.request.providerAddressOverride,
        providerFaxOverride: this.request.providerFaxOverride,
        providerEmailOverride: this.request.providerEmailOverride,
        providerPhoneOverride: this.request.providerPhoneOverride,
        providerNameOverride: this.request.providerNameOverride
      };
      return objectToReturn;
    },
    publicProviderButtonName: function publicProviderButtonName() {
      if (this.publicNote) {
        return 'Make Private';
      } else {
        return 'Make Public';
      }
    },
    logStamps: function logStamps() {
      var logStrings = [];
      var sortedLogs = this.request.log;

      sortedLogs.sort(function (a, b) {
        a = new Date(parseInt(a.timestamp) * 1000);
        b = new Date(parseInt(b.timestamp) * 1000);
        return a > b ? -1 : a < b ? 1 : 0;
      });
      sortedLogs.forEach(function (element) {
        var stamp = element.timestamp;
        var ts = new Date(parseInt(stamp) * 1000);
        var stampString = __WEBPACK_IMPORTED_MODULE_7_date_fns_format___default()(ts, 'MMM D YYYY HH:MM:ss Z');
        var message = element.message;

        var messageHere = message;

        var fullString = stampString + ' ' + messageHere;
        logStrings.push(fullString);
      });
      return logStrings;
    },
    providerInformation: function providerInformation() {
      var providerInformation = {};

      providerInformation.title = 'Provider Information';
      if (this.request) {
        providerInformation.data = [{
          title: 'Name',
          data: this.formatProviderName(this.request)
        }, {
          title: 'Address',
          data: this.formatProviderAddress(this.request)
        }, {
          title: 'MR Phone',
          data: this.formatProviderPhone(this.request)
        }, {
          title: 'MR Fax',
          data: this.formatProviderFax(this.request)
        }, {
          title: 'MR Email',
          data: this.formatProviderEmail(this.request)
        }, {
          title: 'Google Places ID',
          data: this.formatProviderGooglePlacesURL(this.request)
        }, {
          title: 'Provider Note',
          data: this.request.provider.notes
        }];
      } else {
        return null;
      }
      return providerInformation;
    },
    requestInformation: function requestInformation() {
      var requestInformation = {};
      requestInformation.title = 'Request Information';
      requestInformation.data = [{
        title: 'Date Requested',
        data: this.convertDate(this.request.created)
      }, requestInformation.data = {
        title: 'Dates of Service',
        data: this.convertDate(this.request.start)
      }, requestInformation.data = {
        title: 'Status',
        data: this.request.status
      }];
      return requestInformation;
    },
    patientInformation: function patientInformation() {
      var patientInformation = {};
      patientInformation.title = 'Patient Information';
      patientInformation.data = [{
        title: 'Name',
        data: this.formatPatientName(this.request)
      }, patientInformation.data = {
        title: 'Date of birth',
        data: this.formatPatientBirthdate(this.request)
      }, patientInformation.data = {
        title: 'Address',
        data: this.formatPatientAddress(this.request)
      }];
      return patientInformation;
    }
  }),
  watch: {
    request: function request(val) {
      var _this11 = this;

      if (this.request) {
        if (this.request.missingProviderInfo && !this.request.provider) {
          if (this.request.missingProviderInfo.includes(':')) {
            var placesIDArray = this.request.missingProviderInfo.split(':');
            this.placesID = placesIDArray[1];
            // this is a google places request. we should see if a provider exists with this information.
            // look up provider by google places ID
            this.getProviderIDFromGooglePlacesID({
              googlePlaceIDs: [this.placesID]
            }).then(function (data) {
              // this will either return a provider with data or create a blank provider to put data in.
              // the request does neet to be updated with this provider.
              var statusToSet = 'NEEDS_FAX_NUMBER';
              if (data.fax) {
                statusToSet = 'SENDING';
              }
              _this11.setStatus({
                id: _this11.request.id,
                status: {
                  provider: data[0]._id,
                  status: statusToSet
                }
              }).then(function (data) {
                _this11.getRequest(_this11.requestID);
              });
            });
          }
        } else if (this.request.missingProviderInfo) {
          if (this.request.missingProviderInfo.includes(':')) {
            var _placesIDArray = this.request.missingProviderInfo.split(':');
            this.placesID = _placesIDArray[1];
            // this has a provider assigned as well. it may be missing information
          }
        }
      }
    },
    userSearchResults: function userSearchResults() {
      if (!this.userPatientMatch.length > 0) {
        this.createUserPatientMatch();
      }
      this.oneChartUsers = this.userSearchResults.length;
    },
    patientSearchResults: function patientSearchResults() {
      var _this12 = this;

      this.oneChartPatients = this.patientSearchResults;
      this.smartChoiceCount = 0;
      this.grayhawkCount = 0;
      this.imagineMDCount = 0;
      this.smartChoiceToday = 0;
      this.smartChoice7Days = 0;
      this.smartChoiceThisMonth = 0;
      this.smartChoiceUserCount = 0;
      this.smartChoiceUsersThisMonth = [];

      this.smartChoiceUsers = [];

      var todayCuttoffDate = new Date();
      todayCuttoffDate.setHours(0, 0, 0, 0);
      var todayCuttoff = todayCuttoffDate.getTime() / 1000;

      var sevenDayCutoff = todayCuttoffDate.getTime() / 1000;
      sevenDayCutoff = sevenDayCutoff - 604800;

      var thisMonthCutOff = this.getTimestampOfStartOfThisMonth();

      var previousMonthCutOff = this.getTimestampOfStartOfPreviousMonth();

      this.patientSearchResults.forEach(function (patient) {
        if (patient.creator) {
          if (!_this12.userIDsOfCreatorsOfPatients.includes(patient.creator.id)) {
            _this12.userIDsOfCreatorsOfPatients.push(patient.creator.id);
          }
        }
        if (patient.partner) {
          if (patient.partner.id === '5a4fa82c8e4b74e028665d04') {
            _this12.smartChoiceCount = _this12.smartChoiceCount + 1;
            if (patient.creator) {
              if (!_this12.smartChoiceUsers.includes(patient.creator)) {
                if (patient.creator.email) {
                  if (!_this12.smartChoiceUsers.includes(patient.creator.email)) {
                    _this12.smartChoiceUsers.push(patient.creator.email);
                  }
                }
                if (patient.creator.created) {
                  if (patient.creator.created > thisMonthCutOff) {
                    if (!_this12.smartChoiceUsersThisMonth.includes(patient.creator.email)) {
                      _this12.smartChoiceUsersThisMonth.push(patient.creator.email);
                    }
                    if (patient.creator.created > sevenDayCutoff) {
                      if (!_this12.smartChoiceUsersLastWeek.includes(patient.creator.email)) {
                        _this12.smartChoiceUsersLastWeek.push(patient.creator.email);
                      }
                    }
                  } else if (patient.creator.created > previousMonthCutOff) {
                    if (!_this12.smartChoiceUsersLastMonth.includes(patient.creator.email)) {
                      _this12.smartChoiceUsersLastMonth.push(patient.creator.email);
                    }
                  }
                }
              }
            }
            if (patient.creator) {}
            if (patient.created > todayCuttoff) {
              _this12.smartChoiceToday = _this12.smartChoiceToday + 1;
            }
            if (patient.created > sevenDayCutoff) {
              _this12.smartChoice7Days = _this12.smartChoice7Days + 1;
            }
          }
          if (patient.partner.id === '5acb94000495d7065c909bc2') {
            _this12.grayhawkCount = _this12.grayhawkCount + 1;
          }
          if (patient.partner.id === '5b73507c4aef2028740f662b') {
            _this12.imagineMDCount = _this12.imagineMDCount + 1;
          }
        } else {
          if (!_this12.nonPartnerPatients.includes(patient)) {
            _this12.nonPartnerPatients.push(patient);
            if (patient.creator) {
              if (!_this12.userCreatorsOfNonPartnerPatients.includes(patient.creator)) {
                _this12.userCreatorsOfNonPartnerPatients.push(patient.creator);
              }
            }
          }
        }
      });

      this.numberOfPatients = this.smartChoiceCount;
      this.smartChoiceUserCount = this.smartChoiceUsers.length;
      if (!this.userPatientMatch.length > 0) {
        this.createUserPatientMatch();
      }
    }
  },
  created: function created() {
    var vm = this;
    vm.requestID = vm.$route.params.id;
  },
  mounted: function mounted() {}
  // const vm = this

  // vm.getRequest(this.$route.params.id).then(() => {
  //   this.getRequestOverrides({ id: this.$route.params.id }).then(data => {
  //   })
  // })

  // vm.getDocumentFiles({ requestID: vm.$route.params.id }).then(() => {})

  // TODO: Clear files from store

});

/***/ }),
/* 259 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//


/* harmony default export */ __webpack_exports__["a"] = ({
  name: 'FileCard',
  props: {
    dataValue: {
      type: Number,
      default: null
    },
    labelValue: {
      type: String,
      default: ''
    },
    partnerValue: {
      type: String,
      default: ''
    }
  }
});

/***/ }),
/* 260 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//

/* harmony default export */ __webpack_exports__["a"] = ({
  name: 'FileCard',
  props: {
    title: {
      type: String,
      default: 'NO TITLE PROVIDED'
    },
    data: {
      type: Array,
      default: []
    }
  }
});

/***/ }),
/* 261 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_extends__ = __webpack_require__(1);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_extends___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_extends__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__components_cards_ProviderCard__ = __webpack_require__(214);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__core_mixins_DialogMixin__ = __webpack_require__(5);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3_vuex__ = __webpack_require__(2);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4__core_helpers_bus__ = __webpack_require__(3);

//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//






/* harmony default export */ __webpack_exports__["a"] = ({
  name: 'OneProviderInfoDialog',
  mixins: [__WEBPACK_IMPORTED_MODULE_2__core_mixins_DialogMixin__["a" /* default */]],
  components: {
    ProviderCard: __WEBPACK_IMPORTED_MODULE_1__components_cards_ProviderCard__["a" /* default */]
  },
  data: function data() {
    return {
      faxInput: null,
      emailInput: null,
      recipientUpdated: false
    };
  },

  computed: {},
  mounted: function mounted() {
    this.$on('open', this.onOpen);
  },

  methods: __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_extends___default()({}, Object(__WEBPACK_IMPORTED_MODULE_3_vuex__["b" /* mapActions */])('admin', ['getPatientList', 'getUserList', 'getRequest', 'getRequestProvider', 'setStatus', 'sendRequest', 'getRequestOverrides', 'submitRequestOverrides', 'submitRequestNote', 'getDocumentFiles', 'updateFaxOrEmail']), {
    resendRequest: function resendRequest() {
      var _this = this;

      if (this.recipientUpdated) {
        this.updateFaxOrEmail({ id: this.options.request.id, fax: this.faxInput, email: this.emailInput }).then(function (data) {
          _this.sendRequest({ id: _this.options.request.id }).then(function () {
            _this.toast('success', 'Sending Request');
            _this.close();
          }).catch(function (error) {
            _this.toast('error', error);
            return error;
          });
        }).catch(function (error) {
          _this.toast('error', error);
          return error;
        });
      } else {
        console.log('no info updated');
        this.sendRequest({ id: this.options.request.id }).then(function () {
          _this.toast('success', 'Sending Request');
          _this.close();
        }).catch(function (error) {
          _this.toast('error', error);
          return error;
        });
      }
    },
    toast: function toast(type, text) {
      __WEBPACK_IMPORTED_MODULE_4__core_helpers_bus__["a" /* default */].$emit('toast', { type: type, text: text });
    },
    close: function close() {
      this.cancel();
    },
    onOpen: function onOpen() {
      this.recipientUpdated = false;
      if (this.options.request) {
        if (this.options.request.providerFaxOverride) {
          this.faxInput = this.options.request.providerFaxOverride;
        } else {
          this.faxInput = null;
        }
        if (this.options.request.providerEmailOverride) {
          this.emailInput = this.options.request.providerEmailOverride;
        } else {
          this.emailInput = null;
        }
      }
    }
  }),
  watch: {}
});

/***/ }),
/* 262 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_extends__ = __webpack_require__(1);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_extends___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_extends__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_vuex__ = __webpack_require__(2);

//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//



/* harmony default export */ __webpack_exports__["a"] = ({
  name: 'AdminDocumentsPage',
  data: function data() {
    return {
      headers: [{
        text: 'Document ID'
      }, {
        text: 'Creation Date'
      }, {
        text: 'Faxed From'
      }],
      rowsPerPageItems: [25, 50, 100],
      currentPagination: {
        rowsPerPage: 25
      }
    };
  },

  methods: __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_extends___default()({}, Object(__WEBPACK_IMPORTED_MODULE_1_vuex__["b" /* mapActions */])('admin', ['getFiles']), {
    convertDate: function convertDate(timestamp) {
      var d = new Date(timestamp * 1000);
      return d.getMonth() + 1 + '/' + d.getDate() + '/' + d.getFullYear();
    },
    alternatingColors: function alternatingColors(index) {
      if (index % 2 === 0) {
        return 'whiteAlternate';
      } else {
        return 'grayAlternate';
      }
    },
    goToDocumentPage: function goToDocumentPage(id) {
      this.$router.push({
        name: 'AdminDocumentPage',
        params: { id: id }
      });
    },
    updatePagination: function updatePagination(pag) {
      this.getFiles({
        limit: this.currentPagination.rowsPerPage,
        offset: (pag.page - 1) * pag.rowsPerPage
      });

      console.log('update:pagination', pag);
    }
  }),
  computed: __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_extends___default()({}, Object(__WEBPACK_IMPORTED_MODULE_1_vuex__["d" /* mapState */])('admin', ['files', 'totalItems', 'pagination'])),
  // watch: {
  //   currentPagination(amount) {
  //     this.getFiles({ limit: this.currentPagination.rowsPerPage })
  //   }
  // },
  mounted: function mounted() {
    this.getFiles({ limit: this.currentPagination.rowsPerPage });
  }
});

/***/ }),
/* 263 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_extends__ = __webpack_require__(1);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_extends___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_extends__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_vuex__ = __webpack_require__(2);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__core_helpers_bus__ = __webpack_require__(3);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3__components_dialogs_AdvancedPatientSearchAdmin__ = __webpack_require__(216);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4__components_dialogs_PatientSearchDialog__ = __webpack_require__(634);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_5__components_dialogs_FileDialog__ = __webpack_require__(218);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_6__components_PatientAssignment__ = __webpack_require__(637);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_7__components_dialogs_ConfirmAssignmentDialog__ = __webpack_require__(640);

//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//









/* harmony default export */ __webpack_exports__["a"] = ({
  name: 'AdminDocumentsPage',
  components: {
    AdvancedPatientSearchAdmin: __WEBPACK_IMPORTED_MODULE_3__components_dialogs_AdvancedPatientSearchAdmin__["a" /* default */],
    PatientSearchDialog: __WEBPACK_IMPORTED_MODULE_4__components_dialogs_PatientSearchDialog__["a" /* default */],
    FileDialog: __WEBPACK_IMPORTED_MODULE_5__components_dialogs_FileDialog__["a" /* default */],
    PatientAssignment: __WEBPACK_IMPORTED_MODULE_6__components_PatientAssignment__["a" /* default */],
    ConfirmAssignmentDialog: __WEBPACK_IMPORTED_MODULE_7__components_dialogs_ConfirmAssignmentDialog__["a" /* default */]
  },
  data: function data() {
    return {
      // Document information
      fileURL: null,
      headers: {},
      documentId: null,

      // Patient search
      patientID: null,
      patientInfo: null,
      requestID: null,
      providerID: null,
      providerInfo: null,
      orginalProviderInfo: null,
      orginalRequestInfo: null,
      patientRequestChanges: false,
      patientLabel: 'Patient',

      // Date of care
      dateOfCareInput: null,
      dateOfCareMask: '##/##/####',
      dateOfCareHint: 'mm/dd/yyyy',
      dateOfCareLabel: 'Date of Care',

      // Document Type
      typeInput: { text: 'UNKNOWN', value: 'UNKNOWN' },
      typeLabel: 'Document Type',
      recordTypes: [],

      // Document Description
      description: null,
      descriptionLabel: 'Document Description',

      // Loading statuses
      patientLoading: true,
      providerLoading: true,
      documentLoading: true,

      // Iframe
      iframeSource: null
    };
  },

  methods: __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_extends___default()({}, Object(__WEBPACK_IMPORTED_MODULE_1_vuex__["b" /* mapActions */])('admin', ['getFile', 'setFileInfo', 'getRecordTypes', 'setStatus', 'getDocumentProvider', 'getPatients', 'getPatient', 'openFile', 'viewFile']), Object(__WEBPACK_IMPORTED_MODULE_1_vuex__["b" /* mapActions */])('provider', ['getProviderIDFromNPI', 'search']), {
    submitDocumentChanges: function submitDocumentChanges() {
      var vm = this;
      var file = {};

      if (vm.providerID) {
        file.renderingProvider = vm.providerID;
      }
      if (vm.patientID) {
        file.patient = this.patientID;
      }
      if (vm.dateOfCareInput) {
        file.encounterDate = vm.unixEncounterDate(vm.dateOfCareInput);
      }
      if (vm.typeInput) {
        if (vm.typeInput.value) {
          file.recordType = vm.typeInput.value;
        } else {
          file.recordType = vm.typeInput;
        }
      }
      if (vm.description) {
        file.description = vm.description;
      }
      if (vm.requestID) {
        file.request = vm.requestID;
        vm.setRequestToComplete(vm.requestID);
      }

      vm.setFileInfo({ file: file, id: vm.documentId }).then(function () {
        vm.toast('success', 'Document successfully updated');
      });
    },
    patientSearch: function patientSearch() {
      this.$refs.patientSearch.open();
    },
    archiveFile: function archiveFile() {
      var vm = this;
      var file = {};
      file.archived = true;

      vm.setFileInfo({ file: file, id: vm.documentId }).then(function () {
        vm.toast('success', 'Document archived');
      });
    },

    // Formatting the encounter date, format example: '2012.08.10 (YYYY-MM-DD)'
    unixEncounterDate: function unixEncounterDate(date) {
      if (date !== '') {
        var formatDate = date.slice(0, 2) + '/' + date.slice(2, 4) + '/' + date.slice(4, 8);
        console.log(new Date(formatDate).getTime() / 1000);
        console.log(new Date(formatDate).getTime() / 1000);
        return new Date(formatDate).getTime() / 1000;
      }
    },
    toast: function toast(type, text) {
      __WEBPACK_IMPORTED_MODULE_2__core_helpers_bus__["a" /* default */].$emit('toast', { type: type, text: text });
    },
    showPatientSearch: function showPatientSearch() {
      this.$refs.patientSearchDialog.open({});
    },
    openFile2: function openFile2(file) {
      this.$refs.fileDialog.open({
        file: file
      });
    },
    convertDate: function convertDate(timestamp) {
      var d = new Date(timestamp * 1000);

      var month = d.getMonth();
      var day = d.getDate();
      var year = d.getFullYear();

      var monthStringExtra = '';
      var dayStringExtra = '';

      if (month < 10) {
        monthStringExtra = '0';
      }
      if (day < 10) {
        dayStringExtra = '0';
      }

      var date = monthStringExtra + (month + 1).toString() + dayStringExtra + day.toString() + year;
      return date;
    },

    // TODO: Deprecated
    openSelectedFileDialog: function openSelectedFileDialog(fileBundle) {
      console.log(fileBundle);
      var file = fileBundle;
      this.openFile(file);
    },
    loadIframe: function loadIframe(fileBundle) {
      console.log(fileBundle);
      // get the url of the files to be displayed
      var url = null;
      switch (fileBundle.mimetype) {
        case 'application/dicom+zip':
          var imgs = fileBundle;
          var q = [];
          for (var i = 0; i < imgs.length; i++) {
            var img = imgs[i];
            q.push(img._id, img.dicomNumFiles, img.accessToken);
          }
          if (!this.isMobile) {
            url = 'https://onechart-clinical-viewer.firebaseapp.com/' + '?study=' + q.join(',');
          } else {
            url = "https://onechart-image-viewer.firebaseapp.com/" + '?study=' + q.join(',');
          }
          break;
        case 'application/pdf':
          url = fileBundle.downloadURL + '?alt=media&token=' + fileBundle.accessToken;
          var fileUrl = "https://onechart-pdf-viewer.firebaseapp.com/" + '?file=' + encodeURIComponent(url);
          url = fileUrl;
          break;
      }
      this.iframeSource = url;
    },
    selectPatientAndRequest: function selectPatientAndRequest(vals) {
      this.patientID = vals.patient;
      if (vals.request) {
        this.requestID = vals.request;
        this.fillOutDocInfoFromRequest(vals.request);
        this.providerInfo = vals.provider;
        this.providerID = vals.provider.id;
      }
      this.patientRequestChanges = true;
    },
    fillOutDocInfoFromRequest: function fillOutDocInfoFromRequest() {},
    setRequestToComplete: function setRequestToComplete(requestID) {
      this.setStatus({
        id: requestID,
        status: {
          status: 'COMPLETED'
        }
      });
    },
    cancel: function cancel() {
      if (this.orginalProviderInfo) {
        this.providerID = this.orginalProviderInfo.id;
      } else this.providerID = null;
      this.providerInfo = this.orginalProviderInfo;

      if (this.orginalRequestInfo) {
        this.requestID = this.orginalRequestInfo;
      } else {
        this.requestID = null;
      }

      this.patientRequestChanges = false;
    },
    tieDocumentAndRequest: function tieDocumentAndRequest() {
      var _this = this;

      if (this.requestID) {
        var file = {
          request: this.requestID
        };

        this.setFileInfo({ file: file, id: this.documentId }).then(function () {
          _this.toast('success', 'Request and document successfully tied');
        });
      }
    },
    confirmAssignment: function confirmAssignment(payload) {
      this.$refs.confirmAssignment.open({
        payload: payload
      });
    },
    assignDocumentToPatient: function assignDocumentToPatient(payload) {
      var _this2 = this;

      var file = {};
      if (payload.provider) {
        file.renderingProvider = payload.provider;
      }
      if (payload.request) {
        file.request = payload.request;
        this.setRequestToComplete(payload.request);
      }
      if (payload.patient) {
        file.patient = payload.patient;
        this.setFileInfo({ file: file, id: this.documentId }).then(function () {
          _this2.toast('success', 'Document Filed to Chart');
        });
      } else {
        this.toast('error', 'No Patient Selected');
      }
    }
  }),
  computed: __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_extends___default()({}, Object(__WEBPACK_IMPORTED_MODULE_1_vuex__["d" /* mapState */])('admin', ['file', 'documentProvider']), Object(__WEBPACK_IMPORTED_MODULE_1_vuex__["d" /* mapState */])('provider', ['searchResults']), {
    providerDisplay: function providerDisplay() {
      if (!this.providerID) {
        return null;
      } else if (this.providerInfo) {
        if (this.providerInfo.firstName && this.providerInfo.lastName) {
          return this.providerInfo.firstName + ' ' + this.providerInfo.lastName;
        } else if (this.providerInfo.organizationName) {
          return this.providerInfo.organizationName;
        } else {
          return this.providerID;
        }
      }
    },
    patientDisplay: function patientDisplay() {
      var _this3 = this;

      if (!this.patientID) {
        this.patientLoading = false;
        return null;
      } else if (!this.patientInfo || this.patientInfo.id !== this.patientID) {
        this.patientLoading = true;
        this.getPatient({ id: this.patientID }).then(function (patient) {
          _this3.patientInfo = patient;
          _this3.patientLoading = false;
          return _this3.patientInfo.firstName + ' ' + _this3.patientInfo.lastName;
        });
      } else {
        this.patientLoading = false;
        return this.patientInfo.firstName + ' ' + this.patientInfo.lastName;
      }
    }
  }),
  mounted: function mounted() {
    var _this4 = this;

    this.viewFile(this.$route.params.id).then(function (data) {
      console.log('view file is back');
      console.log(data);
      _this4.fileURL = data;
    });
  },
  created: function created() {
    var _this5 = this;

    var vm = this;

    this.getRecordTypes().then(function (data) {
      var tempRT = [];
      for (var d in data.data) {
        tempRT.push({ text: data.data[d], value: data.data[d] });
      }
      _this5.recordTypes = tempRT;
    });

    vm.documentId = vm.$route.params.id;
    this.getFile(vm.documentId).then(function () {
      var file = vm.file[0];
      // openSelectedFileDialog(file)
      if (vm.file[0]) {
        vm.loadIframe(vm.file[0]);
      }

      if (file.patient && file.patient.id) {
        vm.patientID = file.patient.id;
      } else {
        vm.patientLoading = false;
      }

      if (file.renderingProvider && file.renderingProvider.id) {
        vm.providerID = file.renderingProvider.id;
        vm.getDocumentProvider({ id: vm.providerID }).then(function (providerInfo) {
          vm.orginalProviderInfo = providerInfo;
          vm.providerInfo = providerInfo;
          vm.providerLoading = false;
        });
      } else {
        vm.providerLoading = false;
      }
      if (file.encounterDate) {
        vm.dateOfCareInput = vm.convertDate(file.encounterDate);
      }
      if (file.recordType) {
        var tempType = { text: '', value: '' };
        tempType.text = file.recordType;
        tempType.value = file.recordType;

        vm.typeInput = tempType;
      }
      if (file.request && file.request.id) {
        vm.orginalRequestInfo = file.request.id;
        vm.requestID = file.request.id;
      }
      if (file.description) {
        vm.description = file.description;
      }
    });

    this.documentLoading = false;
  }
});

/***/ }),
/* 264 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_extends__ = __webpack_require__(1);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_extends___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_extends__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__core_components_Avatar__ = __webpack_require__(20);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__core_mixins_DialogMixin__ = __webpack_require__(5);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3__core_mixins_HelperMixin__ = __webpack_require__(12);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4__core_helpers_bus__ = __webpack_require__(3);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_5_vuex__ = __webpack_require__(2);

//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//







/* harmony default export */ __webpack_exports__["a"] = ({
  name: 'OneConfirmDialog',
  mixins: [__WEBPACK_IMPORTED_MODULE_2__core_mixins_DialogMixin__["a" /* default */], __WEBPACK_IMPORTED_MODULE_3__core_mixins_HelperMixin__["a" /* default */]],
  components: {
    Avatar: __WEBPACK_IMPORTED_MODULE_1__core_components_Avatar__["a" /* default */]
  },
  data: function data() {
    return {
      // selected patient string
      selectedPatientString: null,
      // State control
      searching: false,

      // Patient Data Table
      isLoading: false,
      resultsEmpty: false,
      headers: [{
        text: 'Name',
        align: 'left',
        sortable: false,
        value: 'fullName'
      }, {
        text: 'Patient ID',
        align: 'left',
        sortable: false,
        value: 'id'
      }, {
        text: 'Gender',
        align: 'left',
        sortable: false,
        value: 'gender'
      }, {
        text: 'Birth date',
        align: 'left',
        sortable: false,
        value: 'birthdateString'
      }, {
        text: '',
        align: 'right',
        sortable: false,
        value: 'action'
      }],

      // Patient Requests Datatable
      requestHeaders: [{
        text: 'Provider',
        align: 'left',
        sortable: false,
        value: 'id'
      }, {
        text: 'Address',
        align: 'left',
        sortable: false,
        value: 'date'
      }, {
        text: 'Dates of Service',
        align: 'left',
        sortable: false,
        value: 'date'
      }, {
        text: '',
        align: 'right',
        sortable: false,
        value: 'action'
      }],

      // Search Fields
      patientFields: {
        firstName: '',
        lastName: '',
        id: '',
        DOB: ''
      },

      // Selected Values
      selectedPatient: null,
      selectedRequest: null
    };
  },

  methods: __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_extends___default()({}, Object(__WEBPACK_IMPORTED_MODULE_5_vuex__["b" /* mapActions */])('admin', ['getPatients', 'getPatientRequests']), Object(__WEBPACK_IMPORTED_MODULE_5_vuex__["c" /* mapMutations */])('admin', ['setPatientRequest']), {
    toast: function toast(type, text) {
      __WEBPACK_IMPORTED_MODULE_4__core_helpers_bus__["a" /* default */].$emit('toast', { type: type, text: text });
    },
    selectPatient: function selectPatient(patient) {
      var vm = this;
      vm.$emit('selectPatient', patient);
      this.close();
    },
    formatDate: function formatDate(timestamp) {
      var d = new Date(timestamp * 1000);
      var MyDateString = ('0' + (d.getMonth() + 1)).slice(-2) + '/' + ('0' + d.getDate()).slice(-2) + '/' + d.getFullYear();
      return MyDateString;
    },
    close: function close() {
      this.backToPatients();
      this.searching = false;
      this.cancel();

      this.toast('success', 'Patient and request set');
    },
    search: function search() {
      this.backToPatients();
      this.searching = true;

      this.getPatients({
        id: this.patientFields.id,
        firstName: this.patientFields.firstName,
        lastName: this.patientFields.lastName,
        DOB: this.patientFields.DOB
      });
    },
    viewRequests: function viewRequests(patient) {
      this.selectedPatientString = patient.firstName + ' ' + patient.lastName + ' ' + patient.gender.charAt(0) + ' ' + this.formatDate(patient.birthdate);

      this.selectedPatient = patient.id;
      this.getPatientRequests({ patientID: patient.id });
    },
    backToPatients: function backToPatients() {
      this.selectedPatient = null;
      this.selectedRequest = null;
      this.setPatientRequest(null);
    },
    selectRequest: function selectRequest(request) {
      this.selectedRequest = request.id;
      this.$emit('valuesEmit', {
        patient: this.selectedPatient,
        request: this.selectedRequest,
        provider: request.provider,
        patientDisplayString: this.selectedPatientString
      });
      this.close();
    },
    selectWithoutRequest: function selectWithoutRequest() {
      this.$emit('valuesEmit', {
        patient: this.selectedPatient,
        patientDisplayString: this.selectedPatientString
      });
      this.close();
    }
  }),
  computed: __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_extends___default()({}, Object(__WEBPACK_IMPORTED_MODULE_5_vuex__["d" /* mapState */])('admin', ['patientSearchResults', 'patientRequests']), {
    showBuilding: function showBuilding() {
      return this.options.unit && this.options.building;
    },
    combinedFieldsObj: function combinedFieldsObj() {
      var patient = this.patientFields;
      return patient.firstName + patient.lastName + patient.id + patient.DOB;
    }
  })
});

/***/ }),
/* 265 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_extends__ = __webpack_require__(1);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_extends___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_extends__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_vuex__ = __webpack_require__(2);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_date_fns_format__ = __webpack_require__(59);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_date_fns_format___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_2_date_fns_format__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3__core_helpers_bus__ = __webpack_require__(3);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4__core_mixins_HelperMixin__ = __webpack_require__(12);

//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//






/* harmony default export */ __webpack_exports__["a"] = ({
  mixins: [__WEBPACK_IMPORTED_MODULE_4__core_mixins_HelperMixin__["a" /* default */]],
  methods: __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_extends___default()({}, Object(__WEBPACK_IMPORTED_MODULE_1_vuex__["b" /* mapActions */])('admin', ['getPatientList', 'getUserList', 'getRequest', 'getRequestProvider', 'setStatus', 'sendRequest', 'getRequestOverrides', 'submitRequestOverrides', 'submitRequestNote', 'getDocumentFiles', 'searchForPatient']), Object(__WEBPACK_IMPORTED_MODULE_1_vuex__["c" /* mapMutations */])('admin', ['setPatientSearchResults']), {
    clearTheResults: function clearTheResults() {
      this.setPatientSearchResults(null);
    },
    pullRequest: function pullRequest() {
      var vm = this;
      vm.getRequest(vm.$route.params.id).then(function () {
        vm.$refs.chatScroll.scrollTop = vm.$refs.chatScroll.scrollHeight;
      });
    },
    launchSearch: function launchSearch() {
      if (this.firstNameInput || this.lastNameInput) {
        this.searchForPatient({
          firstName: this.firstNameInput,
          lastName: this.lastNameInput
        });
      }
    },
    toast: function toast(type, text) {
      __WEBPACK_IMPORTED_MODULE_3__core_helpers_bus__["a" /* default */].$emit('toast', { type: type, text: text });
    },
    parseTimestamp: function parseTimestamp(timestamp) {
      var ts = new Date(parseInt(timestamp) * 1000);
      return __WEBPACK_IMPORTED_MODULE_2_date_fns_format___default()(ts, 'MMM D YYYY HH:MM:ss Z');
    },
    alternatingColors: function alternatingColors(index) {
      if (index % 2 === 0) {
        return 'whiteAlternate';
      } else {
        return 'grayAlternate';
      }
    }
  }),
  data: function data() {
    return {
      logEntryInput: null,
      updatingLog: false,
      showNav: false,
      firstNameInput: null,
      lastNameInput: null,
      birthdateInput: null
    };
  },

  watch: {
    $route: function $route(val) {
      console.log(val);
    },
    request: function request(val) {
      console.log('request is back');
      if (val && this.$refs.chatScroll) {
        var vm = this;
        vm.$refs.chatScroll.scrollTop = vm.$refs.chatScroll.scrollHeight;
      }
    }
  },
  computed: __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_extends___default()({}, Object(__WEBPACK_IMPORTED_MODULE_1_vuex__["d" /* mapState */])('admin', ['patientSearchResults', 'userSearchResults', 'request', 'files']), Object(__WEBPACK_IMPORTED_MODULE_1_vuex__["d" /* mapState */])('auth', ['user'])),
  mounted: function mounted() {
    this.showNav = true;
  }
});

/***/ }),
/* 266 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_extends__ = __webpack_require__(1);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_extends___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_extends__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__core_mixins_DialogMixin__ = __webpack_require__(5);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__core_mixins_HelperMixin__ = __webpack_require__(12);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3_vuex__ = __webpack_require__(2);

//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//





/* harmony default export */ __webpack_exports__["a"] = ({
  name: 'RequestDialog',
  mixins: [__WEBPACK_IMPORTED_MODULE_1__core_mixins_DialogMixin__["a" /* default */], __WEBPACK_IMPORTED_MODULE_2__core_mixins_HelperMixin__["a" /* default */]],
  components: {},
  data: function data() {
    return {};
  },

  methods: __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_extends___default()({}, Object(__WEBPACK_IMPORTED_MODULE_3_vuex__["b" /* mapActions */])('provider', ['search', 'getProviderIDFromNPI', 'multipleShareFiles', 'getProviderAuth']), Object(__WEBPACK_IMPORTED_MODULE_3_vuex__["b" /* mapActions */])('admin', ['getPatient', 'fuzzySearchForPatient', 'setRequestToComplete']), {
    confirmAssignment: function confirmAssignment() {
      this.$emit('confirmedAssignmentEmit', this.options.payload);
      this.cancel();
    }
  }),
  watch: {},
  computed: __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_extends___default()({}, Object(__WEBPACK_IMPORTED_MODULE_3_vuex__["d" /* mapState */])('auth', ['currentUserGroups']), Object(__WEBPACK_IMPORTED_MODULE_3_vuex__["d" /* mapState */])('admin', ['patientSearchResults']))
});

/***/ }),
/* 267 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_extends__ = __webpack_require__(1);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_extends___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_extends__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_vuex__ = __webpack_require__(2);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__components_dialogs_NewUserGroupDialog__ = __webpack_require__(646);

//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//




/* harmony default export */ __webpack_exports__["a"] = ({
  components: {
    NewUserGroupDialog: __WEBPACK_IMPORTED_MODULE_2__components_dialogs_NewUserGroupDialog__["a" /* default */]
  },
  data: function data() {
    return {
      // TODO: groups, rowsPerPageItems, currentPagination, totalItems
      headers: [{
        text: 'User-group ID'
      }, {
        text: 'Name'
      }, {
        text: 'Creation Date'
      }, {
        text: 'Provider'
      }],
      rowsPerPageItems: [25, 50, 100],
      currentPagination: {
        rowsPerPage: 25
      }
    };
  },

  methods: __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_extends___default()({}, Object(__WEBPACK_IMPORTED_MODULE_1_vuex__["b" /* mapActions */])('admin', ['getUserGroups']), {
    openNewUGDialog: function openNewUGDialog() {
      this.$refs.newUGDialog.open();
    },
    convertDate: function convertDate(timestamp) {
      var d = new Date(timestamp * 1000);
      return d.getMonth() + 1 + '/' + d.getDate() + '/' + d.getFullYear();
    },
    displayProviderName: function displayProviderName(provider) {
      if (provider && provider.organizationName) {
        return provider.organizationName;
      } else if (provider) {
        return provider.firstName + ' ' + provider.lastName;
      }
    },
    updatePagination: function updatePagination(pag) {
      this.getUserGroups({
        limit: this.currentPagination.rowsPerPage,
        offset: (pag.page - 1) * pag.rowsPerPage
      });

      console.log('update:pagination', pag);
    }
  }),
  computed: __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_extends___default()({}, Object(__WEBPACK_IMPORTED_MODULE_1_vuex__["d" /* mapState */])('admin', ['groups', 'groupsPageInfo'])),
  created: function created() {
    this.getUserGroups({ limit: this.currentPagination.rowsPerPage });
  }
});

/***/ }),
/* 268 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_extends__ = __webpack_require__(1);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_extends___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_extends__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__core_helpers_bus__ = __webpack_require__(3);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__core_mixins_DialogMixin__ = __webpack_require__(5);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3_vuex__ = __webpack_require__(2);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4__components_providerSearchField__ = __webpack_require__(648);

//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//






/* harmony default export */ __webpack_exports__["a"] = ({
  mixins: [__WEBPACK_IMPORTED_MODULE_2__core_mixins_DialogMixin__["a" /* default */]],
  components: {
    ProviderSearchField: __WEBPACK_IMPORTED_MODULE_4__components_providerSearchField__["a" /* default */]
  },
  data: function data() {
    return {
      // User-group name
      userGroupName: null,
      userGroupNameLabel: 'User Group Name',
      userGroupRule: [function (v) {
        return !!v || 'A name is required for a user-group';
      }],

      // Provider info
      providerIDForSubmission: null,
      providerError: null,

      // Form
      valid: false
    };
  },

  methods: __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_extends___default()({}, Object(__WEBPACK_IMPORTED_MODULE_3_vuex__["b" /* mapActions */])('admin', ['submitUserGroup']), {
    submit: function submit() {
      var vm = this;
      vm.submitUserGroup({
        name: vm.userGroupName,
        provider: vm.providerIDForSubmission
      }).then(function () {
        vm.toast('success', 'User group successfully created');
      });

      vm.userGroupName = null;
      vm.providerIDForSubmission = null;
      vm.$refs.provSearchField.clearSearch();

      vm.ok();
    },
    selectProvider: function selectProvider(provider) {
      if (provider.userGroup) {
        this.providerError = 'This provider already has a user group: ' + provider.userGroup;
      } else {
        this.providerIDForSubmission = provider._id;
      }
    },
    toast: function toast(type, text) {
      __WEBPACK_IMPORTED_MODULE_1__core_helpers_bus__["a" /* default */].$emit('toast', { type: type, text: text });
    },
    cancelDialog: function cancelDialog() {
      // TODO: Clear the states
      this.cancel();
    }
  }),
  watch: {
    providerIDForSubmission: function providerIDForSubmission() {
      this.providerError = null;
    }
  },
  mounted: function mounted() {
    this.$on('open', this.onOpen);
    this.$on('close', this.onClose);
  }
});

/***/ }),
/* 269 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_extends__ = __webpack_require__(1);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_extends___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_extends__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_vuex__ = __webpack_require__(2);

//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//



/* harmony default export */ __webpack_exports__["a"] = ({
  data: function data() {
    return {
      autoCompleteSearch: [],
      providerIDForSubmission: null,
      comboBoxSearch: null,
      comboBoxItems: [],
      uploadQ: [],
      providerSearchRequired: true
    };
  },

  methods: __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_extends___default()({}, Object(__WEBPACK_IMPORTED_MODULE_1_vuex__["b" /* mapActions */])('provider', ['getProviderIDFromNPI', 'search']), {
    clearSearch: function clearSearch() {
      this.autoCompleteSearch = [];
      this.providerIDForSubmission = null;
      this.comboBoxSearch = null;
      this.comboBoxItems = [];
      this.uploadQ = [];
      this.providerSearchRequired = true;
    }
  }),
  computed: __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_extends___default()({}, Object(__WEBPACK_IMPORTED_MODULE_1_vuex__["d" /* mapState */])('provider', ['searchResults'])),
  watch: {
    autoCompleteSearch: function autoCompleteSearch(val) {
      var _this = this;

      this.getProviderIDFromNPI({ npis: [val.npi] }).then(function (providerReturn) {
        _this.providerIDForSubmission = providerReturn[0]._id;
        _this.$emit('selectedProvider', providerReturn[0]);
      });
    },
    comboBoxSearch: function comboBoxSearch(val) {
      if (val) {
        this.search({ type: 'individual', terms: val });
      }
    }
  }
});

/***/ }),
/* 270 */,
/* 271 */,
/* 272 */,
/* 273 */,
/* 274 */,
/* 275 */,
/* 276 */,
/* 277 */,
/* 278 */,
/* 279 */,
/* 280 */,
/* 281 */,
/* 282 */,
/* 283 */,
/* 284 */,
/* 285 */,
/* 286 */,
/* 287 */,
/* 288 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
Object.defineProperty(__webpack_exports__, "__esModule", { value: true });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_vue__ = __webpack_require__(48);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_vuetify__ = __webpack_require__(290);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_vuetify___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_1_vuetify__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_vue_i18n__ = __webpack_require__(291);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3_vuetify_dist_vuetify_css__ = __webpack_require__(292);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3_vuetify_dist_vuetify_css___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_3_vuetify_dist_vuetify_css__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4__App__ = __webpack_require__(294);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_5__router_router__ = __webpack_require__(198);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_6__store__ = __webpack_require__(135);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_7_vue_analytics__ = __webpack_require__(771);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_7_vue_analytics___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_7_vue_analytics__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_8__i18n__ = __webpack_require__(772);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_9_vue_worker__ = __webpack_require__(776);
// The Vue build version to load with the `import` command
// (runtime-only or standalone) has been set in webpack.base.conf with an alias.













__WEBPACK_IMPORTED_MODULE_0_vue__["default"].use(__WEBPACK_IMPORTED_MODULE_9_vue_worker__["a" /* default */]);

__WEBPACK_IMPORTED_MODULE_0_vue__["default"].prototype.$subdomainPartner = 'default';

if (window.location.host.includes('smartchoice')) {
  __WEBPACK_IMPORTED_MODULE_0_vue__["default"].prototype.$subdomainPartner = '5a4fa82c8e4b74e028665d04';
} else if (window.location.host.includes('grayhawk')) {
  __WEBPACK_IMPORTED_MODULE_0_vue__["default"].prototype.$subdomainPartner = '5acb94000495d7065c909bc2';
} else if (window.location.host.includes('imaginemd')) {
  __WEBPACK_IMPORTED_MODULE_0_vue__["default"].prototype.$subdomainPartner = '5b73507c4aef2028740f662b';
} else if (window.location.host.includes('newparkmedical')) {
  __WEBPACK_IMPORTED_MODULE_0_vue__["default"].prototype.$subdomainPartner = '5a3f56ec92808ba8d3d5a391';
} else {
  __WEBPACK_IMPORTED_MODULE_0_vue__["default"].prototype.$subdomainPartner = 'default';
}

__WEBPACK_IMPORTED_MODULE_0_vue__["default"].use(__WEBPACK_IMPORTED_MODULE_1_vuetify___default.a, {
  theme: {
    primary: '#4485ed',
    secondary: '#5F5F5F',
    accent: '#43A047',
    deselected: '#cccccc',
    scgreen: '#8AC33E',
    contrast: '#BDBDBD',
    headerColor: '#ffffff'
  }
});

__WEBPACK_IMPORTED_MODULE_0_vue__["default"].use(__WEBPACK_IMPORTED_MODULE_2_vue_i18n__["a" /* default */]);
var i18n = new __WEBPACK_IMPORTED_MODULE_2_vue_i18n__["a" /* default */]({
  locale: 'en',
  fallbackLocale: 'en',
  messages: __WEBPACK_IMPORTED_MODULE_8__i18n__["a" /* default */]
});

__WEBPACK_IMPORTED_MODULE_0_vue__["default"].prototype.$default = {
  avatar: {
    sm: 47,
    lg: 74,
    xl: 120
  }

  // Config
};__WEBPACK_IMPORTED_MODULE_0_vue__["default"].config.productionTip = "production" !== 'production';

// const isProd = process.env.NODE_ENV === 'production'

__WEBPACK_IMPORTED_MODULE_0_vue__["default"].use(__WEBPACK_IMPORTED_MODULE_7_vue_analytics___default.a, {
  id: 'UA-124830022-1',
  router: __WEBPACK_IMPORTED_MODULE_5__router_router__["a" /* default */],
  autoTracking: {
    exception: true
  }
});
/* eslint-disable no-new */
new __WEBPACK_IMPORTED_MODULE_0_vue__["default"]({
  el: '#app',
  router: __WEBPACK_IMPORTED_MODULE_5__router_router__["a" /* default */],
  store: __WEBPACK_IMPORTED_MODULE_6__store__["a" /* default */],
  i18n: i18n,
  template: '<App/>',
  components: { App: __WEBPACK_IMPORTED_MODULE_4__App__["a" /* default */] }
});

/***/ }),
/* 289 */,
/* 290 */,
/* 291 */,
/* 292 */
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ }),
/* 293 */,
/* 294 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_vue_loader_lib_selector_type_script_index_0_App_vue__ = __webpack_require__(142);
/* unused harmony namespace reexport */
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__node_modules_vue_loader_lib_template_compiler_index_id_data_v_b8965bae_hasScoped_false_transformToRequire_video_src_poster_source_src_img_src_image_xlink_href_buble_transforms_node_modules_vue_loader_lib_selector_type_template_index_0_App_vue__ = __webpack_require__(436);
function injectStyle (ssrContext) {
  __webpack_require__(295)
}
var normalizeComponent = __webpack_require__(0)
/* script */


/* template */

/* template functional */
var __vue_template_functional__ = false
/* styles */
var __vue_styles__ = injectStyle
/* scopeId */
var __vue_scopeId__ = null
/* moduleIdentifier (server only) */
var __vue_module_identifier__ = null
var Component = normalizeComponent(
  __WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_vue_loader_lib_selector_type_script_index_0_App_vue__["a" /* default */],
  __WEBPACK_IMPORTED_MODULE_1__node_modules_vue_loader_lib_template_compiler_index_id_data_v_b8965bae_hasScoped_false_transformToRequire_video_src_poster_source_src_img_src_image_xlink_href_buble_transforms_node_modules_vue_loader_lib_selector_type_template_index_0_App_vue__["a" /* default */],
  __vue_template_functional__,
  __vue_styles__,
  __vue_scopeId__,
  __vue_module_identifier__
)

/* harmony default export */ __webpack_exports__["a"] = (Component.exports);


/***/ }),
/* 295 */
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ }),
/* 296 */,
/* 297 */,
/* 298 */,
/* 299 */,
/* 300 */,
/* 301 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_vue_loader_lib_selector_type_script_index_0_Footer_vue__ = __webpack_require__(147);
/* unused harmony namespace reexport */
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__node_modules_vue_loader_lib_template_compiler_index_id_data_v_acb38718_hasScoped_true_transformToRequire_video_src_poster_source_src_img_src_image_xlink_href_buble_transforms_node_modules_vue_loader_lib_selector_type_template_index_0_Footer_vue__ = __webpack_require__(365);
function injectStyle (ssrContext) {
  __webpack_require__(302)
}
var normalizeComponent = __webpack_require__(0)
/* script */


/* template */

/* template functional */
var __vue_template_functional__ = false
/* styles */
var __vue_styles__ = injectStyle
/* scopeId */
var __vue_scopeId__ = "data-v-acb38718"
/* moduleIdentifier (server only) */
var __vue_module_identifier__ = null
var Component = normalizeComponent(
  __WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_vue_loader_lib_selector_type_script_index_0_Footer_vue__["a" /* default */],
  __WEBPACK_IMPORTED_MODULE_1__node_modules_vue_loader_lib_template_compiler_index_id_data_v_acb38718_hasScoped_true_transformToRequire_video_src_poster_source_src_img_src_image_xlink_href_buble_transforms_node_modules_vue_loader_lib_selector_type_template_index_0_Footer_vue__["a" /* default */],
  __vue_template_functional__,
  __vue_styles__,
  __vue_scopeId__,
  __vue_module_identifier__
)

/* customBlocks */
var customBlock = __webpack_require__(366)
if (customBlock && customBlock.__esModule) {
  customBlock = customBlock.default
}
if (typeof customBlock === "function") {
  customBlock(Component)
}


/* harmony default export */ __webpack_exports__["a"] = (Component.exports);


/***/ }),
/* 302 */
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ }),
/* 303 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony default export */ __webpack_exports__["a"] = ({
  urls: {
    privacy: 'https://www.onecharthealth.com/privacy',
    terms: 'https://www.onecharthealth.com/terms-of-use'
  }
});

/***/ }),
/* 304 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_vue_loader_lib_selector_type_script_index_0_TermsOfUseDialog_vue__ = __webpack_require__(148);
/* unused harmony namespace reexport */
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__node_modules_vue_loader_lib_template_compiler_index_id_data_v_6a02d11d_hasScoped_true_transformToRequire_video_src_poster_source_src_img_src_image_xlink_href_buble_transforms_node_modules_vue_loader_lib_selector_type_template_index_0_TermsOfUseDialog_vue__ = __webpack_require__(361);
function injectStyle (ssrContext) {
  __webpack_require__(305)
}
var normalizeComponent = __webpack_require__(0)
/* script */


/* template */

/* template functional */
var __vue_template_functional__ = false
/* styles */
var __vue_styles__ = injectStyle
/* scopeId */
var __vue_scopeId__ = "data-v-6a02d11d"
/* moduleIdentifier (server only) */
var __vue_module_identifier__ = null
var Component = normalizeComponent(
  __WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_vue_loader_lib_selector_type_script_index_0_TermsOfUseDialog_vue__["a" /* default */],
  __WEBPACK_IMPORTED_MODULE_1__node_modules_vue_loader_lib_template_compiler_index_id_data_v_6a02d11d_hasScoped_true_transformToRequire_video_src_poster_source_src_img_src_image_xlink_href_buble_transforms_node_modules_vue_loader_lib_selector_type_template_index_0_TermsOfUseDialog_vue__["a" /* default */],
  __vue_template_functional__,
  __vue_styles__,
  __vue_scopeId__,
  __vue_module_identifier__
)

/* harmony default export */ __webpack_exports__["a"] = (Component.exports);


/***/ }),
/* 305 */
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ }),
/* 306 */,
/* 307 */,
/* 308 */,
/* 309 */,
/* 310 */,
/* 311 */,
/* 312 */,
/* 313 */,
/* 314 */,
/* 315 */,
/* 316 */,
/* 317 */,
/* 318 */,
/* 319 */,
/* 320 */,
/* 321 */,
/* 322 */,
/* 323 */,
/* 324 */,
/* 325 */,
/* 326 */,
/* 327 */,
/* 328 */,
/* 329 */,
/* 330 */,
/* 331 */,
/* 332 */,
/* 333 */,
/* 334 */,
/* 335 */,
/* 336 */,
/* 337 */,
/* 338 */,
/* 339 */,
/* 340 */,
/* 341 */,
/* 342 */,
/* 343 */,
/* 344 */,
/* 345 */,
/* 346 */,
/* 347 */,
/* 348 */,
/* 349 */,
/* 350 */,
/* 351 */,
/* 352 */,
/* 353 */,
/* 354 */,
/* 355 */,
/* 356 */,
/* 357 */,
/* 358 */,
/* 359 */,
/* 360 */,
/* 361 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('v-dialog',{attrs:{"hide-overlay":"","fullscreen":_vm.$vuetify.breakpoint.xsOnly,"scrollable":"","max-width":"900px","transition":_vm.transition},model:{value:(_vm.show),callback:function ($$v) {_vm.show=$$v},expression:"show"}},[_c('v-card',{staticStyle:{"min-height":"600px"},attrs:{"color":"white"}},[_c('v-toolbar',{attrs:{"flat":"","color":"transparent"}},[_c('v-toolbar-title',{attrs:{"color":"primary"}},[_vm._v("OneChart Terms of Use")]),_vm._v(" "),_c('v-spacer'),_vm._v(" "),_c('v-btn',{attrs:{"flat":"","icon":""},on:{"click":this.cancel}},[_c('v-icon',[_vm._v("close")])],1)],1),_vm._v(" "),_c('v-card-text',[(_vm.$subdomainPartner === 'default')?_c('v-layout',{attrs:{"column":""}},[_c('p',{staticClass:"c0"},[_c('span',{staticClass:"c5"},[_vm._v("Updated: Aug 15")]),_c('span',{staticClass:"c1"},[_vm._v(", 2018")])]),_vm._v(" "),_c('p',{staticClass:"c0"},[_c('span',{staticClass:"c5"},[_vm._v("Effective: Aug 15")]),_c('span',{staticClass:"c1"},[_vm._v(", 2018")])])]):_vm._e(),_vm._v(" "),_c('v-layout',{attrs:{"else":""}},[(_vm.$subdomainPartner === '5a4fa82c8e4b74e028665d04')?_c('v-layout',{attrs:{"column":""}},[_c('p',{staticClass:"c0"},[_c('span',{staticClass:"c5"},[_vm._v("Updated: May 9")]),_c('span',{staticClass:"c1"},[_vm._v(", 2018")])]),_vm._v(" "),_c('p',{staticClass:"c0"},[_c('span',{staticClass:"c5"},[_vm._v("Effective: May 9")]),_c('span',{staticClass:"c1"},[_vm._v(", 2018")])])]):_vm._e(),_vm._v(" "),(_vm.$subdomainPartner === '5acb94000495d7065c909bc2')?_c('v-layout',{attrs:{"column":""}},[_c('p',{staticClass:"c0"},[_c('span',{staticClass:"c5"},[_vm._v("Updated: Feb 22")]),_c('span',{staticClass:"c1"},[_vm._v(", 2018")])]),_vm._v(" "),_c('p',{staticClass:"c0"},[_c('span',{staticClass:"c5"},[_vm._v("Effective: Feb 22")]),_c('span',{staticClass:"c1"},[_vm._v(", 2018")])])]):_vm._e(),_vm._v(" "),(_vm.$subdomainPartner === '5b73507c4aef2028740f662b')?_c('v-layout',{attrs:{"column":""}},[_c('p',{staticClass:"c0"},[_c('span',{staticClass:"c5"},[_vm._v("Updated: Aug 14")]),_c('span',{staticClass:"c1"},[_vm._v(", 2018")])]),_vm._v(" "),_c('p',{staticClass:"c0"},[_c('span',{staticClass:"c5"},[_vm._v("Effective: Aug 14")]),_c('span',{staticClass:"c1"},[_vm._v(", 2018")])])]):_vm._e()],1),_vm._v(" "),_c('p',{staticClass:"c0"},[_c('span',{staticClass:"c5"},[_vm._v("Thanks for using OneChart! These terms of service (\"Terms\") cover your use and access to our\n          services, software and websites (\"Services\") and your responsibilities when using our Services. Your\n          agreement is with OneChart Health, LLC (“OneChart”). Our ")]),_c('span',{staticClass:"c7 c14 c11"},[_vm._v("Privacy\n          Policy")]),_c('span',{staticClass:"c5"},[_vm._v(" explains how we collect and use your information. By using our Services,\n          whether in connection with a paid or free trial of the services, you are agreeing to be bound by these Terms\n          and our ")]),_c('span',{staticClass:"c7 c11 c14"},[_vm._v("Privacy Policy")]),_c('span',{staticClass:"c1"},[_vm._v(". If you are using our Services\n          for an organization, you are agreeing to these Terms on behalf of that organization.")])]),_vm._v(" "),_c('p',{staticClass:"c2"},[_c('span',{staticClass:"c3"},[_vm._v("Your File & Your Permissions")])]),_vm._v(" "),_c('p',{staticClass:"c0"},[_c('span',{staticClass:"c1"},[_vm._v("When you use our Services, you provide us with things like your personal information, medical provider\n          and physician information, contacts, and so on (\"Your File\"). Your File is yours. These Terms don't\n          give us any rights to Your File except for the limited rights that enable us to offer the Services. ")])]),_vm._v(" "),_c('p',{staticClass:"c0"},[_c('span',{staticClass:"c1"},[_vm._v("We need your permission to do things like record Your File, back it up, and link you to your records\n          when you use the Services. Our Services also provide you with features like thumbnails, document previews, commenting,\n          easy sorting, editing, sharing and searching. These and other features may require our systems to access, store,\n          and scan Your File. You give us permission to do so, and this permission extends to our affiliates and trusted\n          third parties we work with.")])]),_vm._v(" "),(_vm.$subdomainPartner != 'default')?_c('v-layout',[(_vm.$subdomainPartner === '5a4fa82c8e4b74e028665d04')?_c('v-layout',{attrs:{"column":""}},[_c('p',{staticClass:"c0"},[_c('span',{staticClass:"c9 c11"},[_vm._v("Smart Choice MRI & Your File")])]),_vm._v(" "),_c('p',{staticClass:"c0"},[_c('span',{staticClass:"c5"},[_vm._v("Smart Choice MRI LLC retains the right to remove those portions of your file that were generated by Smart Choice MRI. This includes but is not limited to Images and associated reports. This right does not extend to any information or documents not created by Smart Choice within your file.")])])]):_vm._e(),_vm._v(" "),(_vm.$subdomainPartner === '5acb94000495d7065c909bc2')?_c('v-layout',{attrs:{"column":""}},[_c('p',{staticClass:"c0"},[_c('span',{staticClass:"c9 c11"},[_vm._v("Authorization to share your file with Grayhawk Home Care")])]),_vm._v(" "),_c('p',{staticClass:"c0"},[_c('span',{staticClass:"c5"},[_vm._v("Our Services let you access your personal, protected health information, and view your data across multiple devices. Our Services also provide the ability to easily share your data with others including your health care providers. By accepting this agreement, you authorize OneChart Health to share your entire record, including existing health care information, as well as future additions to your file, with Grayhawk Home Care for the purposes of continuing care. You also authorize Grayhawk Home Care to request records from other health care providers on your behalf and add the records to your file. Our services let you grant as well as remove access to your file from any third party at your discretion. As the owner of your health care information you may choose to withdraw the above authorization whenever you would like.")])])]):_vm._e(),_vm._v(" "),(_vm.$subdomainPartner === '5b73507c4aef2028740f662b')?_c('v-layout',{attrs:{"column":""}},[_c('p',{staticClass:"c0"},[_c('span',{staticClass:"c9 c11"},[_vm._v("Authorization to share your file with ImagineMD")])]),_vm._v(" "),_c('p',{staticClass:"c0"},[_c('span',{staticClass:"c5"},[_vm._v("Our Services let you access your personal, protected health information, and view your data across multiple devices. Our Services also provide the ability to easily share your data with others including your health care providers. By accepting this agreement, you authorize OneChart Health to share your entire record, including existing health care information, as well as future additions to your file, with ImagineMD for the purposes of continuing care. You also authorize ImagineMD to request records from other health care providers on your behalf and add the records to your file. Our services let you grant as well as remove access to your file from any third party at your discretion. As the owner of your health care information you may choose to withdraw the above authorization whenever you would like.")])])]):_vm._e()],1):_vm._e(),_vm._v(" "),_c('p',{staticClass:"c2"},[_c('span',{staticClass:"c3"},[_vm._v("Your Sharing Activities")])]),_vm._v(" "),_c('p',{staticClass:"c0"},[_c('span',{staticClass:"c1"},[_vm._v("Our Services let you access your personal, protected health information, share your data with others,\n          and view your data across multiple devices, so please think carefully about what you share. Do not use the Services\n          unless you know you can do so in a safe manner.")])]),_vm._v(" "),_c('p',{staticClass:"c2"},[_c('span',{staticClass:"c3"},[_vm._v("Your Responsibilities")])]),_vm._v(" "),_c('p',{staticClass:"c0"},[_c('span',{staticClass:"c1"},[_vm._v("You are responsible for your conduct. Content in the Services may be protected by others' intellectual\n          property rights. Please don't copy, upload, download or share content unless you have the right to do so.")])]),_vm._v(" "),_c('p',{staticClass:"c0"},[_c('span',{staticClass:"c1"},[_vm._v("We may review your conduct and content for compliance with these Terms but we have no obligation to\n          do so. We aren't responsible for the content people transmit, view, and share via the Services.")])]),_vm._v(" "),_c('p',{staticClass:"c0"},[_c('span',{staticClass:"c1"},[_vm._v("Help us keep you informed and Your File protected. Safeguard your password to the Services, and keep\n          your account information current. Don't share your account credentials or give others access to your account.")])]),_vm._v(" "),_c('p',{staticClass:"c0"},[_c('span',{staticClass:"c1"},[_vm._v("You may use our Services only as permitted by applicable law, including export control laws and regulations.\n          ")])]),_vm._v(" "),_c('p',{staticClass:"c0"},[_c('span',{staticClass:"c1"},[_vm._v("Our Services are not intended for and may not be used by people under the age of 13. By using our Services\n          you are representing to us that you are over 13. Parents and guardians of individuals under the age of 13 may\n          use OneChart to access information for such individuals for whom they have the legal right to do so in accordance\n          with this Agreement.")])]),_vm._v(" "),_c('p',{staticClass:"c0"},[_c('span',{staticClass:"c1 c4"},[_vm._v("In addition to complying with the other terms, conditions and restrictions set forth below in this\n          Agreement, You agree not to (a) license, sublicense, sell, resell, rent, lease, transfer, assign, distribute,\n          time share or otherwise commercially exploit or make the Services available to any third party; (b) use the Services\n          to process data on behalf of any third party; (c) modify, adapt, or hack the Services or otherwise attempt to\n          gain unauthorized access to the Services or related systems or networks; (d) falsely imply any sponsorship or\n          association with OneChart or its affiliates, (e) use the Services in any unlawful manner, including, but not\n          limited to, violation of any person’s privacy rights; (f) use the Services to send unsolicited or unauthorized\n          bulk mail, junk mail, spam, pyramid schemes or other forms of duplicative or unsolicited messages; (g) use the\n          Services to store or transmit files, materials, data, text, audio, video, images or other content that infringes\n          on any person’s intellectual property rights; (h) use the Services in any manner that interferes with or\n          disrupts the integrity or performance of the Services and its components; (i) attempt to decipher, decompile,\n          reverse engineer or otherwise discover the source code of any Software making up the Services; (j) use the Services\n          to knowingly post, transmit, upload, link to, send or store any content that is unlawful, racist, hateful, abusive,\n          libelous, obscene, or discriminatory; (k) use the Services to store or transmit any “protected health information”\n          as that term is defined in 45 C.F.R. 160.103, unless you are the legal owner or custodian of such information;\n          (l) use the Services to knowingly post transmit, upload, link to, send or store any viruses, malware, Trojan\n          horses, time bombs, or any other similar harmful software (“Malicious Software”); (m) use or launch\n          any automated system that accesses a Service (i.e., bot) in a manner that sends more request messages to a Service\n          server in a given period of time than a human can reasonably produce in the same period by using a conventional\n          on-line web browser; or (n) attempt to use, or use the Services in violation of this Agreement.")])]),_vm._v(" "),_c('p',{staticClass:"c2"},[_c('span',{staticClass:"c3"},[_vm._v("Sponsored Accounts")])]),_vm._v(" "),_c('p',{staticClass:"c0"},[_c('span',{staticClass:"c7 c15"},[_vm._v("Billing")]),_c('span',{staticClass:"c7"},[_vm._v(". We will automatically bill the sponsoring organization for each\n          covered patient. You have no financial responsibility for the covered patients and will not be charged for access\n          to the services for each covered patient. Should you wish to continue the services beyond the sponsorship period,\n          you may choose to convert to an Individual Paid Account. This conversion is not automatic. You will be prompted\n          to convert your account at the point that the sponsorship ends.")])]),_vm._v(" "),_c('p',{staticClass:"c2"},[_c('span',{staticClass:"c9"},[_vm._v("Individual ")]),_c('span',{staticClass:"c3"},[_vm._v("Paid Accounts")])]),_vm._v(" "),_c('p',{staticClass:"c0"},[_c('span',{staticClass:"c5 c15"},[_vm._v("Billing")]),_c('span',{staticClass:"c1"},[_vm._v(". We will automatically bill you for your Paid Account on each periodic\n          renewal until cancellation. You are responsible for all applicable taxes, and we will charge tax when required\n          to do so. Some jurisdictions have mandatory local laws regarding your cancellation rights, and this paragraph\n          doesn't override these laws.")])]),_vm._v(" "),_c('p',{staticClass:"c0"},[_c('span',{staticClass:"c5 c15"},[_vm._v("No Refunds")]),_c('span',{staticClass:"c1"},[_vm._v(". You may cancel your OneChart Paid Account at any time\n          or revert your account to an unpaid account that allows you to continue to view your records. Refunds are only\n          issued if required by law.")])]),_vm._v(" "),_c('p',{staticClass:"c0"},[_c('span',{staticClass:"c5 c15"},[_vm._v("Suspensions")]),_c('span',{staticClass:"c1"},[_vm._v(". Your Paid Account will remain in effect until it's cancelled\n          or terminated under these Terms. If you don't pay for your Paid Account on time, we reserve the right to\n          suspend or limit your access to the Services.")])]),_vm._v(" "),_c('p',{staticClass:"c0"},[_c('span',{staticClass:"c5 c15"},[_vm._v("Changes")]),_c('span',{staticClass:"c1"},[_vm._v(". We may change the fees in effect but will give you advance notice\n          of these changes via a message to the email address associated with your account.")])]),_vm._v(" "),_c('p',{staticClass:"c2"},[_c('span',{staticClass:"c3"},[_vm._v("Termination")])]),_vm._v(" "),_c('p',{staticClass:"c0"},[_c('span',{staticClass:"c5"},[_vm._v("Violation of this Agreement may, in OneChart’s sole discretion, result in termination of your\n          OneChart account. You understand and agree that OneChart cannot and will not be responsible for the Content posted\n          on the Services. You use the Services at your own risk. If you violate the letter or spirit of this Agreement,\n          or otherwise create risk or possible legal exposure for OneChart, we can stop providing all or part of the Service\n          to you. In doing so we may ")]),_c('span',{staticClass:"c4 c11 c16"},[_vm._v("remove, disable and discard any of your data associated\n          with the Services.")])]),_vm._v(" "),_c('p',{staticClass:"c0"},[_c('span',{staticClass:"c5 c4"},[_vm._v("We shall not be liable to you or any other third party for any such modification, suspension or discontinuation\n          of your rights to access and use the Services. Any suspected fraudulent, abusive, or illegal activity by you\n          or any party we reasonably believe to be associated with you may be referred to law enforcement authorities at\n          our sole discretion")])]),_vm._v(" "),_c('p',{staticClass:"c0"},[_c('span',{staticClass:"c5"},[_vm._v("You may stop using our Services at any time. If at any point you decide to discontinue your subscription,\n          you may continue to store, and share, your file at no cost to you. If at any point you would like to remove your\n          information completely from the OneChart platform, your may do so by emailing ")]),_c('span',{staticClass:"c7 c11 c17"},[_c('a',{staticClass:"c10",attrs:{"href":"mailto:support@onecharthealth.com"}},[_vm._v("support@onecharthealth.com")])]),_c('span',{staticClass:"c1"},[_vm._v(".\n          After confirming your intention to remove all of your data, OneChart will remove your file and all identifiable\n          information within 7 business days of your request.  We reserve the right to suspend or terminate your access\n          to the Services if:")])]),_vm._v(" "),_c('p',{staticClass:"c0"},[_c('span',{staticClass:"c1"},[_vm._v("(a) you breach these Terms,")])]),_vm._v(" "),_c('p',{staticClass:"c0"},[_c('span',{staticClass:"c1"},[_vm._v("(b) you use the Services in a manner that would cause a real risk of harm or loss to us or other users,\n          or")])]),_vm._v(" "),_c('p',{staticClass:"c0"},[_c('span',{staticClass:"c1"},[_vm._v("(c) you don't have a Paid Account and haven't accessed our Services for 12 consecutive months.")])]),_vm._v(" "),_c('p',{staticClass:"c0"},[_c('span',{staticClass:"c1"},[_vm._v("Before suspending or terminating your access to the Services we will notify you at the email address\n          associated with your account in an effort to give you the opportunity to remedy your account standing. If after\n          such notice you fail to take the steps we ask of you, we will terminate or suspend your access to the Services.")])]),_vm._v(" "),_c('p',{staticClass:"c0"},[_c('span',{staticClass:"c1"},[_vm._v("We won't provide notice before termination if:")])]),_vm._v(" "),_c('p',{staticClass:"c0"},[_c('span',{staticClass:"c1"},[_vm._v("(a) you materially breach these Terms,")])]),_vm._v(" "),_c('p',{staticClass:"c0"},[_c('span',{staticClass:"c1"},[_vm._v("(b) doing so would cause us legal liability or compromise our ability to provide the Services to our\n          other users, or")])]),_vm._v(" "),_c('p',{staticClass:"c0"},[_c('span',{staticClass:"c1"},[_vm._v("(c) the law prohibits us from doing so.")])]),_vm._v(" "),_c('p',{staticClass:"c2"},[_c('span',{staticClass:"c3"},[_vm._v("Discontinuation of Services")])]),_vm._v(" "),_c('p',{staticClass:"c0"},[_c('span',{staticClass:"c1"},[_vm._v("We may decide to discontinue the Services in response to unforeseen circumstances beyond OneChart’s\n          control or to comply with the law. If we discontinue Services in this way before the end of any fixed or minimum\n          term you have paid us for, we will refund the portion of the fees you have pre-paid but haven't received\n          Services for. ")])]),_vm._v(" "),_c('p',{staticClass:"c2"},[_c('span',{staticClass:"c3"},[_vm._v("Software")])]),_vm._v(" "),_c('p',{staticClass:"c0"},[_c('span',{staticClass:"c1"},[_vm._v("Some of our Services allow you to download client software (\"Software\") which may update automatically.\n          So long as you comply with these Terms, we give you a limited, nonexclusive, nontransferable, revocable license\n          to use the Software, solely to access the Services. None of the Software is offered under an open source license.\n          Unless the following restrictions are prohibited by law, you agree not to reverse engineer or decompile the Services,\n          attempt to do so, or assist anyone in doing so.        ")])]),_vm._v(" "),_c('p',{staticClass:"c2"},[_c('span',{staticClass:"c3"},[_vm._v("Beta Services")])]),_vm._v(" "),_c('p',{staticClass:"c0"},[_c('span',{staticClass:"c1"},[_vm._v("We sometimes release products and features that we are still testing and evaluating. Those Services\n          have been marked beta, preview, early access, or evaluation (or with words or phrases with similar meanings)\n          and may not be as reliable as OneChart’s other services, so please keep that in mind.")])]),_vm._v(" "),_c('p',{staticClass:"c2"},[_c('span',{staticClass:"c3"},[_vm._v("Intellectual Property Use and Ownership")])]),_vm._v(" "),_c('p',{staticClass:"c0"},[_c('span',{staticClass:"c1"},[_vm._v("The Services are protected by copyright, trademark, and other US and foreign laws. These Terms don't\n          grant you any right, title or interest in the Services, others' content in the Services, OneChart trademarks,\n          logos and other brand features. ")])]),_vm._v(" "),_c('p',{staticClass:"c0"},[_c('span',{staticClass:"c5 c4"},[_vm._v("Software and other components of or used to provide the Services, including all related Intellectual\n          Property Rights, will remain with OneChart and belong exclusively to OneChart.. OneChart")]),_c('span',{staticClass:"c7 c4 c19"},[_vm._v("TM")]),_c('span',{staticClass:"c5 c4"},[_vm._v(", and OneChart’s other product and service names and logos used or displayed in or on the Services\n          are registered or unregistered trademarks of OneChart (collectively, “Marks”), and you may only use\n          applicable Marks in a manner permitted by us to identify you in using the Services; provided you do not\n          attempt, now or in the future, to claim any rights in the Marks, degrade the distinctiveness of the Marks, or\n          use the Marks to disparage or misrepresent us, our services or products.")])]),_vm._v(" "),_c('p',{staticClass:"c2"},[_c('span',{staticClass:"c3"},[_vm._v("Copyright")])]),_vm._v(" "),_c('p',{staticClass:"c0"},[_c('span',{staticClass:"c1"},[_vm._v("We respect the intellectual property of others and ask that you do too. We respond to notices of alleged\n          copyright infringement if they comply with the law, and such notices should be reported using our contact below.\n          We reserve the right to delete or disable content alleged to be infringing and terminate accounts of repeat infringers.\n          Our designated agent for notice of alleged copyright infringement on the Services is:")])]),_vm._v(" "),_c('p',{staticClass:"c0"},[_c('span',{staticClass:"c1"},[_vm._v("Copyright Agent"),_c('br'),_vm._v("OneChart Health, LLC"),_c('br'),_vm._v("231 Davis Lane")])]),_vm._v(" "),_c('p',{staticClass:"c0"},[_c('span',{staticClass:"c1"},[_vm._v("Lehi, UT 84043")])]),_vm._v(" "),_c('p',{staticClass:"c2"},[_c('span',{staticClass:"c3"},[_vm._v("Services \"AS IS\"")])]),_vm._v(" "),_c('p',{staticClass:"c0"},[_c('span',{staticClass:"c5 c4"},[_vm._v("WE ENDEAVOUR TO PROVIDE THE BEST SERVICE WE CAN, BUT YOU UNDERSTAND AND AGREE THAT THE SERVICE, INCLUDING,\n          WITHOUT LIMITATION, ONECHART CONTENT, IS PROVIDED ON AN \"AS IS\", \"AS AVAILABLE\" AND \"WITH\n          ALL FAULTS\" BASIS. TO THE FULLEST EXTENT PERMISSIBLE BY LAW, NEITHER ONECHART NOR ITS AFFILIATES NOR ANY\n          OF ITS EMPLOYEES, MANAGERS, OFFICERS, LICENSORS (AS THIRD PARTY BENEFICIARIES) OR AGENTS (COLLECTIVELY, THE \"ONECHART\n          PARTIES\") MAKE ANY REPRESENTATIONS OR WARRANTIES OR ENDORSEMENTS OF ANY KIND WHATSOEVER, EXPRESS OR IMPLIED,\n          AS TO: (A) THE SERVICE; (B) THE ONECHART CONTENT; (C) USER CONTENT; OR (D) SECURITY ASSOCIATED WITH THE TRANSMISSION\n          OF INFORMATION TO ONECHART OR VIA THE SERVICE. IN ADDITION, THE ONECHART PARTIES HEREBY DISCLAIM ALL WARRANTIES,\n          EXPRESS OR IMPLIED, INCLUDING, BUT NOT LIMITED TO, THE WARRANTIES OF MERCHANTABILITY, FITNESS FOR A PARTICULAR\n          PURPOSE, NON-INFRINGEMENT, TITLE, CUSTOM, TRADE, QUIET ENJOYMENT, SYSTEM INTEGRATION AND FREEDOM FROM COMPUTER\n          VIRUS.")]),_c('span',{staticClass:"c5"},[_c('br'),_c('br')]),_c('span',{staticClass:"c1 c4"},[_vm._v("THE ONECHART PARTIES DO NOT REPRESENT OR WARRANT\n          THAT THE SERVICE WILL BE ERROR-FREE OR UNINTERRUPTED; THAT DEFECTS WILL BE CORRECTED; OR THAT THE SERVICE OR\n          THE SERVER THAT MAKES THE SERVICE AVAILABLE IS FREE FROM ANY HARMFUL COMPONENTS, INCLUDING, WITHOUT LIMITATION,\n          VIRUSES. THE ONECHARTONECHART PARTIES DO NOT MAKE ANY REPRESENTATIONS OR WARRANTIES THAT THE INFORMATION (INCLUDING\n          ANY INSTRUCTIONS) ON THE SERVICE IS ACCURATE, COMPLETE, OR USEFUL. YOU ACKNOWLEDGE THAT YOUR USE OF THE SERVICE\n          IS AT YOUR SOLE RISK. THE ONECHART PARTIES DO NOT WARRANT THAT YOUR USE OF THE SERVICE IS LAWFUL IN ANY PARTICULAR\n          JURISDICTION, AND THE ONECHART PARTIES SPECIFICALLY DISCLAIM SUCH WARRANTIES. ")])]),_vm._v(" "),_c('p',{staticClass:"c0"},[_c('span',{staticClass:"c5"},[_vm._v("BY ACCESSING OR USING THE SERVICE YOU REPRESENT AND WARRANT THAT YOUR ACTIVITIES ARE LAWFUL IN EVERY\n          JURISDICTION WHERE YOU ACCESS OR USE THE SERVICE. "),_c('br'),_c('br'),_vm._v("THE ONECHART PARTIES DO NOT ENDORSE CONTENT AND\n          SPECIFICALLY DISCLAIM ANY RESPONSIBILITY OR LIABILITY TO ANY PERSON OR ENTITY FOR ANY LOSS, DAMAGE (WHETHER ACTUAL,\n          CONSEQUENTIAL, PUNITIVE OR OTHERWISE), INJURY, CLAIM, LIABILITY OR")]),_c('span',{staticClass:"c4 c8"},[_vm._v(" OTHER CAUSE\n          OF ANY KIND OR CHARACTER BASED UPON OR RESULTING FROM ANY CONTENT.")])]),_vm._v(" "),_c('p',{staticClass:"c2"},[_c('span',{staticClass:"c3"},[_vm._v("Limitation of Liability")])]),_vm._v(" "),_c('p',{staticClass:"c0"},[_c('span',{staticClass:"c5"},[_vm._v("WE DON'T EXCLUDE OR LIMIT OUR LIABILITY TO YOU WHERE IT WOULD BE ILLEGAL TO DO SO—THIS INCLUDES\n          ANY LIABILITY FOR ONECHART’S OR ITS AFFILIATES' FRAUD OR FRAUDULENT MISREPRESENTATION IN PROVIDING\n          THE SERVICES.")])]),_vm._v(" "),_c('p',{staticClass:"c0"},[_c('span',{staticClass:"c1"},[_vm._v("UNDER NO CIRCUMSTANCES WILL THE ONECHART PARTIES BE LIABLE TO YOU FOR ANY LOSS OR DAMAGES OF ANY KIND\n          (INCLUDING, WITHOUT LIMITATION, FOR ANY DIRECT, INDIRECT, ECONOMIC, EXEMPLARY, SPECIAL, PUNITIVE, INCIDENTAL\n          OR CONSEQUENTIAL LOSSES OR DAMAGES) THAT ARE DIRECTLY OR INDIRECTLY RELATED TO: (A) THE SERVICE; (B) THE ONECHART\n          CONTENT; (C) USER CONTENT; (D) YOUR USE OF, INABILITY TO USE, OR THE PERFORMANCE OF THE SERVICE; (E) ANY ACTION\n          TAKEN IN CONNECTION WITH AN INVESTIGATION BY THE ONECHART PARTIES OR LAW ENFORCEMENT AUTHORITIES REGARDING YOUR\n          OR ANY OTHER PARTY'S USE OF THE SERVICE; (F) ANY ACTION TAKEN IN CONNECTION WITH COPYRIGHT OR OTHER INTELLECTUAL\n          PROPERTY OWNERS; (G) ANY ERRORS OR OMISSIONS IN THE SERVICE'S OPERATION; OR (H) ANY DAMAGE TO ANY USER'S\n          COMPUTER, MOBILE DEVICE, OR OTHER EQUIPMENT OR TECHNOLOGY INCLUDING, WITHOUT LIMITATION, DAMAGE FROM ANY SECURITY\n          BREACH OR FROM ANY VIRUS, BUGS, TAMPERING, FRAUD, ERROR, OMISSION, INTERRUPTION, DEFECT, DELAY IN OPERATION OR\n          TRANSMISSION, COMPUTER LINE OR NETWORK FAILURE OR ANY OTHER TECHNICAL OR OTHER MALFUNCTION, INCLUDING, WITHOUT\n          LIMITATION, DAMAGES FOR LOST PROFITS, LOSS OF GOODWILL, LOSS OF DATA, WORK STOPPAGE, ACCURACY OF RESULTS, OR\n          COMPUTER FAILURE OR MALFUNCTION, EVEN IF FORESEEABLE OR EVEN IF THE ONECHART PARTIES HAVE BEEN ADVISED OF OR\n          SHOULD HAVE KNOWN OF THE POSSIBILITY OF SUCH DAMAGES, WHETHER IN AN ACTION OF CONTRACT, NEGLIGENCE, STRICT LIABILITY\n          OR TORT (INCLUDING, WITHOUT LIMITATION, WHETHER CAUSED IN WHOLE OR IN PART BY NEGLIGENCE, ACTS OF GOD, TELECOMMUNICATIONS\n          FAILURE, OR THEFT OR DESTRUCTION OF THE SERVICE). IN NO EVENT WILL THE ONECHART PARTIES BE LIABLE TO YOU OR ANYONE\n          ELSE FOR LOSS, DAMAGE OR INJURY, INCLUDING, WITHOUT LIMITATION, DEATH OR PERSONAL INJURY. ")])]),_vm._v(" "),_c('p',{staticClass:"c0"},[_c('span',{staticClass:"c1"},[_vm._v("IN NO EVENT WILL THE COLLECTIVE AGGREGATE LIABILITY OF ONECHART AND ITS AFFILIATES, SUPPLIERS, AND SERVICE\n          PROVIDERS, ARISING OUT OF OR RELATED TO THIS AGREEMENT, WHETHER ARISING UNDER OR RELATED TO BREACH OF CONTRACT,\n          TORT (INCLUDING NEGLIGENCE), STRICT LIABILITY OR ANY OTHER LEGAL OR EQUITABLE THEORY, EXCEED THE TOTAL AMOUNTS\n          PAID TO ONECHART UNDER THIS AGREEMENT IN THE TWO MONTH PERIOD PRECEDING THE EVENT GIVING RISE TO THE CLAIM OR\n          $2000, WHICHEVER IS LESS. THE FOREGOING LIMITATIONS APPLY EVEN IF ANY REMEDY FAILS OF ITS ESSENTIAL PURPOSE.")])]),_vm._v(" "),_c('p',{staticClass:"c0"},[_c('span',{staticClass:"c1"},[_vm._v("YOU AGREE THAT IN THE EVENT YOU INCUR ANY DAMAGES, LOSSES OR INJURIES THAT ARISE OUT OF ONECHART'S\n          ACTS OR OMISSIONS, THE DAMAGES, IF ANY, CAUSED TO YOU ARE NOT IRREPARABLE OR SUFFICIENT TO ENTITLE YOU TO AN\n          INJUNCTION PREVENTING ANY EXPLOITATION OF ANY WEB SITE, SERVICE, PROPERTY, PRODUCT OR OTHER CONTENT OWNED OR\n          CONTROLLED BY THE ONECHART PARTIES, AND YOU WILL HAVE NO RIGHTS TO ENJOIN OR RESTRAIN THE DEVELOPMENT, PRODUCTION,\n          DISTRIBUTION, ADVERTISING, EXHIBITION OR EXPLOITATION OF ANY WEB SITE, PROPERTY, PRODUCT, SERVICE, OR OTHER CONTENT\n          OWNED OR CONTROLLED BY THE ONECHART PARTIES. ")])]),_vm._v(" "),_c('p',{staticClass:"c0"},[_c('span',{staticClass:"c1"},[_vm._v("BY ACCESSING THE SERVICE, YOU UNDERSTAND THAT YOU MAY BE WAIVING RIGHTS WITH RESPECT TO CLAIMS THAT\n          ARE AT THIS TIME UNKNOWN OR UNSUSPECTED, AND IN ACCORDANCE WITH SUCH WAIVER, YOU ACKNOWLEDGE THAT YOU HAVE READ\n          AND UNDERSTAND, AND HEREBY EXPRESSLY WAIVE, THE BENEFITS OF SECTION 1542 OF THE CIVIL CODE OF CALIFORNIA, AND\n          ANY SIMILAR LAW OF ANY STATE OR TERRITORY, WHICH PROVIDES AS FOLLOWS: \"A GENERAL RELEASE DOES NOT EXTEND\n          TO CLAIMS WHICH THE CREDITOR DOES NOT KNOW OR SUSPECT TO EXIST IN HIS FAVOR AT THE TIME OF EXECUTING THE RELEASE,\n          WHICH IF KNOWN BY HIM MUST HAVE MATERIALLY AFFECTED HIS SETTLEMENT WITH THE DEBTOR.\" ")])]),_vm._v(" "),_c('p',{staticClass:"c0"},[_c('span',{staticClass:"c1"},[_vm._v("ONECHART IS NOT RESPONSIBLE FOR THE ACTIONS, CONTENT, INFORMATION, OR DATA OF THIRD PARTIES, AND YOU\n          RELEASE US, OUR DIRECTORS, OFFICERS, EMPLOYEES, AND AGENTS FROM ANY CLAIMS AND DAMAGES, KNOWN AND UNKNOWN, ARISING\n          OUT OF OR IN ANY WAY CONNECTED WITH ANY CLAIM YOU HAVE AGAINST ANY SUCH THIRD PARTIES.")])]),_vm._v(" "),_c('p',{staticClass:"c0"},[_c('span',{staticClass:"c1"},[_vm._v("IN COUNTRIES WHERE THE PRECEDING TYPES OF EXCLUSIONS ARE NOT ALLOWED, WE ARE RESPONSIBLE TO YOU ONLY\n          FOR LOSSES AND DAMAGES THAT ARE A REASONABLY FORESEEABLE RESULT OF OUR FAILURE TO USE REASONABLE CARE AND SKILL\n          OR OUR BREACH OF OUR CONTRACT WITH YOU. THIS PARAGRAPH DOESN'T AFFECT CONSUMER RIGHTS THAT CAN'T BE WAIVED\n          OR LIMITED BY ANY CONTRACT OR AGREEMENT.")])]),_vm._v(" "),_c('p',{staticClass:"c2"},[_c('span',{staticClass:"c3"},[_vm._v("Dispute Resolution")])]),_vm._v(" "),_c('p',{staticClass:"c0"},[_c('span',{staticClass:"c5 c4"},[_vm._v("Your issue is important to us and we may be able to resolve your dispute without needing formal legal\n          proceedings. Before filing a claim against OneChart, you agree to try to resolve the dispute informally by contacting\n          support@onecharthealth.com. We'll try to resolve the dispute by contacting you via email. If a dispute is\n          not resolved within 15 days of submission, you or OneChart may bring a formal proceeding.")])]),_vm._v(" "),_c('p',{staticClass:"c2"},[_c('span',{staticClass:"c9 c11"},[_vm._v("Governing Law")])]),_vm._v(" "),_c('p',{staticClass:"c0"},[_c('span',{staticClass:"c5 c4"},[_vm._v("This Agreement shall be governed by the laws of the State of Utah, without reference to conflict\n          of laws principles. Any disputes under this Agreement shall be resolved in a court of general jurisdiction in\n          Salt Lake County, Utah. You hereby expressly agree to submit to the exclusive personal jurisdiction of this jurisdiction\n          for the purpose of resolving any dispute relating to this Agreement or access to or use of the Services by You,\n          Agents or End Users.")])]),_vm._v(" "),_c('p',{staticClass:"c2"},[_c('span',{staticClass:"c3"},[_vm._v("Entire Agreement")])]),_vm._v(" "),_c('p',{staticClass:"c0"},[_c('span',{staticClass:"c1"},[_vm._v("These Terms constitute the entire agreement between you and OneChart with respect to the subject matter\n          of these Terms, and supersede and replace any other prior or contemporaneous agreements, or terms and conditions\n          applicable to the subject matter of these Terms. These Terms create no third party beneficiary rights.")])]),_vm._v(" "),_c('p',{staticClass:"c2"},[_c('span',{staticClass:"c3"},[_vm._v("Waiver, Severability & Assignment")])]),_vm._v(" "),_c('p',{staticClass:"c0"},[_c('span',{staticClass:"c1"},[_vm._v("OneChart’s failure to enforce a provision is not a waiver of its right to do so later. If a provision\n          is found unenforceable, the remaining provisions of the Terms will remain in full effect and an enforceable term\n          will be substituted reflecting our intent as closely as possible. You may not assign any of your rights under\n          these Terms, and any such attempt will be void. OneChart may assign its rights to any of its affiliates or subsidiaries,\n          or to any successor in interest of any business associated with the Services.")])]),_vm._v(" "),_c('p',{staticClass:"c2"},[_c('span',{staticClass:"c3"},[_vm._v("Modifications")])]),_vm._v(" "),_c('p',{staticClass:"c0"},[_c('span',{staticClass:"c1"},[_vm._v("We may revise these Terms from time to time to better reflect:")])]),_vm._v(" "),_c('p',{staticClass:"c0"},[_c('span',{staticClass:"c1"},[_vm._v("(a) changes to the law,")])]),_vm._v(" "),_c('p',{staticClass:"c0"},[_c('span',{staticClass:"c1"},[_vm._v("(b) new regulatory requirements, or")])]),_vm._v(" "),_c('p',{staticClass:"c0"},[_c('span',{staticClass:"c1"},[_vm._v("(c) improvements or enhancements made to our Services.")])]),_vm._v(" "),_c('p',{staticClass:"c0"},[_c('span',{staticClass:"c1"},[_vm._v("If an update affects your use of the Services or your legal rights as a user of our Services, we will\n          notify you prior to the update's effective date by sending an email to the email address associated with\n          your account or via an in-product notification. These updated terms will be effective no less than 30 days from\n          when we notify you.")])]),_vm._v(" "),_c('p',{staticClass:"c0"},[_c('span',{staticClass:"c1"},[_vm._v("If you don't agree to the updates we make, please cancel your account before they become effective.\n          Where applicable, we will offer you a prorated refund based on the amounts you have prepaid for Services and\n          your account cancellation date. By continuing to use or access the Services after the updates come into effect,\n          you agree to be bound by the revised Terms.")])])],1)],1)],1)}
var staticRenderFns = []
var esExports = { render: render, staticRenderFns: staticRenderFns }
/* harmony default export */ __webpack_exports__["a"] = (esExports);

/***/ }),
/* 362 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_vue_loader_lib_selector_type_script_index_0_PrivacyPolicyDialog_vue__ = __webpack_require__(166);
/* unused harmony namespace reexport */
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__node_modules_vue_loader_lib_template_compiler_index_id_data_v_1167bb01_hasScoped_true_transformToRequire_video_src_poster_source_src_img_src_image_xlink_href_buble_transforms_node_modules_vue_loader_lib_selector_type_template_index_0_PrivacyPolicyDialog_vue__ = __webpack_require__(364);
function injectStyle (ssrContext) {
  __webpack_require__(363)
}
var normalizeComponent = __webpack_require__(0)
/* script */


/* template */

/* template functional */
var __vue_template_functional__ = false
/* styles */
var __vue_styles__ = injectStyle
/* scopeId */
var __vue_scopeId__ = "data-v-1167bb01"
/* moduleIdentifier (server only) */
var __vue_module_identifier__ = null
var Component = normalizeComponent(
  __WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_vue_loader_lib_selector_type_script_index_0_PrivacyPolicyDialog_vue__["a" /* default */],
  __WEBPACK_IMPORTED_MODULE_1__node_modules_vue_loader_lib_template_compiler_index_id_data_v_1167bb01_hasScoped_true_transformToRequire_video_src_poster_source_src_img_src_image_xlink_href_buble_transforms_node_modules_vue_loader_lib_selector_type_template_index_0_PrivacyPolicyDialog_vue__["a" /* default */],
  __vue_template_functional__,
  __vue_styles__,
  __vue_scopeId__,
  __vue_module_identifier__
)

/* harmony default export */ __webpack_exports__["a"] = (Component.exports);


/***/ }),
/* 363 */
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ }),
/* 364 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('v-dialog',{attrs:{"hide-overlay":"","fullscreen":_vm.$vuetify.breakpoint.xsOnly,"scrollable":"","max-width":"900px","transition":_vm.transition},model:{value:(_vm.show),callback:function ($$v) {_vm.show=$$v},expression:"show"}},[_c('v-card',{staticStyle:{"min-height":"600px"},attrs:{"color":"white"}},[_c('v-toolbar',{attrs:{"flat":"","color":"transparent"}},[_c('v-toolbar-title',{attrs:{"color":"primary"}},[_vm._v("Privacy Policy")]),_vm._v(" "),_c('v-spacer'),_vm._v(" "),_c('v-btn',{attrs:{"flat":"","icon":""},on:{"click":this.cancel}},[_c('v-icon',[_vm._v("close")])],1)],1),_vm._v(" "),_c('v-card-text',[_c('p',{staticClass:"c2"},[_c('span',{staticClass:"c4"},[_vm._v("Updated: November 01, 2017")])]),_vm._v(" "),_c('p',{staticClass:"c2"},[_c('span',[_vm._v("Effective: November 01, 2017")])]),_vm._v(" "),_c('p',{staticClass:"c2"},[_c('span',[_vm._v("If you have joined OneChart through a partner organization, your organization may have an additional Enterprise\n            Agreement that may have modified the privacy policy below. Please contact your organization’s Administration\n            for ")]),_c('span',[_vm._v("details")]),_c('span',[_vm._v(".")])]),_vm._v(" "),_c('p',{staticClass:"c2"},[_c('span',[_vm._v("Thanks for using OneChart! ")]),_c('span',[_vm._v("Here we describe how we collect, use and handle your information, including\n            your medical information, when you use our websites, software and services (\"Services\"), how such information\n            may be disclosed and how you can get access to such information.")]),_c('span',{staticClass:"c4"},[_vm._v(" Please read it\n            carefully.")])]),_vm._v(" "),_c('p',{staticClass:"c2"},[_c('span',{staticClass:"c5"},[_vm._v("What Information We Collect & Why")])]),_vm._v(" "),_c('p',{staticClass:"c2"},[_c('span',{staticClass:"c4"},[_vm._v("We collect and use the following information to provide, improve and protect our Services:")])]),_vm._v(" "),_c('p',{staticClass:"c2"},[_c('span',{staticClass:"c1"},[_vm._v("Account")]),_c('span',{staticClass:"c4"},[_vm._v(". We collect, and associate with your account, information like your\n            name, email address, phone number, payment info, physical address, physician and health care provider information\n            you provide, and account activity.")])]),_vm._v(" "),_c('p',{staticClass:"c2"},[_c('span',{staticClass:"c1"},[_vm._v("Services")]),_c('span',[_vm._v(". Our Services are a conduit designed to make it simple for you to access personal\n            health information you request through your OneChart account (“")]),_c('span',[_vm._v("Your Chart")]),_c('span',[_vm._v("”),\n            share Your Chart data with others, and view Your Chart across multiple devices. Only you and the individuals\n            you designate can see Your Chart. You are given the ability to share and un-share Your Chart with whomever you\n            like. To make all of this possible, we ")]),_c('span',[_vm._v("store")]),_c('span',[_vm._v(", ")]),_c('span',[_vm._v("process")]),_c('span',{staticClass:"c4"},[_vm._v(",\n            and transmit Your Chart as well as information related to it. As a mere conduit, we touch the minimum amount\n            of protected health information, if any, necessary to provide you the Services.")])]),_vm._v(" "),_c('p',{staticClass:"c2"},[_c('span',{staticClass:"c1"},[_vm._v("Usage")]),_c('span',[_vm._v(". We collect ")]),_c('span',[_vm._v("information related to how you use the Services")]),_c('span',{staticClass:"c4"},[_vm._v(", including actions you take in your account (like sharing, editing, viewing, and moving files or folders).\n            This helps us provide you with features like the \"Recently Viewed\" page and version history.")])]),_vm._v(" "),_c('p',{staticClass:"c2"},[_c('span',[_vm._v("We also ")]),_c('span',{staticClass:"c4"},[_vm._v("collect information from and about the devices you use to access the Services.\n            This includes things like IP addresses, the type of browser and device you use, the web page you visited before\n            coming to our sites, and identifiers associated with your devices. Your devices (depending on their settings)\n            may also transmit location information to the Services.")])]),_vm._v(" "),_c('p',{staticClass:"c2"},[_c('span',{staticClass:"c1"},[_vm._v("Cookies and other technologies")]),_c('span',[_vm._v(". We use technologies like cookies and pixel tags to\n            provide, improve, protect and promote our Services. For example, cookies help us with things like remembering\n            your username for your next visit, understanding how you are interacting with our Services, and improving them\n            based on that information. You can set your browser to not accept cookies, but this may limit your ability to\n            use the Services. If our systems receive a DNT signal from your browser, we'll respond to that signal as\n            outlined ")]),_c('span',[_vm._v("here")]),_c('span',{staticClass:"c4"},[_vm._v(".")])]),_vm._v(" "),_c('p',{staticClass:"c2"},[_c('span',{staticClass:"c5"},[_vm._v("With whom")])]),_vm._v(" "),_c('p',{staticClass:"c2"},[_c('span',{staticClass:"c6"},[_vm._v("We may share information as discussed below, ")]),_c('span',{staticClass:"c6"},[_vm._v("but we")]),_c('span',[_vm._v(" will not\n            sell it to advertisers")]),_c('span',{staticClass:"c4"},[_vm._v(".")])]),_vm._v(" "),_c('p',{staticClass:"c2"},[_c('span',{staticClass:"c1"},[_vm._v("Others working for OneChart. ")]),_c('span',{staticClass:"c4"},[_vm._v("OneChart uses certain trusted third parties (for\n            example, providers of customer support and IT services) to help us provide, improve, and protect our Services.\n            These third parties will not be given access to your health information. Access to your non-health related account\n            identifying information will be provided only to perform tasks on our behalf in compliance with this Privacy\n            Policy, and we'll remain responsible for their handling of your information per our instructions.")])]),_vm._v(" "),_c('p',{staticClass:"c2"},[_c('span',{staticClass:"c1"},[_vm._v("OneChart administrators.")]),_c('span',[_vm._v(" Our Services are designed to operate as your private electronic\n            courier. Like any good courier it is our policy not to view the contents of your package. When you initiate the\n            flow of your health information through the OneChart conduit, ")]),_c('span',[_vm._v("only you have permission to view health\n            information that could identify you")]),_c('span',{staticClass:"c4"},[_vm._v(". Such identifiable health information is called protected\n            health information. No person at OneChart views such information without your consent. No software at OneChart\n            processes such information for any purpose other than to enable you to view it. Our Services are designed to\n            organize and format such information in a user friendly format but OneChart does not process or perform analysis\n            of such information on behalf of any health care provider or any other person or entity.  When you use OneChart\n            to request such information from a provider, HIPAA trained staff at your provider may view your protected health\n            information as they would in the normal course of processing your request to give you access your health information.")])]),_vm._v(" "),_c('p',{staticClass:"c2"},[_c('span',{staticClass:"c1"},[_vm._v("Aggregate data sharing. ")]),_c('span',{staticClass:"c4"},[_vm._v("We strive to make the world a better place by helping\n            researchers learn better ways to end human suffering caused by disease. You can consent to allow us to share\n            your aggregate health data with researchers and for general insight. We will never share your personally identifiable\n            health information and will only share aggregate data with your consent. Aggregate data means any and all of\n            your personal information is first removed from the data before it is shared so that no person or entity can\n            identify you.  At any time, including before you use the Services, you can refuse to consent to aggregate\n            data sharing. We encourage you to participate with us in this important initiative but never penalize users who\n            do not consent. You are free to enjoy the same full functionality of our Services regardless of your aggregate\n            data sharing preferences.")])]),_vm._v(" "),_c('p',{staticClass:"c2"},[_c('span',{staticClass:"c1"},[_vm._v("Other applications")]),_c('span',[_vm._v(". You can also give third parties access to your information and account—for\n            example, via ")]),_c('span',{staticClass:"c11"},[_vm._v("OneChart APIs")]),_c('span',{staticClass:"c4"},[_vm._v(". Just remember that their use\n            of your information will be governed by their privacy policies and terms.")])]),_vm._v(" "),_c('p',{staticClass:"c2"},[_c('span',{staticClass:"c1"},[_vm._v("Law & Order")]),_c('span',[_vm._v(". We may disclose your information to third parties if we determine that\n            such disclosure is reasonably necessary to (a) comply with the law; (b) ")]),_c('span',[_vm._v("protect any person from\n            death or serious bodily injury")]),_c('span',{staticClass:"c4"},[_vm._v("; (c) prevent fraud or abuse of OneChart or our users;\n            or (d) protect Onechart’s property rights.")])]),_vm._v(" "),_c('p',{staticClass:"c2"},[_c('span',[_vm._v("Stewardship of your data is critical to us and a responsibility that we embrace. We believe that our users'\n            data should receive the same legal protections regardless of whether it's stored on our services or on their\n            home computer's hard drive. We'll abide by our OneChart ")]),_c('span',[_vm._v("Government Request Principles ")]),_c('span',{staticClass:"c4"},[_vm._v("when receiving, scrutinizing and responding to government requests (including national security requests)\n            for our users' data:")])]),_vm._v(" "),_c('p',{staticClass:"c3"},[_c('span',{staticClass:"c4"},[_vm._v("Be transparent,")])]),_vm._v(" "),_c('p',{staticClass:"c3"},[_c('span',{staticClass:"c4"},[_vm._v("Protect all users, and")])]),_vm._v(" "),_c('p',{staticClass:"c3"},[_c('span',{staticClass:"c4"},[_vm._v("Provide trusted services.")])]),_vm._v(" "),_c('p',{staticClass:"c2"},[_c('span',{staticClass:"c5"},[_vm._v("How")])]),_vm._v(" "),_c('p',{staticClass:"c2"},[_c('span',{staticClass:"c1"},[_vm._v("Security")]),_c('span',[_vm._v(". We are committed to protecting the security of your personal information and\n            we will take reasonable steps to protect your personal information from misuse, interference, loss, unauthorized\n            access, modification or disclosure. We use technologies and processes such as access control procedures, network\n            firewalls, ")]),_c('span',[_vm._v("encryption and physical security")]),_c('span',{staticClass:"c4"},[_vm._v(". When you complete one of our\n            online forms or contact us through our website, we ensure that your contact details are stored on password protected\n            databases.")])]),_vm._v(" "),_c('p',{staticClass:"c2"},[_c('span',{staticClass:"c1"},[_vm._v("Retention")]),_c('span',{staticClass:"c4"},[_vm._v(". We'll retain information you store on our Services for as long\n            as we need it to provide you the Services. We will destroy or permanently de-identify any of your information\n            which is in our possession or control and which we no longer needed for the purpose for which it was collected.")])]),_vm._v(" "),_c('p',{staticClass:"c2"},[_c('span',[_vm._v("But please note: (1) there might be some latency in deleting this information from our servers and back-up storage;\n            and (2) we may retain this information if necessary to comply with our legal obligations, resolve disputes, or\n            enforce our agreements. ")]),_c('span',[_vm._v("You can access your personal information by logging into your OneChart account.")])]),_vm._v(" "),_c('p',{staticClass:"c2"},[_c('span',{staticClass:"c10"},[_vm._v("If you have a complaint or concern about privacy issues")]),_c('span',{staticClass:"c4"},[_vm._v(":")])]),_vm._v(" "),_c('p',{staticClass:"c2"},[_c('span',[_vm._v("Such as:")])]),_vm._v(" "),_c('p',{staticClass:"c2"},[_c('span',{staticClass:"c4"},[_vm._v("(a) questions or comments about our Privacy Policy; ")])]),_vm._v(" "),_c('p',{staticClass:"c2"},[_c('span',{staticClass:"c4"},[_vm._v("(b) you believe we did not agree to provide you with\n            access to your personal information; or ")])]),_vm._v(" "),_c('p',{staticClass:"c2"},[_c('span',{staticClass:"c4"},[_vm._v("(c) you have or a complaint about our information handling\n            practices, ")])]),_vm._v(" "),_c('p',{staticClass:"c2"},[_c('span',[_vm._v("We ask that you first submit any such complaints directly to us via support")]),_c('span',[_vm._v("@")]),_c('span',[_vm._v("onecharthealth.com.\n            If you aren't satisfied with our response, you  ")]),_c('span',[_vm._v("have the right to file a complaint with\n            the Federal Privacy Commissioner")]),_c('span',{staticClass:"c4"},[_vm._v(".")])]),_vm._v(" "),_c('p',{staticClass:"c2"},[_c('span',{staticClass:"c4"},[_vm._v("How to contact us:")])]),_vm._v(" "),_c('p',{staticClass:"c2"},[_c('span',{staticClass:"c4"},[_vm._v("By email: support@onecharthealth.com")])]),_vm._v(" "),_c('p',{staticClass:"c2"},[_c('span',{staticClass:"c4"},[_vm._v("By telephone: (801) 683-5354")])]),_vm._v(" "),_c('p',{staticClass:"c2",attrs:{"id":"h.gjdgxs"}},[_c('span',{staticClass:"c5"},[_vm._v("Changes")])]),_vm._v(" "),_c('p',{staticClass:"c2"},[_c('span',{staticClass:"c4"},[_vm._v("If we are involved in a reorganization, merger, acquisition or sale of our assets, your information\n            may be transferred as part of that deal. We will notify you (for example, via a message to the email address\n            associated with your account) of any such deal and outline your choices in that event.")])]),_vm._v(" "),_c('p',{staticClass:"c2"},[_c('span',{staticClass:"c4"},[_vm._v("We may revise this Privacy Policy from time to time, and will post the most current version on our website.\n            If a revision meaningfully reduces your rights, we will notify you.")])]),_vm._v(" "),_c('p',{staticClass:"c2"},[_c('span',{staticClass:"c9"},[_vm._v("Contact")])]),_vm._v(" "),_c('p',{staticClass:"c2"},[_c('span',[_vm._v("Have questions or concerns about OneChart, our Services and privacy? Contact us at ")]),_c('span',{staticClass:"c11"},[_vm._v("support@onecharthealth.com")]),_c('span',[_vm._v(".")])]),_vm._v(" "),_c('p',{staticClass:"c0"},[_c('span',{staticClass:"c4"})])])],1)],1)}
var staticRenderFns = []
var esExports = { render: render, staticRenderFns: staticRenderFns }
/* harmony default export */ __webpack_exports__["a"] = (esExports);

/***/ }),
/* 365 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('footer',{staticClass:"ui-footer",class:_vm.footerClasses()},[_c('div',{staticClass:"ui-footer__app"},[_vm._m(0),_vm._v(" "),_c('nav',{staticClass:"ui-footer__app__nav"},[_c('v-btn',{attrs:{"flat":"","color":"primary"},on:{"click":_vm.showPrivacy}},[_vm._v("Privacy Policy")]),_vm._v(" "),_c('v-btn',{attrs:{"flat":"","color":"primary"},on:{"click":_vm.showTerms}},[_vm._v("Terms of Use")])],1)]),_vm._v(" "),_c('terms-of-use-dialog',{ref:"termsOfUseDialog"}),_vm._v(" "),_c('privacy-policy-dialog',{ref:"privacyPolicyDialog"})],1)}
var staticRenderFns = [function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('p',{staticClass:"ui-footer__app__copyright"},[_vm._v("\n      "+_vm._s(_vm.$t('common.note.copyright', { year: _vm.year,  version: _vm.version }))+"\n    ")])}]
var esExports = { render: render, staticRenderFns: staticRenderFns }
/* harmony default export */ __webpack_exports__["a"] = (esExports);

/***/ }),
/* 366 */
/***/ (function(module, exports) {

module.exports = function (Component) {
  Component.options.__i18n = Component.options.__i18n || []
  Component.options.__i18n.push('{"en":{"common":{"link":{"giveFeedback":"Give Feedback","legal":"Legal","privacyPolicy":"Privacy Policy","productRecall":"Product Recall","termsOfUse":"Terms of Use"},"note":{"copyright":"© {year} OneChart, Inc. All rights reserved."},"title":{"giveFeedback":"Give Feedback"}}}}')
  delete Component.options._Ctor
}


/***/ }),
/* 367 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_vue_loader_lib_selector_type_script_index_0_Backdrop_vue__ = __webpack_require__(167);
/* unused harmony namespace reexport */
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__node_modules_vue_loader_lib_template_compiler_index_id_data_v_03c08af8_hasScoped_true_transformToRequire_video_src_poster_source_src_img_src_image_xlink_href_buble_transforms_node_modules_vue_loader_lib_selector_type_template_index_0_Backdrop_vue__ = __webpack_require__(369);
function injectStyle (ssrContext) {
  __webpack_require__(368)
}
var normalizeComponent = __webpack_require__(0)
/* script */


/* template */

/* template functional */
var __vue_template_functional__ = false
/* styles */
var __vue_styles__ = injectStyle
/* scopeId */
var __vue_scopeId__ = "data-v-03c08af8"
/* moduleIdentifier (server only) */
var __vue_module_identifier__ = null
var Component = normalizeComponent(
  __WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_vue_loader_lib_selector_type_script_index_0_Backdrop_vue__["a" /* default */],
  __WEBPACK_IMPORTED_MODULE_1__node_modules_vue_loader_lib_template_compiler_index_id_data_v_03c08af8_hasScoped_true_transformToRequire_video_src_poster_source_src_img_src_image_xlink_href_buble_transforms_node_modules_vue_loader_lib_selector_type_template_index_0_Backdrop_vue__["a" /* default */],
  __vue_template_functional__,
  __vue_styles__,
  __vue_scopeId__,
  __vue_module_identifier__
)

/* harmony default export */ __webpack_exports__["a"] = (Component.exports);


/***/ }),
/* 368 */
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ }),
/* 369 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return (_vm.showBackdrop)?_c('div',{staticClass:"backdrop",on:{"mousedown":_vm.closeDrawers}}):_vm._e()}
var staticRenderFns = []
var esExports = { render: render, staticRenderFns: staticRenderFns }
/* harmony default export */ __webpack_exports__["a"] = (esExports);

/***/ }),
/* 370 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_vue_loader_lib_selector_type_script_index_0_DesktopHeader_vue__ = __webpack_require__(168);
/* unused harmony namespace reexport */
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__node_modules_vue_loader_lib_template_compiler_index_id_data_v_0737c3b2_hasScoped_true_transformToRequire_video_src_poster_source_src_img_src_image_xlink_href_buble_transforms_node_modules_vue_loader_lib_selector_type_template_index_0_DesktopHeader_vue__ = __webpack_require__(387);
function injectStyle (ssrContext) {
  __webpack_require__(371)
}
var normalizeComponent = __webpack_require__(0)
/* script */


/* template */

/* template functional */
var __vue_template_functional__ = false
/* styles */
var __vue_styles__ = injectStyle
/* scopeId */
var __vue_scopeId__ = "data-v-0737c3b2"
/* moduleIdentifier (server only) */
var __vue_module_identifier__ = null
var Component = normalizeComponent(
  __WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_vue_loader_lib_selector_type_script_index_0_DesktopHeader_vue__["a" /* default */],
  __WEBPACK_IMPORTED_MODULE_1__node_modules_vue_loader_lib_template_compiler_index_id_data_v_0737c3b2_hasScoped_true_transformToRequire_video_src_poster_source_src_img_src_image_xlink_href_buble_transforms_node_modules_vue_loader_lib_selector_type_template_index_0_DesktopHeader_vue__["a" /* default */],
  __vue_template_functional__,
  __vue_styles__,
  __vue_scopeId__,
  __vue_module_identifier__
)

/* harmony default export */ __webpack_exports__["a"] = (Component.exports);


/***/ }),
/* 371 */
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ }),
/* 372 */
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ }),
/* 373 */,
/* 374 */,
/* 375 */,
/* 376 */,
/* 377 */,
/* 378 */,
/* 379 */,
/* 380 */
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ }),
/* 381 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('i',{staticClass:"material-icons",style:(_vm.style)},[_vm._v(_vm._s(_vm.icon))])}
var staticRenderFns = []
var esExports = { render: render, staticRenderFns: staticRenderFns }
/* harmony default export */ __webpack_exports__["a"] = (esExports);

/***/ }),
/* 382 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"ui-avatar ui-avatar--wrapper ui-avatar-noselect"},[_c('div',{staticClass:"avatar",style:([_vm.avatarStyle])},[(_vm.showText)?_c('span',{staticClass:"ui-avatar--text",style:([_vm.textStyle])},[_vm._v(_vm._s(_vm.text))]):_vm._e(),_vm._v(" "),(_vm.showIcon)?_c('icon',{style:([_vm.textStyle]),attrs:{"icon":_vm.icon}}):_vm._e(),_vm._v(" "),(_vm.showStatus)?_c('div',{staticClass:"ui-avatar--status",style:([_vm.statusStyle])},[_c('div',{style:([_vm.indicatorStyle])})]):_vm._e()],1),_vm._v(" "),(_vm.label)?_c('div',{staticClass:"ui-avatar--label",style:([_vm.labelStyle])},[_vm._v(_vm._s(_vm.label))]):_vm._e()])}
var staticRenderFns = []
var esExports = { render: render, staticRenderFns: staticRenderFns }
/* harmony default export */ __webpack_exports__["a"] = (esExports);

/***/ }),
/* 383 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('v-layout',[_c('v-flex',{attrs:{"xs12":"","md8":"","offset-md2":""}},[_c('v-toolbar',{staticClass:"header-desktop",attrs:{"flat":"","color":"transparent","dense":"","justify-center":""}},[_c('v-layout',{staticClass:"header-content",attrs:{"align-center":""}},[_c('v-toolbar-title',{staticClass:"header-left hidden-xs-only"},[(this.showLogo)?_c('div',{staticClass:"logo",attrs:{"router":"","to":"/"},on:{"click":_vm.gotoMainPage}},[(this.$subdomainPartner === '5a4fa82c8e4b74e028665d04')?_c('v-layout',[_c('img',{staticStyle:{"margin-right":"10px"},attrs:{"src":'https://storage.googleapis.com/onechart-assets/logos/header/5a4fa82c8e4b74e028665d04.png',"height":"40","alt":""}}),_vm._v(" "),_c('img',{staticStyle:{"border-left":"1px solid white","padding-left":"10px","margin-top":"13px"},attrs:{"src":'https://storage.googleapis.com/onechart-assets/logos/header/default_white.png',"height":"14","alt":""}})]):(this.$subdomainPartner === '5a3f56ec92808ba8d3d5a391')?_c('img',{attrs:{"src":this.showLogo,"height":"20","alt":""}}):(this.$subdomainPartner != 'default')?_c('img',{staticStyle:{"margin-top":"3px"},attrs:{"src":this.showLogo,"height":"40","alt":""}}):_vm._e(),_vm._v(" "),(this.$subdomainPartner === 'default')?_c('img',{staticStyle:{"margin-top":"3px"},attrs:{"src":this.showLogo,"height":"20","alt":""}}):_vm._e()],1):_c('div',{staticClass:"logo",attrs:{"router":"","to":"/"},on:{"click":_vm.gotoMainPage}},[_c('div',{staticClass:"logo-title"},[_vm._v("OneChart")])])]),_vm._v(" "),_c('v-spacer'),_vm._v(" "),_vm._t("center"),_vm._v(" "),(this.showLogo)?_c('v-toolbar-title',{staticClass:"hidden-sm-and-up",on:{"click":_vm.gotoMainPage}},[(this.$subdomainPartner === '5a4fa82c8e4b74e028665d04')?_c('v-layout',[_c('img',{staticStyle:{"margin-right":"10px"},attrs:{"src":'https://storage.googleapis.com/onechart-assets/logos/header/5a4fa82c8e4b74e028665d04_mobile.png',"height":"14","alt":""}}),_vm._v(" "),_c('img',{staticStyle:{"border-left":"1px solid white","padding-left":"10px"},attrs:{"src":'https://storage.googleapis.com/onechart-assets/logos/header/default_white.png',"height":"14","alt":""}})]):(this.$subdomainPartner === '5a3f56ec92808ba8d3d5a391')?_c('img',{attrs:{"src":this.showLogo,"height":"20","alt":""}}):(this.$subdomainPartner != 'default')?_c('img',{attrs:{"src":this.showLogo,"height":"40","alt":""}}):_vm._e(),_vm._v(" "),(this.$subdomainPartner === 'default')?_c('img',{staticStyle:{"margin-top":"3px"},attrs:{"src":this.showLogo,"height":"20","alt":""}}):_vm._e()],1):_c('v-toolbar-title',{staticClass:"hidden-sm-and-up"},[_c('div',{staticClass:"logo",attrs:{"router":"","to":"/"},on:{"click":_vm.gotoMainPage}},[_c('div',{staticClass:"logo-title"},[_vm._v("OneChart")])])]),_vm._v(" "),_c('v-spacer'),_vm._v(" "),_c('div',{staticClass:"header-right",staticStyle:{"position":"absolute","right":"0px"}},[(_vm.user)?_c('v-menu',{staticClass:"main-menu-label",attrs:{"bottom":"","offset-y":""}},[_c('v-layout',{staticClass:"profile-content",staticStyle:{"margin-right":"10px"},attrs:{"slot":"activator","row":"","align-center":"","justify-end":""},slot:"activator"},[_c('div',{staticClass:"hidden-xs-only username mr-1"},[_vm._v(_vm._s(_vm.username))]),_vm._v(" "),_c('div',[(_vm.showAlert && this.$vuetify.breakpoint.smAndDown)?_c('v-badge',{attrs:{"color":"yellow","left":"","overlap":""}},[_c('v-icon',{attrs:{"slot":"badge","dark":"","small":""},slot:"badge"},[_vm._v("priority_high")]),_vm._v(" "),_c('v-icon',{attrs:{"color":"contrast","medium":""}},[_vm._v("\n        account_circle\n      ")])],1):(_vm.showAlert)?_c('v-badge',{attrs:{"color":"yellow","right":"","overlap":""}},[_c('v-icon',{attrs:{"slot":"badge","dark":"","small":""},slot:"badge"},[_vm._v("priority_high")]),_vm._v(" "),_c('v-icon',{attrs:{"color":"contrast","medium":""}},[_vm._v("\n        account_circle\n      ")])],1):_c('v-icon',{attrs:{"color":"contrast","medium":""}},[_vm._v("\n        account_circle\n      ")])],1)]),_vm._v(" "),_c('v-list',{attrs:{"dense":""}},_vm._l((_vm.menuItems),function(option){return _c('v-list-tile',{key:option.label,on:{"click":function($event){option.action()}}},[_c('v-list-tile-title',{staticClass:"main-menu-label"},[_c('v-layout',{attrs:{"row":"","align-center":""}},[(option.icon)?_c('icon',{staticClass:"menu-icon",attrs:{"icon":option.icon,"size":20}}):_vm._e(),_vm._v("\n                "+_vm._s(_vm.$t(option.label))+"\n              ")],1)],1)],1)}))],1):_vm._e()],1)],2)],1)],1)],1)}
var staticRenderFns = []
var esExports = { render: render, staticRenderFns: staticRenderFns }
/* harmony default export */ __webpack_exports__["a"] = (esExports);

/***/ }),
/* 384 */
/***/ (function(module, exports) {

module.exports = function (Component) {
  Component.options.__i18n = Component.options.__i18n || []
  Component.options.__i18n.push('{"en":{"link":{"chat":"Chat"}}}')
  delete Component.options._Ctor
}


/***/ }),
/* 385 */
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ }),
/* 386 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('v-layout',{staticClass:"links",attrs:{"column":"","align-center":""}},[_c('v-layout',{staticClass:"content",attrs:{"row":""}},[_c('v-btn',{attrs:{"flat":"","dark":"","router-link":"","to":{name: 'PatientsPage'}}},[_vm._v(_vm._s(_vm.$t('label.patients')))]),_vm._v(" "),_c('v-spacer')],1)],1)}
var staticRenderFns = []
var esExports = { render: render, staticRenderFns: staticRenderFns }
/* harmony default export */ __webpack_exports__["a"] = (esExports);

/***/ }),
/* 387 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"header-style"},[_c('desktop-header',{attrs:{"mainMenu":_vm.menuItems,"user":_vm.user}})],1)}
var staticRenderFns = []
var esExports = { render: render, staticRenderFns: staticRenderFns }
/* harmony default export */ __webpack_exports__["a"] = (esExports);

/***/ }),
/* 388 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_vue_loader_lib_selector_type_script_index_0_MobileHeader_vue__ = __webpack_require__(177);
/* unused harmony namespace reexport */
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__node_modules_vue_loader_lib_template_compiler_index_id_data_v_18c126d8_hasScoped_true_transformToRequire_video_src_poster_source_src_img_src_image_xlink_href_buble_transforms_node_modules_vue_loader_lib_selector_type_template_index_0_MobileHeader_vue__ = __webpack_require__(390);
function injectStyle (ssrContext) {
  __webpack_require__(389)
}
var normalizeComponent = __webpack_require__(0)
/* script */


/* template */

/* template functional */
var __vue_template_functional__ = false
/* styles */
var __vue_styles__ = injectStyle
/* scopeId */
var __vue_scopeId__ = "data-v-18c126d8"
/* moduleIdentifier (server only) */
var __vue_module_identifier__ = null
var Component = normalizeComponent(
  __WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_vue_loader_lib_selector_type_script_index_0_MobileHeader_vue__["a" /* default */],
  __WEBPACK_IMPORTED_MODULE_1__node_modules_vue_loader_lib_template_compiler_index_id_data_v_18c126d8_hasScoped_true_transformToRequire_video_src_poster_source_src_img_src_image_xlink_href_buble_transforms_node_modules_vue_loader_lib_selector_type_template_index_0_MobileHeader_vue__["a" /* default */],
  __vue_template_functional__,
  __vue_styles__,
  __vue_scopeId__,
  __vue_module_identifier__
)

/* harmony default export */ __webpack_exports__["a"] = (Component.exports);


/***/ }),
/* 389 */
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ }),
/* 390 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',[_c('v-toolbar-title',{staticClass:"header-left mt-2"},[_c('div',{staticClass:"logo",attrs:{"router":"","to":"/"},on:{"click":_vm.gotoMainPage}},[_c('i',{staticClass:"logo-icon material-icons"},[_vm._v("assignment_ind")]),_vm._v(" "),_c('div',{staticClass:"logo-title"},[_vm._v("OneChart")])])]),_vm._v(" "),_c('v-spacer'),_vm._v(" "),_c('div',{staticClass:"header-right"},[(_vm.user)?_c('v-menu',{staticClass:"main-menu-label",attrs:{"bottom":"","offset-y":""}},[_c('v-layout',{staticClass:"profile-content",attrs:{"slot":"activator","row":"","align-center":"","justify-end":""},slot:"activator"},[_c('div',{staticClass:"username mr-1"},[_vm._v(_vm._s(_vm.username))]),_vm._v(" "),_c('avatar',{staticClass:"ma-1",attrs:{"size":35,"backgroundColor":"#1565C0","color":"white","fontSize":16,"scaleFont":false,"name":_vm.username,"src":_vm.userImageUrl}}),_vm._v(" "),_c('icon',{attrs:{"icon":"keyboard_arrow_down","size":12}})],1),_vm._v(" "),_c('v-list',{attrs:{"dense":""}},_vm._l((_vm.menuItems),function(option){return _c('v-list-tile',{key:option.label,on:{"click":function($event){option.action()}}},[_c('v-list-tile-title',{staticClass:"main-menu-label"},[_c('v-layout',{attrs:{"row":"","align-center":""}},[(option.icon)?_c('icon',{staticClass:"menu-icon",attrs:{"icon":option.icon,"size":20}}):_vm._e(),_vm._v("\n                  "+_vm._s(_vm.$t(option.label))+"\n                ")],1)],1)],1)}))],1):_vm._e()],1)],1)}
var staticRenderFns = []
var esExports = { render: render, staticRenderFns: staticRenderFns }
/* harmony default export */ __webpack_exports__["a"] = (esExports);

/***/ }),
/* 391 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/**
 * https://github.com/shawnmclean/Idle.js/
 */
var Idle = {};

Idle = function () {
  Idle.isAway = false;

  Idle.awayTimeout = 3000;

  Idle.awayTimestamp = 0;

  Idle.awayTimer = null;

  Idle.onAway = null;

  Idle.onAwayBack = null;

  Idle.onVisible = null;

  Idle.onHidden = null;

  function Idle(options) {
    var activeMethod = void 0,
        activity = void 0;
    if (options) {
      this.awayTimeout = parseInt(options.awayTimeout, 10);
      this.onAway = options.onAway;
      this.onAwayBack = options.onAwayBack;
      this.onVisible = options.onVisible;
      this.onHidden = options.onHidden;
    }
    activity = this;
    activeMethod = function activeMethod() {
      return activity.onActive();
    };
    window.onclick = activeMethod;
    window.onmousemove = activeMethod;
    window.onmouseenter = activeMethod;
    window.onkeydown = activeMethod;
    window.onscroll = activeMethod;
    this.startAwayTimeout();
    document.addEventListener('visibilitychange', function () {
      return activity.handleVisibilityChange();
    }, false);
    document.addEventListener('webkitvisibilitychange', function () {
      return activity.handleVisibilityChange();
    }, false);
    document.addEventListener('msvisibilitychange', function () {
      return activity.handleVisibilityChange();
    }, false);
  }

  Idle.prototype.onActive = function () {
    this.awayTimestamp = new Date().getTime() + this.awayTimeout;
    if (this.isAway) {
      if (this.onAwayBack) this.onAwayBack();
      this.startAwayTimeout();
    }
    this.isAway = false;
    return true;
  };

  Idle.prototype.startAwayTimeout = function () {
    var activity = void 0;
    this.awayTimestamp = new Date().getTime() + this.awayTimeout;
    if (this.awayTimer !== null) clearTimeout(this.awayTimer);
    activity = this;
    return this.awayTimer = setTimeout(function () {
      return activity.checkAway();
    }, this.awayTimeout + 100);
  };

  Idle.prototype.setAwayTimeout = function (ms) {
    this.awayTimeout = parseInt(ms, 10);
    return this.startAwayTimeout();
  };

  Idle.prototype.checkAway = function () {
    var activity = void 0,
        t = void 0;
    t = new Date().getTime();
    if (t < this.awayTimestamp) {
      this.isAway = false;
      activity = this;
      this.awayTimer = setTimeout(function () {
        return activity.checkAway();
      }, this.awayTimestamp - t + 100);
      return;
    }
    if (this.awayTimer !== null) clearTimeout(this.awayTimer);
    this.isAway = true;
    if (this.onAway) return this.onAway();
  };

  Idle.prototype.handleVisibilityChange = function () {
    if (document.hidden || document.msHidden || document.webkitHidden) {
      if (this.onHidden) return this.onHidden();
    } else {
      if (this.onVisible) return this.onVisible();
    }
  };

  return Idle;
}();

/* harmony default export */ __webpack_exports__["a"] = (Idle);

/***/ }),
/* 392 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_vue_loader_lib_selector_type_script_index_0_ApplicationHeader_vue__ = __webpack_require__(178);
/* unused harmony namespace reexport */
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__node_modules_vue_loader_lib_template_compiler_index_id_data_v_369e2848_hasScoped_true_transformToRequire_video_src_poster_source_src_img_src_image_xlink_href_buble_transforms_node_modules_vue_loader_lib_selector_type_template_index_0_ApplicationHeader_vue__ = __webpack_require__(397);
function injectStyle (ssrContext) {
  __webpack_require__(393)
}
var normalizeComponent = __webpack_require__(0)
/* script */


/* template */

/* template functional */
var __vue_template_functional__ = false
/* styles */
var __vue_styles__ = injectStyle
/* scopeId */
var __vue_scopeId__ = "data-v-369e2848"
/* moduleIdentifier (server only) */
var __vue_module_identifier__ = null
var Component = normalizeComponent(
  __WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_vue_loader_lib_selector_type_script_index_0_ApplicationHeader_vue__["a" /* default */],
  __WEBPACK_IMPORTED_MODULE_1__node_modules_vue_loader_lib_template_compiler_index_id_data_v_369e2848_hasScoped_true_transformToRequire_video_src_poster_source_src_img_src_image_xlink_href_buble_transforms_node_modules_vue_loader_lib_selector_type_template_index_0_ApplicationHeader_vue__["a" /* default */],
  __vue_template_functional__,
  __vue_styles__,
  __vue_scopeId__,
  __vue_module_identifier__
)

/* harmony default export */ __webpack_exports__["a"] = (Component.exports);


/***/ }),
/* 393 */
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ }),
/* 394 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_vue_loader_lib_selector_type_script_index_0_EditPatientInfoDialog_vue__ = __webpack_require__(179);
/* unused harmony namespace reexport */
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__node_modules_vue_loader_lib_template_compiler_index_id_data_v_207cadda_hasScoped_true_transformToRequire_video_src_poster_source_src_img_src_image_xlink_href_buble_transforms_node_modules_vue_loader_lib_selector_type_template_index_0_EditPatientInfoDialog_vue__ = __webpack_require__(396);
function injectStyle (ssrContext) {
  __webpack_require__(395)
}
var normalizeComponent = __webpack_require__(0)
/* script */


/* template */

/* template functional */
var __vue_template_functional__ = false
/* styles */
var __vue_styles__ = injectStyle
/* scopeId */
var __vue_scopeId__ = "data-v-207cadda"
/* moduleIdentifier (server only) */
var __vue_module_identifier__ = null
var Component = normalizeComponent(
  __WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_vue_loader_lib_selector_type_script_index_0_EditPatientInfoDialog_vue__["a" /* default */],
  __WEBPACK_IMPORTED_MODULE_1__node_modules_vue_loader_lib_template_compiler_index_id_data_v_207cadda_hasScoped_true_transformToRequire_video_src_poster_source_src_img_src_image_xlink_href_buble_transforms_node_modules_vue_loader_lib_selector_type_template_index_0_EditPatientInfoDialog_vue__["a" /* default */],
  __vue_template_functional__,
  __vue_styles__,
  __vue_scopeId__,
  __vue_module_identifier__
)

/* harmony default export */ __webpack_exports__["a"] = (Component.exports);


/***/ }),
/* 395 */
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ }),
/* 396 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('v-dialog',{attrs:{"fullscreen":_vm.$vuetify.breakpoint.xsOnly,"scrollable":"","max-width":"600px","transition":_vm.transition},model:{value:(_vm.show),callback:function ($$v) {_vm.show=$$v},expression:"show"}},[(_vm.opened)?_c('v-card',{directives:[{name:"show",rawName:"v-show",value:(this.showSplash),expression:"this.showSplash"}],staticClass:"fade-in one",attrs:{"flat":"","color":"primary"}},[_c('v-toolbar',{attrs:{"flat":""}},[_c('v-btn',{attrs:{"dark":"","icon":""},on:{"click":function($event){_vm.cancel()}}},[_c('v-icon',[_vm._v("close")])],1)],1),_vm._v(" "),_c('v-card-text',[_c('v-layout',{directives:[{name:"show",rawName:"v-show",value:(this.stage === 1),expression:"this.stage === 1"}],attrs:{"column":""}},[_c('v-layout',{attrs:{"justify-center":"","row":""}},[_c('span',{staticClass:"fade-in one mb-3",staticStyle:{"color":"white","font-weight":"700","font-size":"28px"}},[_vm._v("Welcome to OneChart")])]),_vm._v(" "),_c('v-layout',{attrs:{"justify-center":"","row":""}},[_c('v-layout',{staticClass:"fade-in oneLong mx-3 mb-3",staticStyle:{"max-width":"500px"},attrs:{"row":""}},[_c('v-layout',{staticStyle:{"margin-right":"20px"},attrs:{"column":""}},[_c('v-icon',{attrs:{"large":"","color":"white"}},[_vm._v("description")])],1),_vm._v(" "),_c('v-layout',{attrs:{"column":""}},[_c('span',{staticStyle:{"color":"white","font-weight":"300","font-size":"24px"}},[_vm._v("Collect medical records from wherever care was received.")])])],1)],1),_vm._v(" "),_c('v-layout',{attrs:{"justify-center":"","row":""}},[_c('v-layout',{staticClass:"fade-in twoLong mx-3 mb-3",staticStyle:{"max-width":"500px"},attrs:{"row":""}},[_c('v-layout',{staticStyle:{"margin-right":"20px"},attrs:{"column":""}},[_c('v-icon',{attrs:{"large":"","color":"white"}},[_vm._v("important_devices")])],1),_vm._v(" "),_c('v-layout',{attrs:{"column":""}},[_c('span',{staticStyle:{"color":"white","font-weight":"300","font-size":"24px"}},[_vm._v("Access the chart from any internet connected device.")])])],1)],1),_vm._v(" "),_c('v-layout',{attrs:{"justify-center":"","row":""}},[_c('v-layout',{staticClass:"fade-in threeLong mx-3 mb-3",staticStyle:{"max-width":"500px"},attrs:{"row":""}},[_c('v-layout',{staticStyle:{"margin-right":"20px"},attrs:{"column":""}},[_c('v-icon',{attrs:{"large":"","color":"white"}},[_vm._v("group")])],1),_vm._v(" "),_c('v-layout',{attrs:{"column":""}},[_c('span',{staticStyle:{"color":"white","font-weight":"300","font-size":"24px"}},[_vm._v("Share with any doctor, care team member, or anyone else.")])])],1)],1)],1),_vm._v(" "),_c('v-layout',{directives:[{name:"show",rawName:"v-show",value:(this.stage === 2),expression:"this.stage === 2"}],attrs:{"column":""}},[_vm._v("\n        Select Provider or not\n      ")])],1),_vm._v(" "),_c('v-card-actions',[_c('v-toolbar',{attrs:{"flat":""}},[_c('v-spacer'),_vm._v(" "),_c('v-btn',{attrs:{"depressed":""},on:{"click":function($event){_vm.createPatient()}}},[_vm._v("Create a Chart")])],1)],1)],1):_vm._e()],1)}
var staticRenderFns = []
var esExports = { render: render, staticRenderFns: staticRenderFns }
/* harmony default export */ __webpack_exports__["a"] = (esExports);

/***/ }),
/* 397 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('v-toolbar',{attrs:{"app":"","clipped-left":"","flat":"","color":"headerColor"}},[_vm._t("navToggle"),_vm._v(" "),_c('v-layout',{attrs:{"justify-center":"","row":""}},[_c('v-flex',{class:_vm.sizingClass},[_c('div',[_c('v-layout',{attrs:{"align-center":"","flat":""}},[_c('v-toolbar-title',{staticStyle:{"color":"#4485ed","font-weight":"700","margin-left":"0px","padding-top":"5px","cursor":"pointer"}},[_c('img',{attrs:{"src":_vm.logoSource,"height":"40","alt":""}})]),_vm._v(" "),_c('v-spacer'),_vm._v(" "),_c('v-menu',{attrs:{"bottom":"","offset-y":""}},[(!_vm.isMobile)?_c('v-btn',{attrs:{"slot":"activator","color":"contrast","flat":""},slot:"activator"},[_c('span',{staticStyle:{"text-transform":"lowercase"}},[_vm._v(_vm._s(_vm.theDisplayedAccount))]),_vm._v(" "),_c('v-icon',{staticClass:"ml-2",attrs:{"small":""}},[_vm._v("person")])],1):_c('v-btn',{attrs:{"slot":"activator","icon":"","color":"contrast","outline":""},slot:"activator"},[_c('v-icon',[_vm._v("person")])],1),_vm._v(" "),_c('v-list',_vm._l((_vm.menuItems),function(item,index){return _c('v-list-tile',{key:index,on:{"click":function($event){_vm.handleMenuSelection(index)}}},[_c('v-list-tile-avatar',[_c('v-icon',[_vm._v(_vm._s(item.icon))])],1),_vm._v(" "),_c('v-list-tile-title',[_vm._v(_vm._s(item.title))])],1)}))],1)],1)],1)])],1),_vm._v(" "),_c('edit-patient-info-dialog',{ref:"editPatientInfoDialog"}),_vm._v(" "),_c('v-divider',{staticStyle:{"position":"absolute","bottom":"0px","width":"110%","left":"0px"}})],2)}
var staticRenderFns = []
var esExports = { render: render, staticRenderFns: staticRenderFns }
/* harmony default export */ __webpack_exports__["a"] = (esExports);

/***/ }),
/* 398 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_vue_loader_lib_selector_type_script_index_0_GlobalNavigationToolbar_vue__ = __webpack_require__(180);
/* unused harmony namespace reexport */
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__node_modules_vue_loader_lib_template_compiler_index_id_data_v_1344b4f4_hasScoped_true_transformToRequire_video_src_poster_source_src_img_src_image_xlink_href_buble_transforms_node_modules_vue_loader_lib_selector_type_template_index_0_GlobalNavigationToolbar_vue__ = __webpack_require__(416);
function injectStyle (ssrContext) {
  __webpack_require__(399)
}
var normalizeComponent = __webpack_require__(0)
/* script */


/* template */

/* template functional */
var __vue_template_functional__ = false
/* styles */
var __vue_styles__ = injectStyle
/* scopeId */
var __vue_scopeId__ = "data-v-1344b4f4"
/* moduleIdentifier (server only) */
var __vue_module_identifier__ = null
var Component = normalizeComponent(
  __WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_vue_loader_lib_selector_type_script_index_0_GlobalNavigationToolbar_vue__["a" /* default */],
  __WEBPACK_IMPORTED_MODULE_1__node_modules_vue_loader_lib_template_compiler_index_id_data_v_1344b4f4_hasScoped_true_transformToRequire_video_src_poster_source_src_img_src_image_xlink_href_buble_transforms_node_modules_vue_loader_lib_selector_type_template_index_0_GlobalNavigationToolbar_vue__["a" /* default */],
  __vue_template_functional__,
  __vue_styles__,
  __vue_scopeId__,
  __vue_module_identifier__
)

/* harmony default export */ __webpack_exports__["a"] = (Component.exports);


/***/ }),
/* 399 */
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ }),
/* 400 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_vue_loader_lib_selector_type_script_index_0_UploadFilesDialog_vue__ = __webpack_require__(181);
/* unused harmony namespace reexport */
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__node_modules_vue_loader_lib_template_compiler_index_id_data_v_041197c2_hasScoped_true_transformToRequire_video_src_poster_source_src_img_src_image_xlink_href_buble_transforms_node_modules_vue_loader_lib_selector_type_template_index_0_UploadFilesDialog_vue__ = __webpack_require__(415);
function injectStyle (ssrContext) {
  __webpack_require__(401)
}
var normalizeComponent = __webpack_require__(0)
/* script */


/* template */

/* template functional */
var __vue_template_functional__ = false
/* styles */
var __vue_styles__ = injectStyle
/* scopeId */
var __vue_scopeId__ = "data-v-041197c2"
/* moduleIdentifier (server only) */
var __vue_module_identifier__ = null
var Component = normalizeComponent(
  __WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_vue_loader_lib_selector_type_script_index_0_UploadFilesDialog_vue__["a" /* default */],
  __WEBPACK_IMPORTED_MODULE_1__node_modules_vue_loader_lib_template_compiler_index_id_data_v_041197c2_hasScoped_true_transformToRequire_video_src_poster_source_src_img_src_image_xlink_href_buble_transforms_node_modules_vue_loader_lib_selector_type_template_index_0_UploadFilesDialog_vue__["a" /* default */],
  __vue_template_functional__,
  __vue_styles__,
  __vue_scopeId__,
  __vue_module_identifier__
)

/* harmony default export */ __webpack_exports__["a"] = (Component.exports);


/***/ }),
/* 401 */
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ }),
/* 402 */,
/* 403 */,
/* 404 */,
/* 405 */,
/* 406 */,
/* 407 */,
/* 408 */,
/* 409 */,
/* 410 */,
/* 411 */,
/* 412 */,
/* 413 */,
/* 414 */,
/* 415 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('v-dialog',{attrs:{"max-width":_vm.options.maxWidth,"transition":_vm.transition,"fullscreen":_vm.$vuetify.breakpoint.xsOnly,"scrollable":""},model:{value:(_vm.show),callback:function ($$v) {_vm.show=$$v},expression:"show"}},[_c('v-card',{staticStyle:{"min-height":"500px"},attrs:{"column":""}},[_c('v-toolbar',{staticStyle:{"border-bottom":"1px solid #f5f5f5","background-color":"white","margin":"0px","padding":"0px"},attrs:{"dark":"","color":"primary","column":"","flat":""}},[_c('v-toolbar-title',[_vm._v("Upload Records")])],1),_vm._v(" "),_c('v-card-text',[_c('v-layout',{attrs:{"column":""}},[_c('span',{staticStyle:{"font-size":"18px","font-weight":"700"}},[_vm._v("Record Information")]),_vm._v(" "),_c('v-autocomplete',{staticClass:"mt-3",attrs:{"hide-selected":"","items":_vm.providersToDisplay,"item-text":"displayName","search-input":_vm.uploadProviderSearchInput,"return-object":"","outline":"","required":"","label":"Medical Provider"},on:{"update:searchInput":function($event){_vm.uploadProviderSearchInput=$event}},scopedSlots:_vm._u([{key:"item",fn:function(ref){
var item = ref.item;
var tile = ref.tile;
return [_c('v-list-tile-avatar',[(item.icon)?_c('v-icon',{staticStyle:{"background-color":"#eeeeee"},attrs:{"color":"primary"}},[_vm._v(_vm._s(item.icon))]):_c('v-icon',{staticStyle:{"background-color":"#eeeeee"},attrs:{"color":"primary"}},[_vm._v("person")])],1),_vm._v(" "),_c('v-list-tile-content',[_c('v-list-tile-title',{domProps:{"textContent":_vm._s(item.displayName)}}),_vm._v(" "),_c('v-list-tile-sub-title',{domProps:{"textContent":_vm._s(item.displayLocale)}})],1)]}}]),model:{value:(_vm.providerInputValue),callback:function ($$v) {_vm.providerInputValue=$$v},expression:"providerInputValue"}},[_c('template',{slot:"no-data"},[_c('v-list-tile',[_c('v-list-tile-title',[_vm._v("\n                Search by "),_c('strong',[_vm._v("Provider Name")])])],1)],1)],2),_vm._v(" "),_c('v-layout',{attrs:{"row":""}},[_c('v-flex',{attrs:{"xs8":""}},[_c('v-select',{staticClass:"mr-2",attrs:{"items":_vm.recordTypes,"outline":"","required":"","label":"Record Type"},model:{value:(_vm.typeInput),callback:function ($$v) {_vm.typeInput=$$v},expression:"typeInput"}})],1),_vm._v(" "),_c('v-flex',{attrs:{"xs4":""}},[_c('v-text-field',{attrs:{"outline":"","hint":"mm/dd/yyyy","mask":"##/##/####","persistent-hint":"","label":"Record Date"},model:{value:(_vm.dateInput),callback:function ($$v) {_vm.dateInput=$$v},expression:"dateInput"}})],1)],1)],1),_vm._v(" "),_c('v-card',{staticClass:"dropzone",staticStyle:{"background-color":"#eeeeee","border-radius":"4px","cursor":"pointer"},attrs:{"flat":"","mb-4":""}},[_c('vue-dropzone',{ref:"dropzone",staticStyle:{"width":"100%","border":"0px","background-color":"transparent"},attrs:{"useCustomSlot":true,"id":"dropzone","options":_vm.dropzoneOptions},on:{"vdropzone-files-added":_vm.filesAdded,"vdropzone-queue-complete":_vm.allFilesCompleted,"vdropzone-sending":_vm.changeURL,"vdropzone-error":_vm.errorOccured}},[_c('v-container',{staticClass:"dropzone-custom-content ma-0",attrs:{"fill-height":""}},[_c('v-layout',{attrs:{"justify-center":"","column":""}},[_c('v-layout',{attrs:{"row":""}},[_c('v-spacer',[_c('v-icon',{staticStyle:{"border-radius":"50%","height":"80px","width":"80px","border":"4px solid #999999"},attrs:{"x-large":""}},[_vm._v("cloud_upload")])],1)],1),_vm._v(" "),_c('v-layout',{staticClass:"mx-2",attrs:{"row":""}},[_c('v-spacer',[_c('div',{staticStyle:{"margin-top":"5px","opacity":"0.6"}},[_c('p',[_vm._v("Click to choose a PDF to upload or drag and drop your file here")])])])],1)],1)],1)],1)],1)],1),_vm._v(" "),_c('v-spacer'),_vm._v(" "),_c('v-card-actions',{staticClass:"px-3 pb-3"},[_c('v-btn',{attrs:{"depressed":""},on:{"click":_vm.close}},[_vm._v("Cancel")]),_vm._v(" "),_c('v-spacer'),_vm._v(" "),_c('v-btn',{attrs:{"color":"primary","depressed":""},on:{"click":function($event){_vm.submitFiles()}}},[_vm._v("Upload")])],1)],1),_vm._v(" "),_c('div',{attrs:{"id":"tpl"}},[_c('div',{staticClass:"dz-preview dz-file-preview well",attrs:{"id":"dz-preview-template"}},[_c('div',{staticClass:"dz-details"},[_c('div',{staticClass:"dz-filename"},[_c('span',{attrs:{"data-dz-name":""}})]),_vm._v(" "),_c('div',{staticClass:"dz-size",attrs:{"data-dz-size":""}})]),_vm._v(" "),_c('div',{staticClass:"dz-progress"},[_c('span',{staticClass:"dz-upload",attrs:{"data-dz-uploadprogress":""}})]),_vm._v(" "),_c('div',{staticClass:"dz-success-mark"},[_c('span')]),_vm._v(" "),_c('div',{staticClass:"dz-error-mark"},[_c('span')]),_vm._v(" "),_c('div',{staticClass:"dz-error-message"},[_c('span',{attrs:{"data-dz-errormessage":""}})])])])],1)}
var staticRenderFns = []
var esExports = { render: render, staticRenderFns: staticRenderFns }
/* harmony default export */ __webpack_exports__["a"] = (esExports);

/***/ }),
/* 416 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('v-layout',{attrs:{"column":"","fill-height":""}},[(this.isMobile)?_c('v-toolbar',{attrs:{"flat":""}}):_vm._e(),_vm._v(" "),(_vm.pageNavigationItems.length > 0)?_c('v-list',{attrs:{"dark":""}},_vm._l((_vm.pageNavigationItems),function(item,i){return _c('v-list-tile',{key:i,on:{"click":function($event){_vm.goToPage(item)}}},[_c('v-list-tile-avatar',[(_vm.pageLocation === item.destination)?_c('v-icon',{class:{'headerTab': item.header === 'true'},attrs:{"color":"primary"}},[_vm._v(_vm._s(item.icon))]):_c('v-icon',{class:{'headerTab': item.header === 'true'}},[_vm._v(_vm._s(item.icon))])],1),_vm._v(" "),_c('v-list-tile-title',[(item.header)?_c('span',{staticStyle:{"font-weight":"700"}},[_vm._v(_vm._s(item.title))]):_c('span',[_vm._v(_vm._s(item.title))])])],1)})):_c('v-layout',{directives:[{name:"show",rawName:"v-show",value:(!_vm.pageNavigationItems.length > 0),expression:"!pageNavigationItems.length > 0"}],staticClass:"mx-3 mt-3 mb-2",staticStyle:{"opacity":"0.6"},attrs:{"column":""}},[_c('v-card',{staticStyle:{"border":"1px solid #E8EAED","border-radius":"6px","cursor":"pointer"},attrs:{"flat":""}},[_c('v-card-text',[_c('span',{staticStyle:{"font-weight":"700","font-size":"18px","margin":"10px"}},[_vm._v("\n          About OneChart\n        ")]),_vm._v(" "),_c('p',{staticStyle:{"font-size":"14px","margin":"10px","text-align":"justified"}},[_vm._v("OneChart is a patient-first cloud based medical records platform designed to empower individuals and families to collect, store, and share their medical records in any care setting.")])]),_vm._v(" "),_c('v-card-actions',[_c('v-spacer'),_vm._v(" "),_c('v-btn',{attrs:{"small":"","flat":"","color":"primary"},nativeOn:{"click":function($event){_vm.goToAbout()}}},[_vm._v("Learn More")])],1)],1)],1),_vm._v(" "),_c('v-spacer'),_vm._v(" "),_c('v-list',_vm._l((_vm.globalNavigationItems),function(item,i){return _c('v-list-tile',{key:i,on:{"click":function($event){_vm.menuAction(i)}}},[_c('v-list-tile-avatar',[_c('v-icon',[_vm._v(_vm._s(item.icon))])],1),_vm._v(" "),_c('span',[_vm._v(_vm._s(item.title))])],1)})),_vm._v(" "),_c('upload-files-dialog',{ref:"upload"})],1)}
var staticRenderFns = []
var esExports = { render: render, staticRenderFns: staticRenderFns }
/* harmony default export */ __webpack_exports__["a"] = (esExports);

/***/ }),
/* 417 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_vue_loader_lib_selector_type_script_index_0_IdleDialog_vue__ = __webpack_require__(191);
/* unused harmony namespace reexport */
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__node_modules_vue_loader_lib_template_compiler_index_id_data_v_9e2a31f2_hasScoped_true_transformToRequire_video_src_poster_source_src_img_src_image_xlink_href_buble_transforms_node_modules_vue_loader_lib_selector_type_template_index_0_IdleDialog_vue__ = __webpack_require__(421);
function injectStyle (ssrContext) {
  __webpack_require__(418)
}
var normalizeComponent = __webpack_require__(0)
/* script */


/* template */

/* template functional */
var __vue_template_functional__ = false
/* styles */
var __vue_styles__ = injectStyle
/* scopeId */
var __vue_scopeId__ = "data-v-9e2a31f2"
/* moduleIdentifier (server only) */
var __vue_module_identifier__ = null
var Component = normalizeComponent(
  __WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_vue_loader_lib_selector_type_script_index_0_IdleDialog_vue__["a" /* default */],
  __WEBPACK_IMPORTED_MODULE_1__node_modules_vue_loader_lib_template_compiler_index_id_data_v_9e2a31f2_hasScoped_true_transformToRequire_video_src_poster_source_src_img_src_image_xlink_href_buble_transforms_node_modules_vue_loader_lib_selector_type_template_index_0_IdleDialog_vue__["a" /* default */],
  __vue_template_functional__,
  __vue_styles__,
  __vue_scopeId__,
  __vue_module_identifier__
)

/* harmony default export */ __webpack_exports__["a"] = (Component.exports);


/***/ }),
/* 418 */
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ }),
/* 419 */
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ }),
/* 420 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('v-card',{staticClass:"mt-4",staticStyle:{"background-color":"transparent"},attrs:{"flat":""}},[_c('v-layout',{attrs:{"row":""}},[_c('v-layout',{attrs:{"column":"","justify-center":""}},[_c('div',{staticClass:"logo",staticStyle:{"margin":"0 auto"}},[_c('img',{staticStyle:{"width":"300px"},attrs:{"src":_vm.correctLogoURL,"alt":""}})]),_vm._v(" "),(_vm.showCobranding)?_c('v-layout',{staticClass:"mt-2",attrs:{"justify-center":""}},[_c('span',{staticStyle:{"opacity":"0.5","font-size":"10"}},[_vm._v("Powered by OneChart Health")])]):_c('v-layout',{staticClass:"mt-2",attrs:{"justify-center":""}},[_c('span',{staticClass:"text-xs-center",staticStyle:{"opacity":"0.5","font-size":"10","width":"300px"}},[_vm._v("Securely store, access, and share your health information anywhere")])])],1)],1)],1)}
var staticRenderFns = []
var esExports = { render: render, staticRenderFns: staticRenderFns }
/* harmony default export */ __webpack_exports__["a"] = (esExports);

/***/ }),
/* 421 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('v-dialog',{attrs:{"persistent":_vm.options.persistent,"max-width":_vm.options.maxWidth,"fullscreen":"","scrollable":""},model:{value:(_vm.show),callback:function ($$v) {_vm.show=$$v},expression:"show"}},[_c('v-card',{attrs:{"flat":""}},[_c('v-layout',{staticStyle:{"margin-top":"5%"},attrs:{"row":"","justify-center":""}},[_c('v-card',{attrs:{"flat":""}},[_c('branding-header-card'),_vm._v(" "),_c('v-layout',{attrs:{"justify-center":"","row":""}},[_c('v-layout',{attrs:{"column":""}},[_c('v-layout',{staticClass:"ma-3",attrs:{"justify-center":"","row":""}},[_c('span',{staticStyle:{"font-weight":"700"}},[_vm._v("SESSION TIMEOUT")])]),_vm._v(" "),_c('span',{staticClass:"mb-4 mx-3",staticStyle:{"max-width":"400px"}},[_vm._v("For security purposes you will be logged out shortly due to inactivity. Please choose to stay signed in or to log out. Otherwise, you will be logged out automatically.")])],1)],1),_vm._v(" "),_c('v-card-text',[_c('div',{staticClass:"content"},[_vm._v("You will be logged out shortly. Do you want to stay signed in?")])]),_vm._v(" "),_c('v-card-actions',[_c('v-layout',{attrs:{"column":""}},[_c('v-btn',{attrs:{"flat":"","color":"primary"},on:{"click":function($event){_vm.ok()}}},[_vm._v("Sign me out")]),_vm._v(" "),_c('v-btn',{attrs:{"depressed":"","dark":"","color":"primary"},on:{"click":function($event){_vm.cancel()}}},[_vm._v("Keep me signed in")])],1)],1)],1)],1)],1)],1)}
var staticRenderFns = []
var esExports = { render: render, staticRenderFns: staticRenderFns }
/* harmony default export */ __webpack_exports__["a"] = (esExports);

/***/ }),
/* 422 */
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ }),
/* 423 */,
/* 424 */,
/* 425 */,
/* 426 */,
/* 427 */,
/* 428 */,
/* 429 */,
/* 430 */,
/* 431 */,
/* 432 */,
/* 433 */,
/* 434 */,
/* 435 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('v-navigation-drawer',{staticStyle:{"background-color":"#fafafc"},attrs:{"app":"","clipped":"","persistent":"","right":""},model:{value:(_vm.showNav),callback:function ($$v) {_vm.showNav=$$v},expression:"showNav"}},[_c('v-toolbar',{attrs:{"color":"#fafafc"}},[_c('v-toolbar-title',[_vm._v("\n            Notes\n        ")])],1),_vm._v(" "),(_vm.request)?_c('div',{ref:"chatScroll",staticClass:"messages scroll-y",staticStyle:{"background-color":"transparent"},attrs:{"flat":""}},_vm._l((_vm.request.log),function(log,index){return _c('v-layout',{key:index,attrs:{"row":""}},[_c('v-card',{class:_vm.alternatingColors(index),staticStyle:{"width":"100%"},attrs:{"flat":"","tile":""}},[_c('v-card-text',[_c('div',{staticStyle:{"font-size":"10px"}},[_vm._v(_vm._s(_vm.parseTimestamp(log.timestamp)))]),_vm._v(" "),_c('div',{staticStyle:{"overflow-wrap":"break-word","font-size":"12px"}},[_vm._v(_vm._s(log.message))])])],1)],1)})):_vm._e(),_vm._v(" "),_c('v-card',{staticStyle:{"width":"100%","bottom":"0","left":"0","position":"absolute","border-top":"1px solid #f5f5f5"},attrs:{"tile":"","color":"transparent"}},[_c('v-textarea',{staticClass:"px-2 mt-2",staticStyle:{"font-size":"12px"},attrs:{"outline":"","solo":"","hide-details":"","auto-grow":"","flat":""},on:{"keyup":function($event){if(!('button' in $event)&&_vm._k($event.keyCode,"enter",13,$event.key,"Enter")){ return null; }return _vm.submitLogEntry($event)}},model:{value:(_vm.logEntryInput),callback:function ($$v) {_vm.logEntryInput=$$v},expression:"logEntryInput"}}),_vm._v(" "),_c('v-layout',{attrs:{"column":""}},[_c('v-btn',{attrs:{"dark":"","depressed":"","color":"blue"},on:{"click":_vm.submitLogEntry}},[(_vm.updatingLog)?_c('v-progress-circular',{attrs:{"indeterminate":"","color":"white","size":"14","width":2}}):_c('span',[_vm._v("Submit Note")])],1)],1)],1)],1)}
var staticRenderFns = []
var esExports = { render: render, staticRenderFns: staticRenderFns }
/* harmony default export */ __webpack_exports__["a"] = (esExports);

/***/ }),
/* 436 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{class:_vm.classes,attrs:{"id":"app"}},[_c('v-app',[(!_vm.$route.meta.replaceHeader)?_c('v-toolbar',{staticStyle:{"background-color":"#e6e6e6"},attrs:{"flat":"","app":""}},[_c('v-toolbar-title',[_vm._v("\n        "+_vm._s(this.$route.meta.displayName)+"\n      ")]),_vm._v(" "),_c('v-spacer'),_vm._v(" "),(_vm.loadingRequests || _vm.loadingFiles)?_c('v-progress-circular',{attrs:{"color":"#4485ed","indeterminate":""}}):_vm._e()],1):_vm._e(),_vm._v(" "),(_vm.showHeader)?_c('v-navigation-drawer',{staticStyle:{"background-color":"#2E313A"},attrs:{"fixed":"","app":"","mini-variant":""}},[_c('v-layout',{staticStyle:{"height":"64px","background-color":"#4485ed"},attrs:{"justify-center":"","align-center":"","row":""}},[_c('v-avatar',[_c('v-icon',[_vm._v("folder")])],1)],1),_vm._v(" "),_c('global-navigation-toolbar')],1):_vm._e(),_vm._v(" "),_c('v-content',[_c('v-container',{staticClass:"pa-0 ma-0",attrs:{"fill-height":"","fluid":""}},[_c('router-view')],1)],1)],1),_vm._v(" "),_c('idle-dialog',{ref:"idleDialog"}),_vm._v(" "),_c('v-snackbar',{attrs:{"color":_vm.snackbarType,"timeout":3500},model:{value:(_vm.showSnackbar),callback:function ($$v) {_vm.showSnackbar=$$v},expression:"showSnackbar"}},[(_vm.snackbarType == 'success')?_c('v-icon',{staticClass:"mr-3",attrs:{"color":"white"}},[_vm._v("check")]):_c('v-icon',{staticClass:"mr-3",attrs:{"color":"white"}},[_vm._v("warning")]),_vm._v(" "),_c('div',[_vm._v(_vm._s(_vm.snackbarText))]),_vm._v(" "),_c('v-spacer')],1)],1)}
var staticRenderFns = []
var esExports = { render: render, staticRenderFns: staticRenderFns }
/* harmony default export */ __webpack_exports__["a"] = (esExports);

/***/ }),
/* 437 */,
/* 438 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_vue_loader_lib_selector_type_script_index_0_LoginPage_vue__ = __webpack_require__(199);
/* unused harmony namespace reexport */
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__node_modules_vue_loader_lib_template_compiler_index_id_data_v_2ebc1507_hasScoped_true_transformToRequire_video_src_poster_source_src_img_src_image_xlink_href_buble_transforms_node_modules_vue_loader_lib_selector_type_template_index_0_LoginPage_vue__ = __webpack_require__(440);
function injectStyle (ssrContext) {
  __webpack_require__(439)
}
var normalizeComponent = __webpack_require__(0)
/* script */


/* template */

/* template functional */
var __vue_template_functional__ = false
/* styles */
var __vue_styles__ = injectStyle
/* scopeId */
var __vue_scopeId__ = "data-v-2ebc1507"
/* moduleIdentifier (server only) */
var __vue_module_identifier__ = null
var Component = normalizeComponent(
  __WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_vue_loader_lib_selector_type_script_index_0_LoginPage_vue__["a" /* default */],
  __WEBPACK_IMPORTED_MODULE_1__node_modules_vue_loader_lib_template_compiler_index_id_data_v_2ebc1507_hasScoped_true_transformToRequire_video_src_poster_source_src_img_src_image_xlink_href_buble_transforms_node_modules_vue_loader_lib_selector_type_template_index_0_LoginPage_vue__["a" /* default */],
  __vue_template_functional__,
  __vue_styles__,
  __vue_scopeId__,
  __vue_module_identifier__
)

/* harmony default export */ __webpack_exports__["a"] = (Component.exports);


/***/ }),
/* 439 */
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ }),
/* 440 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('v-layout',{staticStyle:{"margin-top":"5%"},attrs:{"row":"","justify-center":"","align-center":""}},[_c('v-card',{staticClass:"login",staticStyle:{"border-radius":"6px","border":"1px solid #eeeeee"},attrs:{"flat":""}},[_c('branding-header-card'),_vm._v(" "),_c('v-card-text',[_c('v-layout',{attrs:{"row":""}},[_c('v-flex',[_c('v-layout',{directives:[{name:"show",rawName:"v-show",value:(!_vm.loading),expression:"!loading"}],attrs:{"column":""}},[_c('v-layout',{attrs:{"row":""}},[_c('v-flex',[_c('v-form',[_c('v-layout',[_c('span',{staticClass:"ml-2",staticStyle:{"opacity":"0.6","font-size":"10","font-weight":"700"}},[_vm._v("Sign In to continue to OneChart")])]),_vm._v(" "),_c('v-text-field',{staticClass:"mt-3",attrs:{"outline":"","hide-details":"","label":"Email","required":""},model:{value:(_vm.email),callback:function ($$v) {_vm.email=$$v},expression:"email"}}),_vm._v(" "),_c('v-text-field',{staticClass:"mt-4",attrs:{"outline":"","hide-details":"","label":"Password","required":"","hint":"At least 8 characters","append-icon":_vm.isPassVisible ? 'visibility_off' : 'visibility',"append-icon-cb":function () { return (_vm.isPassVisible = !_vm.isPassVisible); },"type":_vm.isPassVisible ? 'text' : 'password'},nativeOn:{"keydown":function($event){return _vm.enterPressed($event)}},model:{value:(_vm.password),callback:function ($$v) {_vm.password=$$v},expression:"password"}})],1)],1)],1)],1)],1)],1)],1),_vm._v(" "),_c('v-card-actions',{staticStyle:{"background-color":"white"},attrs:{"flat":""}},[_c('v-spacer'),_vm._v(" "),_c('v-btn',{staticStyle:{"min-width":"0"},attrs:{"depressed":"","color":"primary"},on:{"click":function($event){_vm.submit()}}},[_c('span',{directives:[{name:"show",rawName:"v-show",value:(!_vm.loadingLogin),expression:"!loadingLogin"}]},[_vm._v(_vm._s(_vm.signInButtonText))]),_vm._v(" "),_c('v-progress-circular',{directives:[{name:"show",rawName:"v-show",value:(_vm.loadingLogin),expression:"loadingLogin"}],attrs:{"indeterminate":"","color":"white","size":20}})],1)],1)],1)],1)}
var staticRenderFns = []
var esExports = { render: render, staticRenderFns: staticRenderFns }
/* harmony default export */ __webpack_exports__["a"] = (esExports);

/***/ }),
/* 441 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_vue_loader_lib_selector_type_script_index_0_ForgotPasswordPage_vue__ = __webpack_require__(200);
/* unused harmony namespace reexport */
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__node_modules_vue_loader_lib_template_compiler_index_id_data_v_9f8383fc_hasScoped_true_transformToRequire_video_src_poster_source_src_img_src_image_xlink_href_buble_transforms_node_modules_vue_loader_lib_selector_type_template_index_0_ForgotPasswordPage_vue__ = __webpack_require__(446);
function injectStyle (ssrContext) {
  __webpack_require__(442)
}
var normalizeComponent = __webpack_require__(0)
/* script */


/* template */

/* template functional */
var __vue_template_functional__ = false
/* styles */
var __vue_styles__ = injectStyle
/* scopeId */
var __vue_scopeId__ = "data-v-9f8383fc"
/* moduleIdentifier (server only) */
var __vue_module_identifier__ = null
var Component = normalizeComponent(
  __WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_vue_loader_lib_selector_type_script_index_0_ForgotPasswordPage_vue__["a" /* default */],
  __WEBPACK_IMPORTED_MODULE_1__node_modules_vue_loader_lib_template_compiler_index_id_data_v_9f8383fc_hasScoped_true_transformToRequire_video_src_poster_source_src_img_src_image_xlink_href_buble_transforms_node_modules_vue_loader_lib_selector_type_template_index_0_ForgotPasswordPage_vue__["a" /* default */],
  __vue_template_functional__,
  __vue_styles__,
  __vue_scopeId__,
  __vue_module_identifier__
)

/* harmony default export */ __webpack_exports__["a"] = (Component.exports);


/***/ }),
/* 442 */
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ }),
/* 443 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_vue_loader_lib_selector_type_script_index_0_LogoHeaderCard_vue__ = __webpack_require__(201);
/* unused harmony namespace reexport */
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__node_modules_vue_loader_lib_template_compiler_index_id_data_v_cbe0eafa_hasScoped_true_transformToRequire_video_src_poster_source_src_img_src_image_xlink_href_buble_transforms_node_modules_vue_loader_lib_selector_type_template_index_0_LogoHeaderCard_vue__ = __webpack_require__(445);
function injectStyle (ssrContext) {
  __webpack_require__(444)
}
var normalizeComponent = __webpack_require__(0)
/* script */


/* template */

/* template functional */
var __vue_template_functional__ = false
/* styles */
var __vue_styles__ = injectStyle
/* scopeId */
var __vue_scopeId__ = "data-v-cbe0eafa"
/* moduleIdentifier (server only) */
var __vue_module_identifier__ = null
var Component = normalizeComponent(
  __WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_vue_loader_lib_selector_type_script_index_0_LogoHeaderCard_vue__["a" /* default */],
  __WEBPACK_IMPORTED_MODULE_1__node_modules_vue_loader_lib_template_compiler_index_id_data_v_cbe0eafa_hasScoped_true_transformToRequire_video_src_poster_source_src_img_src_image_xlink_href_buble_transforms_node_modules_vue_loader_lib_selector_type_template_index_0_LogoHeaderCard_vue__["a" /* default */],
  __vue_template_functional__,
  __vue_styles__,
  __vue_scopeId__,
  __vue_module_identifier__
)

/* harmony default export */ __webpack_exports__["a"] = (Component.exports);


/***/ }),
/* 444 */
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ }),
/* 445 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('v-card',{staticStyle:{"background-color":"transparent"},attrs:{"flat":""},nativeOn:{"click":function($event){_vm.$router.push({name: 'HomePage'})}}},[_c('v-card-text',[_c('v-layout',{attrs:{"row":""}},[_c('v-layout',{attrs:{"column":"","justify-center":""}},[(_vm.showLogo)?_c('div',{staticClass:"logo",staticStyle:{"margin":"0 auto"}},[_c('img',{staticStyle:{"max-width":"100%","margin-bottom":"30px"},attrs:{"src":_vm.showLogo,"alt":""}})]):_vm._e(),_vm._v(" "),(_vm.showLogo)?_c('v-divider',{directives:[{name:"show",rawName:"v-show",value:(!_vm.recordShare && !_vm.providerLanding),expression:"!recordShare && !providerLanding"}],staticStyle:{"margin-bottom":"10px"}}):_vm._e(),_vm._v(" "),_c('div',{staticClass:"logo",staticStyle:{"margin":"0 auto"}},[(_vm.showLogo)?_c('img',{directives:[{name:"show",rawName:"v-show",value:(!_vm.recordShare && !_vm.providerLanding),expression:"!recordShare && !providerLanding"}],staticStyle:{"height":"40px","max-width":"100%","margin-bottom":"20px"},attrs:{"src":_vm.standardLogo,"alt":""}}):_c('img',{staticStyle:{"max-width":"100%"},attrs:{"src":_vm.standardLogo,"alt":""}})]),_vm._v(" "),(_vm.loginDetailText)?_c('v-layout',{attrs:{"justify-center":"","column":""}},[(!_vm.recordShare && !_vm.providerLanding)?_c('span',{staticStyle:{"font-size":"18px","font-weight":"300","text-align":"center","margin-top":"20px","margin-right":"30px","margin-left":"30px"}},[_vm._v(_vm._s(_vm.loginDetailText))]):_vm._e(),_vm._v(" "),(_vm.recordShare)?_c('span',{staticStyle:{"font-size":"18px","font-weight":"700","text-align":"center","margin-top":"20px"}},[_vm._v(_vm._s(_vm.loginDetailText))]):_vm._e(),_vm._v(" "),(_vm.recordShare)?_c('span',{staticStyle:{"font-size":"14px","margin-top":"5px","font-weight":"300","text-align":"center"}},[_vm._v("Returning OneChart users may enter their credentials below. To maintain the privacy and confidentiality of the shared records, if this is your first time using the OneChart platform you must register before viewing the shared records.")]):_vm._e()]):_vm._e()],1)],1)],1)],1)}
var staticRenderFns = []
var esExports = { render: render, staticRenderFns: staticRenderFns }
/* harmony default export */ __webpack_exports__["a"] = (esExports);

/***/ }),
/* 446 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('v-layout',{staticClass:"forgot-password",attrs:{"justify-center":""}},[_c('v-card',{attrs:{"flat":"","color":"transparent"}},[_c('logo-header-card'),_vm._v(" "),_c('v-card-text',[_c('p',[_vm._v("Enter your email address below, and a link to reset your password will be sent immediately.")]),_vm._v(" "),_c('v-form',{model:{value:(_vm.valid),callback:function ($$v) {_vm.valid=$$v},expression:"valid"}},[_c('v-text-field',{staticClass:"form-input",attrs:{"flat":"","outline":"","label":"E-mail","rules":_vm.emailRules,"required":""},model:{value:(_vm.email),callback:function ($$v) {_vm.email=$$v},expression:"email"}})],1)],1),_vm._v(" "),_c('v-card-actions',[_c('v-spacer'),_vm._v(" "),_c('v-btn',{attrs:{"depressed":"","color":"primary","disabled":!_vm.valid},on:{"click":function($event){_vm.doResetPassword()}}},[_vm._v("Reset password")])],1)],1)],1)}
var staticRenderFns = []
var esExports = { render: render, staticRenderFns: staticRenderFns }
/* harmony default export */ __webpack_exports__["a"] = (esExports);

/***/ }),
/* 447 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_vue_loader_lib_selector_type_script_index_0_ResetPasswordPage_vue__ = __webpack_require__(202);
/* unused harmony namespace reexport */
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__node_modules_vue_loader_lib_template_compiler_index_id_data_v_f50089e8_hasScoped_true_transformToRequire_video_src_poster_source_src_img_src_image_xlink_href_buble_transforms_node_modules_vue_loader_lib_selector_type_template_index_0_ResetPasswordPage_vue__ = __webpack_require__(449);
function injectStyle (ssrContext) {
  __webpack_require__(448)
}
var normalizeComponent = __webpack_require__(0)
/* script */


/* template */

/* template functional */
var __vue_template_functional__ = false
/* styles */
var __vue_styles__ = injectStyle
/* scopeId */
var __vue_scopeId__ = "data-v-f50089e8"
/* moduleIdentifier (server only) */
var __vue_module_identifier__ = null
var Component = normalizeComponent(
  __WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_vue_loader_lib_selector_type_script_index_0_ResetPasswordPage_vue__["a" /* default */],
  __WEBPACK_IMPORTED_MODULE_1__node_modules_vue_loader_lib_template_compiler_index_id_data_v_f50089e8_hasScoped_true_transformToRequire_video_src_poster_source_src_img_src_image_xlink_href_buble_transforms_node_modules_vue_loader_lib_selector_type_template_index_0_ResetPasswordPage_vue__["a" /* default */],
  __vue_template_functional__,
  __vue_styles__,
  __vue_scopeId__,
  __vue_module_identifier__
)

/* harmony default export */ __webpack_exports__["a"] = (Component.exports);


/***/ }),
/* 448 */
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ }),
/* 449 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('v-layout',{staticClass:"reset-password-page",attrs:{"column":"","justify-center":"","align-center":""}},[(this.showSpecialtyLogo)?_c('div',{staticClass:"logo"},[_c('img',{staticStyle:{"margin-top":"16px"},attrs:{"src":this.showSpecialtyLogo,"height":"50","alt":""}})]):_c('div',{staticClass:"logo",attrs:{"router":""}},[_c('i',{staticClass:"material-icons",staticStyle:{"padding":"7px","margin-right":"20px","backgroundColor":"#4485ed","border-radius":"50%","color":"#E6E6E8"}},[_vm._v("folder")]),_vm._v(" "),_c('div',{staticClass:"logo-title"},[_vm._v("OneChart")])]),_vm._v(" "),(_vm.authUser)?_c('v-layout',{attrs:{"column":""}},[(_vm.sent)?_c('v-card',{attrs:{"flat":"","color":"transparent"}},[_c('v-card-text',[_c('v-layout',{attrs:{"justify-center":"","align-center":""}},[_c('i',{staticClass:"material-icons check-icon"},[_vm._v("check_circle")])]),_vm._v(" "),_c('div',{staticClass:"content"},[_vm._v(_vm._s(_vm.$t('auth.sendResetPasswordSent')))]),_vm._v(" "),_c('div',{staticClass:"email"},[_vm._v(_vm._s(_vm.authUser.email || _vm.$t('auth.noEmail')))])],1)],1):_c('v-card',{staticClass:"card",attrs:{"flat":"","color":"transparent"}},[_c('v-card-text',[_c('div',{staticClass:"content"},[_vm._v(_vm._s(_vm.$t('auth.sendResetPasswordContent')))]),_vm._v(" "),_c('div',{staticClass:"email"},[_vm._v(_vm._s(_vm.authUser.email  || _vm.$t('auth.noEmail')))])]),_vm._v(" "),_c('v-card-actions',[(_vm.authUser.email)?_c('v-btn',{staticStyle:{"width":"100%"},attrs:{"depressed":"","loading":_vm.sending,"color":"primary"},on:{"click":function($event){_vm.reset()}}},[_vm._v(_vm._s(_vm.$t('auth.sendResetPassword')))]):_vm._e()],1)],1)],1):_c('v-progress-circular',{staticClass:"busy",attrs:{"indeterminate":"","size":50,"color":"primary"}})],1)}
var staticRenderFns = []
var esExports = { render: render, staticRenderFns: staticRenderFns }
/* harmony default export */ __webpack_exports__["a"] = (esExports);

/***/ }),
/* 450 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_vue_loader_lib_selector_type_script_index_0_AdminLandingPage_vue__ = __webpack_require__(203);
/* unused harmony namespace reexport */
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__node_modules_vue_loader_lib_template_compiler_index_id_data_v_567ab8be_hasScoped_true_transformToRequire_video_src_poster_source_src_img_src_image_xlink_href_buble_transforms_node_modules_vue_loader_lib_selector_type_template_index_0_AdminLandingPage_vue__ = __webpack_require__(452);
function injectStyle (ssrContext) {
  __webpack_require__(451)
}
var normalizeComponent = __webpack_require__(0)
/* script */


/* template */

/* template functional */
var __vue_template_functional__ = false
/* styles */
var __vue_styles__ = injectStyle
/* scopeId */
var __vue_scopeId__ = "data-v-567ab8be"
/* moduleIdentifier (server only) */
var __vue_module_identifier__ = null
var Component = normalizeComponent(
  __WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_vue_loader_lib_selector_type_script_index_0_AdminLandingPage_vue__["a" /* default */],
  __WEBPACK_IMPORTED_MODULE_1__node_modules_vue_loader_lib_template_compiler_index_id_data_v_567ab8be_hasScoped_true_transformToRequire_video_src_poster_source_src_img_src_image_xlink_href_buble_transforms_node_modules_vue_loader_lib_selector_type_template_index_0_AdminLandingPage_vue__["a" /* default */],
  __vue_template_functional__,
  __vue_styles__,
  __vue_scopeId__,
  __vue_module_identifier__
)

/* harmony default export */ __webpack_exports__["a"] = (Component.exports);


/***/ }),
/* 451 */
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ }),
/* 452 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('v-layout',{staticClass:"patient-page",attrs:{"column":""}},[_c('v-container',{attrs:{"fluid":"","grid-list-md":""}},[_c('span',{staticClass:"headerTabSelected"},[_vm._v("Admin")]),_vm._v(" "),_c('v-layout',{attrs:{"row":"","wrap":"","mb-3":""}},[_c('v-btn',{attrs:{"router":"","to":{name: 'AdminUploadsPage'},"depressed":""}},[_vm._v("Documents")]),_vm._v(" "),_c('v-btn',{attrs:{"router":"","to":{name: 'AdminFileUploadPage'},"depressed":""}},[_vm._v("Add Medical Record")]),_vm._v(" "),_c('v-btn',{attrs:{"router":"","to":{name: 'AdminRequestsPage'},"depressed":""}},[_vm._v("Requests")]),_vm._v(" "),_c('v-btn',{attrs:{"router":"","to":{name: 'AdminPatientsPage'},"depressed":""}},[_vm._v("Patients")]),_vm._v(" "),_c('v-btn',{attrs:{"router":"","to":{name: 'AdminProvidersPage'},"depressed":""}},[_vm._v("Providers")])],1),_vm._v(" "),_c('span',{staticClass:"headerTabSelected"},[_vm._v("Stats")]),_vm._v(" "),_c('v-data-iterator',{attrs:{"items":_vm.items,"rows-per-page-items":_vm.rowsPerPageItems,"pagination":_vm.pagination,"content-tag":"v-layout","row":"","wrap":""},on:{"update:pagination":function($event){_vm.pagination=$event}},scopedSlots:_vm._u([{key:"item",fn:function(props){return _c('v-flex',{attrs:{"xs12":"","sm6":"","md4":"","lg3":""}},[_c('v-card',{attrs:{"flat":""}},[_c('v-card-title',[_c('h4',[_vm._v(_vm._s(props.item.name))])]),_vm._v(" "),_c('v-divider'),_vm._v(" "),_c('div',{directives:[{name:"show",rawName:"v-show",value:(!_vm.patientSearchResults),expression:"!patientSearchResults"}],staticClass:"text-xs-center mt-4"},[_c('v-progress-circular',{attrs:{"size":30,"width":3,"color":"#eeeeee","indeterminate":""}})],1),_vm._v(" "),_c('v-list',{directives:[{name:"show",rawName:"v-show",value:(_vm.patientSearchResults),expression:"patientSearchResults"}],attrs:{"dense":""}},[_c('v-list-tile',[_c('v-list-tile-content',[_vm._v("Total Patients:")]),_vm._v(" "),_c('v-list-tile-content',{staticClass:"align-end"},[_vm._v(_vm._s(props.item.totalPatients))])],1),_vm._v(" "),_c('v-list-tile',[_c('v-list-tile-content',[_vm._v("New Patients Today:")]),_vm._v(" "),_c('v-list-tile-content',{staticClass:"align-end"},[_vm._v(_vm._s(props.item.newPatientsToday))])],1),_vm._v(" "),_c('v-list-tile',[_c('v-list-tile-content',[_vm._v("New Patients This Month:")]),_vm._v(" "),_c('v-list-tile-content',{staticClass:"align-end"},[_vm._v(_vm._s(props.item.newPatientsThisMonth))])],1),_vm._v(" "),_c('v-list-tile',[_c('v-list-tile-content',[_vm._v("New Patients Last Month:")]),_vm._v(" "),_c('v-list-tile-content',{staticClass:"align-end"},[_vm._v(_vm._s(props.item.newPatientsLastMonth))])],1)],1)],1)],1)}}])})],1)],1)}
var staticRenderFns = []
var esExports = { render: render, staticRenderFns: staticRenderFns }
/* harmony default export */ __webpack_exports__["a"] = (esExports);

/***/ }),
/* 453 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_vue_loader_lib_selector_type_script_index_0_AdminProvidersPage_vue__ = __webpack_require__(204);
/* unused harmony namespace reexport */
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__node_modules_vue_loader_lib_template_compiler_index_id_data_v_43bd9730_hasScoped_true_transformToRequire_video_src_poster_source_src_img_src_image_xlink_href_buble_transforms_node_modules_vue_loader_lib_selector_type_template_index_0_AdminProvidersPage_vue__ = __webpack_require__(465);
function injectStyle (ssrContext) {
  __webpack_require__(454)
}
var normalizeComponent = __webpack_require__(0)
/* script */


/* template */

/* template functional */
var __vue_template_functional__ = false
/* styles */
var __vue_styles__ = injectStyle
/* scopeId */
var __vue_scopeId__ = "data-v-43bd9730"
/* moduleIdentifier (server only) */
var __vue_module_identifier__ = null
var Component = normalizeComponent(
  __WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_vue_loader_lib_selector_type_script_index_0_AdminProvidersPage_vue__["a" /* default */],
  __WEBPACK_IMPORTED_MODULE_1__node_modules_vue_loader_lib_template_compiler_index_id_data_v_43bd9730_hasScoped_true_transformToRequire_video_src_poster_source_src_img_src_image_xlink_href_buble_transforms_node_modules_vue_loader_lib_selector_type_template_index_0_AdminProvidersPage_vue__["a" /* default */],
  __vue_template_functional__,
  __vue_styles__,
  __vue_scopeId__,
  __vue_module_identifier__
)

/* harmony default export */ __webpack_exports__["a"] = (Component.exports);


/***/ }),
/* 454 */
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ }),
/* 455 */
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ }),
/* 456 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('v-layout',{staticClass:"titlebar",attrs:{"column":"","justify-center":""}},[_c('v-layout',{attrs:{"row":""}},[_c('div',{class:{ 'pageSubtitle light': !this.small, 'titlebar-title-small': this.small }},[_vm._v(_vm._s(_vm.title))]),_vm._v(" "),_c('v-spacer'),_vm._v(" "),_vm._t("actionButton")],2),_vm._v(" "),_c('v-layout',{staticClass:"helperText",attrs:{"row":""}},[_vm._t("helperText")],2)],1)}
var staticRenderFns = []
var esExports = { render: render, staticRenderFns: staticRenderFns }
/* harmony default export */ __webpack_exports__["a"] = (esExports);

/***/ }),
/* 457 */
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ }),
/* 458 */,
/* 459 */,
/* 460 */,
/* 461 */,
/* 462 */
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ }),
/* 463 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('textarea',{ref:"textarea",staticClass:"textarea",attrs:{"placeholder":_vm.placeholder},domProps:{"value":_vm.value},on:{"input":function (e) { _vm.$emit('input', e.target.value) },"focus":function (e) { return e.target.select(); }}})}
var staticRenderFns = []
var esExports = { render: render, staticRenderFns: staticRenderFns }
/* harmony default export */ __webpack_exports__["a"] = (esExports);

/***/ }),
/* 464 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('v-dialog',{staticClass:"search-dialog",attrs:{"persistent":_vm.options.persistent,"transition":_vm.transition,"max-width":"600px","fullscreen":_vm.$vuetify.breakpoint.xsOnly,"scrollable":""},model:{value:(_vm.show),callback:function ($$v) {_vm.show=$$v},expression:"show"}},[_c('v-card',{attrs:{"height":"550px"}},[_c('v-toolbar',{attrs:{"flat":"","dark":"","color":"primary"}},[_c('v-btn',{attrs:{"icon":"","dark":""},on:{"click":_vm.cancelDialog}},[_c('v-icon',[_vm._v("close")])],1),_vm._v(" "),_c('v-toolbar-title',[_vm._v(_vm._s(_vm.formTitle))]),_vm._v(" "),_c('v-spacer'),_vm._v(" "),_c('v-btn',{staticStyle:{"min-width":"0","font-weight":"700"},attrs:{"disabled":!_vm.addressValid,"dark":"","flat":""},on:{"click":function($event){_vm.submit()}}},[_vm._v("SUBMIT")])],1),_vm._v(" "),_c('v-card-text',[_c('v-card',{directives:[{name:"show",rawName:"v-show",value:(!this.selectedAllergy),expression:"!this.selectedAllergy"}],staticClass:"mx-2 my-1",attrs:{"column":"","flat":""}},[_c('v-layout',{attrs:{"column":""}},[_c('v-form',{model:{value:(_vm.profileValid),callback:function ($$v) {_vm.profileValid=$$v},expression:"profileValid"}},[_c('v-text-field',{staticClass:"mt-1 mb-1",attrs:{"flat":"","label":"First Name"},model:{value:(_vm.firstNameInput),callback:function ($$v) {_vm.firstNameInput=$$v},expression:"firstNameInput"}}),_vm._v(" "),_c('v-text-field',{staticClass:"mt-1 mb-1",attrs:{"flat":"","label":"Last Name"},model:{value:(_vm.lastNameInput),callback:function ($$v) {_vm.lastNameInput=$$v},expression:"lastNameInput"}}),_vm._v(" "),_c('v-text-field',{staticClass:"mt-1 mb-1",attrs:{"flat":"","label":"Credentials"},model:{value:(_vm.credentialsInput),callback:function ($$v) {_vm.credentialsInput=$$v},expression:"credentialsInput"}}),_vm._v(" "),_c('v-text-field',{staticClass:"mt-1 mb-1",attrs:{"flat":"","label":"Organization Name"},model:{value:(_vm.orgNameInput),callback:function ($$v) {_vm.orgNameInput=$$v},expression:"orgNameInput"}}),_vm._v(" "),_c('v-text-field',{staticClass:"mt-1 mb-1",attrs:{"flat":"","mask":_vm.phoneMask,"label":"Phone"},model:{value:(_vm.phoneInput),callback:function ($$v) {_vm.phoneInput=$$v},expression:"phoneInput"}}),_vm._v(" "),_c('v-text-field',{staticClass:"mt-1 mb-1",attrs:{"flat":"","mask":_vm.phoneMask,"label":"Fax"},model:{value:(_vm.faxInput),callback:function ($$v) {_vm.faxInput=$$v},expression:"faxInput"}}),_vm._v(" "),_c('v-text-field',{staticClass:"mt-1 mb-1",attrs:{"flat":"","label":"Email"},model:{value:(_vm.emailInput),callback:function ($$v) {_vm.emailInput=$$v},expression:"emailInput"}})],1),_vm._v(" "),_c('v-form',{model:{value:(_vm.addressValid),callback:function ($$v) {_vm.addressValid=$$v},expression:"addressValid"}},[_c('v-text-field',{staticClass:"mt-1 mb-1",attrs:{"flat":"","label":"Street Address","rules":_vm.line1Rules},model:{value:(_vm.line1Input),callback:function ($$v) {_vm.line1Input=$$v},expression:"line1Input"}}),_vm._v(" "),_c('v-text-field',{staticClass:"mt-1 mb-1",attrs:{"flat":"","label":"Address Line 2"},model:{value:(_vm.line2Input),callback:function ($$v) {_vm.line2Input=$$v},expression:"line2Input"}}),_vm._v(" "),_c('v-text-field',{staticClass:"mt-1 mb-1",attrs:{"flat":"","label":"City","rules":_vm.cityRules},model:{value:(_vm.cityInput),callback:function ($$v) {_vm.cityInput=$$v},expression:"cityInput"}}),_vm._v(" "),_c('v-text-field',{staticClass:"mt-1 mb-1",attrs:{"hint":"Two letter abbreviation","rules":_vm.stateValidationRule,"mask":"AA","persistent-hint":"","label":"State"},model:{value:(_vm.stateInput),callback:function ($$v) {_vm.stateInput=$$v},expression:"stateInput"}}),_vm._v(" "),_c('v-text-field',{staticClass:"mt-1 mb-1",attrs:{"flat":"","label":"Zip Code","rules":_vm.zipRules,"mask":"#####"},model:{value:(_vm.zipInput),callback:function ($$v) {_vm.zipInput=$$v},expression:"zipInput"}}),_vm._v(" "),_c('v-text-field',{staticClass:"mt-1 mb-1",attrs:{"multi-line":"","flat":"","label":"Provider Notes"},model:{value:(_vm.notesInput),callback:function ($$v) {_vm.notesInput=$$v},expression:"notesInput"}})],1)],1)],1)],1),_vm._v(" "),(_vm.selectedAllergy !== '')?_c('v-card',{attrs:{"flat":""}},[_c('v-card-text',[_c('span',{staticClass:"dialogSectionTitle"},[_vm._v(_vm._s(_vm.selectedAllergy))]),_vm._v(" "),_c('v-layout',{attrs:{"column":""}},[_c('div',{staticClass:"mb-2"}),_vm._v(" "),_c('v-layout',{attrs:{"column":"","justify-center":""}},[_c('span',{staticClass:"dialogSectionTitle",staticStyle:{"opacity":".3"}},[_vm._v("Select onset date (optional)")]),_vm._v(" "),_c('v-date-picker',{staticClass:"mt-4",staticStyle:{"margin":"auto"},attrs:{"flat":"","min-width":"640px","no-title":""},model:{value:(_vm.date),callback:function ($$v) {_vm.date=$$v},expression:"date"}})],1)],1)],1)],1):_vm._e()],1)],1)}
var staticRenderFns = []
var esExports = { render: render, staticRenderFns: staticRenderFns }
/* harmony default export */ __webpack_exports__["a"] = (esExports);

/***/ }),
/* 465 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('v-layout',{staticClass:"patient-page",attrs:{"column":""}},[_c('v-card',{staticClass:"ma-2 mt-4",attrs:{"flat":""}},[_c('v-layout',{attrs:{"row":""}},[_c('span',{staticClass:"headerTabUnselected",on:{"click":function($event){_vm.adminHome()}}},[_vm._v("Admin")]),_c('span',{staticClass:"headerTabSelected"},[_vm._v("Providers")])]),_vm._v(" "),_c('v-text-field',{staticClass:"search-field mt-3 mb-4",attrs:{"hide-details":"","solo":"","flat":"","background-color":"transparent","prepend-icon":"search","label":"Search by provider ID, last name, org name, zip code","single-line":""},model:{value:(_vm.search),callback:function ($$v) {_vm.search=$$v},expression:"search"}}),_vm._v(" "),_c('v-data-table',{staticClass:"flat mb-2 table-border",attrs:{"headers":_vm.headers,"items":_vm.providerSearchResults,"sort-icon":"","rows-per-page-items":[15,{text: 'All', value:-1}],"search":_vm.search,"color":"#eeeeee"},scopedSlots:_vm._u([{key:"items",fn:function(props){return [_c('tr',{staticStyle:{"cursor":"pointer"},on:{"click":function($event){props.expanded = !props.expanded}}},[_c('td',{staticClass:"text-xs-left"},[_vm._v(_vm._s(props.item.id))]),_vm._v(" "),_c('td',[_vm._v(" "+_vm._s(_vm.formatNPI(props.item)))]),_vm._v(" "),_c('td',{staticClass:"text-xs-left"},[_vm._v(_vm._s(_vm.formatProviderName(props.item)))]),_vm._v(" "),_c('td',{staticClass:"text-xs-left"},[_vm._v(_vm._s(_vm.formatOrgName(props.item)))]),_vm._v(" "),_c('td',{staticClass:"text-xs-left"},[_vm._v(_vm._s(_vm.formatZip(props.item)))])])]}},{key:"expand",fn:function(props){return [_c('v-card',{attrs:{"flat":""}},[_c('v-toolbar',{attrs:{"dense":"","flat":"","color":"transparent"}},[_c('v-toolbar-title',[_vm._v(_vm._s(_vm.formatProviderNameForCard(props.item)))]),_vm._v(" "),_c('v-spacer'),_vm._v(" "),_c('v-toolbar-items',[_c('v-btn',{attrs:{"small":"","flat":"","icon":""},on:{"click":function($event){_vm.editProvider(props.item)}}},[_c('v-icon',[_vm._v("edit")])],1)],1)],1),_vm._v(" "),_c('v-card-text',[_c('v-layout',{attrs:{"column":""}},[_c('v-layout',{attrs:{"row":"","wrap":""}},[_c('v-card',{staticClass:"ma-2",attrs:{"flat":""}},[_c('v-layout',{attrs:{"column":""}},[_c('span',[_vm._v("Address")]),_vm._v(" "),_c('span',[_vm._v(_vm._s(_vm.providerDisplayAddressFromProviderObject(props.item)))])])],1),_vm._v(" "),_c('v-card',{staticClass:"ma-2",attrs:{"flat":""}},[_c('v-layout',{attrs:{"column":""}},[_c('span',[_vm._v("Phone")]),_vm._v(" "),_c('span',[_vm._v(_vm._s(props.item.phone))])])],1),_vm._v(" "),_c('v-card',{staticClass:"ma-2",attrs:{"flat":""}},[_c('v-layout',{attrs:{"column":""}},[_c('span',[_vm._v("Fax")]),_vm._v(" "),_c('span',[_vm._v(_vm._s(props.item.fax))])])],1),_vm._v(" "),_c('v-card',{staticClass:"ma-2",attrs:{"flat":""}},[_c('v-layout',{attrs:{"column":""}},[_c('span',[_vm._v("Email")]),_vm._v(" "),_c('span',[_vm._v(_vm._s(props.item.email))])])],1)],1),_vm._v(" "),_c('v-card',{staticClass:"ma-2",attrs:{"flat":""}},[_c('v-layout',{attrs:{"column":""}},[_c('span',[_vm._v("Provider Notes")]),_vm._v(" "),_c('span',[_vm._v(_vm._s(props.item.notes))])])],1),_vm._v(" "),_c('v-layout',{attrs:{"row":"","wrap":""}},[_c('v-card',{staticClass:"ma-2",attrs:{"flat":""}},[_c('v-layout',{attrs:{"row":""}},[_c('v-layout',{attrs:{"column":""}},[_c('span',[_vm._v("Secure Affiliate Link")]),_vm._v(" "),_c('span',[_vm._v(_vm._s(_vm.formatSecureAffiliateLink(props.item)))])]),_vm._v(" "),_c('v-spacer'),_vm._v(" "),_c('v-btn',{attrs:{"depressed":""},on:{"click":function($event){_vm.sendInviteFax(props.item)}}},[_vm._v("Send Invite Fax")])],1)],1)],1),_vm._v(" "),(props.item.googlePlaceID)?_c('v-layout',{attrs:{"row":"","wrap":""}},[_c('v-card',{staticClass:"ma-2",attrs:{"flat":""}},[_c('v-layout',{attrs:{"column":""}},[_c('span',[_vm._v("Google Places Link")]),_vm._v(" "),_c('a',{attrs:{"href":_vm.formatGooglePlacesLink(props.item),"target":"_blank"}},[_vm._v(_vm._s(_vm.formatGooglePlacesLink(props.item)))])])],1)],1):_vm._e(),_vm._v(" "),_c('v-card',{staticClass:"ma-2",staticStyle:{"opacity":"0.5"},attrs:{"flat":""}},[_c('span',[_vm._v(_vm._s(props.item))])]),_vm._v(" "),_c('v-layout',{staticStyle:{"opacity":"0.5","margin-top":"20px"},attrs:{"row":""}},[_c('v-spacer'),_vm._v(_vm._s(_vm.formatOrigin(props.item))+"\n              ")],1)],1)],1)],1)]}}])},[_c('v-progress-linear',{directives:[{name:"show",rawName:"v-show",value:(!_vm.providerSearchResults),expression:"!providerSearchResults"}],attrs:{"slot":"progress","color":"blue","indeterminate":""},slot:"progress"})],1)],1),_vm._v(" "),_c('add-edit-provider-dialog',{ref:"addEditProviderDialog",on:{"emitProviderUpdate":function($event){_vm.reloadOnReturn()}}})],1)}
var staticRenderFns = []
var esExports = { render: render, staticRenderFns: staticRenderFns }
/* harmony default export */ __webpack_exports__["a"] = (esExports);

/***/ }),
/* 466 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_vue_loader_lib_selector_type_script_index_0_AdminUploadsPage_vue__ = __webpack_require__(209);
/* unused harmony namespace reexport */
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__node_modules_vue_loader_lib_template_compiler_index_id_data_v_6d32a4ba_hasScoped_true_transformToRequire_video_src_poster_source_src_img_src_image_xlink_href_buble_transforms_node_modules_vue_loader_lib_selector_type_template_index_0_AdminUploadsPage_vue__ = __webpack_require__(471);
function injectStyle (ssrContext) {
  __webpack_require__(467)
}
var normalizeComponent = __webpack_require__(0)
/* script */


/* template */

/* template functional */
var __vue_template_functional__ = false
/* styles */
var __vue_styles__ = injectStyle
/* scopeId */
var __vue_scopeId__ = "data-v-6d32a4ba"
/* moduleIdentifier (server only) */
var __vue_module_identifier__ = null
var Component = normalizeComponent(
  __WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_vue_loader_lib_selector_type_script_index_0_AdminUploadsPage_vue__["a" /* default */],
  __WEBPACK_IMPORTED_MODULE_1__node_modules_vue_loader_lib_template_compiler_index_id_data_v_6d32a4ba_hasScoped_true_transformToRequire_video_src_poster_source_src_img_src_image_xlink_href_buble_transforms_node_modules_vue_loader_lib_selector_type_template_index_0_AdminUploadsPage_vue__["a" /* default */],
  __vue_template_functional__,
  __vue_styles__,
  __vue_scopeId__,
  __vue_module_identifier__
)

/* harmony default export */ __webpack_exports__["a"] = (Component.exports);


/***/ }),
/* 467 */
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ }),
/* 468 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_vue_loader_lib_selector_type_script_index_0_UploadDialog_vue__ = __webpack_require__(210);
/* unused harmony namespace reexport */
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__node_modules_vue_loader_lib_template_compiler_index_id_data_v_c0f37462_hasScoped_true_transformToRequire_video_src_poster_source_src_img_src_image_xlink_href_buble_transforms_node_modules_vue_loader_lib_selector_type_template_index_0_UploadDialog_vue__ = __webpack_require__(470);
function injectStyle (ssrContext) {
  __webpack_require__(469)
}
var normalizeComponent = __webpack_require__(0)
/* script */


/* template */

/* template functional */
var __vue_template_functional__ = false
/* styles */
var __vue_styles__ = injectStyle
/* scopeId */
var __vue_scopeId__ = "data-v-c0f37462"
/* moduleIdentifier (server only) */
var __vue_module_identifier__ = null
var Component = normalizeComponent(
  __WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_vue_loader_lib_selector_type_script_index_0_UploadDialog_vue__["a" /* default */],
  __WEBPACK_IMPORTED_MODULE_1__node_modules_vue_loader_lib_template_compiler_index_id_data_v_c0f37462_hasScoped_true_transformToRequire_video_src_poster_source_src_img_src_image_xlink_href_buble_transforms_node_modules_vue_loader_lib_selector_type_template_index_0_UploadDialog_vue__["a" /* default */],
  __vue_template_functional__,
  __vue_styles__,
  __vue_scopeId__,
  __vue_module_identifier__
)

/* harmony default export */ __webpack_exports__["a"] = (Component.exports);


/***/ }),
/* 469 */
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ }),
/* 470 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('v-dialog',{attrs:{"max-width":_vm.options.maxWidth,"fullscreen":_vm.$vuetify.breakpoint.xsOnly,"scrollable":""},model:{value:(_vm.show),callback:function ($$v) {_vm.show=$$v},expression:"show"}},[_c('v-card',{staticClass:"background",attrs:{"max-height":"480px"}},[_c('v-toolbar',{attrs:{"color":"primary","flat":""}},[_c('v-toolbar-title',{staticClass:"title"},[_vm._v("Admin upload")])],1),_vm._v(" "),_c('v-card-text',{staticClass:"card-text"},[(!_vm.edit)?_c('v-layout',{staticClass:"strd-card",attrs:{"column":""}},[_c('v-layout',{staticClass:"mx-1 pa-2 border",attrs:{"column":"","outline":""}},[_c('v-layout',{attrs:{"row":""}},[_c('span',{staticClass:"dialog-title"},[_vm._v("Status")]),_vm._v(" "),_c('v-spacer'),_vm._v(" "),_c('span',{staticClass:"status"},[_vm._v(_vm._s(_vm.options.upload.status))])],1),_vm._v(" "),_c('v-layout',{attrs:{"row":""}},[_c('span',{staticClass:"dialog-sub-title"},[_vm._v("Mimetype")]),_vm._v(" "),_c('v-spacer'),_vm._v(" "),_c('span',{staticClass:"content"},[_vm._v(_vm._s(_vm.options.upload.mimetype))])],1),_vm._v(" "),_c('v-layout',{attrs:{"row":""}},[_c('span',{staticClass:"dialog-sub-title"},[_vm._v("Type")]),_vm._v(" "),_c('v-spacer'),_vm._v(" "),_c('span',{staticClass:"content"},[_vm._v(_vm._s(_vm.options.upload.type))])],1)],1),_vm._v(" "),(_vm.options.patient.firstName)?_c('v-divider',{staticClass:"dialog-divider"}):_vm._e(),_vm._v(" "),(_vm.options.patient.firstName)?_c('v-layout',{staticClass:"mx-1 mb-2 pa-2 border",attrs:{"column":"","outline":""}},[_c('v-layout',{attrs:{"row":""}},[_c('span',{staticClass:"dialog-title"},[_vm._v("Patient")]),_vm._v(" "),_c('v-spacer'),_vm._v(" "),_c('span',{staticClass:"content"},[_vm._v(_vm._s(_vm.options.patient.firstName + " " + _vm.options.patient.lastName))])],1),_vm._v(" "),_c('v-layout',{attrs:{"row":""}},[_c('span',{staticClass:"dialog-sub-title"},[_vm._v("Birthdate")]),_vm._v(" "),_c('v-spacer'),_vm._v(" "),_c('span',{staticClass:"content"},[_vm._v(_vm._s(_vm.convertDate(_vm.options.patient.birthdate)))])],1),_vm._v(" "),_c('v-layout',{attrs:{"row":""}},[_c('span',{staticClass:"dialog-sub-title"},[_vm._v("Phone number")]),_vm._v(" "),_c('v-spacer'),_vm._v(" "),_c('span',{staticClass:"content"},[_vm._v(_vm._s(_vm.options.patient.phone))])],1),_vm._v(" "),_c('v-layout',{attrs:{"row":""}},[_c('span',{staticClass:"dialog-sub-title"},[_vm._v("Address")]),_vm._v(" "),_c('v-spacer'),_vm._v(" "),_c('span',{staticClass:"content"},[_vm._v(_vm._s(_vm.options.patient.address.line1 + ", " + _vm.options.patient.address.city + " " + _vm.options.patient.address.zip))])],1)],1):_vm._e()],1):_c('v-layout',{staticClass:"strd-card",attrs:{"column":""}},[_c('v-form',{staticClass:"ma-2"},[_c('v-layout',{staticClass:"dialog-small-title"},[_vm._v("\n            Status\n          ")]),_vm._v(" "),_c('v-select',{staticClass:"form-input mb-2",attrs:{"items":_vm.statuses,"label":"Status","solo":"","flat":""},model:{value:(_vm.options.upload.status),callback:function ($$v) {_vm.$set(_vm.options.upload, "status", $$v)},expression:"options.upload.status"}})],1)],1)],1),_vm._v(" "),_c('v-card-actions',[_c('v-spacer'),_vm._v(" "),(!_vm.edit)?_c('v-btn',{attrs:{"depressed":"","color":"primary"},on:{"click":function($event){_vm.clickEdit()}}},[_vm._v("Edit")]):_c('v-layout',{attrs:{"row":""}},[_c('v-spacer'),_vm._v(" "),_c('v-btn',{attrs:{"flat":"","color":"primary"},on:{"click":function($event){_vm.cancelEdit()}}},[_vm._v("Cancel")]),_vm._v(" "),_c('v-btn',{attrs:{"depressed":"","color":"primary"},on:{"click":function($event){_vm.submit()}}},[_vm._v("Submit")])],1)],1)],1)],1)}
var staticRenderFns = []
var esExports = { render: render, staticRenderFns: staticRenderFns }
/* harmony default export */ __webpack_exports__["a"] = (esExports);

/***/ }),
/* 471 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('v-layout',{staticClass:"patient-page",attrs:{"column":""}},[_c('v-card',{staticClass:"ma-2 mt-4",attrs:{"flat":""}},[_c('v-layout',{attrs:{"align-center":"","row":""}},[_c('v-text-field',{ref:"input",staticClass:"search-field mt-2",attrs:{"hide-details":"","solo":"","flat":"","background-color":"transparent","placeholder":'Document ID',"prepend-icon":"search"},model:{value:(_vm.search),callback:function ($$v) {_vm.search=$$v},expression:"search"}}),_vm._v(" "),_c('v-btn',{on:{"click":function($event){_vm.setFileInfo(_vm.search)}}},[_vm._v("Go")])],1),_vm._v(" "),(_vm.filesToDisplay)?_c('v-data-table',{directives:[{name:"show",rawName:"v-show",value:(_vm.showTable),expression:"showTable"}],staticClass:"flat mb-2 table-border",attrs:{"headers":_vm.headers,"items":_vm.filesToDisplay,"sort-icon":"","rows-per-page-items":[10,25,{text: 'All', value:-1}],"search":_vm.search},scopedSlots:_vm._u([{key:"items",fn:function(props){return [_c('tr',{staticStyle:{"cursor":"pointer"},on:{"click":function($event){_vm.setFileInfo(props.item.id)}}},[_c('td',[_vm._v(" "+_vm._s(props.item.id))]),_vm._v(" "),_c('td',[_vm._v(" "+_vm._s(_vm.displayPatientName(props.item)))]),_vm._v(" "),_c('td',{staticClass:"text-xs-left"},[_vm._v(_vm._s(_vm.formatDate(props.item.encounterDate)))]),_vm._v(" "),_c('td',{staticClass:"text-xs-left"},[_vm._v(_vm._s(_vm.displayProvider(props.item)))]),_vm._v(" "),_c('td',{staticClass:"text-xs-left"},[_vm._v(_vm._s(props.item.recordType))]),_vm._v(" "),_c('td',{staticClass:"text-xs-left"},[_vm._v(_vm._s(_vm.formatDate(props.item.created)))])])]}}])}):_vm._e()],1)],1)}
var staticRenderFns = []
var esExports = { render: render, staticRenderFns: staticRenderFns }
/* harmony default export */ __webpack_exports__["a"] = (esExports);

/***/ }),
/* 472 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_vue_loader_lib_selector_type_script_index_0_AdminPatientsPage_vue__ = __webpack_require__(211);
/* unused harmony namespace reexport */
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__node_modules_vue_loader_lib_template_compiler_index_id_data_v_16de66a4_hasScoped_true_transformToRequire_video_src_poster_source_src_img_src_image_xlink_href_buble_transforms_node_modules_vue_loader_lib_selector_type_template_index_0_AdminPatientsPage_vue__ = __webpack_require__(474);
function injectStyle (ssrContext) {
  __webpack_require__(473)
}
var normalizeComponent = __webpack_require__(0)
/* script */


/* template */

/* template functional */
var __vue_template_functional__ = false
/* styles */
var __vue_styles__ = injectStyle
/* scopeId */
var __vue_scopeId__ = "data-v-16de66a4"
/* moduleIdentifier (server only) */
var __vue_module_identifier__ = null
var Component = normalizeComponent(
  __WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_vue_loader_lib_selector_type_script_index_0_AdminPatientsPage_vue__["a" /* default */],
  __WEBPACK_IMPORTED_MODULE_1__node_modules_vue_loader_lib_template_compiler_index_id_data_v_16de66a4_hasScoped_true_transformToRequire_video_src_poster_source_src_img_src_image_xlink_href_buble_transforms_node_modules_vue_loader_lib_selector_type_template_index_0_AdminPatientsPage_vue__["a" /* default */],
  __vue_template_functional__,
  __vue_styles__,
  __vue_scopeId__,
  __vue_module_identifier__
)

/* harmony default export */ __webpack_exports__["a"] = (Component.exports);


/***/ }),
/* 473 */
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ }),
/* 474 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('v-layout',{staticClass:"patient-page",attrs:{"column":""}},[_c('v-card',{staticClass:"ma-2 mt-4",attrs:{"flat":""}},[_c('v-layout',{attrs:{"row":""}},[_c('span',{staticClass:"headerTabUnselected",on:{"click":function($event){_vm.adminHome()}}},[_vm._v("Admin")]),_c('span',{staticClass:"headerTabSelected"},[_vm._v("Patients")])]),_vm._v(" "),_c('v-text-field',{staticClass:"search-field mt-3 mb-4",attrs:{"hide-details":"","solo":"","flat":"","background-color":"transparent","prepend-icon":"search","label":"Search by patient or user last name, email address","single-line":""},model:{value:(_vm.search),callback:function ($$v) {_vm.search=$$v},expression:"search"}}),_vm._v(" "),_c('v-layout',{attrs:{"row":""}},[_c('v-btn',{on:{"click":function($event){_vm.filterSmartChoice()}}},[_vm._v("Smart Choice")]),_c('v-btn',{on:{"click":function($event){_vm.filterImagineMD()}}},[_vm._v("ImagineMD")]),_c('v-btn',{on:{"click":function($event){_vm.filterGrayhawk()}}},[_vm._v("Grayhawk")])],1),_vm._v(" "),_c('v-layout',{directives:[{name:"show",rawName:"v-show",value:(!_vm.patientSearchResults),expression:"!patientSearchResults"}],staticClass:"fade-in one loader",attrs:{"row":"","justify-center":""}},[_c('v-progress-circular',{attrs:{"size":70,"width":3,"color":"primary","indeterminate":""}})],1),_vm._v(" "),(_vm.patientSearchResults)?_c('v-data-table',{staticClass:"flat mb-2 table-border",attrs:{"headers":_vm.headers,"items":_vm.patientSearchResults,"sort-icon":"","rows-per-page-items":[15, 100,{text: 'All', value:-1}],"search":_vm.search,"color":"#eeeeee"},scopedSlots:_vm._u([{key:"items",fn:function(props){return [_c('tr',{staticStyle:{"cursor":"pointer"},on:{"click":function($event){props.expanded = !props.expanded}}},[_c('td',[_vm._v(" "+_vm._s(_vm.formatPartnerName(props.item)))]),_vm._v(" "),_c('td',{staticClass:"text-xs-left"},[_vm._v(_vm._s(props.item.id))]),_vm._v(" "),_c('td',{staticClass:"text-xs-left"},[_vm._v(_vm._s(_vm.formatDate(props.item.created)))]),_vm._v(" "),_c('td',{staticClass:"text-xs-left"},[_vm._v(_vm._s(_vm.formatPatientName(props.item)))]),_vm._v(" "),_c('td',{staticClass:"text-xs-left"},[_vm._v(_vm._s(_vm.formatDate(props.item.birthdate)))]),_vm._v(" "),_c('td',{staticClass:"text-xs-left"},[_vm._v(_vm._s(_vm.formatCreatorEmail(props.item)))])])]}},{key:"expand",fn:function(props){return [_c('v-card',{attrs:{"flat":""}},[_c('v-toolbar',{attrs:{"dense":"","flat":"","color":"transparent"}},[_c('v-toolbar-title',[_vm._v(_vm._s(_vm.formatPatientName(props.item)))]),_vm._v(" "),_c('v-spacer'),_vm._v(" "),_c('v-toolbar-title',[_vm._v("\n              "+_vm._s(_vm.formatPartnerName(props.item))+"\n          ")])],1),_vm._v(" "),_c('v-card-text',[_c('v-layout',{attrs:{"column":""}},[_c('v-layout',{attrs:{"row":"","wrap":""}},[_c('v-card',{staticClass:"ma-2",attrs:{"flat":""}},[_c('v-layout',{attrs:{"column":""}},[_c('span',[_vm._v("Address")]),_vm._v(" "),_c('span',[_vm._v(_vm._s(_vm.providerDisplayAddressFromProviderObject(props.item)))])])],1),_vm._v(" "),_c('v-card',{staticClass:"ma-2",attrs:{"flat":""}},[_c('v-layout',{attrs:{"column":""}},[_c('span',[_vm._v("Gender")]),_vm._v(" "),_c('span',[_vm._v(_vm._s(props.item.gender))])])],1),_vm._v(" "),_c('v-card',{staticClass:"ma-2",attrs:{"flat":""}},[_c('v-layout',{attrs:{"column":""}},[_c('span',[_vm._v("Phone")]),_vm._v(" "),_c('span',[_vm._v(_vm._s(props.item.phone))])])],1),_vm._v(" "),_c('v-card',{staticClass:"ma-2",attrs:{"flat":""}},[_c('v-layout',{attrs:{"column":""}},[_c('span',[_vm._v("Creator")]),_vm._v(" "),_c('span',[_vm._v(_vm._s(_vm.formatCreatorName(props.item)))])])],1),_vm._v(" "),_c('v-card',{staticClass:"ma-2",attrs:{"flat":""}},[_c('v-layout',{attrs:{"column":""}},[_c('span',[_vm._v("Creator Email")]),_vm._v(" "),_c('span',[_vm._v(_vm._s(_vm.formatCreatorEmail(props.item)))])])],1),_vm._v(" "),(props.item.creator)?_c('v-card',{staticClass:"ma-2",attrs:{"flat":""}},[_c('v-layout',{attrs:{"column":""}},[_c('v-btn',{attrs:{"depressed":""},on:{"click":function($event){_vm.doResetPassword(props.item)}}},[_vm._v("Send Password Reset")])],1)],1):_vm._e()],1),_vm._v(" "),_c('v-card',{staticClass:"ma-2",staticStyle:{"opacity":"0.5"},attrs:{"flat":""}},[_c('span',[_vm._v(_vm._s(props.item))])])],1)],1)],1)]}}])}):_vm._e()],1)],1)}
var staticRenderFns = []
var esExports = { render: render, staticRenderFns: staticRenderFns }
/* harmony default export */ __webpack_exports__["a"] = (esExports);

/***/ }),
/* 475 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_vue_loader_lib_selector_type_script_index_0_AdminFileUploadPage_vue__ = __webpack_require__(212);
/* unused harmony namespace reexport */
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__node_modules_vue_loader_lib_template_compiler_index_id_data_v_37b0f31d_hasScoped_true_transformToRequire_video_src_poster_source_src_img_src_image_xlink_href_buble_transforms_node_modules_vue_loader_lib_selector_type_template_index_0_AdminFileUploadPage_vue__ = __webpack_require__(606);
function injectStyle (ssrContext) {
  __webpack_require__(476)
}
var normalizeComponent = __webpack_require__(0)
/* script */


/* template */

/* template functional */
var __vue_template_functional__ = false
/* styles */
var __vue_styles__ = injectStyle
/* scopeId */
var __vue_scopeId__ = "data-v-37b0f31d"
/* moduleIdentifier (server only) */
var __vue_module_identifier__ = null
var Component = normalizeComponent(
  __WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_vue_loader_lib_selector_type_script_index_0_AdminFileUploadPage_vue__["a" /* default */],
  __WEBPACK_IMPORTED_MODULE_1__node_modules_vue_loader_lib_template_compiler_index_id_data_v_37b0f31d_hasScoped_true_transformToRequire_video_src_poster_source_src_img_src_image_xlink_href_buble_transforms_node_modules_vue_loader_lib_selector_type_template_index_0_AdminFileUploadPage_vue__["a" /* default */],
  __vue_template_functional__,
  __vue_styles__,
  __vue_scopeId__,
  __vue_module_identifier__
)

/* harmony default export */ __webpack_exports__["a"] = (Component.exports);


/***/ }),
/* 476 */
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ }),
/* 477 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_vue_loader_lib_selector_type_script_index_0_ProviderSelectorDialog_vue__ = __webpack_require__(213);
/* unused harmony namespace reexport */
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__node_modules_vue_loader_lib_template_compiler_index_id_data_v_00f0a762_hasScoped_true_transformToRequire_video_src_poster_source_src_img_src_image_xlink_href_buble_transforms_node_modules_vue_loader_lib_selector_type_template_index_0_ProviderSelectorDialog_vue__ = __webpack_require__(481);
function injectStyle (ssrContext) {
  __webpack_require__(478)
}
var normalizeComponent = __webpack_require__(0)
/* script */


/* template */

/* template functional */
var __vue_template_functional__ = false
/* styles */
var __vue_styles__ = injectStyle
/* scopeId */
var __vue_scopeId__ = "data-v-00f0a762"
/* moduleIdentifier (server only) */
var __vue_module_identifier__ = null
var Component = normalizeComponent(
  __WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_vue_loader_lib_selector_type_script_index_0_ProviderSelectorDialog_vue__["a" /* default */],
  __WEBPACK_IMPORTED_MODULE_1__node_modules_vue_loader_lib_template_compiler_index_id_data_v_00f0a762_hasScoped_true_transformToRequire_video_src_poster_source_src_img_src_image_xlink_href_buble_transforms_node_modules_vue_loader_lib_selector_type_template_index_0_ProviderSelectorDialog_vue__["a" /* default */],
  __vue_template_functional__,
  __vue_styles__,
  __vue_scopeId__,
  __vue_module_identifier__
)

/* harmony default export */ __webpack_exports__["a"] = (Component.exports);


/***/ }),
/* 478 */
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ }),
/* 479 */
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ }),
/* 480 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('v-card',{staticClass:"provider-card",attrs:{"flat":""}},[_vm._t("header"),_vm._v(" "),_c('v-card-text',{staticClass:"provider-card-text"},[_c('v-layout',{attrs:{"row":"","justify-start":""}},[_c('avatar',{staticClass:"mr-4",attrs:{"name":_vm.avatarString,"size":_vm.avatarSize,"borderSize":1,"color":"#222","borderColor":"#dddddd","backgroundColor":"transparent"}}),_vm._v(" "),_c('v-layout',{attrs:{"column":""}},[(_vm.provider.type==='google')?_c('v-layout',{staticClass:"provider-info",attrs:{"column":""}},[_c('span',{staticClass:"name"},[_vm._v(_vm._s(_vm.name))]),_vm._v(" "),_c('span',{staticClass:"phone"},[_vm._v(_vm._s(_vm.phone))]),_vm._v(" "),_c('span',{staticClass:"email"},[_vm._v(_vm._s(_vm.provider.address.line1))])]):_c('v-layout',{staticClass:"provider-info",attrs:{"column":""}},[_c('span',{staticClass:"name"},[_vm._v(_vm._s(_vm.providerTitle)+"\n          ")]),_vm._v(" "),_c('span',{staticClass:"phone"},[_vm._v(_vm._s(_vm.provider.type))]),_vm._v(" "),_c('span',{staticClass:"phone"},[_vm._v(_vm._s(_vm.phone))]),_vm._v(" "),_c('span',{staticClass:"email"},[_vm._v(_vm._s(_vm.address))])])],1)],1),_vm._v(" "),_c('v-spacer'),_vm._v(" "),_vm._t("removeProviderSlot")],2),_vm._v(" "),_c('v-card-actions',{staticClass:"provider-actions"},[_vm._t("actions")],2)],2)}
var staticRenderFns = []
var esExports = { render: render, staticRenderFns: staticRenderFns }
/* harmony default export */ __webpack_exports__["a"] = (esExports);

/***/ }),
/* 481 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('v-dialog',{attrs:{"max-width":_vm.options.maxWidth,"transition":_vm.transition,"fullscreen":_vm.$vuetify.breakpoint.xsOnly,"scrollable":""},model:{value:(_vm.show),callback:function ($$v) {_vm.show=$$v},expression:"show"}},[_c('v-card',{staticStyle:{"height":"600px"}},[_c('v-toolbar',{attrs:{"flat":"","dark":"","color":"primary"}},[_c('v-btn',{attrs:{"icon":"","dark":""},on:{"click":_vm.close}},[_c('v-icon',[_vm._v("close")])],1),_vm._v(" "),_c('v-toolbar-title',[_vm._v("Select Provider")]),_vm._v(" "),_c('v-spacer'),_vm._v(" "),_c('v-progress-circular',{directives:[{name:"show",rawName:"v-show",value:(_vm.loadingShare),expression:"loadingShare"}],attrs:{"indeterminate":"","color":"white","size":20}})],1),_vm._v(" "),_c('v-card',{attrs:{"column":"","flat":""}},[_c('v-text-field',{ref:"input",staticClass:"input",attrs:{"prepend-icon":"search","placeholder":"Provider search","solo":"","flat":""},model:{value:(_vm.formInput),callback:function ($$v) {_vm.formInput=$$v},expression:"formInput"}}),_vm._v(" "),_c('v-divider'),_vm._v(" "),_c('v-card-text',_vm._l((_vm.searchResults),function(provider){return _c('provider-card',{key:provider.npi,staticClass:"mt-3",attrs:{"provider":provider},on:{"click":function($event){_vm.selectProvider(provider)}}},[_c('v-layout',{attrs:{"slot":"actions"},slot:"actions"},[_c('v-spacer'),_vm._v(" "),_c('v-btn',{attrs:{"depressed":"","flat":"","color":"primary"},on:{"click":function($event){_vm.selectProvider(provider)}}},[_c('span',{directives:[{name:"show",rawName:"v-show",value:(!_vm.loadingShare),expression:"!loadingShare"}]},[_vm._v("select")])])],1)],1)}))],1),_vm._v(" "),_c('v-spacer')],1)],1)}
var staticRenderFns = []
var esExports = { render: render, staticRenderFns: staticRenderFns }
/* harmony default export */ __webpack_exports__["a"] = (esExports);

/***/ }),
/* 482 */
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ }),
/* 483 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('v-dialog',{attrs:{"max-width":_vm.options.maxWidth,"transition":_vm.transition,"fullscreen":_vm.$vuetify.breakpoint.xsOnly,"scrollable":""},model:{value:(_vm.show),callback:function ($$v) {_vm.show=$$v},expression:"show"}},[_c('v-card',{staticStyle:{"height":"500px"},attrs:{"column":""}},[_c('v-toolbar',{staticStyle:{"border-bottom":"1px solid #f5f5f5","background-color":"white","margin":"0px","padding":"0px"},attrs:{"dark":"","color":"primary","column":"","flat":""}},[_c('v-toolbar-title',[_vm._v("Advanced Patient Search")])],1),_vm._v(" "),_c('v-toolbar',{directives:[{name:"show",rawName:"v-show",value:(this.searchBanner),expression:"this.searchBanner"}],staticClass:"fade-in slow",staticStyle:{"cursor":"pointer"},on:{"click":function($event){_vm.queryMode()}}},[_c('v-icon',{staticClass:"mr-2"},[_vm._v("search")]),_c('span',[_vm._v(_vm._s(_vm.searchQuery))]),_vm._v(" "),_c('v-spacer'),_vm._v(" "),_c('v-btn',{attrs:{"icon":""},on:{"click":function($event){_vm.queryMode()}}},[_c('v-icon',[_vm._v("close")])],1)],1),_vm._v(" "),_c('v-card-text',[_c('v-slide-y-transition',[_c('v-layout',{directives:[{name:"show",rawName:"v-show",value:(!this.searchBanner),expression:"!this.searchBanner"}],attrs:{"column":""}},[_c('span',{staticStyle:{"font-size":"18px","font-weight":"700"}},[_vm._v("Patient Information")]),_vm._v(" "),_c('v-layout',{staticClass:"mt-3",attrs:{"row":"","wrap":"","align-center":""}},[_c('v-text-field',{attrs:{"required":"","label":"Last Name","outline":"","hint":"Case-Sensitive, Exact","persistent-hint":""},model:{value:(_vm.patientLastName),callback:function ($$v) {_vm.patientLastName=$$v},expression:"patientLastName"}}),_vm._v(" "),_c('v-text-field',{staticClass:"ml-2",attrs:{"required":"","label":"First Name","outline":""},model:{value:(_vm.patientFirstName),callback:function ($$v) {_vm.patientFirstName=$$v},expression:"patientFirstName"}}),_vm._v(" "),_c('v-text-field',{staticClass:"ml-2",attrs:{"required":"","outline":"","label":"Date of Birth","hint":"MM/DD/YYYY format","persistent-hint":"","mask":"##/##/####"},on:{"blur":function($event){_vm.date = _vm.parseDate(_vm.dateFormatted)}},model:{value:(_vm.dateFormatted),callback:function ($$v) {_vm.dateFormatted=$$v},expression:"dateFormatted"}})],1),_vm._v(" "),_c('v-layout',{staticStyle:{"opacity":"0.5"},attrs:{"column":""}},[_c('span',{staticClass:"mb-2",staticStyle:{"font-size":"18px","font-weight":"700"}},[_vm._v("Privacy Notice")]),_vm._v(" "),_c('span',[_vm._v("Medical record privacy is protected by Federal Law.\n              The medical information contained within OneChart is privileged and confidential, and may only be accessed for the purposes of continuing care.\n              Improper use or unauthorized access to medical information may be subject to State and Federal penalties.\n              Any disclosure, copying, use, or distribution of the information contained in OneChart without the explicit permission of the patient is strictly prohibited.")])])],1)],1),_vm._v(" "),_c('v-data-table',{directives:[{name:"show",rawName:"v-show",value:(this.searchBanner && _vm.patientSearchResultsCleaned.length > 0),expression:"this.searchBanner && patientSearchResultsCleaned.length > 0"}],staticClass:"flat mb-2 table-border",attrs:{"headers":_vm.headers,"items":_vm.patientSearchResultsCleaned,"sort-icon":"","rows-per-page-items":[1000],"color":"#eeeeee","loading":_vm.isLoading},scopedSlots:_vm._u([{key:"items",fn:function(props){return [_c('tr',{staticStyle:{"cursor":"pointer"},on:{"click":function($event){props.expanded = !props.expanded}}},[_c('td',{staticClass:"text-xs-left"},[_vm._v(_vm._s(props.item.fullName))]),_vm._v(" "),(!_vm.isMobile)?_c('td',{staticClass:"text-xs-left"},[_vm._v(_vm._s(props.item.gender))]):_vm._e(),_vm._v(" "),_c('td',{staticClass:"text-xs-right"},[_vm._v(_vm._s(props.item.birthdateString))])])]}},{key:"expand",fn:function(props){return [_c('v-card',{staticClass:"mb-3",attrs:{"flat":""}},[_c('v-card-title',{staticStyle:{"font-size":"18px","font-weight":"700"}},[_vm._v("\n              "+_vm._s(props.item.fullName)+"\n            ")]),_vm._v(" "),_c('v-card-text',[_c('v-layout',{attrs:{"column":""}},[_c('v-layout',{attrs:{"row":"","wrap":""}},[_c('v-card',{staticClass:"ma-1 mr-2",attrs:{"flat":""}},[_c('v-layout',{attrs:{"column":""}},[_c('span',[_vm._v("Birthdate")]),_vm._v(" "),_c('span',[_vm._v(_vm._s(props.item.birthdateString))])])],1),_vm._v(" "),_c('v-card',{staticClass:"ma-1 mr-2",attrs:{"flat":""}},[_c('v-layout',{attrs:{"column":""}},[_c('span',[_vm._v("Gender")]),_vm._v(" "),_c('span',[_vm._v(_vm._s(props.item.gender))])])],1),_vm._v(" "),_c('v-card',{staticClass:"ma-1 mr-2",attrs:{"flat":""}},[_c('v-layout',{attrs:{"column":""}},[_c('span',[_vm._v("Address")]),_vm._v(" "),_c('span',[_vm._v(_vm._s(_vm.providerDisplayAddressFromProviderObject(props.item)))])])],1),_vm._v(" "),_c('v-card',{staticClass:"ma-1",attrs:{"flat":""}},[_c('v-layout',{attrs:{"column":""}},[_c('span',[_vm._v("Phone")]),_vm._v(" "),_c('span',[_vm._v(_vm._s(props.item.phone))])])],1)],1)],1)],1),_vm._v(" "),_c('v-toolbar',{attrs:{"flat":"","color":"transparent"}},[_c('v-spacer'),_vm._v(" "),_c('v-btn',{attrs:{"left":"","depressed":"","color":"primary"},on:{"click":function($event){_vm.selectPatient(props.item)}}},[_vm._v("Select Patient")])],1)],1)]}}])},[_c('v-progress-linear',{attrs:{"slot":"progress","color":"blue","indeterminate":""},slot:"progress"}),_vm._v(" "),_c('template',{slot:"no-data"},[_c('v-layout',{staticStyle:{"min-height":"350px","opacity":"0.3"},attrs:{"column":"","justify-center":"","align-center":""}},[_c('v-icon',{staticStyle:{"border-radius":"50%","height":"80px","width":"80px","border":"3px solid #999999"},attrs:{"x-large":""}},[_vm._v("folder_open")]),_vm._v(" "),_c('div',{staticStyle:{"width":"250px","margin-top":"5px","opacity":"0.6","text-align":"center"}},[_c('p',{staticStyle:{"font-weight":"700"}},[_vm._v("OneChart Health")])])],1)],1)],2),_vm._v(" "),_c('v-layout',{directives:[{name:"show",rawName:"v-show",value:(_vm.showEmptyResults),expression:"showEmptyResults"}],staticStyle:{"min-height":"350px","opacity":"0.3"},attrs:{"column":"","justify-center":"","align-center":""}},[_c('v-icon',{staticStyle:{"border-radius":"50%","height":"80px","width":"80px","border":"3px solid #999999"},attrs:{"x-large":""}},[_vm._v("warning")]),_vm._v(" "),_c('div',{staticStyle:{"width":"250px","margin-top":"5px","opacity":"0.6","text-align":"center"}},[_c('p',{staticStyle:{"font-weight":"700"}},[_vm._v("No Matching Results")])])],1)],1),_vm._v(" "),_c('v-spacer'),_vm._v(" "),_c('v-card-actions',{staticClass:"px-3 pb-3"},[_c('v-btn',{attrs:{"depressed":""},on:{"click":_vm.close}},[_vm._v("Cancel")]),_vm._v(" "),_c('v-spacer'),_vm._v(" "),_c('v-btn',{directives:[{name:"show",rawName:"v-show",value:(!this.searchBanner),expression:"!this.searchBanner"}],attrs:{"disabled":!_vm.canSearch,"color":"primary","depressed":""},on:{"click":function($event){_vm.searchPatientPopulation()}}},[_vm._v("Agree and Search Patient Database")])],1)],1)],1)}
var staticRenderFns = []
var esExports = { render: render, staticRenderFns: staticRenderFns }
/* harmony default export */ __webpack_exports__["a"] = (esExports);

/***/ }),
/* 484 */
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ }),
/* 485 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__babel_loader_vue_loader_lib_selector_type_script_index_0_vuePdfNoSss_vue__ = __webpack_require__(220);
/* unused harmony namespace reexport */
function injectStyle (ssrContext) {
  __webpack_require__(486)
}
var normalizeComponent = __webpack_require__(0)
/* script */


/* template */
var __vue_template__ = null
/* template functional */
var __vue_template_functional__ = false
/* styles */
var __vue_styles__ = injectStyle
/* scopeId */
var __vue_scopeId__ = null
/* moduleIdentifier (server only) */
var __vue_module_identifier__ = null
var Component = normalizeComponent(
  __WEBPACK_IMPORTED_MODULE_0__babel_loader_vue_loader_lib_selector_type_script_index_0_vuePdfNoSss_vue__["a" /* default */],
  __vue_template__,
  __vue_template_functional__,
  __vue_styles__,
  __vue_scopeId__,
  __vue_module_identifier__
)

/* harmony default export */ __webpack_exports__["a"] = (Component.exports);


/***/ }),
/* 486 */
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ }),
/* 487 */,
/* 488 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__babel_loader_vue_loader_lib_selector_type_script_index_0_resize_sensor_vue__ = __webpack_require__(221);
/* unused harmony namespace reexport */
function injectStyle (ssrContext) {
  __webpack_require__(489)
}
var normalizeComponent = __webpack_require__(0)
/* script */


/* template */
var __vue_template__ = null
/* template functional */
var __vue_template_functional__ = false
/* styles */
var __vue_styles__ = injectStyle
/* scopeId */
var __vue_scopeId__ = null
/* moduleIdentifier (server only) */
var __vue_module_identifier__ = null
var Component = normalizeComponent(
  __WEBPACK_IMPORTED_MODULE_0__babel_loader_vue_loader_lib_selector_type_script_index_0_resize_sensor_vue__["a" /* default */],
  __vue_template__,
  __vue_template_functional__,
  __vue_styles__,
  __vue_scopeId__,
  __vue_module_identifier__
)

/* harmony default export */ __webpack_exports__["a"] = (Component.exports);


/***/ }),
/* 489 */
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ }),
/* 490 */,
/* 491 */,
/* 492 */,
/* 493 */,
/* 494 */,
/* 495 */,
/* 496 */,
/* 497 */,
/* 498 */,
/* 499 */,
/* 500 */,
/* 501 */,
/* 502 */,
/* 503 */,
/* 504 */,
/* 505 */,
/* 506 */,
/* 507 */,
/* 508 */,
/* 509 */,
/* 510 */,
/* 511 */,
/* 512 */,
/* 513 */,
/* 514 */,
/* 515 */,
/* 516 */,
/* 517 */,
/* 518 */,
/* 519 */,
/* 520 */,
/* 521 */,
/* 522 */,
/* 523 */,
/* 524 */,
/* 525 */,
/* 526 */,
/* 527 */,
/* 528 */,
/* 529 */,
/* 530 */,
/* 531 */,
/* 532 */,
/* 533 */,
/* 534 */,
/* 535 */,
/* 536 */,
/* 537 */,
/* 538 */,
/* 539 */,
/* 540 */,
/* 541 */,
/* 542 */,
/* 543 */,
/* 544 */,
/* 545 */,
/* 546 */,
/* 547 */,
/* 548 */,
/* 549 */,
/* 550 */,
/* 551 */,
/* 552 */,
/* 553 */,
/* 554 */,
/* 555 */,
/* 556 */,
/* 557 */,
/* 558 */,
/* 559 */,
/* 560 */,
/* 561 */,
/* 562 */,
/* 563 */,
/* 564 */
/***/ (function(module, exports) {

/* (ignored) */

/***/ }),
/* 565 */,
/* 566 */,
/* 567 */,
/* 568 */,
/* 569 */,
/* 570 */,
/* 571 */,
/* 572 */,
/* 573 */,
/* 574 */,
/* 575 */,
/* 576 */,
/* 577 */,
/* 578 */,
/* 579 */,
/* 580 */,
/* 581 */,
/* 582 */,
/* 583 */,
/* 584 */,
/* 585 */
/***/ (function(module, exports) {

/* (ignored) */

/***/ }),
/* 586 */
/***/ (function(module, exports) {

/* (ignored) */

/***/ }),
/* 587 */
/***/ (function(module, exports) {

/* (ignored) */

/***/ }),
/* 588 */,
/* 589 */,
/* 590 */,
/* 591 */,
/* 592 */,
/* 593 */,
/* 594 */,
/* 595 */
/***/ (function(module, exports, __webpack_require__) {

var map = {
	"./78-EUC-H.bcmap": [
		778,
		168
	],
	"./78-EUC-V.bcmap": [
		779,
		167
	],
	"./78-H.bcmap": [
		780,
		166
	],
	"./78-RKSJ-H.bcmap": [
		781,
		165
	],
	"./78-RKSJ-V.bcmap": [
		782,
		164
	],
	"./78-V.bcmap": [
		783,
		163
	],
	"./78ms-RKSJ-H.bcmap": [
		784,
		162
	],
	"./78ms-RKSJ-V.bcmap": [
		785,
		161
	],
	"./83pv-RKSJ-H.bcmap": [
		786,
		160
	],
	"./90ms-RKSJ-H.bcmap": [
		787,
		159
	],
	"./90ms-RKSJ-V.bcmap": [
		788,
		158
	],
	"./90msp-RKSJ-H.bcmap": [
		789,
		157
	],
	"./90msp-RKSJ-V.bcmap": [
		790,
		156
	],
	"./90pv-RKSJ-H.bcmap": [
		791,
		155
	],
	"./90pv-RKSJ-V.bcmap": [
		792,
		154
	],
	"./Add-H.bcmap": [
		793,
		153
	],
	"./Add-RKSJ-H.bcmap": [
		794,
		152
	],
	"./Add-RKSJ-V.bcmap": [
		795,
		151
	],
	"./Add-V.bcmap": [
		796,
		150
	],
	"./Adobe-CNS1-0.bcmap": [
		797,
		149
	],
	"./Adobe-CNS1-1.bcmap": [
		798,
		148
	],
	"./Adobe-CNS1-2.bcmap": [
		799,
		147
	],
	"./Adobe-CNS1-3.bcmap": [
		800,
		146
	],
	"./Adobe-CNS1-4.bcmap": [
		801,
		145
	],
	"./Adobe-CNS1-5.bcmap": [
		802,
		144
	],
	"./Adobe-CNS1-6.bcmap": [
		803,
		143
	],
	"./Adobe-CNS1-UCS2.bcmap": [
		804,
		142
	],
	"./Adobe-GB1-0.bcmap": [
		805,
		141
	],
	"./Adobe-GB1-1.bcmap": [
		806,
		140
	],
	"./Adobe-GB1-2.bcmap": [
		807,
		139
	],
	"./Adobe-GB1-3.bcmap": [
		808,
		138
	],
	"./Adobe-GB1-4.bcmap": [
		809,
		137
	],
	"./Adobe-GB1-5.bcmap": [
		810,
		136
	],
	"./Adobe-GB1-UCS2.bcmap": [
		811,
		135
	],
	"./Adobe-Japan1-0.bcmap": [
		812,
		134
	],
	"./Adobe-Japan1-1.bcmap": [
		813,
		133
	],
	"./Adobe-Japan1-2.bcmap": [
		814,
		132
	],
	"./Adobe-Japan1-3.bcmap": [
		815,
		131
	],
	"./Adobe-Japan1-4.bcmap": [
		816,
		130
	],
	"./Adobe-Japan1-5.bcmap": [
		817,
		129
	],
	"./Adobe-Japan1-6.bcmap": [
		818,
		128
	],
	"./Adobe-Japan1-UCS2.bcmap": [
		819,
		127
	],
	"./Adobe-Korea1-0.bcmap": [
		820,
		126
	],
	"./Adobe-Korea1-1.bcmap": [
		821,
		125
	],
	"./Adobe-Korea1-2.bcmap": [
		822,
		124
	],
	"./Adobe-Korea1-UCS2.bcmap": [
		823,
		123
	],
	"./B5-H.bcmap": [
		824,
		122
	],
	"./B5-V.bcmap": [
		825,
		121
	],
	"./B5pc-H.bcmap": [
		826,
		120
	],
	"./B5pc-V.bcmap": [
		827,
		119
	],
	"./CNS-EUC-H.bcmap": [
		828,
		118
	],
	"./CNS-EUC-V.bcmap": [
		829,
		117
	],
	"./CNS1-H.bcmap": [
		830,
		116
	],
	"./CNS1-V.bcmap": [
		831,
		115
	],
	"./CNS2-H.bcmap": [
		832,
		114
	],
	"./CNS2-V.bcmap": [
		833,
		113
	],
	"./ETHK-B5-H.bcmap": [
		834,
		112
	],
	"./ETHK-B5-V.bcmap": [
		835,
		111
	],
	"./ETen-B5-H.bcmap": [
		836,
		110
	],
	"./ETen-B5-V.bcmap": [
		837,
		109
	],
	"./ETenms-B5-H.bcmap": [
		838,
		108
	],
	"./ETenms-B5-V.bcmap": [
		839,
		107
	],
	"./EUC-H.bcmap": [
		840,
		106
	],
	"./EUC-V.bcmap": [
		841,
		105
	],
	"./Ext-H.bcmap": [
		842,
		104
	],
	"./Ext-RKSJ-H.bcmap": [
		843,
		103
	],
	"./Ext-RKSJ-V.bcmap": [
		844,
		102
	],
	"./Ext-V.bcmap": [
		845,
		101
	],
	"./GB-EUC-H.bcmap": [
		846,
		100
	],
	"./GB-EUC-V.bcmap": [
		847,
		99
	],
	"./GB-H.bcmap": [
		848,
		98
	],
	"./GB-V.bcmap": [
		849,
		97
	],
	"./GBK-EUC-H.bcmap": [
		850,
		96
	],
	"./GBK-EUC-V.bcmap": [
		851,
		95
	],
	"./GBK2K-H.bcmap": [
		852,
		94
	],
	"./GBK2K-V.bcmap": [
		853,
		93
	],
	"./GBKp-EUC-H.bcmap": [
		854,
		92
	],
	"./GBKp-EUC-V.bcmap": [
		855,
		91
	],
	"./GBT-EUC-H.bcmap": [
		856,
		90
	],
	"./GBT-EUC-V.bcmap": [
		857,
		89
	],
	"./GBT-H.bcmap": [
		858,
		88
	],
	"./GBT-V.bcmap": [
		859,
		87
	],
	"./GBTpc-EUC-H.bcmap": [
		860,
		86
	],
	"./GBTpc-EUC-V.bcmap": [
		861,
		85
	],
	"./GBpc-EUC-H.bcmap": [
		862,
		84
	],
	"./GBpc-EUC-V.bcmap": [
		863,
		83
	],
	"./H.bcmap": [
		864,
		82
	],
	"./HKdla-B5-H.bcmap": [
		865,
		81
	],
	"./HKdla-B5-V.bcmap": [
		866,
		80
	],
	"./HKdlb-B5-H.bcmap": [
		867,
		79
	],
	"./HKdlb-B5-V.bcmap": [
		868,
		78
	],
	"./HKgccs-B5-H.bcmap": [
		869,
		77
	],
	"./HKgccs-B5-V.bcmap": [
		870,
		76
	],
	"./HKm314-B5-H.bcmap": [
		871,
		75
	],
	"./HKm314-B5-V.bcmap": [
		872,
		74
	],
	"./HKm471-B5-H.bcmap": [
		873,
		73
	],
	"./HKm471-B5-V.bcmap": [
		874,
		72
	],
	"./HKscs-B5-H.bcmap": [
		875,
		71
	],
	"./HKscs-B5-V.bcmap": [
		876,
		70
	],
	"./Hankaku.bcmap": [
		877,
		69
	],
	"./Hiragana.bcmap": [
		878,
		68
	],
	"./KSC-EUC-H.bcmap": [
		879,
		67
	],
	"./KSC-EUC-V.bcmap": [
		880,
		66
	],
	"./KSC-H.bcmap": [
		881,
		65
	],
	"./KSC-Johab-H.bcmap": [
		882,
		64
	],
	"./KSC-Johab-V.bcmap": [
		883,
		63
	],
	"./KSC-V.bcmap": [
		884,
		62
	],
	"./KSCms-UHC-H.bcmap": [
		885,
		61
	],
	"./KSCms-UHC-HW-H.bcmap": [
		886,
		60
	],
	"./KSCms-UHC-HW-V.bcmap": [
		887,
		59
	],
	"./KSCms-UHC-V.bcmap": [
		888,
		58
	],
	"./KSCpc-EUC-H.bcmap": [
		889,
		57
	],
	"./KSCpc-EUC-V.bcmap": [
		890,
		56
	],
	"./Katakana.bcmap": [
		891,
		55
	],
	"./NWP-H.bcmap": [
		892,
		54
	],
	"./NWP-V.bcmap": [
		893,
		53
	],
	"./RKSJ-H.bcmap": [
		894,
		52
	],
	"./RKSJ-V.bcmap": [
		895,
		51
	],
	"./Roman.bcmap": [
		896,
		50
	],
	"./UniCNS-UCS2-H.bcmap": [
		897,
		49
	],
	"./UniCNS-UCS2-V.bcmap": [
		898,
		48
	],
	"./UniCNS-UTF16-H.bcmap": [
		899,
		47
	],
	"./UniCNS-UTF16-V.bcmap": [
		900,
		46
	],
	"./UniCNS-UTF32-H.bcmap": [
		901,
		45
	],
	"./UniCNS-UTF32-V.bcmap": [
		902,
		44
	],
	"./UniCNS-UTF8-H.bcmap": [
		903,
		43
	],
	"./UniCNS-UTF8-V.bcmap": [
		904,
		42
	],
	"./UniGB-UCS2-H.bcmap": [
		905,
		41
	],
	"./UniGB-UCS2-V.bcmap": [
		906,
		40
	],
	"./UniGB-UTF16-H.bcmap": [
		907,
		39
	],
	"./UniGB-UTF16-V.bcmap": [
		908,
		38
	],
	"./UniGB-UTF32-H.bcmap": [
		909,
		37
	],
	"./UniGB-UTF32-V.bcmap": [
		910,
		36
	],
	"./UniGB-UTF8-H.bcmap": [
		911,
		35
	],
	"./UniGB-UTF8-V.bcmap": [
		912,
		34
	],
	"./UniJIS-UCS2-H.bcmap": [
		913,
		33
	],
	"./UniJIS-UCS2-HW-H.bcmap": [
		914,
		32
	],
	"./UniJIS-UCS2-HW-V.bcmap": [
		915,
		31
	],
	"./UniJIS-UCS2-V.bcmap": [
		916,
		30
	],
	"./UniJIS-UTF16-H.bcmap": [
		917,
		29
	],
	"./UniJIS-UTF16-V.bcmap": [
		918,
		28
	],
	"./UniJIS-UTF32-H.bcmap": [
		919,
		27
	],
	"./UniJIS-UTF32-V.bcmap": [
		920,
		26
	],
	"./UniJIS-UTF8-H.bcmap": [
		921,
		25
	],
	"./UniJIS-UTF8-V.bcmap": [
		922,
		24
	],
	"./UniJIS2004-UTF16-H.bcmap": [
		923,
		23
	],
	"./UniJIS2004-UTF16-V.bcmap": [
		924,
		22
	],
	"./UniJIS2004-UTF32-H.bcmap": [
		925,
		21
	],
	"./UniJIS2004-UTF32-V.bcmap": [
		926,
		20
	],
	"./UniJIS2004-UTF8-H.bcmap": [
		927,
		19
	],
	"./UniJIS2004-UTF8-V.bcmap": [
		928,
		18
	],
	"./UniJISPro-UCS2-HW-V.bcmap": [
		929,
		17
	],
	"./UniJISPro-UCS2-V.bcmap": [
		930,
		16
	],
	"./UniJISPro-UTF8-V.bcmap": [
		931,
		15
	],
	"./UniJISX0213-UTF32-H.bcmap": [
		932,
		14
	],
	"./UniJISX0213-UTF32-V.bcmap": [
		933,
		13
	],
	"./UniJISX02132004-UTF32-H.bcmap": [
		934,
		12
	],
	"./UniJISX02132004-UTF32-V.bcmap": [
		935,
		11
	],
	"./UniKS-UCS2-H.bcmap": [
		936,
		10
	],
	"./UniKS-UCS2-V.bcmap": [
		937,
		9
	],
	"./UniKS-UTF16-H.bcmap": [
		938,
		8
	],
	"./UniKS-UTF16-V.bcmap": [
		939,
		7
	],
	"./UniKS-UTF32-H.bcmap": [
		940,
		6
	],
	"./UniKS-UTF32-V.bcmap": [
		941,
		5
	],
	"./UniKS-UTF8-H.bcmap": [
		942,
		4
	],
	"./UniKS-UTF8-V.bcmap": [
		943,
		3
	],
	"./V.bcmap": [
		944,
		2
	],
	"./WP-Symbol.bcmap": [
		945,
		1
	]
};
function webpackAsyncContext(req) {
	var ids = map[req];
	if(!ids)
		return Promise.reject(new Error("Cannot find module '" + req + "'."));
	return __webpack_require__.e(ids[1]).then(function() {
		return __webpack_require__(ids[0]);
	});
};
webpackAsyncContext.keys = function webpackAsyncContextKeys() {
	return Object.keys(map);
};
webpackAsyncContext.id = 595;
module.exports = webpackAsyncContext;

/***/ }),
/* 596 */,
/* 597 */,
/* 598 */
/***/ (function(module, exports) {

/* (ignored) */

/***/ }),
/* 599 */
/***/ (function(module, exports) {

/* (ignored) */

/***/ }),
/* 600 */
/***/ (function(module, exports) {

/* (ignored) */

/***/ }),
/* 601 */,
/* 602 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_vue_loader_lib_selector_type_script_index_0_DownloadImagesDialog_vue__ = __webpack_require__(255);
/* unused harmony namespace reexport */
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__node_modules_vue_loader_lib_template_compiler_index_id_data_v_00690cd9_hasScoped_true_transformToRequire_video_src_poster_source_src_img_src_image_xlink_href_buble_transforms_node_modules_vue_loader_lib_selector_type_template_index_0_DownloadImagesDialog_vue__ = __webpack_require__(604);
function injectStyle (ssrContext) {
  __webpack_require__(603)
}
var normalizeComponent = __webpack_require__(0)
/* script */


/* template */

/* template functional */
var __vue_template_functional__ = false
/* styles */
var __vue_styles__ = injectStyle
/* scopeId */
var __vue_scopeId__ = "data-v-00690cd9"
/* moduleIdentifier (server only) */
var __vue_module_identifier__ = null
var Component = normalizeComponent(
  __WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_vue_loader_lib_selector_type_script_index_0_DownloadImagesDialog_vue__["a" /* default */],
  __WEBPACK_IMPORTED_MODULE_1__node_modules_vue_loader_lib_template_compiler_index_id_data_v_00690cd9_hasScoped_true_transformToRequire_video_src_poster_source_src_img_src_image_xlink_href_buble_transforms_node_modules_vue_loader_lib_selector_type_template_index_0_DownloadImagesDialog_vue__["a" /* default */],
  __vue_template_functional__,
  __vue_styles__,
  __vue_scopeId__,
  __vue_module_identifier__
)

/* harmony default export */ __webpack_exports__["a"] = (Component.exports);


/***/ }),
/* 603 */
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ }),
/* 604 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('v-dialog',{staticClass:"search-dialog",attrs:{"persistent":_vm.options.persistent,"transition":_vm.transition,"max-width":_vm.options.maxWidth,"min-width":"640px","fullscreen":_vm.$vuetify.breakpoint.xsOnly,"scrollable":""},model:{value:(_vm.show),callback:function ($$v) {_vm.show=$$v},expression:"show"}},[_c('v-card',{attrs:{"height":"485px"}},[_c('v-toolbar',{attrs:{"flat":"","dark":"","color":"primary"}},[_c('v-btn',{attrs:{"icon":"","dark":""},on:{"click":_vm.cancelDialog}},[_c('v-icon',[_vm._v("close")])],1),_vm._v(" "),_c('v-toolbar-title',[_vm._v("Download")]),_vm._v(" "),_c('v-spacer')],1),_vm._v(" "),_c('v-card-text',[(this.options.forwardedImages)?_c('v-list',_vm._l((this.options.forwardedImages),function(item){return _c('v-list-tile',{key:item._id,attrs:{"row":""},on:{"click":function($event){_vm.download(item)}}},[_c('v-list-tile-content',[_c('v-list-tile-title',[_vm._v(_vm._s(item.description))])],1),_vm._v(" "),_c('v-list-tile-avatar',[_c('v-icon',[_vm._v("file_download")])],1)],1)})):_vm._e()],1),_vm._v(" "),_c('v-spacer'),_vm._v(" "),_c('v-divider'),_vm._v(" "),_c('v-card-actions',[_c('v-spacer'),_vm._v(" "),_c('v-btn',{attrs:{"color":"primary","depressed":""},on:{"click":_vm._downloadBundle}},[_vm._v("Download All")])],1)],1)],1)}
var staticRenderFns = []
var esExports = { render: render, staticRenderFns: staticRenderFns }
/* harmony default export */ __webpack_exports__["a"] = (esExports);

/***/ }),
/* 605 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('v-dialog',{attrs:{"fullscreen":true,"transition":"dialog-bottom-transition","scrollable":""},model:{value:(_vm.show),callback:function ($$v) {_vm.show=$$v},expression:"show"}},[_c('v-card',[_c('v-toolbar',{attrs:{"dense":"","flat":"","dark":"","color":"#444444"}},[_c('div',[_vm._v("Medical Record Viewer")]),_vm._v(" "),_c('v-spacer'),_vm._v(" "),_c('v-btn',{attrs:{"icon":"","dark":""},on:{"click":_vm.onClose}},[_c('v-icon',[_vm._v("close")])],1)],1),_vm._v(" "),_c('v-layout',{attrs:{"fill-height":"","column":"","justify-center":""}},[_c('iframe',{staticStyle:{"width":"100%","height":"100%","overflow":"hidden"},attrs:{"src":this.options.fileLocation,"frameborder":"0"}})])],1)],1)}
var staticRenderFns = []
var esExports = { render: render, staticRenderFns: staticRenderFns }
/* harmony default export */ __webpack_exports__["a"] = (esExports);

/***/ }),
/* 606 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('v-layout',{attrs:{"row":"","justify-center":""}},[_c('v-flex',[_c('v-card',{staticClass:"ma-2 mt-4",attrs:{"flat":""}},[_c('v-layout',{attrs:{"column":""}},[_c('v-text-field',{staticClass:"mt-4",attrs:{"outline":"","hide-details":"","readonly":"","label":"Patient"},on:{"click":function($event){_vm.showPatientSearch()}},model:{value:(_vm.patientID),callback:function ($$v) {_vm.patientID=$$v},expression:"patientID"}}),_vm._v(" "),_c('v-menu',{ref:"menuProvider",staticClass:"mt-4",attrs:{"close-on-content-click":true,"lazy":"","transition":"scale-transition","offset-y":"","full-width":"","min-width":"290px"},model:{value:(_vm.menuProvider),callback:function ($$v) {_vm.menuProvider=$$v},expression:"menuProvider"}},[_c('v-text-field',{attrs:{"slot":"activator","hint":_vm.providerID,"persistent-hint":"","outline":"","hide-details":"","label":"Provider"},slot:"activator",model:{value:(_vm.providerName),callback:function ($$v) {_vm.providerName=$$v},expression:"providerName"}}),_vm._v(" "),(_vm.searchResults)?_c('v-list',_vm._l((_vm.searchResults),function(provider){return _c('v-list-tile',{key:provider.npi,attrs:{"row":"","provider":provider},on:{"click":function($event){_vm.selectProvider(provider)}}},[_c('v-list-tile-content',{staticStyle:{"margin":"5px"}},[_c('v-list-tile-title',[_vm._v(_vm._s(provider.displayNameIndividual))]),_vm._v(" "),_c('v-list-tile-sub-title',[_vm._v(_vm._s(provider.displayAddressIndividual))])],1)],1)})):_vm._e()],1),_vm._v(" "),_c('v-text-field',{staticClass:"mt-4",attrs:{"outline":"","hide-details":"","hint":"mm/dd/yyyy","mask":"##/##/####","persistent-hint":"","label":"Encounter Date"},model:{value:(_vm.date),callback:function ($$v) {_vm.date=$$v},expression:"date"}}),_vm._v(" "),_c('v-select',{staticClass:"mt-4",attrs:{"items":_vm.recordTypes,"outline":"","required":"","label":"Record Type"},model:{value:(_vm.typeInput),callback:function ($$v) {_vm.typeInput=$$v},expression:"typeInput"}}),_vm._v(" "),(_vm.file)?_c('v-layout',{staticStyle:{"cursor":"pointer"},on:{"click":function($event){_vm.openFile(_vm.file[0])}}},[_c('v-card',{staticClass:"standardCard",staticStyle:{"background-color":"#eeeeee"},attrs:{"flat":"","width":"100%"}},[_c('v-card-text',{staticClass:"file-card-text"},[(_vm.file[0].originalFilename)?_c('v-layout',{staticClass:"file-card-title-text"},[_vm._v("\n                      "+_vm._s(_vm.file[0].originalFilename)+"\n                    ")]):_c('v-layout',{staticClass:"file-card-title-text"},[_vm._v("\n                      No file name\n                    ")]),_vm._v(" "),_c('v-layout',[_vm._v("\n                      "+_vm._s(_vm.file[0].id)+"\n                    ")]),_vm._v(" "),(_vm.file[0].patient)?_c('v-layout',[_vm._v("\n                      "+_vm._s(_vm.file[0].patient.firstName)+" "+_vm._s(_vm.file[0].patient.lastName)+"\n                    ")]):_vm._e(),_vm._v(" "),(_vm.file[0].renderingProvider)?_c('v-layout',[_vm._v("\n                      "+_vm._s(_vm.providerName)+"\n                    ")]):_vm._e()],1)],1)],1):_vm._e(),_vm._v(" "),_c('v-layout',{attrs:{"row":""}},[_c('v-spacer'),_vm._v(" "),_c('v-btn',{attrs:{"color":"primary"},on:{"click":_vm.uploadRecord}},[_vm._v("Assign File")])],1)],1)],1)],1),_vm._v(" "),_c('provider-selector-dialog',{ref:"providerDialog",on:{"emitProvider":function($event){_vm.addProvider($event)}}}),_vm._v(" "),_c('file-dialog',{ref:"fileDialog"}),_vm._v(" "),_c('advanced-patient-search-admin',{ref:"patientSearchDialog",on:{"emitPatient":function($event){_vm.selectPatient($event)}}})],1)}
var staticRenderFns = []
var esExports = { render: render, staticRenderFns: staticRenderFns }
/* harmony default export */ __webpack_exports__["a"] = (esExports);

/***/ }),
/* 607 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_vue_loader_lib_selector_type_script_index_0_AdminRequestsPage_vue__ = __webpack_require__(256);
/* unused harmony namespace reexport */
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__node_modules_vue_loader_lib_template_compiler_index_id_data_v_26198314_hasScoped_true_transformToRequire_video_src_poster_source_src_img_src_image_xlink_href_buble_transforms_node_modules_vue_loader_lib_selector_type_template_index_0_AdminRequestsPage_vue__ = __webpack_require__(616);
function injectStyle (ssrContext) {
  __webpack_require__(608)
}
var normalizeComponent = __webpack_require__(0)
/* script */


/* template */

/* template functional */
var __vue_template_functional__ = false
/* styles */
var __vue_styles__ = injectStyle
/* scopeId */
var __vue_scopeId__ = "data-v-26198314"
/* moduleIdentifier (server only) */
var __vue_module_identifier__ = null
var Component = normalizeComponent(
  __WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_vue_loader_lib_selector_type_script_index_0_AdminRequestsPage_vue__["a" /* default */],
  __WEBPACK_IMPORTED_MODULE_1__node_modules_vue_loader_lib_template_compiler_index_id_data_v_26198314_hasScoped_true_transformToRequire_video_src_poster_source_src_img_src_image_xlink_href_buble_transforms_node_modules_vue_loader_lib_selector_type_template_index_0_AdminRequestsPage_vue__["a" /* default */],
  __vue_template_functional__,
  __vue_styles__,
  __vue_scopeId__,
  __vue_module_identifier__
)

/* harmony default export */ __webpack_exports__["a"] = (Component.exports);


/***/ }),
/* 608 */
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ }),
/* 609 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_vue_loader_lib_selector_type_script_index_0_RequestInfoDialog_vue__ = __webpack_require__(257);
/* unused harmony namespace reexport */
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__node_modules_vue_loader_lib_template_compiler_index_id_data_v_727de77a_hasScoped_true_transformToRequire_video_src_poster_source_src_img_src_image_xlink_href_buble_transforms_node_modules_vue_loader_lib_selector_type_template_index_0_RequestInfoDialog_vue__ = __webpack_require__(615);
function injectStyle (ssrContext) {
  __webpack_require__(610)
}
var normalizeComponent = __webpack_require__(0)
/* script */


/* template */

/* template functional */
var __vue_template_functional__ = false
/* styles */
var __vue_styles__ = injectStyle
/* scopeId */
var __vue_scopeId__ = "data-v-727de77a"
/* moduleIdentifier (server only) */
var __vue_module_identifier__ = null
var Component = normalizeComponent(
  __WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_vue_loader_lib_selector_type_script_index_0_RequestInfoDialog_vue__["a" /* default */],
  __WEBPACK_IMPORTED_MODULE_1__node_modules_vue_loader_lib_template_compiler_index_id_data_v_727de77a_hasScoped_true_transformToRequire_video_src_poster_source_src_img_src_image_xlink_href_buble_transforms_node_modules_vue_loader_lib_selector_type_template_index_0_RequestInfoDialog_vue__["a" /* default */],
  __vue_template_functional__,
  __vue_styles__,
  __vue_scopeId__,
  __vue_module_identifier__
)

/* harmony default export */ __webpack_exports__["a"] = (Component.exports);


/***/ }),
/* 610 */
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ }),
/* 611 */,
/* 612 */,
/* 613 */,
/* 614 */,
/* 615 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('v-dialog',{attrs:{"hide-overlay":"","fullscreen":"","scrollable":"","transition":"dialog-bottom-transition"},model:{value:(_vm.show),callback:function ($$v) {_vm.show=$$v},expression:"show"}},[_c('div',{ref:"myDiv",attrs:{"id":"myDiv"}}),_vm._v(" "),(this.options.request)?_c('v-card',{staticClass:"background"},[_c('v-toolbar',{attrs:{"flat":"","dark":"","color":"primary"}},[(_vm.standardEditViewMode)?_c('v-btn',{attrs:{"icon":"","dark":""},on:{"click":this.cancel}},[_c('v-icon',[_vm._v("close")])],1):_vm._e(),_vm._v(" "),(_vm.providerEditViewMode)?_c('v-btn',{attrs:{"icon":"","dark":""},on:{"click":function($event){_vm.backToStandardMode()}}},[_c('v-icon',[_vm._v("arrow_back_ios")])],1):_vm._e(),_vm._v(" "),_c('v-toolbar-title',[_vm._v("Records Request")]),_vm._v(" "),_c('v-spacer')],1),_vm._v(" "),_c('v-card-text',{staticClass:"card-text"},[(_vm.standardEditViewMode)?_c('v-container',{staticClass:"fade-in one",attrs:{"grid-list-md":""}},[_c('v-layout',{attrs:{"row":"","wrap":""}},[_c('v-flex',{attrs:{"xs12":"","sm6":""}},[_c('v-card',{attrs:{"flat":""}},[_c('v-card-text',[_c('v-layout',{staticStyle:{"margin-bottom":"10px"},attrs:{"row":""}},[_c('span',{staticClass:"dialogSectionTitle"},[_vm._v("Request")]),_vm._v(" "),_c('v-spacer'),_vm._v(" "),_c('span',{staticClass:"status"},[_vm._v(_vm._s(_vm.options.request.status))])],1),_vm._v(" "),_c('v-divider'),_vm._v(" "),_c('v-layout',{staticStyle:{"margin-top":"10px"},attrs:{"row":""}},[_c('span',{staticClass:"dialog-title"},[_vm._v("Patient")]),_vm._v(" "),_c('v-spacer'),_vm._v(" "),_c('span',{staticClass:"content"},[_vm._v(_vm._s(_vm.options.patient.firstName + " " + _vm.options.patient.lastName))])],1),_vm._v(" "),_c('v-layout',{attrs:{"row":""}},[_c('span',{staticClass:"dialog-sub-title"},[_vm._v("Birthdate")]),_vm._v(" "),_c('v-spacer'),_vm._v(" "),_c('span',{staticClass:"content"},[_vm._v(_vm._s(_vm.convertDate(_vm.options.patient.birthdate)))])],1),_vm._v(" "),_c('v-layout',{attrs:{"row":""}},[_c('span',{staticClass:"dialog-sub-title"},[_vm._v("Phone number")]),_vm._v(" "),_c('v-spacer'),_vm._v(" "),_c('span',{staticClass:"content"},[_vm._v(_vm._s(_vm.options.patient.phone))])],1),_vm._v(" "),_c('v-layout',{attrs:{"row":""}},[_c('span',{staticClass:"dialog-sub-title"},[_vm._v("Address")]),_vm._v(" "),_c('v-spacer'),_vm._v(" "),_c('span',{staticClass:"content"},[_vm._v(_vm._s(_vm.options.patient.address.line1 + ", " + _vm.options.patient.address.city + " " + _vm.options.patient.address.zip))])],1),_vm._v(" "),_c('v-layout',{attrs:{"row":""}},[_c('span',{staticClass:"dialog-title"},[_vm._v("Dates of Service")]),_vm._v(" "),_c('v-spacer'),_vm._v(" "),_c('span',{staticClass:"content"},[_vm._v(_vm._s(_vm.convertDate(_vm.options.request.start))+" - "+_vm._s(_vm.convertDate(_vm.options.request.end)))])],1),_vm._v(" "),_c('v-layout',{attrs:{"row":""}},[(_vm.options.provider)?_c('span',{staticClass:"dialog-title"},[_vm._v("Provider")]):_vm._e(),_vm._v(" "),_c('v-spacer'),_vm._v(" "),_c('span',{staticClass:"content"},[_vm._v(_vm._s(_vm.returnProviderDisplayName()))])],1),_vm._v(" "),(_vm.options.provider && _vm.options.provider.address)?_c('v-layout',{attrs:{"row":""}},[_c('span',{staticClass:"dialog-sub-title"},[_vm._v("Address")]),_vm._v(" "),_c('v-spacer'),_vm._v(" "),_c('span',{staticClass:"content"},[_vm._v(_vm._s(_vm.options.provider[0].address.line1 + ", " + _vm.options.provider[0].address.city + " " + _vm.options.provider[0].address.zip))])],1):_vm._e(),_vm._v(" "),(_vm.options.provider)?_c('v-layout',{attrs:{"row":""}},[_c('span',{staticClass:"dialog-sub-title"},[_vm._v("Phone")]),_vm._v(" "),_c('v-spacer'),_vm._v(" "),_c('span',{staticClass:"content"},[_vm._v(_vm._s(_vm.options.provider[0].phone))])],1):_vm._e(),_vm._v(" "),(_vm.options.provider)?_c('v-layout',{attrs:{"row":""}},[_c('span',{staticClass:"dialog-sub-title"},[_vm._v("Fax")]),_vm._v(" "),_c('v-spacer'),_vm._v(" "),_c('span',{staticClass:"content"},[_vm._v(_vm._s(_vm.options.provider[0].fax))])],1):_vm._e(),_vm._v(" "),_c('v-text-field',{attrs:{"label":"Provider Notes","multi-line":""},model:{value:(_vm.editProviderNote),callback:function ($$v) {_vm.editProviderNote=$$v},expression:"editProviderNote"}}),_vm._v(" "),_c('v-layout',[_c('v-spacer'),_vm._v(" "),_c('v-btn',{staticStyle:{"min-width":"0","font-weight":"700"},attrs:{"color":"primary","disabled":!this.providerNoteHasBeenEdited,"left":"","depressed":""},on:{"click":function($event){_vm.submitProviderNote()}}},[_vm._v("Update Provider Note")])],1)],1)],1)],1),_vm._v(" "),_c('v-flex',{attrs:{"xs12":"","sm6":""}},[_c('v-card',{attrs:{"flat":""}},[_c('v-card-text',{attrs:{"column":""}},[_c('v-layout',{staticStyle:{"margin-bottom":"10px"},attrs:{"row":""}},[_c('span',{staticClass:"dialogSectionTitle"},[_vm._v("Action")]),_vm._v(" "),_c('v-spacer'),_vm._v(" "),_c('span',{staticClass:"status"},[_vm._v(_vm._s(_vm.suggestedAction))])],1),_vm._v(" "),_c('v-divider'),_vm._v(" "),(_vm.standardEditViewMode && _vm.options.provider && !this.completedMode)?_c('v-layout',{staticStyle:{"margin-top":"10px"},attrs:{"column":""}},[(this.options.request.status === 'SENT')?_c('span',{staticClass:"message"},[_vm._v("This request has been sent. Please verify delivery and ensure that the practice is processing the request in a timely manner.")]):_vm._e(),_vm._v(" "),(this.options.request.status === 'NEEDS_FAX_NUMBER')?_c('span',{staticClass:"message"},[_vm._v("This request needs a fax number. Please contact the provider office and verify the best number use for a medical records request. After updating the field below, the system will send the fax.")]):_vm._e(),_vm._v(" "),_c('v-form',{staticClass:"pa-2 mt-2"},[(_vm.options.provider)?_c('v-layout',{attrs:{"column":""}},[_c('v-text-field',{attrs:{"flat":"","label":"Phone"},model:{value:(_vm.editPhone),callback:function ($$v) {_vm.editPhone=$$v},expression:"editPhone"}}),_vm._v(" "),_c('v-text-field',{attrs:{"flat":"","label":"Medical Records Fax"},model:{value:(_vm.editFax),callback:function ($$v) {_vm.editFax=$$v},expression:"editFax"}}),_vm._v(" "),_c('v-text-field',{attrs:{"flat":"","label":"Medical Records Email"},model:{value:(_vm.editEmail),callback:function ($$v) {_vm.editEmail=$$v},expression:"editEmail"}}),_vm._v(" "),_c('v-text-field',{staticClass:"mt-1 mb-1",attrs:{"prepend-icon":"event","hint":"mm/dd/yyyy","mask":"##/##/####","persistent-hint":"","label":"Next Follow Up"},model:{value:(_vm.nextFollowUpDate),callback:function ($$v) {_vm.nextFollowUpDate=$$v},expression:"nextFollowUpDate"}})],1):_vm._e()],1),_vm._v(" "),_c('v-layout',{attrs:{"row":""}},[_c('v-spacer'),_c('v-btn',{attrs:{"disabled":!_vm.edit,"color":"primary"},on:{"click":_vm.submit}},[_vm._v("Update")])],1)],1):_vm._e(),_vm._v(" "),(_vm.completedMode)?_c('v-layout',{staticStyle:{"margin-top":"10px"},attrs:{"column":""}},[_c('span',{staticClass:"message"},[_vm._v("This request has been marked as completed. No further action is needed.")])]):_vm._e(),_vm._v(" "),(_vm.proposeSuggestedProviderMode && !this.options.provider)?_c('v-layout',{staticStyle:{"margin-top":"10px"},attrs:{"column":""}},[_c('span',{staticClass:"message"},[_vm._v("This request is missing full provider information but a potential matching provider has been found. Review the proposed provider information, edit the data for accuracy and display purposes and attach the provider to this request to continue.")]),_vm._v(" "),_c('v-layout',[_c('v-spacer'),_vm._v(" "),_c('v-btn',{staticStyle:{"min-width":"0","font-weight":"700"},attrs:{"color":"primary","left":"","flat":""},on:{"click":function($event){_vm.addGoogleProvider()}}},[_vm._v("Review Provider")])],1)],1):_vm._e()],1)],1)],1)],1)],1):_vm._e(),_vm._v(" "),(_vm.providerEditViewMode)?_c('v-container',{attrs:{"grid-list-md":""}},[_c('v-card',{staticClass:"fade-in one",attrs:{"flat":""}},[_c('v-form',{model:{value:(_vm.suggestedProviderValid),callback:function ($$v) {_vm.suggestedProviderValid=$$v},expression:"suggestedProviderValid"}},[_c('v-card-text',[_c('v-layout',{attrs:{"row":"","wrap":""}},[_c('v-flex',{attrs:{"xs12":"","sm6":"","offset-sm6":""}},[_c('v-layout',{attrs:{"row":""}},[_c('v-radio-group',{attrs:{"row":"","blue":""},model:{value:(_vm.suggestedProvider.type),callback:function ($$v) {_vm.$set(_vm.suggestedProvider, "type", $$v)},expression:"suggestedProvider.type"}},[_c('v-radio',{attrs:{"label":"Individual","value":"INDIVIDUAL"}}),_vm._v(" "),_c('v-radio',{attrs:{"label":"Organization","value":"ORGANIZATION"}})],1)],1)],1),_vm._v(" "),_c('v-flex',{attrs:{"xs12":"","sm6":""}},[_c('v-layout',{staticClass:"pa-1",attrs:{"column":""}},[_c('v-text-field',{directives:[{name:"show",rawName:"v-show",value:(this.suggestedProvider.type === 'ORGANIZATION'),expression:"this.suggestedProvider.type === 'ORGANIZATION'"}],attrs:{"flat":"","label":"Organization Name"},model:{value:(this.suggestedProvider.organizationName),callback:function ($$v) {_vm.$set(this.suggestedProvider, "organizationName", $$v)},expression:"this.suggestedProvider.organizationName"}}),_vm._v(" "),_c('v-text-field',{directives:[{name:"show",rawName:"v-show",value:(this.suggestedProvider.type === 'INDIVIDUAL'),expression:"this.suggestedProvider.type === 'INDIVIDUAL'"}],attrs:{"flat":"","label":"First Name"},model:{value:(this.suggestedProvider.firstName),callback:function ($$v) {_vm.$set(this.suggestedProvider, "firstName", $$v)},expression:"this.suggestedProvider.firstName"}}),_vm._v(" "),_c('v-text-field',{directives:[{name:"show",rawName:"v-show",value:(this.suggestedProvider.type === 'INDIVIDUAL'),expression:"this.suggestedProvider.type === 'INDIVIDUAL'"}],attrs:{"flat":"","label":"Last Name"},model:{value:(this.suggestedProvider.lastName),callback:function ($$v) {_vm.$set(this.suggestedProvider, "lastName", $$v)},expression:"this.suggestedProvider.lastName"}}),_vm._v(" "),_c('v-text-field',{directives:[{name:"show",rawName:"v-show",value:(this.suggestedProvider.type === 'INDIVIDUAL'),expression:"this.suggestedProvider.type === 'INDIVIDUAL'"}],attrs:{"flat":"","label":"Credentials"},model:{value:(this.suggestedProvider.credentials),callback:function ($$v) {_vm.$set(this.suggestedProvider, "credentials", $$v)},expression:"this.suggestedProvider.credentials"}}),_vm._v(" "),_c('v-text-field',{attrs:{"flat":"","label":"Phone"},model:{value:(this.suggestedProvider.phone),callback:function ($$v) {_vm.$set(this.suggestedProvider, "phone", $$v)},expression:"this.suggestedProvider.phone"}}),_vm._v(" "),_c('v-text-field',{attrs:{"flat":"","label":"Medical Records Fax"},model:{value:(this.suggestedProvider.fax),callback:function ($$v) {_vm.$set(this.suggestedProvider, "fax", $$v)},expression:"this.suggestedProvider.fax"}}),_vm._v(" "),_c('v-text-field',{attrs:{"flat":"","label":"Medical Records Email"},model:{value:(this.suggestedProvider.email),callback:function ($$v) {_vm.$set(this.suggestedProvider, "email", $$v)},expression:"this.suggestedProvider.email"}})],1)],1),_vm._v(" "),_c('v-flex',{attrs:{"xs12":"","sm6":""}},[_c('v-layout',{staticClass:"pa-1",attrs:{"column":""}},[_c('v-text-field',{attrs:{"flat":"","label":"Street Address","required":""},model:{value:(this.suggestedProvider.address.line1),callback:function ($$v) {_vm.$set(this.suggestedProvider.address, "line1", $$v)},expression:"this.suggestedProvider.address.line1"}}),_vm._v(" "),_c('v-text-field',{attrs:{"flat":"","label":"Address Line 2"},model:{value:(this.suggestedProvider.address.line2),callback:function ($$v) {_vm.$set(this.suggestedProvider.address, "line2", $$v)},expression:"this.suggestedProvider.address.line2"}}),_vm._v(" "),_c('v-text-field',{attrs:{"flat":"","label":"City","required":""},model:{value:(this.suggestedProvider.address.city),callback:function ($$v) {_vm.$set(this.suggestedProvider.address, "city", $$v)},expression:"this.suggestedProvider.address.city"}}),_vm._v(" "),_c('v-text-field',{attrs:{"flat":"","label":"State","required":""},model:{value:(this.suggestedProvider.address.state),callback:function ($$v) {_vm.$set(this.suggestedProvider.address, "state", $$v)},expression:"this.suggestedProvider.address.state"}}),_vm._v(" "),_c('v-text-field',{attrs:{"flat":"","label":"Zip","required":""},model:{value:(this.suggestedProvider.address.zip),callback:function ($$v) {_vm.$set(this.suggestedProvider.address, "zip", $$v)},expression:"this.suggestedProvider.address.zip"}})],1)],1)],1),_vm._v(" "),_c('v-layout',[_c('v-spacer'),_vm._v(" "),_c('v-btn',{staticStyle:{"min-width":"0","font-weight":"700"},attrs:{"color":"primary","disabled":!_vm.suggestedProviderValid,"left":"","flat":""},nativeOn:{"click":function($event){_vm.addUpdateProvider()}}},[_vm._v("Save Provider Information")])],1)],1)],1)],1)],1):_vm._e(),_vm._v(" "),(_vm.standardEditViewMode)?_c('v-container',{attrs:{"grid-list-md":""}},[_c('v-flex',{attrs:{"xs12":""}},[_c('v-text-field',{attrs:{"label":"Request Notes","multi-line":""},model:{value:(_vm.memo),callback:function ($$v) {_vm.memo=$$v},expression:"memo"}}),_vm._v(" "),_c('v-layout',[_c('v-btn',{staticStyle:{"min-width":"0","font-weight":"700","color":"white"},attrs:{"color":"red","left":"","depressed":""},on:{"click":function($event){_vm.cancelRequest()}}},[_vm._v("Cancel Request")]),_vm._v(" "),_c('v-spacer'),_vm._v(" "),_c('v-btn',{staticStyle:{"min-width":"0","font-weight":"700"},attrs:{"color":"primary","disabled":!this.memo && !this.edit,"left":"","depressed":""},on:{"click":function($event){_vm.submitNotes()}}},[_vm._v("Save Note")])],1),_vm._v(" "),(this.logStamps.length)?_c('v-layout',{staticStyle:{"margin-top":"30px"},attrs:{"column":""}},[_c('span',{staticClass:"dialog-sub-title"},[_vm._v("Request Log")]),_vm._v(" "),_vm._l((this.logStamps),function(logEntry){return _c('span',{key:logEntry},[_vm._v(_vm._s(logEntry))])})],2):_vm._e()],1)],1):_vm._e()],1)],1):_vm._e()],1)}
var staticRenderFns = []
var esExports = { render: render, staticRenderFns: staticRenderFns }
/* harmony default export */ __webpack_exports__["a"] = (esExports);

/***/ }),
/* 616 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('v-layout',{staticClass:"patient-page",attrs:{"column":""}},[_c('v-data-table',{staticClass:"flat table-border",attrs:{"sort-icon":"","color":"#eeeeee","headers":_vm.headers,"items":_vm.activeRequests,"pagination":_vm.currentPagination,"rows-per-page-items":_vm.rowsPerPageItems,"total-items":_vm.requestsPageInfo.total,"loading":_vm.loadingRequests},on:{"update:pagination":[function($event){_vm.currentPagination=$event},_vm.updatePagination]},scopedSlots:_vm._u([{key:"items",fn:function(props){return [(props.item)?_c('tr',{class:_vm.alternatingColors(props.index),staticStyle:{"cursor":"pointer"},on:{"click":function($event){_vm.showMoreInfo(props.item)}}},[_c('td',{staticClass:"text-xs-left pt-3 pb-3",attrs:{"valign":"top"}},[_vm._v(" "+_vm._s(props.item.providerID))]),_vm._v(" "),_c('td',{staticClass:"text-xs-left pt-3 pb-3",attrs:{"valign":"top"}},[_vm._v(_vm._s(props.item.patientID))]),_vm._v(" "),_c('td',{staticClass:"text-xs-left pt-3 pb-3",attrs:{"valign":"top"}},[_vm._v(_vm._s(props.item.status))]),_vm._v(" "),_c('td',{staticClass:"text-xs-left pt-3 pb-3",attrs:{"valign":"top"}},[_vm._v(_vm._s(props.item.createdDate))]),_vm._v(" "),_c('td',{staticClass:"text-xs-left pt-3 pb-3",attrs:{"valign":"top"}},[_vm._v(_vm._s(props.item.lastLog))])]):_vm._e()]}},{key:"expand",fn:function(props){return [_c('v-card',{attrs:{"flat":""}},[_c('v-card-text',[_vm._v(_vm._s(props.item))])],1)]}}])}),_vm._v(" "),_c('request-info-dialog',{ref:"requestInfoDialog"})],1)}
var staticRenderFns = []
var esExports = { render: render, staticRenderFns: staticRenderFns }
/* harmony default export */ __webpack_exports__["a"] = (esExports);

/***/ }),
/* 617 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_vue_loader_lib_selector_type_script_index_0_AdminRequestDetailPage_vue__ = __webpack_require__(258);
/* unused harmony namespace reexport */
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__node_modules_vue_loader_lib_template_compiler_index_id_data_v_636a1b92_hasScoped_true_transformToRequire_video_src_poster_source_src_img_src_image_xlink_href_buble_transforms_node_modules_vue_loader_lib_selector_type_template_index_0_AdminRequestDetailPage_vue__ = __webpack_require__(628);
function injectStyle (ssrContext) {
  __webpack_require__(618)
}
var normalizeComponent = __webpack_require__(0)
/* script */


/* template */

/* template functional */
var __vue_template_functional__ = false
/* styles */
var __vue_styles__ = injectStyle
/* scopeId */
var __vue_scopeId__ = "data-v-636a1b92"
/* moduleIdentifier (server only) */
var __vue_module_identifier__ = null
var Component = normalizeComponent(
  __WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_vue_loader_lib_selector_type_script_index_0_AdminRequestDetailPage_vue__["a" /* default */],
  __WEBPACK_IMPORTED_MODULE_1__node_modules_vue_loader_lib_template_compiler_index_id_data_v_636a1b92_hasScoped_true_transformToRequire_video_src_poster_source_src_img_src_image_xlink_href_buble_transforms_node_modules_vue_loader_lib_selector_type_template_index_0_AdminRequestDetailPage_vue__["a" /* default */],
  __vue_template_functional__,
  __vue_styles__,
  __vue_scopeId__,
  __vue_module_identifier__
)

/* harmony default export */ __webpack_exports__["a"] = (Component.exports);


/***/ }),
/* 618 */
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ }),
/* 619 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_vue_loader_lib_selector_type_script_index_0_DataCard_vue__ = __webpack_require__(259);
/* unused harmony namespace reexport */
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__node_modules_vue_loader_lib_template_compiler_index_id_data_v_11eab3da_hasScoped_true_transformToRequire_video_src_poster_source_src_img_src_image_xlink_href_buble_transforms_node_modules_vue_loader_lib_selector_type_template_index_0_DataCard_vue__ = __webpack_require__(621);
function injectStyle (ssrContext) {
  __webpack_require__(620)
}
var normalizeComponent = __webpack_require__(0)
/* script */


/* template */

/* template functional */
var __vue_template_functional__ = false
/* styles */
var __vue_styles__ = injectStyle
/* scopeId */
var __vue_scopeId__ = "data-v-11eab3da"
/* moduleIdentifier (server only) */
var __vue_module_identifier__ = null
var Component = normalizeComponent(
  __WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_vue_loader_lib_selector_type_script_index_0_DataCard_vue__["a" /* default */],
  __WEBPACK_IMPORTED_MODULE_1__node_modules_vue_loader_lib_template_compiler_index_id_data_v_11eab3da_hasScoped_true_transformToRequire_video_src_poster_source_src_img_src_image_xlink_href_buble_transforms_node_modules_vue_loader_lib_selector_type_template_index_0_DataCard_vue__["a" /* default */],
  __vue_template_functional__,
  __vue_styles__,
  __vue_scopeId__,
  __vue_module_identifier__
)

/* harmony default export */ __webpack_exports__["a"] = (Component.exports);


/***/ }),
/* 620 */
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ }),
/* 621 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('v-card',{staticClass:"fade-in one standardCardFile ml-1 mr-1 mt-2",attrs:{"flat":""}},[_c('v-layout',{attrs:{"column":""}},[_c('v-layout',{staticStyle:{"height":"200"},attrs:{"column":""}},[_c('span',{staticClass:"fade-in three",staticStyle:{"font-size":"30px","text-align":"center","font-weight":"700"}},[_vm._v(_vm._s(_vm.dataValue))]),_vm._v(" "),_c('v-layout',{staticClass:"pa-2",staticStyle:{"border-top":"1px solid #E8EAED","background-color":"white","width":"100%","bottom":"0"},attrs:{"column":"","row":""}},[_c('span',{staticClass:"mainTitle truncate"},[_vm._v(_vm._s(_vm.labelValue))]),_vm._v(" "),_c('span',{staticClass:"subtitle truncate"},[_vm._v(_vm._s(_vm.partnerValue))])])],1)],1)],1)}
var staticRenderFns = []
var esExports = { render: render, staticRenderFns: staticRenderFns }
/* harmony default export */ __webpack_exports__["a"] = (esExports);

/***/ }),
/* 622 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_vue_loader_lib_selector_type_script_index_0_InformationCard_vue__ = __webpack_require__(260);
/* unused harmony namespace reexport */
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__node_modules_vue_loader_lib_template_compiler_index_id_data_v_4b6ffe08_hasScoped_true_transformToRequire_video_src_poster_source_src_img_src_image_xlink_href_buble_transforms_node_modules_vue_loader_lib_selector_type_template_index_0_InformationCard_vue__ = __webpack_require__(624);
function injectStyle (ssrContext) {
  __webpack_require__(623)
}
var normalizeComponent = __webpack_require__(0)
/* script */


/* template */

/* template functional */
var __vue_template_functional__ = false
/* styles */
var __vue_styles__ = injectStyle
/* scopeId */
var __vue_scopeId__ = "data-v-4b6ffe08"
/* moduleIdentifier (server only) */
var __vue_module_identifier__ = null
var Component = normalizeComponent(
  __WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_vue_loader_lib_selector_type_script_index_0_InformationCard_vue__["a" /* default */],
  __WEBPACK_IMPORTED_MODULE_1__node_modules_vue_loader_lib_template_compiler_index_id_data_v_4b6ffe08_hasScoped_true_transformToRequire_video_src_poster_source_src_img_src_image_xlink_href_buble_transforms_node_modules_vue_loader_lib_selector_type_template_index_0_InformationCard_vue__["a" /* default */],
  __vue_template_functional__,
  __vue_styles__,
  __vue_scopeId__,
  __vue_module_identifier__
)

/* harmony default export */ __webpack_exports__["a"] = (Component.exports);


/***/ }),
/* 623 */
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ }),
/* 624 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('v-card',{attrs:{"flat":""}},[_c('v-layout',{staticClass:"admin-sub-title mb-2"},[_vm._v(_vm._s(_vm.title))]),_vm._v(" "),_vm._l((_vm.data),function(item){return _c('v-layout',{key:item.title,staticClass:"admin-content",attrs:{"column":"","ml-2":""}},[_c('v-layout',{attrs:{"row":""}},[_c('v-flex',{staticStyle:{"font-weight":"350"},attrs:{"lg5":"","md5":"","mb-1":""}},[_vm._v("\n        "+_vm._s(item.title)+"\n      ")]),_vm._v(" "),_c('v-flex',{staticStyle:{"font-weight":"500"},attrs:{"lg7":"","md7":"","mb-1":""}},[_vm._v("\n        "+_vm._s(item.data)+"\n      ")])],1)],1)})],2)}
var staticRenderFns = []
var esExports = { render: render, staticRenderFns: staticRenderFns }
/* harmony default export */ __webpack_exports__["a"] = (esExports);

/***/ }),
/* 625 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_vue_loader_lib_selector_type_script_index_0_ResendRequestDialog_vue__ = __webpack_require__(261);
/* unused harmony namespace reexport */
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__node_modules_vue_loader_lib_template_compiler_index_id_data_v_e7a14614_hasScoped_true_transformToRequire_video_src_poster_source_src_img_src_image_xlink_href_buble_transforms_node_modules_vue_loader_lib_selector_type_template_index_0_ResendRequestDialog_vue__ = __webpack_require__(627);
function injectStyle (ssrContext) {
  __webpack_require__(626)
}
var normalizeComponent = __webpack_require__(0)
/* script */


/* template */

/* template functional */
var __vue_template_functional__ = false
/* styles */
var __vue_styles__ = injectStyle
/* scopeId */
var __vue_scopeId__ = "data-v-e7a14614"
/* moduleIdentifier (server only) */
var __vue_module_identifier__ = null
var Component = normalizeComponent(
  __WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_vue_loader_lib_selector_type_script_index_0_ResendRequestDialog_vue__["a" /* default */],
  __WEBPACK_IMPORTED_MODULE_1__node_modules_vue_loader_lib_template_compiler_index_id_data_v_e7a14614_hasScoped_true_transformToRequire_video_src_poster_source_src_img_src_image_xlink_href_buble_transforms_node_modules_vue_loader_lib_selector_type_template_index_0_ResendRequestDialog_vue__["a" /* default */],
  __vue_template_functional__,
  __vue_styles__,
  __vue_scopeId__,
  __vue_module_identifier__
)

/* harmony default export */ __webpack_exports__["a"] = (Component.exports);


/***/ }),
/* 626 */
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ }),
/* 627 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('v-dialog',{attrs:{"max-width":_vm.options.maxWidth,"transition":_vm.transition,"fullscreen":_vm.$vuetify.breakpoint.xsOnly,"scrollable":""},model:{value:(_vm.show),callback:function ($$v) {_vm.show=$$v},expression:"show"}},[_c('v-card',[_c('v-toolbar',{attrs:{"flat":"","dark":"","color":"primary"}},[_c('v-toolbar-title',[_vm._v("Resend Request")]),_vm._v(" "),_c('v-spacer'),_vm._v(" "),_c('v-btn',{attrs:{"icon":"","dark":""},on:{"click":_vm.close}},[_c('v-icon',[_vm._v("close")])],1)],1),_vm._v(" "),_c('v-card-text',[_c('v-text-field',{attrs:{"outline":"","label":"Fax Number"},on:{"change":function($event){_vm.recipientUpdated = true}},model:{value:(_vm.faxInput),callback:function ($$v) {_vm.faxInput=$$v},expression:"faxInput"}}),_vm._v(" "),_c('v-text-field',{attrs:{"outline":"","label":"Email"},on:{"change":function($event){_vm.recipientUpdated = true}},model:{value:(_vm.emailInput),callback:function ($$v) {_vm.emailInput=$$v},expression:"emailInput"}}),_vm._v("\n    Note: requests will be sent by email if the email field is populated. If no email is supplied, the request will be sent by fax.\n    ")],1),_vm._v(" "),_c('v-card-actions',[_c('v-spacer'),_vm._v(" "),_c('v-btn',{attrs:{"disabled":!_vm.faxInput && !_vm.emailInput,"color":"primary"},on:{"click":_vm.resendRequest}},[_vm._v("Resend")])],1)],1)],1)}
var staticRenderFns = []
var esExports = { render: render, staticRenderFns: staticRenderFns }
/* harmony default export */ __webpack_exports__["a"] = (esExports);

/***/ }),
/* 628 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('v-layout',{staticClass:"patient-page",staticStyle:{"background-color":"#525659"},attrs:{"column":""}},[_c('resend-request-dialog',{ref:"resendRequest"}),_vm._v(" "),_c('v-toolbar',{attrs:{"color":"white","flat":""}},[_c('v-toolbar-title',[_vm._v(_vm._s(this.requestID))]),_vm._v(" "),_c('v-spacer'),_vm._v(" "),_c('v-btn',{attrs:{"outline":"","color":"blue"},on:{"click":function($event){_vm.goToHelp()}}},[_vm._v("Help")]),_vm._v(" "),_c('v-btn',{attrs:{"outline":"","color":"green"},on:{"click":function($event){_vm.viewPatient()}}},[_vm._v("View Patient")]),_vm._v(" "),_c('v-menu',{attrs:{"offset-y":""}},[_c('v-btn',{attrs:{"slot":"activator","color":"primary","dark":""},slot:"activator"},[_vm._v("\n          Actions\n        ")]),_vm._v(" "),_c('v-list',[_c('v-list-tile',{on:{"click":function($event){_vm.markError()}}},[_c('v-list-tile-title',[_vm._v("Mark Error")])],1),_vm._v(" "),_c('v-list-tile',{on:{"click":function($event){_vm.cancelRequest()}}},[_c('v-list-tile-title',[_vm._v("Cancel Request")])],1),_vm._v(" "),_c('v-list-tile',{on:{"click":function($event){_vm.resendRequest()}}},[_c('v-list-tile-title',[_vm._v("Resend Request")])],1),_vm._v(" "),_c('v-list-tile',{on:{"click":function($event){_vm.completeRequest()}}},[_c('v-list-tile-title',[_vm._v("Mark Complete")])],1)],1)],1)],1),_vm._v(" "),_c('v-divider'),_vm._v(" "),_c('iframe',{staticStyle:{"height":"100%","width":"100%"},attrs:{"frameBorder":"0","src":_vm.requestURL}}),_vm._v(" "),_c('request-logs')],1)}
var staticRenderFns = []
var esExports = { render: render, staticRenderFns: staticRenderFns }
/* harmony default export */ __webpack_exports__["a"] = (esExports);

/***/ }),
/* 629 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_vue_loader_lib_selector_type_script_index_0_AdminDocumentsPage_vue__ = __webpack_require__(262);
/* unused harmony namespace reexport */
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__node_modules_vue_loader_lib_template_compiler_index_id_data_v_1db52061_hasScoped_true_transformToRequire_video_src_poster_source_src_img_src_image_xlink_href_buble_transforms_node_modules_vue_loader_lib_selector_type_template_index_0_AdminDocumentsPage_vue__ = __webpack_require__(631);
function injectStyle (ssrContext) {
  __webpack_require__(630)
}
var normalizeComponent = __webpack_require__(0)
/* script */


/* template */

/* template functional */
var __vue_template_functional__ = false
/* styles */
var __vue_styles__ = injectStyle
/* scopeId */
var __vue_scopeId__ = "data-v-1db52061"
/* moduleIdentifier (server only) */
var __vue_module_identifier__ = null
var Component = normalizeComponent(
  __WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_vue_loader_lib_selector_type_script_index_0_AdminDocumentsPage_vue__["a" /* default */],
  __WEBPACK_IMPORTED_MODULE_1__node_modules_vue_loader_lib_template_compiler_index_id_data_v_1db52061_hasScoped_true_transformToRequire_video_src_poster_source_src_img_src_image_xlink_href_buble_transforms_node_modules_vue_loader_lib_selector_type_template_index_0_AdminDocumentsPage_vue__["a" /* default */],
  __vue_template_functional__,
  __vue_styles__,
  __vue_scopeId__,
  __vue_module_identifier__
)

/* harmony default export */ __webpack_exports__["a"] = (Component.exports);


/***/ }),
/* 630 */
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ }),
/* 631 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('v-layout',{staticClass:"patient-page",attrs:{"column":""}},[(_vm.files)?_c('v-data-table',{staticClass:"flat table-border pa-0",staticStyle:{"width":"100%"},attrs:{"headers":_vm.headers,"items":_vm.files,"sort-icon":"","rows-per-page-items":_vm.rowsPerPageItems,"pagination":_vm.currentPagination,"total-items":_vm.totalItems},on:{"update:pagination":[function($event){_vm.currentPagination=$event},_vm.updatePagination]},scopedSlots:_vm._u([{key:"items",fn:function(props){return [_c('tr',{class:_vm.alternatingColors(props.index),staticStyle:{"cursor":"pointer"},on:{"click":function($event){_vm.goToDocumentPage(props.item.id)}}},[_c('td',[_vm._v(_vm._s(props.item.id))]),_vm._v(" "),_c('td',[_vm._v(_vm._s(_vm.convertDate(props.item.created)))]),_vm._v(" "),_c('td',[_vm._v(_vm._s(props.item.faxedFrom))])])]}}])}):_c('v-progress-circular',{staticClass:"centered",attrs:{"size":200,"width":15,"color":"primary","indeterminate":""}})],1)}
var staticRenderFns = []
var esExports = { render: render, staticRenderFns: staticRenderFns }
/* harmony default export */ __webpack_exports__["a"] = (esExports);

/***/ }),
/* 632 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_vue_loader_lib_selector_type_script_index_0_AdminDocumentPage_vue__ = __webpack_require__(263);
/* unused harmony namespace reexport */
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__node_modules_vue_loader_lib_template_compiler_index_id_data_v_943c7b0c_hasScoped_true_transformToRequire_video_src_poster_source_src_img_src_image_xlink_href_buble_transforms_node_modules_vue_loader_lib_selector_type_template_index_0_AdminDocumentPage_vue__ = __webpack_require__(643);
function injectStyle (ssrContext) {
  __webpack_require__(633)
}
var normalizeComponent = __webpack_require__(0)
/* script */


/* template */

/* template functional */
var __vue_template_functional__ = false
/* styles */
var __vue_styles__ = injectStyle
/* scopeId */
var __vue_scopeId__ = "data-v-943c7b0c"
/* moduleIdentifier (server only) */
var __vue_module_identifier__ = null
var Component = normalizeComponent(
  __WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_vue_loader_lib_selector_type_script_index_0_AdminDocumentPage_vue__["a" /* default */],
  __WEBPACK_IMPORTED_MODULE_1__node_modules_vue_loader_lib_template_compiler_index_id_data_v_943c7b0c_hasScoped_true_transformToRequire_video_src_poster_source_src_img_src_image_xlink_href_buble_transforms_node_modules_vue_loader_lib_selector_type_template_index_0_AdminDocumentPage_vue__["a" /* default */],
  __vue_template_functional__,
  __vue_styles__,
  __vue_scopeId__,
  __vue_module_identifier__
)

/* harmony default export */ __webpack_exports__["a"] = (Component.exports);


/***/ }),
/* 633 */
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ }),
/* 634 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_vue_loader_lib_selector_type_script_index_0_PatientSearchDialog_vue__ = __webpack_require__(264);
/* unused harmony namespace reexport */
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__node_modules_vue_loader_lib_template_compiler_index_id_data_v_16108ca5_hasScoped_true_transformToRequire_video_src_poster_source_src_img_src_image_xlink_href_buble_transforms_node_modules_vue_loader_lib_selector_type_template_index_0_PatientSearchDialog_vue__ = __webpack_require__(636);
function injectStyle (ssrContext) {
  __webpack_require__(635)
}
var normalizeComponent = __webpack_require__(0)
/* script */


/* template */

/* template functional */
var __vue_template_functional__ = false
/* styles */
var __vue_styles__ = injectStyle
/* scopeId */
var __vue_scopeId__ = "data-v-16108ca5"
/* moduleIdentifier (server only) */
var __vue_module_identifier__ = null
var Component = normalizeComponent(
  __WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_vue_loader_lib_selector_type_script_index_0_PatientSearchDialog_vue__["a" /* default */],
  __WEBPACK_IMPORTED_MODULE_1__node_modules_vue_loader_lib_template_compiler_index_id_data_v_16108ca5_hasScoped_true_transformToRequire_video_src_poster_source_src_img_src_image_xlink_href_buble_transforms_node_modules_vue_loader_lib_selector_type_template_index_0_PatientSearchDialog_vue__["a" /* default */],
  __vue_template_functional__,
  __vue_styles__,
  __vue_scopeId__,
  __vue_module_identifier__
)

/* harmony default export */ __webpack_exports__["a"] = (Component.exports);


/***/ }),
/* 635 */
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ }),
/* 636 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('v-dialog',{attrs:{"max-width":"80%","transition":_vm.transition,"fullscreen":_vm.$vuetify.breakpoint.xsOnly,"scrollable":""},model:{value:(_vm.show),callback:function ($$v) {_vm.show=$$v},expression:"show"}},[_c('v-card',[_c('v-toolbar',{staticStyle:{"border-bottom":"1px solid #f5f5f5","background-color":"white","margin":"0px","padding":"0px"},attrs:{"dark":"","color":"primary","column":"","flat":""}},[_c('v-toolbar-title',[_vm._v("Patient Search")])],1),_vm._v(" "),(_vm.patientRequests)?_c('v-toolbar',[_c('v-toolbar-title',[_vm._v("\n        "+_vm._s(_vm.selectedPatientString)+"\n      ")]),_vm._v(" "),_c('v-spacer'),_vm._v(" "),_c('v-btn',{attrs:{"icon":""},on:{"click":_vm.backToPatients}},[_c('v-icon',[_vm._v("close")])],1)],1):_vm._e(),_vm._v(" "),(!_vm.patientRequests)?_c('v-toolbar',{staticClass:"pt-2",attrs:{"flat":"","color":"#f5f5f5"}},[_c('v-text-field',{attrs:{"label":"Last Name","outline":"","persistent-hint":"","autofocus":"","clearable":""},on:{"keyup":function($event){if(!('button' in $event)&&_vm._k($event.keyCode,"enter",13,$event.key,"Enter")){ return null; }return _vm.search($event)}},model:{value:(_vm.patientFields.lastName),callback:function ($$v) {_vm.$set(_vm.patientFields, "lastName", $$v)},expression:"patientFields.lastName"}}),_vm._v(" "),_c('v-text-field',{staticClass:"ml-4",attrs:{"label":"First Name","outline":"","clearable":""},on:{"keyup":function($event){if(!('button' in $event)&&_vm._k($event.keyCode,"enter",13,$event.key,"Enter")){ return null; }return _vm.search($event)}},model:{value:(_vm.patientFields.firstName),callback:function ($$v) {_vm.$set(_vm.patientFields, "firstName", $$v)},expression:"patientFields.firstName"}}),_vm._v(" "),_c('v-text-field',{staticClass:"ml-4",attrs:{"label":"Patient ID","outline":"","clearable":""},on:{"keyup":function($event){if(!('button' in $event)&&_vm._k($event.keyCode,"enter",13,$event.key,"Enter")){ return null; }return _vm.search($event)}},model:{value:(_vm.patientFields.id),callback:function ($$v) {_vm.$set(_vm.patientFields, "id", $$v)},expression:"patientFields.id"}}),_vm._v(" "),_c('v-text-field',{staticClass:"ml-4",attrs:{"outline":"","label":"Date of Birth","hint":"MM/DD/YYYY format","persistent-hint":"","mask":"##/##/####","clearable":""},on:{"keyup":function($event){if(!('button' in $event)&&_vm._k($event.keyCode,"enter",13,$event.key,"Enter")){ return null; }return _vm.search($event)}},model:{value:(_vm.patientFields.DOB),callback:function ($$v) {_vm.$set(_vm.patientFields, "DOB", $$v)},expression:"patientFields.DOB"}})],1):_vm._e(),_vm._v(" "),_c('v-card-text',{staticClass:"pa-0",staticStyle:{"height":"720px"}},[(_vm.patientSearchResults && !_vm.patientRequests)?_c('v-data-table',{staticClass:"flat mb-2 table-border mt-4",attrs:{"headers":_vm.headers,"items":_vm.patientSearchResults,"flat":"","scrollable":"","rows-per-page-items":[50]},scopedSlots:_vm._u([{key:"items",fn:function(props){return [_c('tr',[_c('td',[_vm._v(_vm._s(props.item.firstName + ' ' + props.item.lastName))]),_vm._v(" "),_c('td',[_vm._v(_vm._s(props.item.id))]),_vm._v(" "),_c('td',[_vm._v(_vm._s(props.item.gender))]),_vm._v(" "),_c('td',[_vm._v(_vm._s(_vm.formatDate(props.item.birthdate)))]),_vm._v(" "),_c('td',{attrs:{"align":"right"}},[_c('v-btn',{attrs:{"depressed":"","color":"primary","outline":"","dark":""},on:{"click":function($event){_vm.viewRequests(props.item)}}},[_vm._v("View Requests")])],1)])]}}])}):_vm._e(),_vm._v(" "),(_vm.patientRequests)?_c('v-layout',{attrs:{"column":""}},[_c('v-layout',{staticClass:"mt-4",attrs:{"row":""}},[_c('v-layout',{staticClass:"table-header"},[_vm._v("Patient Requests List")]),_vm._v(" "),_c('v-btn',{attrs:{"depressed":"","color":"grey","outline":""},on:{"click":_vm.backToPatients}},[_vm._v("Back")]),_vm._v(" "),_c('v-btn',{attrs:{"depressed":"","color":"primary"},on:{"click":_vm.selectWithoutRequest}},[_vm._v("Select Patient")])],1),_vm._v(" "),_c('v-data-table',{staticClass:"flat mb-2 table-border",attrs:{"headers":_vm.requestHeaders,"items":_vm.patientRequests,"flat":"","scrollable":"","rows-per-page-items":[5]},scopedSlots:_vm._u([{key:"items",fn:function(props){return [_c('tr',[_c('td',[_vm._v(_vm._s(props.item.providerNameOverride))]),_vm._v(" "),_c('td',[_vm._v(_vm._s(props.item.providerAddressOverride.line1)+" "+_vm._s(props.item.providerAddressOverride.city)+" "+_vm._s(props.item.providerAddressOverride.state)+" "+_vm._s(props.item.providerAddressOverride.zip))]),_vm._v(" "),_c('td',[_vm._v(_vm._s(_vm.formatDate(props.item.start))+" - "+_vm._s(_vm.formatDate(props.item.end)))]),_vm._v(" "),_c('td',{attrs:{"align":"right"}},[_c('v-btn',{attrs:{"depressed":"","color":"primary","outline":""},on:{"click":function($event){_vm.selectRequest(props.item)}}},[_vm._v("Select Request")])],1)])]}}])})],1):_vm._e()],1)],1)],1)}
var staticRenderFns = []
var esExports = { render: render, staticRenderFns: staticRenderFns }
/* harmony default export */ __webpack_exports__["a"] = (esExports);

/***/ }),
/* 637 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_vue_loader_lib_selector_type_script_index_0_PatientAssignment_vue__ = __webpack_require__(265);
/* unused harmony namespace reexport */
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__node_modules_vue_loader_lib_template_compiler_index_id_data_v_41bd40a2_hasScoped_false_transformToRequire_video_src_poster_source_src_img_src_image_xlink_href_buble_transforms_node_modules_vue_loader_lib_selector_type_template_index_0_PatientAssignment_vue__ = __webpack_require__(639);
function injectStyle (ssrContext) {
  __webpack_require__(638)
}
var normalizeComponent = __webpack_require__(0)
/* script */


/* template */

/* template functional */
var __vue_template_functional__ = false
/* styles */
var __vue_styles__ = injectStyle
/* scopeId */
var __vue_scopeId__ = null
/* moduleIdentifier (server only) */
var __vue_module_identifier__ = null
var Component = normalizeComponent(
  __WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_vue_loader_lib_selector_type_script_index_0_PatientAssignment_vue__["a" /* default */],
  __WEBPACK_IMPORTED_MODULE_1__node_modules_vue_loader_lib_template_compiler_index_id_data_v_41bd40a2_hasScoped_false_transformToRequire_video_src_poster_source_src_img_src_image_xlink_href_buble_transforms_node_modules_vue_loader_lib_selector_type_template_index_0_PatientAssignment_vue__["a" /* default */],
  __vue_template_functional__,
  __vue_styles__,
  __vue_scopeId__,
  __vue_module_identifier__
)

/* harmony default export */ __webpack_exports__["a"] = (Component.exports);


/***/ }),
/* 638 */
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ }),
/* 639 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('v-navigation-drawer',{staticStyle:{"background-color":"#fafafc"},attrs:{"app":"","clipped":"","persistent":"","right":""},model:{value:(_vm.showNav),callback:function ($$v) {_vm.showNav=$$v},expression:"showNav"}},[_c('v-toolbar',{attrs:{"flat":"","color":"#fafafc"}},[_c('v-toolbar-title',[_vm._v("\n            Patient Search\n        ")])],1),_vm._v(" "),(_vm.patientSearchResults)?_c('v-toolbar',{attrs:{"flat":"","color":"#fafafc"}},[_c('v-toolbar-title',[_vm._v("\n            Results\n        ")]),_vm._v(" "),_c('v-spacer'),_vm._v(" "),_c('v-btn',{attrs:{"icon":""},on:{"click":_vm.clearTheResults}},[_c('v-icon',[_vm._v("close")])],1)],1):_vm._e(),_vm._v(" "),(!_vm.patientSearchResults)?_c('v-card',{attrs:{"flat":""}},[_c('v-card-text',{staticClass:"pa-2"},[_c('v-text-field',{staticClass:"mb-2",attrs:{"hide-details":"","outline":"","label":"First Name"},model:{value:(_vm.firstNameInput),callback:function ($$v) {_vm.firstNameInput=$$v},expression:"firstNameInput"}}),_vm._v(" "),_c('v-text-field',{staticClass:"mb-2",attrs:{"hide-details":"","outline":"","label":"Last Name"},model:{value:(_vm.lastNameInput),callback:function ($$v) {_vm.lastNameInput=$$v},expression:"lastNameInput"}}),_vm._v(" "),_c('v-text-field',{staticClass:"mb-2",attrs:{"outline":"","persistent-hint":"","hint":"mm/dd/yyyy","label":"Birthdate"},model:{value:(_vm.birthdateInput),callback:function ($$v) {_vm.birthdateInput=$$v},expression:"birthdateInput"}})],1),_vm._v(" "),_c('v-layout',{attrs:{"column":""}},[_c('v-btn',{attrs:{"depressed":"","color":"primary","dark":""},on:{"click":_vm.launchSearch}},[_vm._v("search")])],1)],1):_vm._e(),_vm._v(" "),(_vm.patientSearchResults)?_c('v-list',{attrs:{"two-line":""}},_vm._l((_vm.patientSearchResults),function(patient,item){return _c('v-list-tile',{key:item,attrs:{"row":""}},[_c('v-list-tile-content',[_c('v-list-tile-title',[_vm._v("\n          "+_vm._s(patient.firstName)+" "+_vm._s(patient.lastName)+"\n        ")]),_vm._v(" "),_c('v-list-tile-sub-title',[_vm._v("\n          "+_vm._s(patient.birthdate)+"\n        ")])],1)],1)})):_vm._e()],1)}
var staticRenderFns = []
var esExports = { render: render, staticRenderFns: staticRenderFns }
/* harmony default export */ __webpack_exports__["a"] = (esExports);

/***/ }),
/* 640 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_vue_loader_lib_selector_type_script_index_0_ConfirmAssignmentDialog_vue__ = __webpack_require__(266);
/* unused harmony namespace reexport */
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__node_modules_vue_loader_lib_template_compiler_index_id_data_v_836b3562_hasScoped_true_transformToRequire_video_src_poster_source_src_img_src_image_xlink_href_buble_transforms_node_modules_vue_loader_lib_selector_type_template_index_0_ConfirmAssignmentDialog_vue__ = __webpack_require__(642);
function injectStyle (ssrContext) {
  __webpack_require__(641)
}
var normalizeComponent = __webpack_require__(0)
/* script */


/* template */

/* template functional */
var __vue_template_functional__ = false
/* styles */
var __vue_styles__ = injectStyle
/* scopeId */
var __vue_scopeId__ = "data-v-836b3562"
/* moduleIdentifier (server only) */
var __vue_module_identifier__ = null
var Component = normalizeComponent(
  __WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_vue_loader_lib_selector_type_script_index_0_ConfirmAssignmentDialog_vue__["a" /* default */],
  __WEBPACK_IMPORTED_MODULE_1__node_modules_vue_loader_lib_template_compiler_index_id_data_v_836b3562_hasScoped_true_transformToRequire_video_src_poster_source_src_img_src_image_xlink_href_buble_transforms_node_modules_vue_loader_lib_selector_type_template_index_0_ConfirmAssignmentDialog_vue__["a" /* default */],
  __vue_template_functional__,
  __vue_styles__,
  __vue_scopeId__,
  __vue_module_identifier__
)

/* harmony default export */ __webpack_exports__["a"] = (Component.exports);


/***/ }),
/* 641 */
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ }),
/* 642 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('v-dialog',{attrs:{"max-width":_vm.options.maxWidth,"transition":_vm.transition,"fullscreen":_vm.$vuetify.breakpoint.xsOnly,"scrollable":""},model:{value:(_vm.show),callback:function ($$v) {_vm.show=$$v},expression:"show"}},[_c('v-card',[_c('v-toolbar',{staticStyle:{"border-bottom":"1px solid #f5f5f5","background-color":"white","margin":"0px","padding":"0px"},attrs:{"dark":"","color":"primary","column":"","flat":""}},[_c('v-toolbar-title',[_vm._v("Confirm Assignment")])],1),_vm._v(" "),(this.options.payload)?_c('v-card-text',[_vm._v("\n      You are about to assign this document to the following patient: "+_vm._s(this.options.payload.patientDisplayString)+"\n\n    ")]):_vm._e(),_vm._v(" "),_c('v-spacer'),_vm._v(" "),_c('v-card-actions',[_c('v-btn',{attrs:{"depressed":""},on:{"click":_vm.cancel}},[_vm._v("Cancel")]),_vm._v(" "),_c('v-spacer'),_vm._v(" "),_c('v-btn',{attrs:{"color":"primary","depressed":""},on:{"click":function($event){_vm.confirmAssignment()}}},[_vm._v("Confirm")])],1)],1)],1)}
var staticRenderFns = []
var esExports = { render: render, staticRenderFns: staticRenderFns }
/* harmony default export */ __webpack_exports__["a"] = (esExports);

/***/ }),
/* 643 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('v-layout',{staticClass:"patient-page",staticStyle:{"background-color":"#525659"},attrs:{"column":""}},[_c('v-toolbar',{attrs:{"color":"white","flat":""}},[_c('v-toolbar-title',[_vm._v(_vm._s(this.$route.params.id))]),_vm._v(" "),_c('v-spacer'),_vm._v(" "),_c('v-btn',{on:{"click":_vm.patientSearch}},[_vm._v("Patient Search")])],1),_vm._v(" "),_c('v-divider'),_vm._v(" "),_c('iframe',{staticStyle:{"height":"100%","width":"100%"},attrs:{"frameBorder":"0","src":_vm.fileURL}}),_vm._v(" "),_c('patient-search-dialog',{ref:"patientSearch",on:{"valuesEmit":_vm.confirmAssignment}}),_vm._v(" "),_c('confirm-assignment-dialog',{ref:"confirmAssignment",on:{"confirmedAssignmentEmit":_vm.assignDocumentToPatient}})],1)}
var staticRenderFns = []
var esExports = { render: render, staticRenderFns: staticRenderFns }
/* harmony default export */ __webpack_exports__["a"] = (esExports);

/***/ }),
/* 644 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_vue_loader_lib_selector_type_script_index_0_AdminUserGroupsPage_vue__ = __webpack_require__(267);
/* unused harmony namespace reexport */
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__node_modules_vue_loader_lib_template_compiler_index_id_data_v_984dbdf0_hasScoped_true_transformToRequire_video_src_poster_source_src_img_src_image_xlink_href_buble_transforms_node_modules_vue_loader_lib_selector_type_template_index_0_AdminUserGroupsPage_vue__ = __webpack_require__(652);
function injectStyle (ssrContext) {
  __webpack_require__(645)
}
var normalizeComponent = __webpack_require__(0)
/* script */


/* template */

/* template functional */
var __vue_template_functional__ = false
/* styles */
var __vue_styles__ = injectStyle
/* scopeId */
var __vue_scopeId__ = "data-v-984dbdf0"
/* moduleIdentifier (server only) */
var __vue_module_identifier__ = null
var Component = normalizeComponent(
  __WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_vue_loader_lib_selector_type_script_index_0_AdminUserGroupsPage_vue__["a" /* default */],
  __WEBPACK_IMPORTED_MODULE_1__node_modules_vue_loader_lib_template_compiler_index_id_data_v_984dbdf0_hasScoped_true_transformToRequire_video_src_poster_source_src_img_src_image_xlink_href_buble_transforms_node_modules_vue_loader_lib_selector_type_template_index_0_AdminUserGroupsPage_vue__["a" /* default */],
  __vue_template_functional__,
  __vue_styles__,
  __vue_scopeId__,
  __vue_module_identifier__
)

/* harmony default export */ __webpack_exports__["a"] = (Component.exports);


/***/ }),
/* 645 */
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ }),
/* 646 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_vue_loader_lib_selector_type_script_index_0_NewUserGroupDialog_vue__ = __webpack_require__(268);
/* unused harmony namespace reexport */
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__node_modules_vue_loader_lib_template_compiler_index_id_data_v_1d7087ba_hasScoped_true_transformToRequire_video_src_poster_source_src_img_src_image_xlink_href_buble_transforms_node_modules_vue_loader_lib_selector_type_template_index_0_NewUserGroupDialog_vue__ = __webpack_require__(651);
function injectStyle (ssrContext) {
  __webpack_require__(647)
}
var normalizeComponent = __webpack_require__(0)
/* script */


/* template */

/* template functional */
var __vue_template_functional__ = false
/* styles */
var __vue_styles__ = injectStyle
/* scopeId */
var __vue_scopeId__ = "data-v-1d7087ba"
/* moduleIdentifier (server only) */
var __vue_module_identifier__ = null
var Component = normalizeComponent(
  __WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_vue_loader_lib_selector_type_script_index_0_NewUserGroupDialog_vue__["a" /* default */],
  __WEBPACK_IMPORTED_MODULE_1__node_modules_vue_loader_lib_template_compiler_index_id_data_v_1d7087ba_hasScoped_true_transformToRequire_video_src_poster_source_src_img_src_image_xlink_href_buble_transforms_node_modules_vue_loader_lib_selector_type_template_index_0_NewUserGroupDialog_vue__["a" /* default */],
  __vue_template_functional__,
  __vue_styles__,
  __vue_scopeId__,
  __vue_module_identifier__
)

/* harmony default export */ __webpack_exports__["a"] = (Component.exports);


/***/ }),
/* 647 */
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ }),
/* 648 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_vue_loader_lib_selector_type_script_index_0_providerSearchField_vue__ = __webpack_require__(269);
/* unused harmony namespace reexport */
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__node_modules_vue_loader_lib_template_compiler_index_id_data_v_4b15f30a_hasScoped_true_transformToRequire_video_src_poster_source_src_img_src_image_xlink_href_buble_transforms_node_modules_vue_loader_lib_selector_type_template_index_0_providerSearchField_vue__ = __webpack_require__(650);
function injectStyle (ssrContext) {
  __webpack_require__(649)
}
var normalizeComponent = __webpack_require__(0)
/* script */


/* template */

/* template functional */
var __vue_template_functional__ = false
/* styles */
var __vue_styles__ = injectStyle
/* scopeId */
var __vue_scopeId__ = "data-v-4b15f30a"
/* moduleIdentifier (server only) */
var __vue_module_identifier__ = null
var Component = normalizeComponent(
  __WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_vue_loader_lib_selector_type_script_index_0_providerSearchField_vue__["a" /* default */],
  __WEBPACK_IMPORTED_MODULE_1__node_modules_vue_loader_lib_template_compiler_index_id_data_v_4b15f30a_hasScoped_true_transformToRequire_video_src_poster_source_src_img_src_image_xlink_href_buble_transforms_node_modules_vue_loader_lib_selector_type_template_index_0_providerSearchField_vue__["a" /* default */],
  __vue_template_functional__,
  __vue_styles__,
  __vue_scopeId__,
  __vue_module_identifier__
)

/* harmony default export */ __webpack_exports__["a"] = (Component.exports);


/***/ }),
/* 649 */
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ }),
/* 650 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('v-autocomplete',{directives:[{name:"show",rawName:"v-show",value:(_vm.providerSearchRequired),expression:"providerSearchRequired"}],attrs:{"items":_vm.searchResults,"item-text":"selectionDisplayName","search-input":_vm.comboBoxSearch,"label":"Medical Provider","persistent-hint":"","small-chips":"","box":"","flat":"","outline":"","return-object":"","cache-items":"","hide-selected":"","disabled":_vm.uploadQ.length > 0},on:{"update:searchInput":function($event){_vm.comboBoxSearch=$event}},scopedSlots:_vm._u([{key:"selection",fn:function(data){return [(data.item.selectionDisplayName)?_c('span',[_vm._v(_vm._s(data.item.selectionDisplayName)),_c('span',{staticStyle:{"opacity":"0.3"}},[_vm._v(" "+_vm._s(data.item.displayLocale))])]):_c('span',[_vm._v("Error")])]}},{key:"item",fn:function(data){return [[_c('v-list-tile-avatar',[_c('v-icon',[_vm._v(_vm._s(data.item.avatar))])],1),_vm._v(" "),_c('v-list-tile-content',[_c('v-list-tile-title',{domProps:{"innerHTML":_vm._s(data.item.selectionDisplayName)}}),_vm._v(" "),_c('v-list-tile-sub-title',{domProps:{"innerHTML":_vm._s(data.item.displayLocale)}})],1)]]}}]),model:{value:(_vm.autoCompleteSearch),callback:function ($$v) {_vm.autoCompleteSearch=$$v},expression:"autoCompleteSearch"}},[_c('template',{slot:"no-data"},[_c('v-list-tile',[_c('v-list-tile-content',[(this.comboBoxSearch)?_c('v-list-tile-title',[_vm._v("No Matching Providers")]):_c('v-list-tile-title',[_vm._v("Search by Name or Address")])],1)],1)],1)],2)}
var staticRenderFns = []
var esExports = { render: render, staticRenderFns: staticRenderFns }
/* harmony default export */ __webpack_exports__["a"] = (esExports);

/***/ }),
/* 651 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('v-dialog',{staticClass:"search-dialog",attrs:{"persistent":_vm.options.persistent,"transition":_vm.transition,"max-width":_vm.options.maxWidth,"min-width":"640px","fullscreen":_vm.$vuetify.breakpoint.xsOnly,"scrollable":""},model:{value:(_vm.show),callback:function ($$v) {_vm.show=$$v},expression:"show"}},[_c('v-card',{attrs:{"height":"340px"}},[_c('v-toolbar',{attrs:{"flat":"","dark":"","color":"primary"}},[_c('v-toolbar-title',[_vm._v("User Group Creation")]),_vm._v(" "),_c('v-spacer'),_vm._v(" "),_c('v-btn',{attrs:{"icon":"","dark":""},on:{"click":_vm.cancelDialog}},[_c('v-icon',[_vm._v("close")])],1)],1),_vm._v(" "),_c('v-card-text',[_c('v-form',{model:{value:(_vm.valid),callback:function ($$v) {_vm.valid=$$v},expression:"valid"}},[_c('v-layout',{staticClass:"mb-4",attrs:{"row":""}},[_c('v-text-field',{attrs:{"box":"","outline":"","hide-details":"","label":_vm.userGroupNameLabel,"rules":_vm.userGroupRule,"required":""},model:{value:(_vm.userGroupName),callback:function ($$v) {_vm.userGroupName=$$v},expression:"userGroupName"}})],1),_vm._v(" "),_c('v-layout',{attrs:{"column":""}},[_c('provider-search-field',{ref:"provSearchField",on:{"selectedProvider":_vm.selectProvider}}),_vm._v(" "),_c('v-layout',{staticClass:"provider-error ml-2"},[_vm._v("\n            "+_vm._s(_vm.providerError)+"\n          ")])],1)],1),_vm._v(" "),_c('v-layout',{staticClass:"mb-3",attrs:{"row":""}},[_c('v-spacer')],1)],1),_vm._v(" "),_c('v-spacer'),_vm._v(" "),_c('v-divider'),_vm._v(" "),_c('v-card-actions',[_c('v-spacer'),_vm._v(" "),_c('v-btn',{attrs:{"color":"primary","depressed":"","disabled":_vm.providerError || !_vm.valid},on:{"click":_vm.submit}},[_vm._v("Submit")])],1)],1)],1)}
var staticRenderFns = []
var esExports = { render: render, staticRenderFns: staticRenderFns }
/* harmony default export */ __webpack_exports__["a"] = (esExports);

/***/ }),
/* 652 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('v-layout',{attrs:{"column":""}},[_c('v-layout',{attrs:{"row":""}},[_c('span',{staticClass:"admin-title"},[_vm._v("Document Management")])]),_vm._v(" "),_c('v-layout',{staticClass:"mb-3",attrs:{"row":""}},[_c('v-spacer'),_vm._v(" "),_c('v-btn',{attrs:{"color":"primary","depressed":""},on:{"click":function($event){_vm.openNewUGDialog()}}},[_vm._v("New user group")])],1),_vm._v(" "),(_vm.groups && _vm.groupsPageInfo)?_c('v-data-table',{staticClass:"flat mb-2 table-border",attrs:{"headers":_vm.headers,"items":_vm.groups,"sort-icon":"","rows-per-page-items":_vm.rowsPerPageItems,"pagination":_vm.currentPagination,"total-items":_vm.groupsPageInfo.total},on:{"update:pagination":[function($event){_vm.currentPagination=$event},_vm.updatePagination]},scopedSlots:_vm._u([{key:"items",fn:function(props){return [_c('tr',[_c('td',[_vm._v(_vm._s(props.item.id))]),_vm._v(" "),_c('td',[_vm._v(_vm._s(props.item.name))]),_vm._v(" "),_c('td',[_vm._v(_vm._s(_vm.convertDate(props.item.created)))]),_vm._v(" "),_c('td',[_vm._v("\n          "+_vm._s(_vm.displayProviderName(props.item.provider))+"\n        ")])])]}}])}):_vm._e(),_vm._v(" "),_c('new-user-group-dialog',{ref:"newUGDialog"})],1)}
var staticRenderFns = []
var esExports = { render: render, staticRenderFns: staticRenderFns }
/* harmony default export */ __webpack_exports__["a"] = (esExports);

/***/ }),
/* 653 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__authGuard__ = __webpack_require__(654);


/* harmony default export */ __webpack_exports__["a"] = ({
  beforeEnter: function beforeEnter(to, from, next) {
    __WEBPACK_IMPORTED_MODULE_0__authGuard__["a" /* default */].beforeEnter(to, from, function () {
      to.name === 'HomePage' && from.query.redirect_after_login ? location.href = from.query.redirect_after_login : console.log();
      next();
    });
  }
});

/***/ }),
/* 654 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__store__ = __webpack_require__(135);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__router_router__ = __webpack_require__(198);



/* harmony default export */ __webpack_exports__["a"] = ({
  beforeEnter: function beforeEnter(to, from, next) {
    if (__WEBPACK_IMPORTED_MODULE_0__store__["a" /* default */].state.auth.user) {
      if (__WEBPACK_IMPORTED_MODULE_0__store__["a" /* default */].state.auth.user.needsPasswordChange) {
        // router.push({ name: 'ResetPasswordPage', replace: true })
      } else {
        next();
      }
    }
    __WEBPACK_IMPORTED_MODULE_0__store__["a" /* default */].dispatch('auth/check').then(next, function () {
      next(false);

      to.path === '/' ? __WEBPACK_IMPORTED_MODULE_1__router_router__["a" /* default */].push({ name: 'LoginPage',
        replace: true
      }) : __WEBPACK_IMPORTED_MODULE_1__router_router__["a" /* default */].push({ name: 'LoginPage',
        replace: true,
        query: {
          redirect_after_login: encodeURI(location.href.split(location.origin).join(''))
        } });
    });
  }
});

/***/ }),
/* 655 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__state__ = __webpack_require__(656);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__getters__ = __webpack_require__(657);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__mutations__ = __webpack_require__(658);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3__actions__ = __webpack_require__(659);





/* harmony default export */ __webpack_exports__["a"] = ({
  namespaced: true,
  state: __WEBPACK_IMPORTED_MODULE_0__state__["a" /* default */],
  getters: __WEBPACK_IMPORTED_MODULE_1__getters__["a" /* default */],
  mutations: __WEBPACK_IMPORTED_MODULE_2__mutations__["a" /* default */],
  actions: __WEBPACK_IMPORTED_MODULE_3__actions__["a" /* default */]
});

/***/ }),
/* 656 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony default export */ __webpack_exports__["a"] = ({
  requests: [],
  loadingRequests: false,
  files: [],
  loadingFiles: false,
  uploads: null,
  patient: null,
  provider: null,
  request: null,
  file: null,
  recordTypes: null,
  patientSearchResults: null,
  userSearchResults: null,
  providerSearchResults: null,
  totalItems: null,
  pagination: null,
  groups: null,
  groupsPageInfo: null,
  requestProviderOverrides: null,
  requestsPageInfo: null,
  patientRequests: null,
  documentProvider: null
});

/***/ }),
/* 657 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony default export */ __webpack_exports__["a"] = ({});

/***/ }),
/* 658 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony default export */ __webpack_exports__["a"] = ({
  setRequests: function setRequests(state, requests) {
    state.requests = requests;
  },
  setLoadingRequests: function setLoadingRequests(state, loading) {
    state.loadingRequests = loading;
  },
  setLoadingFiles: function setLoadingFiles(state, loading) {
    state.loadingFiles = loading;
  },
  setRequestsPageInfo: function setRequestsPageInfo(state, pageInfo) {
    state.requestsPageInfo = pageInfo;
  },
  setRequest: function setRequest(state, request) {
    state.request = request;
  },
  setRequestProvider: function setRequestProvider(state, provider) {
    state.request.provider = provider;
  },
  setUploads: function setUploads(state, uploads) {
    state.uploads = uploads;
  },
  setPatient: function setPatient(state, patient) {
    state.patient = patient;
  },
  setProvider: function setProvider(state, provider) {
    state.provider = provider;
  },
  setFiles: function setFiles(state, files) {
    state.files = files;
  },
  setFile: function setFile(state, file) {
    state.file = file;
  },
  setRecordTypes: function setRecordTypes(state, types) {
    state.recordTypes = types;
  },
  setPatientSearchResults: function setPatientSearchResults(state, searchResults) {
    state.patientSearchResults = searchResults;
  },
  setProviderSearchResults: function setProviderSearchResults(state, searchResults) {
    state.providerSearchResults = searchResults;
  },
  setUserSearchResults: function setUserSearchResults(state, searchResults) {
    state.userSearchResults = searchResults;
  },
  setTotalItems: function setTotalItems(state, totalItems) {
    state.totalItems = totalItems;
  },
  setPagination: function setPagination(state, pagination) {
    state.pagination = pagination;
  },
  setGroups: function setGroups(state, groups) {
    state.groups = groups;
  },
  setGroupsPageInfo: function setGroupsPageInfo(state, pageInfo) {
    state.groupsPageInfo = pageInfo;
  },
  setRequestProviderOverrides: function setRequestProviderOverrides(state, overrides) {
    state.requestProviderOverrides = overrides;
  },
  setPatientRequest: function setPatientRequest(state, requests) {
    state.patientRequests = requests;
  },
  setDocumentProvider: function setDocumentProvider(state, provider) {
    state.setDocumentProvider = provider;
  }
});

/***/ }),
/* 659 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__store_axios__ = __webpack_require__(46);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__core_helpers_parseUrl__ = __webpack_require__(47);



/* harmony default export */ __webpack_exports__["a"] = ({
  getRequests: function getRequests(_ref, _ref2) {
    var commit = _ref.commit;
    var limit = _ref2.limit,
        offset = _ref2.offset,
        order = _ref2.order,
        patients = _ref2.patients;

    commit('setLoadingRequests', true);
    var params = '';
    if (offset) {
      params = ', offset: ' + offset;
    }
    params = params + ', order: "-id"';
    if (patients) {
      params = params + ', patients: ' + patients;
      // params = params + ', provider: "' + search.provider + '"'
    }
    var statuses = '["-COMPLETED", "-CANCELLED"]';
    var query = '{ requests(statuses: ' + statuses + ', limit: ' + limit + params + ') {\n         items { \n          id,\n          provider\n          patient\n          created \n          status\n          log {\n            timestamp\n            message\n          }\n        }\n        pageInfo {\n          offset\n          next\n          count\n          total\n        } \n      } }';

    return __WEBPACK_IMPORTED_MODULE_0__store_axios__["a" /* default */].post('/admin/gql', { query: query }).then(function (_ref3) {
      var data = _ref3.data;

      var ret = data.data.requests;
      var requests = [];
      data.data.requests.items.forEach(function (request) {
        var requestObject = {};
        var d = new Date(request.created * 1000);
        var MyDateString = ('0' + (d.getMonth() + 1)).slice(-2) + '/' + ('0' + d.getDate()).slice(-2) + '/' + d.getFullYear();
        requestObject.createdDate = MyDateString;
        requestObject.providerID = request.provider;
        requestObject.patientID = request.patient;
        if (request.log && request.log.length > 0) {
          requestObject.lastLog = request.log[request.log.length - 1].message;
        }
        requestObject.status = request.status;
        requestObject.id = request.id;
        requests.push(requestObject);
      });
      commit('setRequestsPageInfo', ret.pageInfo);
      commit('setRequests', requests);
      commit('setLoadingRequests', false);
      return data;
    }).catch(function (error) {
      var msg = {
        error: error
      };
      commit('setLoadingRequests', false);
      return msg;
    });
  },
  getFiles: function getFiles(_ref4, _ref5) {
    var commit = _ref4.commit;
    var limit = _ref5.limit,
        offset = _ref5.offset,
        requestID = _ref5.requestID;

    commit('setLoadingFiles', true);
    var params = '';

    if (offset) {
      params = ', offset: ' + offset;
    }
    params = params + ', order: "-id"';
    if (requestID) {
      params = params + ', request: "' + requestID + '"';
    }
    if (!limit) {
      limit = 1000;
    }

    // , offset: ${offset}
    var query = '{\n        files(limit: ' + limit + params + ') {\n          items{\n            id\n            created\n            faxedFrom\n          }\n          pageInfo {\n            offset\n            next\n            count\n            total\n          }\n        }\n      }';
    // '{ files { id created recordType encounterDate originalFilename renderingProvider{id} patient{id firstName lastName} } }'

    return __WEBPACK_IMPORTED_MODULE_0__store_axios__["a" /* default */].post('/admin/gql', { query: query }).then(function (_ref6) {
      var data = _ref6.data;

      var ret = data.data.files;
      commit('setFiles', ret.items);
      commit('setTotalItems', ret.pageInfo.total);
      commit('setPagination', [ret.pageInfo.count, ret.pageInfo.offset]);
      commit('setLoadingFiles', false);
      return data;
    }).catch(function (error) {
      var msg = {
        error: error
      };
      commit('setLoadingFiles', false);
      return msg;
    });
  },
  sendProviderInvite: function sendProviderInvite(_ref7, _ref8) {
    var commit = _ref7.commit;
    var id = _ref8.id;

    var url = Object(__WEBPACK_IMPORTED_MODULE_1__core_helpers_parseUrl__["a" /* default */])('/admin/providers/:id/invite', { id: id });
    return __WEBPACK_IMPORTED_MODULE_0__store_axios__["a" /* default */].post(url).then(function (_ref9) {
      var data = _ref9.data;

      return data;
    });
  },
  getRequest: function getRequest(_ref10, requestID) {
    var commit = _ref10.commit;

    console.log('get request');
    console.log(requestID);
    var id = requestID;
    var url = Object(__WEBPACK_IMPORTED_MODULE_1__core_helpers_parseUrl__["a" /* default */])('/requests/:id', { id: id });
    return __WEBPACK_IMPORTED_MODULE_0__store_axios__["a" /* default */].get(url).then(function (_ref11) {
      var data = _ref11.data;

      var selectedRequest = JSON.parse(data);
      selectedRequest.id = selectedRequest._id;
      commit('setRequest', selectedRequest);
      return selectedRequest;
    });
  },
  getRequestOld: function getRequestOld(_ref12, requestID) {
    var commit = _ref12.commit;

    var query = '{ \n        requests(id: "' + requestID + '") {\n          items {\n            id\n            created\n            end\n            start\n            status\n            missingProviderInfo\n            provider {\n              id \n              notes \n              address {\n                line1 \n                city \n                state \n                zip\n              } \n            fax \n            email \n            phone \n            firstName \n            lastName \n            credentials \n            type \n            organizationName\n            googlePlaceID\n            npi\n            } \n            patient {\n              id \n              partner {\n                id\n                name\n              }\n              birthdate\n              firstName\n              lastName \n              address {\n                line1 \n                line2 \n                city \n                state \n                zip \n              }\n            } \n            log {\n              timestamp \n              message\n            }\n          }\n        } \n      }';

    return __WEBPACK_IMPORTED_MODULE_0__store_axios__["a" /* default */].post('/admin/gql', { query: query }).then(function (_ref13) {
      var data = _ref13.data;

      commit('setRequest', data.data.requests.items[0]);
      return data.data.requests.items[0];
    });
  },
  getRequestProvider: function getRequestProvider(_ref14, requestID) {
    var commit = _ref14.commit;

    var query = '{\n        requests(id: "' + requestID + '") {\n          items {\n            provider {\n              id\n              notes\n              address {\n                line1\n                city\n                state\n                zip\n              }\n              fax \n              email \n              phone \n              firstName \n              lastName \n              credentials \n              type \n              organizationName\n              googlePlaceID\n              npi\n            }\n          }\n        }\n      }';

    return __WEBPACK_IMPORTED_MODULE_0__store_axios__["a" /* default */].post('/admin/gql', { query: query }).then(function (_ref15) {
      var data = _ref15.data;

      commit('setRequestProvider', data.data.requests.items[0].provider);
      return data.data.requests.items[0].provider;
    });
  },

  // TODO: This isn't being used anywhere right now
  getUploads: function getUploads(_ref16) {
    var commit = _ref16.commit,
        dispatch = _ref16.dispatch;

    return __WEBPACK_IMPORTED_MODULE_0__store_axios__["a" /* default */].get('/admin/db/uploads').then(function (_ref17) {
      var data = _ref17.data;

      // for (let i = 0; data.length > i; i++) {
      //   dispatch('getPatient', { id: data[i].patient }).then(patient => {
      //     data[i].patient = patient
      //   })
      // }
      commit('setUploads', data);
    });
  },
  setProviderInfo: function setProviderInfo(_ref18, _ref19) {
    var commit = _ref18.commit;
    var id = _ref19.id,
        info = _ref19.info;

    var url = Object(__WEBPACK_IMPORTED_MODULE_1__core_helpers_parseUrl__["a" /* default */])('/admin/db/provider/:id', { id: id });
    return __WEBPACK_IMPORTED_MODULE_0__store_axios__["a" /* default */].patch(url, info).then(function (_ref20) {
      var data = _ref20.data;

      commit('setProvider', data);
    });
  },
  setFileInfo: function setFileInfo(_ref21, _ref22) {
    var commit = _ref21.commit;
    var file = _ref22.file,
        id = _ref22.id;

    var url = Object(__WEBPACK_IMPORTED_MODULE_1__core_helpers_parseUrl__["a" /* default */])('/admin/file/:id', { id: id });
    return __WEBPACK_IMPORTED_MODULE_0__store_axios__["a" /* default */].patch(url, file).then(function (_ref23) {
      var data = _ref23.data;

      commit('setFile', data);
    });
  },

  // TODO: Not being used
  createProvider: function createProvider(_ref24, provider) {
    var commit = _ref24.commit;

    return __WEBPACK_IMPORTED_MODULE_0__store_axios__["a" /* default */].post('/admin/db/provider', provider).then(function (_ref25) {
      var data = _ref25.data;

      commit('setProvider', data);
      return data;
    });
  },
  getDocumentFiles: function getDocumentFiles(_ref26, _ref27) {
    var commit = _ref26.commit;
    var requestID = _ref27.requestID;

    var params = '';

    if (requestID) {
      params = params + ' request: "' + requestID + '"';
    }

    // , offset: ${offset}
    var query = '{\n        files(' + params + ') {\n          items{\n            id\n            faxedFrom\n            created\n            recordType\n            encounterDate\n            originalFilename\n            mimetype\n            renderingProvider {\n              firstName\n              lastName\n              credentials\n            }\n            patient {\n              firstName\n              lastName\n            }\n            description\n          }\n        }\n      }';
    // '{ files { id created recordType encounterDate originalFilename renderingProvider{id} patient{id firstName lastName} } }'

    return __WEBPACK_IMPORTED_MODULE_0__store_axios__["a" /* default */].post('/admin/gql', { query: query }).then(function (_ref28) {
      var data = _ref28.data;

      var ret = data.data.files;
      commit('setFiles', ret.items);
      return data;
    });
  },
  openFile: function openFile(_ref29, file) {
    var commit = _ref29.commit;

    var authToken = null;
    file._id = file.id;
    switch (file.mimetype) {
      case 'application/dicom+zip':
        var url = 'https://api.onecharthealth.com/files/' + file._id + '/dicom_urls?alt=presign';
        if (authToken) {
          url = url + '&auth_bearer=' + authToken;
        }
        return __WEBPACK_IMPORTED_MODULE_0__store_axios__["a" /* default */].get(url).then(function (_ref30) {
          var data = _ref30.data;

          window.open('https://onechart-clinical-viewer.firebaseapp.com' + '?id=' + file._id + '&jwt=' + encodeURIComponent(data.presign_jwt));
        });
      case 'application/pdf':
        url = 'https://api.onecharthealth.com/files/' + file._id + '?alt=media';
        if (authToken) {
          url = url + '&auth_bearer=' + authToken;
        }
        return __WEBPACK_IMPORTED_MODULE_0__store_axios__["a" /* default */].get(url).then(function (_ref31) {
          var data = _ref31.data;

          // const preSignedRequest = 'https://api.onecharthealth.com/files/' + file._id + '?alt=media&presign_jwt=' + data.presign_jwt
          window.open("https://onechart-pdf-viewer.firebaseapp.com/" + '?file=' + encodeURIComponent(data.download_url));
        });
      // url = 'https://api.onecharthealth.com/files/' + file._id + '?alt=presign'
      // if (authToken) {
      //   url = url + '&auth_bearer=' + authToken
      // }
      // return axios.get(url).then(({ data }) => {
      //   const preSignedRequest = 'https://api.onecharthealth.com/files/' + file._id + '?alt=media&auth_bearer=' + data.presign_jwt
      //   window.open(process.env.PDF_VIEWER_URL + '?file=' + encodeURIComponent(preSignedRequest))
      // })
      default:
        // Ignore
        url = 'https://api.onecharthealth.com/files/' + file._id + '?alt=media';
        if (authToken) {
          url = url + '&auth_bearer=' + authToken;
        }
        return __WEBPACK_IMPORTED_MODULE_0__store_axios__["a" /* default */].get(url).then(function (_ref32) {
          var data = _ref32.data;

          // const preSignedRequest = 'https://api.onecharthealth.com/files/' + file._id + '?alt=media&presign_jwt=' + data.presign_jwt
          window.open("https://onechart-pdf-viewer.firebaseapp.com/" + '?file=' + encodeURIComponent(data.download_url));
        });
    }
  },
  getFile: function getFile(_ref33, fileId) {
    var commit = _ref33.commit;

    var query = '{\n        files(id: "' + fileId + '") {\n          items{\n            id\n            created\n            recordType\n            encounterDate\n            originalFilename\n            mimetype\n            downloadURL\n            accessToken\n            description\n          }\n          pageInfo {\n            offset\n            next\n            count\n            total\n          }\n        }\n      }';
    return __WEBPACK_IMPORTED_MODULE_0__store_axios__["a" /* default */].post('/admin/gql', { query: query }).then(function (_ref34) {
      var data = _ref34.data;

      commit('setFile', data.data.files.items);
      return data;
    });
  },
  searchForPatient: function searchForPatient(_ref35, _ref36) {
    var commit = _ref35.commit;
    var firstName = _ref36.firstName,
        lastName = _ref36.lastName;

    // Split into a first and last name, separated by a comma
    var query = void 0;

    if (firstName.length > 0 && lastName.length > 0) {
      query = '{ patients(firstName: "' + firstName + '" lastName: "' + lastName + '") { items { id firstName lastName birthdate } } }';
    } else if (firstName.length > 0 && !(lastName.length > 0)) {
      query = '{ patients(firstName: "' + firstName + '") { items { id firstName lastName birthdate } } }';
    } else if (!(firstName.length > 0) && lastName.length > 0) {
      query = '{ patients(lastName: "' + lastName + '") { items { id firstName lastName birthdate } } }';
    } else {
      return;
    }

    return __WEBPACK_IMPORTED_MODULE_0__store_axios__["a" /* default */].post('/admin/gql', { query: query }).then(function (_ref37) {
      var data = _ref37.data;

      commit('setPatientSearchResults', data.data.patients.items);
      return data.data.patients.items;
    });
  },
  fuzzySearchForPatient: function fuzzySearchForPatient(_ref38, _ref39) {
    var commit = _ref38.commit;
    var firstName = _ref39.firstName,
        lastName = _ref39.lastName;

    // Split into a first and last name, separated by a comma
    var query = void 0;

    query = '{ patients(lastName: "' + lastName + '") { items { id firstName lastName birthdate gender phone address{line1 line2 city state zip} } } }';

    return __WEBPACK_IMPORTED_MODULE_0__store_axios__["a" /* default */].post('/admin/gql', { query: query }).then(function (_ref40) {
      var data = _ref40.data;

      data.data.patients.items.forEach(function (patient) {
        patient.fullName = patient.firstName + ' ' + patient.lastName;
        var d = new Date(patient.birthdate * 1000);
        patient.birthdateString = ('0' + (d.getMonth() + 1)).slice(-2) + '/' + ('0' + d.getDate()).slice(-2) + '/' + d.getFullYear();
      });

      commit('setPatientSearchResults', data.data.patients.items);
      return data.data.patients.items;
    });
  },
  getPatientList: function getPatientList(_ref41) {
    var commit = _ref41.commit;

    // Split into a first and last name, separated by a comma
    var query = '{ patients { items { id birthdate gender firstName lastName phone address{line1 line2 city state zip} partner{id} created creator{id email firstName lastName created} } } }';

    return __WEBPACK_IMPORTED_MODULE_0__store_axios__["a" /* default */].post('/admin/gql', { query: query }).then(function (_ref42) {
      var data = _ref42.data;

      commit('setPatientSearchResults', data.data.patients.items);
      return data.data.patients.items;
    });
  },
  getProvidersList: function getProvidersList(_ref43) {
    var commit = _ref43.commit;

    // Split into a first and last name, separated by a comma
    var query = '{ providers { items { id firstName lastName credentials organizationName npi specialization type googlePlaceID notes fax email phone affiliateCode address{line1 city state zip } } } }';

    return __WEBPACK_IMPORTED_MODULE_0__store_axios__["a" /* default */].post('/admin/gql', { query: query }).then(function (_ref44) {
      var data = _ref44.data;

      commit('setProviderSearchResults', data.data.providers.items);
      return data.data.providers.items;
    });
  },
  getUserList: function getUserList(_ref45) {
    var commit = _ref45.commit;

    // Split into a first and last name, separated by a comma
    var query = '{ users { items { id email created } } }';

    return __WEBPACK_IMPORTED_MODULE_0__store_axios__["a" /* default */].post('/admin/gql', { query: query }).then(function (_ref46) {
      var data = _ref46.data;

      commit('setUserSearchResults', data.data.users.items);
      return data.data.users.items;
    });
  },
  getRecordTypes: function getRecordTypes(_ref47) {
    var commit = _ref47.commit;

    return __WEBPACK_IMPORTED_MODULE_0__store_axios__["a" /* default */].get('/public/files/record_types').then(function (data) {
      commit('setRecordTypes', data);
      return data;
    });
  },
  postUserGroup: function postUserGroup(_ref48, _ref49) {
    var commit = _ref48.commit;
    var name = _ref49.name,
        provider = _ref49.provider;

    return __WEBPACK_IMPORTED_MODULE_0__store_axios__["a" /* default */].post('/admin/user_groups', { name: name, provider: provider }).then(function (data) {
      // Note, no commit needed for now
      return data;
    });
  },
  getUserGroups: function getUserGroups(_ref50, _ref51) {
    var commit = _ref50.commit;
    var limit = _ref51.limit,
        offset = _ref51.offset;

    var params = '';
    if (offset) {
      params = ', offset: ' + offset;
    }

    var query = '{\n      userGroups(limit: ' + limit + params + ') {\n        items {\n          id\n          name\n          created\n        }\n        pageInfo {\n          count\n          offset\n          next\n          total\n        }\n      }\n    }';
    return __WEBPACK_IMPORTED_MODULE_0__store_axios__["a" /* default */].post('/admin/gql', { query: query }).then(function (_ref52) {
      var data = _ref52.data;

      var slimmed = [];
      data.data.userGroups.items.forEach(function (group) {
        if (!group.name.includes('Staff for')) {
          slimmed.push(group);
        }
      });
      commit('setGroups', slimmed);
      commit('setGroupsPageInfo', data.data.userGroups.pageInfo);
      return data;
    });
  },
  submitUserGroup: function submitUserGroup(_ref53, _ref54) {
    var commit = _ref53.commit;
    var name = _ref54.name,
        provider = _ref54.provider;

    var payload = { name: name };
    if (provider) {
      payload.provider = provider;
    }
    return __WEBPACK_IMPORTED_MODULE_0__store_axios__["a" /* default */].post('/admin/user_groups', payload).then(function (_ref55) {
      var data = _ref55.data;

      return data;
    });
  },
  sendRequest: function sendRequest(_ref56, _ref57) {
    var commit = _ref56.commit;
    var id = _ref57.id;

    var url = Object(__WEBPACK_IMPORTED_MODULE_1__core_helpers_parseUrl__["a" /* default */])('/admin/requests/:id/send', { id: id });
    return __WEBPACK_IMPORTED_MODULE_0__store_axios__["a" /* default */].post(url).then(function (_ref58) {
      var data = _ref58.data;

      return data;
    });
  },
  getRequestOverrides: function getRequestOverrides(_ref59, _ref60) {
    var commit = _ref59.commit;
    var id = _ref60.id;

    var query = '\n    {\n      requests (id: "' + id + '") {\n        items {\n          id\n          providerAddressOverride {\n            city\n            line1\n            line2\n            state\n            zip\n          }\n          providerFaxOverride\n          providerEmailOverride\n          providerPhoneOverride\n          providerNameOverride\n        }\n      }\n    }\n    ';
    return __WEBPACK_IMPORTED_MODULE_0__store_axios__["a" /* default */].post('/admin/gql', { query: query }).then(function (_ref61) {
      var data = _ref61.data;

      commit('setRequestProviderOverrides', data.data.requests.items[0]);
      return data;
    });
  },
  submitRequestOverrides: function submitRequestOverrides(_ref62, _ref63) {
    var commit = _ref62.commit;
    var id = _ref63.id,
        provider = _ref63.provider;

    var overrides = {
      providerNameOverride: provider.name,
      providerAddressOverride: provider.address,
      providerEmailOverride: provider.email,
      providerFaxOverride: provider.fax,
      providerPhoneOverride: provider.phone
    };

    var url = Object(__WEBPACK_IMPORTED_MODULE_1__core_helpers_parseUrl__["a" /* default */])('/admin/requests/:id', { id: id });
    return __WEBPACK_IMPORTED_MODULE_0__store_axios__["a" /* default */].patch(url, overrides).then(function (_ref64) {
      var data = _ref64.data;

      return data;
    });
  },
  updateFaxOrEmail: function updateFaxOrEmail(_ref65, _ref66) {
    var commit = _ref65.commit;
    var id = _ref66.id,
        fax = _ref66.fax,
        email = _ref66.email;

    var overrides = {
      providerFaxOverride: fax,
      providerEmailOverride: email
    };
    var url = Object(__WEBPACK_IMPORTED_MODULE_1__core_helpers_parseUrl__["a" /* default */])('/admin/requests/:id', { id: id });
    return __WEBPACK_IMPORTED_MODULE_0__store_axios__["a" /* default */].patch(url, overrides).then(function (_ref67) {
      var data = _ref67.data;

      return data;
    });
  },
  submitRequestNote: function submitRequestNote(_ref68, _ref69) {
    var commit = _ref68.commit;
    var id = _ref69.id,
        notes = _ref69.notes,
        note = _ref69.note;

    notes.push(note);
    var url = Object(__WEBPACK_IMPORTED_MODULE_1__core_helpers_parseUrl__["a" /* default */])('/admin/requests/:id', { id: id });
    return __WEBPACK_IMPORTED_MODULE_0__store_axios__["a" /* default */].patch(url, { log: notes }).then(function (_ref70) {
      var data = _ref70.data;

      console.log(data);
      return data;
    });
  },
  setStatus: function setStatus(_ref71, _ref72) {
    var commit = _ref71.commit;
    var id = _ref72.id,
        status = _ref72.status;

    var url = Object(__WEBPACK_IMPORTED_MODULE_1__core_helpers_parseUrl__["a" /* default */])('/admin/requests/:id', { id: id });
    return __WEBPACK_IMPORTED_MODULE_0__store_axios__["a" /* default */].patch(url, status).then(function (_ref73) {
      var data = _ref73.data;
    });
  },
  getPatients: function getPatients(_ref74, _ref75) {
    var commit = _ref74.commit;
    var id = _ref75.id,
        firstName = _ref75.firstName,
        lastName = _ref75.lastName,
        DOB = _ref75.DOB;

    var params = '';
    if (id && id !== '') {
      params = params + 'id: "' + id + '", ';
    }
    if (firstName && firstName !== '') {
      params = params + 'firstName: "' + firstName + '", ';
    }
    if (lastName && lastName !== '') {
      params = params + 'lastName: "' + lastName + '", ';
    }
    if (DOB & DOB !== '') {
      params = params + 'birthdate: "' + DOB + '", ';
    }
    var query = '\n    {\n      patients (' + params + ' limit: 30) {\n        items{\n          firstName\n          lastName\n          id\n          birthdate\n          gender\n        }\n      }\n    }\n    ';

    return __WEBPACK_IMPORTED_MODULE_0__store_axios__["a" /* default */].post('/admin/gql', { query: query }).then(function (_ref76) {
      var data = _ref76.data;

      commit('setPatientSearchResults', data.data.patients.items);
      return data.data.patients.items;
    });
  },
  getPatient: function getPatient(_ref77, _ref78) {
    var commit = _ref77.commit;
    var id = _ref78.id;

    var params = '';
    if (id && id !== '') {
      params = params + 'id: "' + id + '", ';
    }
    var query = '\n    {\n      patients (' + params + ') {\n        items{\n          firstName\n          lastName\n          id\n          birthdate\n          gender\n        }\n      }\n    }\n    ';

    return __WEBPACK_IMPORTED_MODULE_0__store_axios__["a" /* default */].post('/admin/gql', { query: query }).then(function (_ref79) {
      var data = _ref79.data;

      commit('setPatient', data.data.patients.items[0]);
      return data.data.patients.items[0];
    });
  },
  viewFile: function viewFile(_ref80, fileID) {
    var commit = _ref80.commit;

    var url = 'https://api.onecharthealth.com/admin/files/' + fileID + '?alt=media';
    return __WEBPACK_IMPORTED_MODULE_0__store_axios__["a" /* default */].get(url).then(function (_ref81) {
      var data = _ref81.data;

      // const preSignedRequest = 'https://api.onecharthealth.com/files/' + file._id + '?alt=media&presign_jwt=' + data.presign_jwt
      return 'https://onechart-pdf-viewer.firebaseapp.com/' + '?file=' + encodeURIComponent(data.download_url);
    });
  },
  getPatientRequests: function getPatientRequests(_ref82, _ref83) {
    var commit = _ref82.commit;
    var patientID = _ref83.patientID;

    var statuses = '["-CANCELLED"]';
    var query = '\n    {\n      requests (patient: "' + patientID + '", statuses: ' + statuses + ') {\n        items {\n          id\n          start\n          end\n          provider\n          providerAddressOverride {\n            city\n            line1\n            line2\n            state\n            zip\n          }\n          providerFaxOverride\n          providerEmailOverride\n          providerPhoneOverride\n          providerNameOverride\n        }\n      }\n    }\n    ';

    return __WEBPACK_IMPORTED_MODULE_0__store_axios__["a" /* default */].post('/admin/gql', { query: query }).then(function (_ref84) {
      var data = _ref84.data;

      console.log('patient requests back');
      console.log(data.data.requests.items);
      commit('setPatientRequest', data.data.requests.items);
      return data.data.requests.items;
    });
  },
  getDocumentProvider: function getDocumentProvider(_ref85, _ref86) {
    var commit = _ref85.commit;
    var id = _ref86.id;

    var query = '\n    {\n      providers (id: "' + id + '") {\n        items {\n          id\n          firstName\n          lastName\n          organizationName\n        }\n      }\n    }\n    ';
    return __WEBPACK_IMPORTED_MODULE_0__store_axios__["a" /* default */].post('/admin/gql', { query: query }).then(function (_ref87) {
      var data = _ref87.data;

      commit('setDocumentProvider', data.data.providers.items[0]);
      return data.data.providers.items[0];
    });
  }
});

/***/ }),
/* 660 */,
/* 661 */,
/* 662 */,
/* 663 */,
/* 664 */,
/* 665 */,
/* 666 */,
/* 667 */,
/* 668 */,
/* 669 */,
/* 670 */,
/* 671 */,
/* 672 */,
/* 673 */,
/* 674 */,
/* 675 */,
/* 676 */,
/* 677 */,
/* 678 */,
/* 679 */,
/* 680 */,
/* 681 */,
/* 682 */,
/* 683 */,
/* 684 */,
/* 685 */,
/* 686 */,
/* 687 */,
/* 688 */,
/* 689 */,
/* 690 */,
/* 691 */,
/* 692 */,
/* 693 */,
/* 694 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "a", function() { return request; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "b", function() { return response; });
var request = {
  Email: 'e',
  Name: 'n',
  Password: 'pswd'
};

var response = {
  _id: 'Id',
  u: 'User',
  grpid: 'Communities'
};

/***/ }),
/* 695 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__state__ = __webpack_require__(696);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__getters__ = __webpack_require__(697);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__mutations__ = __webpack_require__(698);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3__actions__ = __webpack_require__(699);





/* harmony default export */ __webpack_exports__["a"] = ({
  namespaced: true,
  state: __WEBPACK_IMPORTED_MODULE_0__state__["a" /* default */],
  getters: __WEBPACK_IMPORTED_MODULE_1__getters__["a" /* default */],
  mutations: __WEBPACK_IMPORTED_MODULE_2__mutations__["a" /* default */],
  actions: __WEBPACK_IMPORTED_MODULE_3__actions__["a" /* default */]
});

/***/ }),
/* 696 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony default export */ __webpack_exports__["a"] = ({
  token: null,
  user: null,
  authToken: null,
  authUser: null,
  email: null,
  authExpiry: Date.now(), // firebase token expires after 1 hour
  error: null,
  success: null,
  currentUserGroups: null,
  isProviderUser: null,
  signature: null,
  brandingPartner: null
});

/***/ }),
/* 697 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony default export */ __webpack_exports__["a"] = ({});

/***/ }),
/* 698 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__axios__ = __webpack_require__(46);


/* harmony default export */ __webpack_exports__["a"] = ({
  setAuthUser: function setAuthUser(state, authUser) {
    state.authUser = authUser;
  },
  setAuthToken: function setAuthToken(state, authToken) {
    if (authToken) {
      state.authExpiry = Date.now() + 3600;
      state.authToken = authToken;
      __WEBPACK_IMPORTED_MODULE_0__axios__["a" /* default */].defaults.headers.Authorization = 'Bearer ' + state.authToken;
    } else {
      state.authToken = null;
      state.authExpiry = Date.now();
      delete __WEBPACK_IMPORTED_MODULE_0__axios__["a" /* default */].defaults.headers.Authorization;
    }
  },
  setUser: function setUser(state, user) {
    state.user = user;
    user.GroupIds = user.GroupIds || [];
  },
  setBrandingPartner: function setBrandingPartner(state, brandingPartner) {
    state.brandingPartner = brandingPartner;
  },
  setUserGroups: function setUserGroups(state, currentUserGroups) {
    state.currentUserGroups = currentUserGroups;
  },
  setProviderUser: function setProviderUser(state, providerUser) {
    state.isProviderUser = providerUser;
  },
  setUserName: function setUserName(state, _ref) {
    var firstName = _ref.firstName,
        lastName = _ref.lastName;

    state.user.firstName = firstName;
    state.user.lastName = lastName;
  },
  setUserSignature: function setUserSignature(state, data) {
    state.signature = data;
  },
  setActiveCommunity: function setActiveCommunity(state, community) {
    state.activeCommunity = community;
  },
  setEmail: function setEmail(state, email) {
    state.email = email;
  },
  setError: function setError(state, error) {
    state.error = error;
  },
  setSuccess: function setSuccess(state, success) {
    state.success = success;
  }
});

/***/ }),
/* 699 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_promise__ = __webpack_require__(700);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_promise___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_promise__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__store_axios__ = __webpack_require__(46);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_firebase__ = __webpack_require__(711);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_firebase___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_2_firebase__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3_lodash_clone__ = __webpack_require__(721);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3_lodash_clone___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_3_lodash_clone__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4__core_helpers_parseUrl__ = __webpack_require__(47);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_5__store__ = __webpack_require__(135);







__WEBPACK_IMPORTED_MODULE_2_firebase__["initializeApp"]({
    apiKey: 'AIzaSyBhHTQWfKsJSMkk8Be_ajV6oAbwCy79PlU',
    authDomain: 'onechart-prod.firebaseapp.com',
    databaseURL: 'https://onechart-prod.firebaseio.com',
    projectId: 'onechart-prod',
    storageBucket: 'onechart-prod.appspot.com',
    messagingSenderId: '530093705162'
  });
__WEBPACK_IMPORTED_MODULE_2_firebase__["auth"]().setPersistence(__WEBPACK_IMPORTED_MODULE_2_firebase__["auth"].Auth.Persistence.SESSION);

/* harmony default export */ __webpack_exports__["a"] = ({
  getUser: function getUser(_ref) {
    var commit = _ref.commit;

    return __WEBPACK_IMPORTED_MODULE_1__store_axios__["a" /* default */].get('/user').then(function (_ref2) {
      var data = _ref2.data;

      if (data) {
        commit('setUser', data);
      }
    });
  },
  setBranding: function setBranding(_ref3, _ref4) {
    var commit = _ref3.commit;
    var id = _ref4.id;

    var partner = {};
    partner.id = id;
    commit('setBrandingPartner', partner);
  },
  getUserSignature: function getUserSignature(_ref5) {
    var commit = _ref5.commit;

    return __WEBPACK_IMPORTED_MODULE_1__store_axios__["a" /* default */].get('/user/signature').then(function (_ref6) {
      var data = _ref6.data;

      if (data) {
        commit('setUserSignature', data.url);
      }
    });
  },
  postUserSignature: function postUserSignature(_ref7, _ref8) {
    var commit = _ref7.commit;
    var sigData = _ref8.sigData;

    return __WEBPACK_IMPORTED_MODULE_1__store_axios__["a" /* default */].post('user/signature', {
      pngBase64: sigData
    });
  },
  getUserGroups: function getUserGroups(_ref9) {
    var commit = _ref9.commit;

    return __WEBPACK_IMPORTED_MODULE_1__store_axios__["a" /* default */].get('/user/groups').then(function (_ref10) {
      var data = _ref10.data;

      if (data) {
        var isProvider = false;
        data.groups.forEach(function (group) {
          if (group.provider) {
            isProvider = true;
          }
        });
        commit('setProviderUser', isProvider);
        commit('setUserGroups', data);
      }
    });
  },
  insertLog: function insertLog(_ref11, _ref12) {
    var commit = _ref11.commit;
    var actionTitle = _ref12.actionTitle,
        detailTitle = _ref12.detailTitle;

    var timeAppendage = '?time=' + new Date();
    var userAppendage = '&user=';
    if (__WEBPACK_IMPORTED_MODULE_5__store__["a" /* default */].state.auth.authUser) {
      userAppendage = '&user=' + __WEBPACK_IMPORTED_MODULE_5__store__["a" /* default */].state.auth.authUser.email;
    } else {
      userAppendage = userAppendage + 'unauthenticated';
    }
    var actionAppendage = '&action=' + actionTitle;
    var detailAppendage = '&detail=' + detailTitle;
    var url = 'https://script.google.com/macros/s/AKfycbwS1Dpoocy8RzqYI8Fd1QuapPfLuGPsmKp8Ll4UH83nwW6p3FVP/exec' + timeAppendage + userAppendage + actionAppendage + detailAppendage;
    return __WEBPACK_IMPORTED_MODULE_1__store_axios__["a" /* default */].get(url);
  },
  signUp: function signUp(_ref13, _ref14) {
    var commit = _ref13.commit,
        dispatch = _ref13.dispatch;
    var email = _ref14.email,
        password = _ref14.password;

    return new __WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_promise___default.a(function (resolve, reject) {
      __WEBPACK_IMPORTED_MODULE_2_firebase__["auth"]().createUserWithEmailAndPassword(email, password).then(function (user) {
        var authUser = {
          uid: user.uid,
          email: user.email
        };
        commit('setAuthUser', authUser);
        return resolve(authUser);
      }).catch(function (error) {
        return reject(error);
      });
    });
  },
  affiliateThisUserWithProvider: function affiliateThisUserWithProvider(_ref15, _ref16) {
    var commit = _ref15.commit;
    var providerID = _ref16.providerID,
        affiliateCode = _ref16.affiliateCode;

    var payload = {};
    payload['affiliateCode'] = affiliateCode;
    var url = Object(__WEBPACK_IMPORTED_MODULE_4__core_helpers_parseUrl__["a" /* default */])('/provider/:providerID/affiliate', { providerID: providerID });
    return __WEBPACK_IMPORTED_MODULE_1__store_axios__["a" /* default */].post(url, payload).then(function (_ref17) {
      var data = _ref17.data;

      return data;
    });
  },
  updatePassword: function updatePassword(_ref18, _ref19) {
    var commit = _ref18.commit,
        dispatch = _ref18.dispatch;
    var password = _ref19.password;

    return new __WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_promise___default.a(function (resolve, reject) {
      __WEBPACK_IMPORTED_MODULE_2_firebase__["auth"]().currentUser.updatePassword(password).then(function () {
        return resolve();
      }, function (error) {
        return reject(error);
      });
    });
  },
  signIn: function signIn(_ref20, _ref21) {
    var commit = _ref20.commit,
        dispatch = _ref20.dispatch;
    var email = _ref21.email,
        password = _ref21.password;

    return new __WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_promise___default.a(function (resolve, reject) {
      return __WEBPACK_IMPORTED_MODULE_2_firebase__["auth"]().signInWithEmailAndPassword(email, password).then(function (user) {
        // set the timestamp of login for auto-logout functionality
        sessionStorage.setItem('login', new Date().getTime() / 1000);
        var authUser = {
          uid: user.uid,
          email: user.email
        };
        commit('setAuthUser', authUser);
        return resolve(authUser);
      }).catch(function (error) {
        return reject(error);
      });
    });
  },
  check: function check(_ref22) {
    var commit = _ref22.commit,
        dispatch = _ref22.dispatch,
        state = _ref22.state;

    return new __WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_promise___default.a(function (resolve, reject) {
      if (state.authToken && state.authExpiry > Date.now()) {
        return resolve();
      }
      return dispatch('autoSignIn').then(resolve, reject);
    });
  },
  autoSignIn: function autoSignIn(_ref23) {
    var commit = _ref23.commit,
        dispatch = _ref23.dispatch;

    return new __WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_promise___default.a(function (resolve, reject) {
      // check if user is already authentication
      return __WEBPACK_IMPORTED_MODULE_2_firebase__["auth"]().onAuthStateChanged(function (user) {
        if (user) {
          commit('setAuthUser', {
            uid: user.uid,
            email: user.email
          });
          // if user is authenticated
          if (user.email) {
            return dispatch('getAuthUserToken').then(resolve, reject);
          }
        } else {
          return reject(new Error('User not found'));
        }
      });
    });
  },
  getAuthUserToken: function getAuthUserToken(_ref24) {
    var commit = _ref24.commit,
        dispatch = _ref24.dispatch;

    return new __WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_promise___default.a(function (resolve, reject) {
      // get user token
      return __WEBPACK_IMPORTED_MODULE_2_firebase__["auth"]().currentUser.getIdToken( /* forceRefresh */true).then(function (authToken) {
        commit('setAuthToken', authToken);
        return resolve();
      }, reject);
    });
  },
  resetPassword: function resetPassword(_ref25, _ref26) {
    var commit = _ref25.commit;
    var email = _ref26.email;

    return new __WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_promise___default.a(function (resolve, reject) {
      return __WEBPACK_IMPORTED_MODULE_2_firebase__["auth"]().sendPasswordResetEmail(email).then(resolve).catch(function (error) {
        commit('setError', error);
        reject(error);
      });
    });
  },
  signOut: function signOut(_ref27) {
    var commit = _ref27.commit;

    commit('setAuthUser', null);
    commit('setAuthToken', null);
    return __WEBPACK_IMPORTED_MODULE_2_firebase__["auth"]().signOut();
  },
  updateUser: function updateUser(_ref28, user) {
    var commit = _ref28.commit;

    var userCopy = __WEBPACK_IMPORTED_MODULE_3_lodash_clone___default()(user);
    delete userCopy.authID;
    return __WEBPACK_IMPORTED_MODULE_1__store_axios__["a" /* default */].patch('/user', userCopy).then(function (_ref29) {
      var data = _ref29.data;

      commit('setUser', user);
      return data;
    });
  },
  updateUserName: function updateUserName(_ref30, _ref31) {
    var commit = _ref30.commit;
    var firstName = _ref31.firstName,
        lastName = _ref31.lastName;

    return __WEBPACK_IMPORTED_MODULE_1__store_axios__["a" /* default */].patch('/user', {
      firstName: firstName,
      lastName: lastName
    }).then(function (_ref32) {
      var data = _ref32.data;

      commit('setUserName', { firstName: firstName, lastName: lastName });
      return data;
    });
  },
  pay: function pay(_ref33, _ref34) {
    var commit = _ref33.commit;
    var token = _ref34.token;

    return __WEBPACK_IMPORTED_MODULE_1__store_axios__["a" /* default */].post('/stripe/purchase', token).then(function (_ref35) {
      var data = _ref35.data;

      return data;
    });
  },
  checkAndUpdatePassword: function checkAndUpdatePassword(_ref36, _ref37) {
    var commit = _ref36.commit,
        dispatch = _ref36.dispatch;
    var currentPassword = _ref37.currentPassword,
        newPassword = _ref37.newPassword;

    if (currentPassword && newPassword) {
      __WEBPACK_IMPORTED_MODULE_2_firebase__["auth"]().currentUser.reauthenticateWithCredential(__WEBPACK_IMPORTED_MODULE_2_firebase__["auth"].EmailAuthProvider.credential(__WEBPACK_IMPORTED_MODULE_2_firebase__["auth"]().currentUser.email, currentPassword)).then(function () {
        dispatch('updatePassword', { password: newPassword }).then(function () {
          commit('setSuccess', 'Password Reset');
        });
      }).catch(function (error) {
        commit('setError', error);
      });
    }
  },
  uploadFile: function uploadFile(_ref38, _ref39) {
    var commit = _ref38.commit;
    var file = _ref39.file;

    // Create the path reference
    var ref = __WEBPACK_IMPORTED_MODULE_2_firebase__["storage"]().ref();

    // Upload the file
    ref.put(file).then(function (uploadFile) {});
  }
});

/***/ }),
/* 700 */,
/* 701 */,
/* 702 */,
/* 703 */,
/* 704 */,
/* 705 */,
/* 706 */,
/* 707 */,
/* 708 */,
/* 709 */,
/* 710 */,
/* 711 */,
/* 712 */,
/* 713 */,
/* 714 */,
/* 715 */,
/* 716 */,
/* 717 */,
/* 718 */,
/* 719 */,
/* 720 */,
/* 721 */,
/* 722 */,
/* 723 */,
/* 724 */,
/* 725 */,
/* 726 */,
/* 727 */,
/* 728 */,
/* 729 */,
/* 730 */,
/* 731 */,
/* 732 */,
/* 733 */,
/* 734 */,
/* 735 */,
/* 736 */,
/* 737 */,
/* 738 */,
/* 739 */,
/* 740 */,
/* 741 */,
/* 742 */,
/* 743 */,
/* 744 */,
/* 745 */,
/* 746 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__state__ = __webpack_require__(747);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__getters__ = __webpack_require__(748);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__mutations__ = __webpack_require__(749);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3__actions__ = __webpack_require__(750);





/* harmony default export */ __webpack_exports__["a"] = ({
  namespaced: true,
  state: __WEBPACK_IMPORTED_MODULE_0__state__["a" /* default */],
  getters: __WEBPACK_IMPORTED_MODULE_1__getters__["a" /* default */],
  mutations: __WEBPACK_IMPORTED_MODULE_2__mutations__["a" /* default */],
  actions: __WEBPACK_IMPORTED_MODULE_3__actions__["a" /* default */]
});

/***/ }),
/* 747 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony default export */ __webpack_exports__["a"] = ({});

/***/ }),
/* 748 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony default export */ __webpack_exports__["a"] = ({});

/***/ }),
/* 749 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony default export */ __webpack_exports__["a"] = ({});

/***/ }),
/* 750 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__core_helpers_parseUrl__ = __webpack_require__(47);


/* harmony default export */ __webpack_exports__["a"] = ({
  downloadBundle: function downloadBundle(_ref, fileIDs) {
    var rootState = _ref.rootState;

    var token = rootState.auth.authToken;
    var url = Object(__WEBPACK_IMPORTED_MODULE_0__core_helpers_parseUrl__["a" /* default */])("https://api-dot-onechart-prod.appspot.com" + '/download?fileIDs&token', { fileIDs: fileIDs, token: token });
    window.open(url);
  }
});

/***/ }),
/* 751 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__state__ = __webpack_require__(752);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__getters__ = __webpack_require__(753);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__mutations__ = __webpack_require__(754);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3__actions__ = __webpack_require__(755);





/* harmony default export */ __webpack_exports__["a"] = ({
  namespaced: true,
  state: __WEBPACK_IMPORTED_MODULE_0__state__["a" /* default */],
  getters: __WEBPACK_IMPORTED_MODULE_1__getters__["a" /* default */],
  mutations: __WEBPACK_IMPORTED_MODULE_2__mutations__["a" /* default */],
  actions: __WEBPACK_IMPORTED_MODULE_3__actions__["a" /* default */]
});

/***/ }),
/* 752 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony default export */ __webpack_exports__["a"] = ({
  patients: [],
  patient: {},
  files: [],
  requests: [],
  medResults: [],
  probResults: [],
  permissions: [],
  individualPermissions: [],
  preliminaryPermissions: [],
  patientsCount: 0,
  patientsOffset: 0,
  patientsNext: 0,
  searchTermLastName: null,
  searchTermFirstName: null,
  searchTermBirthdate: null,
  searchOrder: null,
  externalUploadLink: null,
  sharedFilesExpiration: null
});

/***/ }),
/* 753 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony default export */ __webpack_exports__["a"] = ({
  getStoredPatient: function getStoredPatient(state) {
    return state.patient;
  }
});

/***/ }),
/* 754 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony default export */ __webpack_exports__["a"] = ({
  setPatients: function setPatients(state, patients) {
    state.patients = patients;
  },
  setPatient: function setPatient(state, patient) {
    if (state.patient.data) {
      state.patient = patient.data;
    } else {
      state.patient = patient;
    }
  },
  setPatientsOffset: function setPatientsOffset(state, offset) {
    state.patientsOffset = offset;
  },
  setPatientsCount: function setPatientsCount(state, count) {
    state.patientsCount = count;
  },
  setPatientsNext: function setPatientsNext(state, next) {
    state.patientsNext = next;
  },
  setSearchTermLastName: function setSearchTermLastName(state, lastName) {
    state.searchTermLastName = lastName;
  },
  setExternalUploadLink: function setExternalUploadLink(state, link) {
    state.externalUploadLink = link;
  },
  setSearchTermFirstName: function setSearchTermFirstName(state, firstName) {
    state.searchTermFirstName = firstName;
  },
  setSearchOrder: function setSearchOrder(state, order) {
    state.searchOrder = order;
  },
  setSearchTermBirthdate: function setSearchTermBirthdate(state, birthdate) {
    state.searchTermBirthdate = birthdate;
  },
  setFiles: function setFiles(state, files) {
    state.files = files;
  },
  setRequests: function setRequests(state, requests) {
    state.requests = requests;
  },
  setMedResults: function setMedResults(state, medResults) {
    state.medResults = medResults;
  },
  setProbResults: function setProbResults(state, probResults) {
    state.probResults = probResults;
  },
  setPermissions: function setPermissions(state, permissions) {
    state.permissions = permissions;
  },
  setUserGroupsPermissions: function setUserGroupsPermissions(state, permissions) {
    state.userGroups = permissions;
  },
  setSharedFilesExpiration: function setSharedFilesExpiration(state, expiration) {
    state.sharedFilesExpiration = expiration;
  },
  setIndividualPermissions: function setIndividualPermissions(state, permissions) {
    state.individualPermissions = permissions;
  },
  setPreliminaryPermissions: function setPreliminaryPermissions(state, permissions) {
    state.preliminaryPermissions = permissions;
  }
});

/***/ }),
/* 755 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__store_axios__ = __webpack_require__(46);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__core_helpers_parseUrl__ = __webpack_require__(47);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_lodash_each__ = __webpack_require__(77);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_lodash_each___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_2_lodash_each__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3_date_fns_format__ = __webpack_require__(59);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3_date_fns_format___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_3_date_fns_format__);





var MED_SEARCH_URL = 'https://clinicaltables.nlm.nih.gov/api/rxterms/v3/search?terms&maxList';
var PROB_SEARCH_URL = 'https://clinicaltables.nlm.nih.gov/api/conditions/v3/search?terms&maxList';

/* harmony default export */ __webpack_exports__["a"] = ({
  clearPatient: function clearPatient(_ref) {
    var commit = _ref.commit;

    commit('setPatient', {});
  },
  getPatients: function getPatients(_ref2) {
    var commit = _ref2.commit;

    var url = Object(__WEBPACK_IMPORTED_MODULE_1__core_helpers_parseUrl__["a" /* default */])('/patients');
    return __WEBPACK_IMPORTED_MODULE_0__store_axios__["a" /* default */].get(url).then(function (_ref3) {
      var data = _ref3.data;

      data.forEach(function (patient) {
        patient.fullName = patient.firstName + ' ' + patient.lastName;
        var d = new Date(patient.birthdate * 1000);
        patient.birthdateString = ('0' + (d.getMonth() + 1)).slice(-2) + '/' + ('0' + d.getDate()).slice(-2) + '/' + d.getFullYear();
      });
      commit('setPatients', data);
      return data;
    });
  },
  getPatientsGQL: function getPatientsGQL(_ref4, _ref5) {
    var commit = _ref4.commit;
    var offset = _ref5.offset,
        order = _ref5.order;

    var queryParameters = 'offset: ' + offset + ', limit: 10, order: ' + '"' + order + '"';
    var query = '{ patients( ' + queryParameters + ' ) { data { id birthdate gender firstName lastName } pageInfo { count offset next } }}';
    commit('setSearchTermLastName', null);
    commit('setSearchTermFirstName', null);
    commit('setSearchTermBirthdate', null);
    commit('setSearchOrder', order);
    return __WEBPACK_IMPORTED_MODULE_0__store_axios__["a" /* default */].post('/gql', { query: query }).then(function (_ref6) {
      var data = _ref6.data;

      console.log(data.data.patients.data);
      console.log(data.data.patients.pageInfo);
      commit('setPatients', data.data.patients.data);
      commit('setPatientsOffset', data.data.patients.pageInfo.offset);
      commit('setPatientsCount', data.data.patients.pageInfo.count);
      commit('setPatientsNext', data.data.patients.pageInfo.next);
      return data.data.patients.data;
    });
  },
  getPatientsGQLSearch: function getPatientsGQLSearch(_ref7, _ref8) {
    var commit = _ref7.commit;
    var firstName = _ref8.firstName,
        lastName = _ref8.lastName,
        birthdate = _ref8.birthdate,
        offset = _ref8.offset,
        order = _ref8.order;

    var lastSearchTerm = '"' + lastName + '"';
    var firstSearchTerm = '"' + firstName + '"';

    var queryParameters = 'offset: ' + offset + ', limit: 10, order: ' + '"' + order + '"';

    commit('setSearchOrder', order);

    if (lastName) {
      queryParameters += ', lastName: ' + lastSearchTerm;
      commit('setSearchTermLastName', lastName);
    } else {
      commit('setSearchTermLastName', null);
    }

    if (firstName) {
      queryParameters += ', firstName: ' + firstSearchTerm;
      commit('setSearchTermFirstName', firstName);
    } else {
      commit('setSearchTermFirstName', null);
    }

    if (birthdate) {
      queryParameters += ', birthdate: ' + birthdate;
      commit('setSearchTermBirthdate', birthdate);
    } else {
      commit('setSearchTermBirthdate', null);
    }

    var query = '{ patients( ' + queryParameters + ' ) { data { id birthdate gender firstName lastName } pageInfo { count offset next } }}';

    return __WEBPACK_IMPORTED_MODULE_0__store_axios__["a" /* default */].post('/gql', { query: query }).then(function (_ref9) {
      var data = _ref9.data;

      console.log(data.data.patients.data);
      console.log(data.data.patients.pageInfo);
      commit('setPatients', data.data.patients.data);
      commit('setPatientsOffset', data.data.patients.pageInfo.offset);
      commit('setPatientsCount', data.data.patients.pageInfo.count);
      commit('setPatientsNext', data.data.patients.pageInfo.next);
      return data.data.patients.data;
    });
  },
  setThePatient: function setThePatient(_ref10, patient) {
    var commit = _ref10.commit;

    commit('setPatient', patient);
    return patient;
  },
  getPatient: function getPatient(_ref11, _ref12) {
    var commit = _ref11.commit;
    var id = _ref12.id;

    var url = Object(__WEBPACK_IMPORTED_MODULE_1__core_helpers_parseUrl__["a" /* default */])('/patients/:id', { id: id });
    __WEBPACK_IMPORTED_MODULE_0__store_axios__["a" /* default */].get(url).then(function (_ref13) {
      var data = _ref13.data;

      commit('setPatient', data);
      return data;
    });
  },
  getSharedFiles: function getSharedFiles(_ref14, _ref15) {
    var commit = _ref14.commit;
    var id = _ref15.id;

    var url = Object(__WEBPACK_IMPORTED_MODULE_1__core_helpers_parseUrl__["a" /* default */])('/shares/:id', { id: id });
    __WEBPACK_IMPORTED_MODULE_0__store_axios__["a" /* default */].get(url).then(function (_ref16) {
      var data = _ref16.data;

      commit('setSharedFilesExpiration', data.share.expiration);
      commit('setPatient', data.patients[0]);
      __WEBPACK_IMPORTED_MODULE_2_lodash_each___default()(data.files, function (item) {
        console.log('files being set');
        var ts = new Date(parseInt(item._id.substr(0, 8), 16) * 1000);
        item.created = __WEBPACK_IMPORTED_MODULE_3_date_fns_format___default()(ts, 'MMM D YYYY');
        item.createdTimestamp = ts.getTime() / 1000;
        item.rawTimestampForSorting = item.createdTimestamp;
        if (item.encounterDate) {
          item.rawTimestampForSorting = item.encounterDate;
        }
      });
      commit('setFiles', data.files);
      console.log(data.files);
      return data.files;
    });
  },
  getFiles: function getFiles(_ref17, _ref18) {
    var commit = _ref17.commit;
    var id = _ref18.id;

    var url = Object(__WEBPACK_IMPORTED_MODULE_1__core_helpers_parseUrl__["a" /* default */])('/patients/:id/files', { id: id });
    return __WEBPACK_IMPORTED_MODULE_0__store_axios__["a" /* default */].get(url).then(function (_ref19) {
      var data = _ref19.data;

      __WEBPACK_IMPORTED_MODULE_2_lodash_each___default()(data, function (item) {
        var ts = new Date(parseInt(item._id.substr(0, 8), 16) * 1000);
        item.created = __WEBPACK_IMPORTED_MODULE_3_date_fns_format___default()(ts, 'MMM D YYYY');
        item.createdTimestamp = ts.getTime() / 1000;
        item.rawTimestampForSorting = item.createdTimestamp;
        if (item.encounterDate) {
          item.rawTimestampForSorting = item.encounterDate;
        }
      });
      commit('setFiles', data);
      return data;
    });
  },
  createPatient: function createPatient(_ref20, patient) {
    var commit = _ref20.commit;

    return __WEBPACK_IMPORTED_MODULE_0__store_axios__["a" /* default */].post('/patient', patient).then(function (_ref21) {
      var data = _ref21.data;

      console.log('create patient return');
      console.log(data);
      commit('setPatient', data);
      return data;
    });
  },
  applySharingCode: function applySharingCode(_ref22, id) {
    var commit = _ref22.commit;

    console.log('sharing code pre');
    console.log(id);
    var url = Object(__WEBPACK_IMPORTED_MODULE_1__core_helpers_parseUrl__["a" /* default */])('/shares/:id/apply', id);
    return __WEBPACK_IMPORTED_MODULE_0__store_axios__["a" /* default */].post(url).then(function (_ref23) {
      var data = _ref23.data;

      console.log('sharing code return');
      console.log(data);
      return data;
    });
  },
  applySharingCodeToUserGroup: function applySharingCodeToUserGroup(_ref24, _ref25) {
    var commit = _ref24.commit;
    var id = _ref25.id,
        ID = _ref25.ID;

    console.log('sharing code pre');
    console.log(id);
    var payload = {};
    payload['userGroup'] = ID;
    console.log(payload);
    var url = Object(__WEBPACK_IMPORTED_MODULE_1__core_helpers_parseUrl__["a" /* default */])('/shares/:id/apply', { id: id });
    return __WEBPACK_IMPORTED_MODULE_0__store_axios__["a" /* default */].post(url, payload).then(function (_ref26) {
      var data = _ref26.data;

      console.log('sharing code return');
      console.log(data);
      return data;
    });
  },
  createPatientWithProvider: function createPatientWithProvider(_ref27, _ref28) {
    var commit = _ref27.commit;
    var patientID = _ref28.patientID,
        id = _ref28.id,
        code = _ref28.code;

    // /partner/:id/sponsor
    var url = Object(__WEBPACK_IMPORTED_MODULE_1__core_helpers_parseUrl__["a" /* default */])('/partner/:id/sponsor', { id: id });
    var payload = {};
    payload['patient'] = patientID;
    payload['sponsorCode'] = code;
    return __WEBPACK_IMPORTED_MODULE_0__store_axios__["a" /* default */].post(url, payload).then(function (_ref29) {
      var data = _ref29.data;

      commit('setPatient', data);
      return data;
    });
  },
  getPendingRequests: function getPendingRequests(_ref30, _ref31) {
    var commit = _ref30.commit;
    var id = _ref31.id;

    var url = Object(__WEBPACK_IMPORTED_MODULE_1__core_helpers_parseUrl__["a" /* default */])('/patients/:id/requests', { id: id });
    return __WEBPACK_IMPORTED_MODULE_0__store_axios__["a" /* default */].get(url).then(function (_ref32) {
      var data = _ref32.data;

      __WEBPACK_IMPORTED_MODULE_2_lodash_each___default()(data, function (item) {
        var ts = new Date(parseInt(item._id.substr(0, 8), 16) * 1000);
        item.created = __WEBPACK_IMPORTED_MODULE_3_date_fns_format___default()(ts, 'MMM D YYYY');
      });

      var filtered = [];
      data.forEach(function (request) {
        if (request.status !== 'CANCELLED' && request.status !== 'COMPLETED') {
          filtered.push(request);
        }
      });

      commit('setRequests', filtered);
      return filtered;
    });
  },
  getPublicUploadLink: function getPublicUploadLink(_ref33, _ref34) {
    var commit = _ref33.commit;
    var id = _ref34.id;

    var url = Object(__WEBPACK_IMPORTED_MODULE_1__core_helpers_parseUrl__["a" /* default */])('/patients/:id/upload_url', { id: id });
    return __WEBPACK_IMPORTED_MODULE_0__store_axios__["a" /* default */].get(url).then(function (_ref35) {
      var data = _ref35.data;

      commit('setExternalUploadLink', data.shortURL);
    });
  },
  updatePatient: function updatePatient(_ref36, _ref37) {
    var commit = _ref36.commit;
    var id = _ref37.id,
        payload = _ref37.payload;

    var url = Object(__WEBPACK_IMPORTED_MODULE_1__core_helpers_parseUrl__["a" /* default */])('/patients/:id', { id: id });
    return __WEBPACK_IMPORTED_MODULE_0__store_axios__["a" /* default */].patch(url, payload);
  },
  lookupMedication: function lookupMedication(_ref38, _ref39) {
    var commit = _ref38.commit;
    var terms = _ref39.terms;

    var url = Object(__WEBPACK_IMPORTED_MODULE_1__core_helpers_parseUrl__["a" /* default */])(MED_SEARCH_URL, { terms: terms, maxList: 5 });

    return __WEBPACK_IMPORTED_MODULE_0__store_axios__["a" /* default */].get(url).then(function (_ref40) {
      var data = _ref40.data;

      var searchResults = data[1];

      commit('setMedResults', searchResults);
      return searchResults;
    });
  },
  lookupProblem: function lookupProblem(_ref41, _ref42) {
    var commit = _ref41.commit;
    var terms = _ref42.terms;

    var url = Object(__WEBPACK_IMPORTED_MODULE_1__core_helpers_parseUrl__["a" /* default */])(PROB_SEARCH_URL, { terms: terms, maxList: 5 });

    return __WEBPACK_IMPORTED_MODULE_0__store_axios__["a" /* default */].get(url).then(function (_ref43) {
      var data = _ref43.data;

      var searchResults = data[3];
      var place = 0;

      __WEBPACK_IMPORTED_MODULE_2_lodash_each___default()(data[3], function (item) {
        searchResults[place] = item[0];
        place = place + 1;
      });

      commit('setProbResults', searchResults);
      return searchResults;
    });
  },
  updatePatientMedications: function updatePatientMedications(_ref44, _ref45) {
    var commit = _ref44.commit;
    var patientId = _ref45.patientId,
        medicationList = _ref45.medicationList;

    var url = Object(__WEBPACK_IMPORTED_MODULE_1__core_helpers_parseUrl__["a" /* default */])('/patients/:id', { id: patientId });
    return __WEBPACK_IMPORTED_MODULE_0__store_axios__["a" /* default */].patch(url, { medications: medicationList });
  },
  updatePatientAllergies: function updatePatientAllergies(_ref46, _ref47) {
    var commit = _ref46.commit;
    var patientId = _ref47.patientId,
        allergyList = _ref47.allergyList;

    var url = Object(__WEBPACK_IMPORTED_MODULE_1__core_helpers_parseUrl__["a" /* default */])('/patients/:id', { id: patientId });
    return __WEBPACK_IMPORTED_MODULE_0__store_axios__["a" /* default */].patch(url, { allergies: allergyList });
  },
  updatePatientProblems: function updatePatientProblems(_ref48, _ref49) {
    var commit = _ref48.commit;
    var patientId = _ref49.patientId,
        problemList = _ref49.problemList;

    var url = Object(__WEBPACK_IMPORTED_MODULE_1__core_helpers_parseUrl__["a" /* default */])('/patients/:id', { id: patientId });
    return __WEBPACK_IMPORTED_MODULE_0__store_axios__["a" /* default */].patch(url, { problems: problemList });
  },
  getPermissions: function getPermissions(_ref50, _ref51) {
    var commit = _ref50.commit;
    var id = _ref51.id;

    // TODO: Change to acls
    var url = Object(__WEBPACK_IMPORTED_MODULE_1__core_helpers_parseUrl__["a" /* default */])('/patients/:id/acls', { id: id });
    return __WEBPACK_IMPORTED_MODULE_0__store_axios__["a" /* default */].get(url).then(function (_ref52) {
      var data = _ref52.data;

      var users = [];
      // let userGroups = []
      // Setting users
      data.forEach(function (item) {
        if (item.user) {
          users.push({ user: item.user, permissions: item.allow });
        } else if (item.userGroup) {
          users.push({ group: item.userGroup, permissions: item.allow });
        }
      });

      commit('setPermissions', users);
      // commit('setUserGroupsPermissions', userGroups)
      return data;
    });
  },
  updateIndividualPermissions: function updateIndividualPermissions(_ref53, _ref54) {
    var commit = _ref53.commit;
    var id = _ref54.id,
        payload = _ref54.payload;

    var url = Object(__WEBPACK_IMPORTED_MODULE_1__core_helpers_parseUrl__["a" /* default */])('/patients/:id/acls', { id: id });
    return __WEBPACK_IMPORTED_MODULE_0__store_axios__["a" /* default */].patch(url, payload);
  },
  getPreliminaryPermissions: function getPreliminaryPermissions(_ref55, _ref56) {
    var commit = _ref55.commit;
    var id = _ref56.id;

    var url = Object(__WEBPACK_IMPORTED_MODULE_1__core_helpers_parseUrl__["a" /* default */])('/patients/:id/acls/user', { id: id });
    return __WEBPACK_IMPORTED_MODULE_0__store_axios__["a" /* default */].get(url).then(function (_ref57) {
      var data = _ref57.data;

      commit('setPreliminaryPermissions', data);
      return data;
    }).catch(function (error) {
      var msg = {
        error: error
      };
      return msg;
    });
  }
});

/***/ }),
/* 756 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__state__ = __webpack_require__(757);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__getters__ = __webpack_require__(758);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__mutations__ = __webpack_require__(759);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3__actions__ = __webpack_require__(760);





/* harmony default export */ __webpack_exports__["a"] = ({
  namespaced: true,
  state: __WEBPACK_IMPORTED_MODULE_0__state__["a" /* default */],
  getters: __WEBPACK_IMPORTED_MODULE_1__getters__["a" /* default */],
  mutations: __WEBPACK_IMPORTED_MODULE_2__mutations__["a" /* default */],
  actions: __WEBPACK_IMPORTED_MODULE_3__actions__["a" /* default */]
});

/***/ }),
/* 757 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony default export */ __webpack_exports__["a"] = ({
  searchResults: [],
  providers: [],
  provider: null,
  partner: null,
  partners: [],
  providerAuthInfo: null,
  providerFeedback: null,
  start: null,
  end: null,
  sharingLink: null,
  localProviderList: []
});

/***/ }),
/* 758 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony default export */ __webpack_exports__["a"] = ({});

/***/ }),
/* 759 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony default export */ __webpack_exports__["a"] = ({
  setSearchResults: function setSearchResults(state, searchResults) {
    state.searchResults = searchResults;
  },
  setProviders: function setProviders(state, providers) {
    state.providers = providers;
  },
  setProvider: function setProvider(state, provider) {
    state.provider = provider;
  },
  setPartners: function setPartners(state, partners) {
    state.partners = partners;
  },
  setPartner: function setPartner(state, partner) {
    state.partner = partner;
  },
  clearPartner: function clearPartner(state) {
    state.partner = null;
  },
  setProviderAuth: function setProviderAuth(state, providerAuthInfo) {
    state.providerAuthInfo = providerAuthInfo;
  },
  setProviderFeedback: function setProviderFeedback(state, userInput) {
    state.providerFeedback = userInput;
  },
  clearProviderFeedback: function clearProviderFeedback(state) {
    state.providerFeedback = null;
  },
  setStartEnd: function setStartEnd(state, _ref) {
    var start = _ref.start,
        end = _ref.end;

    state.start = start;
    state.end = end;
  },
  setSharingLink: function setSharingLink(state, sharingLink) {
    state.sharingLink = sharingLink;
  },
  setLocalProviderList: function setLocalProviderList(state, list) {
    state.localProviderList = list;
  }
});

/***/ }),
/* 760 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__store_axios__ = __webpack_require__(46);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__core_helpers_parseUrl__ = __webpack_require__(47);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_lodash_each__ = __webpack_require__(77);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_lodash_each___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_2_lodash_each__);




var PROVIDER_IDV_URL = 'https://clin-table-search.lhc.nlm.nih.gov/api/npi_idv/v3/search?terms&df&maxList';

// const PROXY_URL = 'https://cors-anywhere.herokuapp.com/'
// const GEOCODING_ORG_URL =
//   'https://maps.googleapis.com/maps/api/geocode/json?&address&key'
var PROVIDER_ORG_URL = 'https://clin-table-search.lhc.nlm.nih.gov/api/npi_idv/v3/search?terms&df&maxList';
// // 'https://clin-table-search.lhc.nlm.nih.gov/api/npi_org/v3/search?terms&df&maxList'
// const PROVIDER_ORG_KEY = 'AIzaSyBhHTQWfKsJSMkk8Be_ajV6oAbwCy79PlU'

var PROVIDER_IDV_FIELDS = ['NPI', 'provider_type', 'name.first', 'name.last', 'name.credential', 'addr_practice.line1', 'addr_practice.line2', 'addr_practice.city', 'addr_practice.state', 'addr_practice.zip', 'addr_practice.phone', 'addr_practice.fax'];

var PROVIDER_ORG_FIELDS = ['NPI', 'name.full', 'addr_practice.line1', 'addr_practice.line2', 'addr_practice.city', 'addr_practice.state', 'addr_practice.zip', 'addr_practice.phone', 'addr_practice.fax'];

/* harmony default export */ __webpack_exports__["a"] = ({
  addProvider: function addProvider(_ref, provider) {
    var commit = _ref.commit;

    var url = '/providers';
    return __WEBPACK_IMPORTED_MODULE_0__store_axios__["a" /* default */].post(url, provider);
  },
  getProviders: function getProviders(_ref2) {
    var commit = _ref2.commit;

    var url = '/providers';
    return __WEBPACK_IMPORTED_MODULE_0__store_axios__["a" /* default */].get(url).then(function (_ref3) {
      var data = _ref3.data;

      commit('setProviders', data);
      return data;
    });
  },
  getInvidualProvider: function getInvidualProvider(_ref4, _ref5) {
    var commit = _ref4.commit;
    var npi = _ref5.npi;

    var terms = npi;
    var df = PROVIDER_IDV_FIELDS.join(',');
    var maxList = 1;
    var url = Object(__WEBPACK_IMPORTED_MODULE_1__core_helpers_parseUrl__["a" /* default */])(PROVIDER_IDV_URL, { terms: terms, df: df, maxList: maxList });

    return __WEBPACK_IMPORTED_MODULE_0__store_axios__["a" /* default */].get(url).then(function (_ref6) {
      var data = _ref6.data;

      var searchResults = [];
      var item = data[3][0]; // get first item
      var searchResultItem = {
        npi: item[0],
        type: item[1],
        name: item[2] + ' ' + item[3],
        first: item[2],
        last: item[3],
        credential: item[4],
        displayNameIndividual: item[2] + ' ' + item[3] + ' ' + item[4],
        address: {
          line1: item[5],
          line2: item[6],
          city: item[7],
          state: item[8],
          zip: item[9]
        },
        displayAddressIndividual: item[5] + ' ' + item[6] + ' ' + item[7] + ' ' + item[8] + ' ' + item[9],
        phone: item[10],
        fax: item[11],
        email: '',
        notes: ''
      };
      commit('setProvider', searchResultItem);
      return searchResults;
    });
  },
  getGoogleProvider: function getGoogleProvider(_ref7, _ref8) {
    var commit = _ref7.commit;
    var googleProvider = _ref8.googleProvider;

    var searchResults = [googleProvider];
    commit('setProvider', googleProvider);
    return searchResults;
  },
  getIndividualProviderForRequestDisplay: function getIndividualProviderForRequestDisplay(_ref9, _ref10) {
    var commit = _ref9.commit;
    var npi = _ref10.npi;

    var terms = npi;
    var df = PROVIDER_IDV_FIELDS.join(',');
    var maxList = 1;
    var url = Object(__WEBPACK_IMPORTED_MODULE_1__core_helpers_parseUrl__["a" /* default */])(PROVIDER_IDV_URL, { terms: terms, df: df, maxList: maxList });
    return __WEBPACK_IMPORTED_MODULE_0__store_axios__["a" /* default */].get(url).then(function (_ref11) {
      var data = _ref11.data;

      var item = data[3][0]; // get first item
      var searchResultItem = {
        npi: item[0],
        type: item[1],
        name: item[2] + ' ' + item[3],
        first: item[2],
        last: item[3],
        credential: item[4],
        displayNameIndividual: item[2] + ' ' + item[3] + ' ' + item[4],
        address: {
          line1: item[5],
          line2: item[6],
          city: item[7],
          state: item[8],
          zip: item[9]
        },
        displayAddressIndividual: item[5] + ' ' + item[6] + ' ' + item[7] + ' ' + item[8] + ' ' + item[9],
        phone: item[10],
        fax: item[11],
        email: '',
        notes: ''
      };
      return searchResultItem;
    });
  },
  getOrganizationProvider: function getOrganizationProvider(_ref12, _ref13) {
    var commit = _ref12.commit;
    var npi = _ref13.npi;

    var terms = npi;
    var df = PROVIDER_ORG_FIELDS.join(',');
    var maxList = 1;
    var url = Object(__WEBPACK_IMPORTED_MODULE_1__core_helpers_parseUrl__["a" /* default */])(PROVIDER_ORG_URL, { terms: terms, df: df, maxList: maxList });

    return __WEBPACK_IMPORTED_MODULE_0__store_axios__["a" /* default */].get(url).then(function (_ref14) {
      var data = _ref14.data;

      var searchResults = [];
      var item = data[3][0]; // get first item
      var searchResultItem = {
        npi: item[0],
        name: item[1],
        address: {
          line1: item[2],
          line2: item[3],
          city: item[4],
          state: item[5],
          zip: item[6]
        },
        phone: item[7],
        fax: item[8],
        email: '',
        notes: ''
      };
      commit('setProvider', searchResultItem);
      return searchResults;
    });
  },
  search: function search(_ref15, _ref16) {
    var dispatch = _ref15.dispatch,
        commit = _ref15.commit;
    var type = _ref16.type,
        terms = _ref16.terms;

    if (terms && terms.trim()) {
      if (type === 'org') {
        return dispatch('simplySearch', { terms: terms });
      }
      return dispatch('simplySearch', { terms: terms });
    } else {
      commit('setSearchResults', []);
    }
  },
  simplySearch: function simplySearch(_ref17, _ref18) {
    var commit = _ref17.commit;
    var terms = _ref18.terms;

    var df = PROVIDER_IDV_FIELDS.join(',');
    var url = Object(__WEBPACK_IMPORTED_MODULE_1__core_helpers_parseUrl__["a" /* default */])(PROVIDER_IDV_URL, { terms: terms, df: df });
    var searchResults = [];
    __WEBPACK_IMPORTED_MODULE_0__store_axios__["a" /* default */].get(url).then(function (_ref19) {
      var data = _ref19.data;

      var list = data[3];
      __WEBPACK_IMPORTED_MODULE_2_lodash_each___default()(list, function (item) {
        var searchResultItem = {
          avatar: 'person',
          npi: item[0],
          type: item[1],
          name: item[2] + ' ' + item[3],
          first: item[2],
          last: item[3],
          credential: item[4],
          displayNameIndividual: item[2] + ' ' + item[3] + ' ' + item[4],
          selectionDisplayName: item[2].toLowerCase().replace(/^\w/, function (c) {
            return c.toUpperCase();
          }) + ' ' + item[3].toLowerCase().replace(/^\w/, function (c) {
            return c.toUpperCase();
          }) + ' ' + item[4],
          displayName: item[2] + ' ' + item[3] + ' ' + item[4],
          displayLocale: item[7] + ', ' + item[8],
          address: {
            line1: item[5],
            line2: item[6],
            city: item[7],
            state: item[8],
            zip: item[9]
          },
          displayAddressIndividual: item[5] + ' ' + item[6] + ' ' + item[7] + ' ' + item[8] + ' ' + item[9],
          phone: item[10],
          fax: item[11],
          email: '',
          notes: ''
        };
        searchResults.push(searchResultItem);
      });
      commit('setSearchResults', searchResults);
    });
    return searchResults;
  },
  searchByIndiviual: function searchByIndiviual(_ref20, _ref21) {
    var commit = _ref20.commit;
    var terms = _ref21.terms;

    var df = PROVIDER_IDV_FIELDS.join(',');
    var url = Object(__WEBPACK_IMPORTED_MODULE_1__core_helpers_parseUrl__["a" /* default */])(PROVIDER_IDV_URL, { terms: terms, df: df });
    return __WEBPACK_IMPORTED_MODULE_0__store_axios__["a" /* default */].get(url).then(function (_ref22) {
      var data = _ref22.data;

      var searchResults = [];
      var list = data[3];
      __WEBPACK_IMPORTED_MODULE_2_lodash_each___default()(list, function (item) {
        var searchResultItem = {
          npi: item[0],
          type: item[1],
          name: item[2] + ' ' + item[3],
          first: item[2],
          last: item[3],
          credential: item[4],
          displayNameIndividual: item[2] + ' ' + item[3] + ' ' + item[4],
          address: {
            line1: item[5],
            line2: item[6],
            city: item[7],
            state: item[8],
            zip: item[9]
          },
          displayAddressIndividual: item[5] + ' ' + item[6] + ' ' + item[7] + ' ' + item[8] + ' ' + item[9],
          phone: item[10],
          fax: item[11],
          email: '',
          notes: ''
        };
        searchResults.push(searchResultItem);
      });
      commit('setSearchResults', searchResults);
      return searchResults;
    });
  },
  searchByOrganization: function searchByOrganization(_ref23, _ref24) {
    var commit = _ref23.commit;
    var terms = _ref24.terms;

    var df = PROVIDER_ORG_FIELDS.join(',');
    var url = Object(__WEBPACK_IMPORTED_MODULE_1__core_helpers_parseUrl__["a" /* default */])(PROVIDER_ORG_URL, { terms: terms, df: df });
    return __WEBPACK_IMPORTED_MODULE_0__store_axios__["a" /* default */].get(url).then(function (_ref25) {
      var data = _ref25.data;

      var searchResults = [];
      var list = data[3];
      __WEBPACK_IMPORTED_MODULE_2_lodash_each___default()(list, function (item) {
        var searchResultItem = {
          npi: item[0],
          name: item[1],
          address: {
            line1: item[2],
            line2: item[3],
            city: item[4],
            state: item[5],
            zip: item[6]
          },
          phone: item[7],
          fax: item[8],
          email: '',
          notes: ''
        };
        searchResults.push(searchResultItem);
      });
      commit('setSearchResults', searchResults);
      return searchResults;
    });
  },

  // searchByOrganization({ commit }, { terms }) {

  //   // TODO: Set up geocode url
  //   const geoUrl = parseUrl(GEOCODING_ORG_URL, {
  //     address: terms,
  //     key: PROVIDER_ORG_KEY
  //   })
  //   return axios.get(geoUrl).then(() => {
  //     const url = parseUrl(PROVIDER_ORG_URL, {
  //       query: terms,
  //       type: 'hospital',
  //       key: PROVIDER_ORG_KEY
  //     })
  //     return axios
  //       .get(url)
  //       .then(({ data }) => {
  //         console.log(data)
  //         let searchResults = []
  //         let list = data[3]
  //         each(list, item => {
  //           let searchResultItem = {
  //             npi: item[0],
  //             name: item[1],
  //             address: {
  //               line1: item[2],
  //               line2: item[3],
  //               city: item[4],
  //               state: item[5],
  //               zip: item[6]
  //             },
  //             phone: item[7],
  //             fax: item[8],
  //             email: '',
  //             notes: ''
  //           }
  //           searchResults.push(searchResultItem)
  //         })
  //         commit('setSearchResults', searchResults)
  //         return searchResults
  //       })
  //       .catch(error => {
  //         console.log(error)
  //       })
  //   })
  // },
  requestDocs: function requestDocs(_ref26, _ref27) {
    var commit = _ref26.commit;
    var provider = _ref27.provider,
        patient = _ref27.patient,
        startDate = _ref27.startDate,
        endDate = _ref27.endDate,
        signature = _ref27.signature;

    var url = Object(__WEBPACK_IMPORTED_MODULE_1__core_helpers_parseUrl__["a" /* default */])('/providers/:id/requests', { id: provider.npi });
    return __WEBPACK_IMPORTED_MODULE_0__store_axios__["a" /* default */].post(url, {
      patientID: patient._id,
      start: startDate,
      end: endDate,
      sigPNGBase64: signature
    });
  },
  requestMissingProvider: function requestMissingProvider(_ref28, _ref29) {
    var commit = _ref28.commit;
    var provider = _ref29.provider,
        patient = _ref29.patient,
        startDate = _ref29.startDate,
        endDate = _ref29.endDate,
        signature = _ref29.signature,
        userFeedback = _ref29.userFeedback;

    var url = '/missing_provider_request';
    return __WEBPACK_IMPORTED_MODULE_0__store_axios__["a" /* default */].post(url, {
      patientID: patient._id,
      start: startDate,
      end: endDate,
      sigPNGBase64: signature,
      missingProviderInfo: userFeedback
    });
  },
  getPartner: function getPartner(_ref30, _ref31) {
    var commit = _ref30.commit,
        dispatch = _ref30.dispatch;
    var npi = _ref31.npi;

    return dispatch('getPartners', {
      npis: [npi]
    }).then(function (partners) {
      commit('setPartner', partners[0]);
      return partners[0];
    });
  },
  getPartners: function getPartners(_ref32, _ref33) {
    var commit = _ref32.commit;
    var npis = _ref33.npis,
        ids = _ref33.ids;

    var url = Object(__WEBPACK_IMPORTED_MODULE_1__core_helpers_parseUrl__["a" /* default */])('/partners?npis&ids', { npis: npis, ids: ids });
    return __WEBPACK_IMPORTED_MODULE_0__store_axios__["a" /* default */].get(url).then(function (_ref34) {
      var data = _ref34.data;

      commit('setPartners', data);
      return data;
    });
  },
  getProviderAuth: function getProviderAuth(_ref35, _ref36) {
    var commit = _ref35.commit;
    var ids = _ref36.ids;

    var url = Object(__WEBPACK_IMPORTED_MODULE_1__core_helpers_parseUrl__["a" /* default */])('/public/providers?ids', { ids: ids });
    return __WEBPACK_IMPORTED_MODULE_0__store_axios__["a" /* default */].get(url).then(function (_ref37) {
      var data = _ref37.data;

      commit('setProviderAuth', data);
      return data;
    });
  },
  setTheLocalProviderList: function setTheLocalProviderList(_ref38, _ref39) {
    var commit = _ref38.commit;
    var ids = _ref39.ids;

    var url = Object(__WEBPACK_IMPORTED_MODULE_1__core_helpers_parseUrl__["a" /* default */])('/public/providers?ids', { ids: ids });
    return __WEBPACK_IMPORTED_MODULE_0__store_axios__["a" /* default */].get(url).then(function (_ref40) {
      var data = _ref40.data;

      commit('setLocalProviderList', data);
      return data;
    });
  },
  getProviderIDFromNPI: function getProviderIDFromNPI(_ref41, _ref42) {
    var commit = _ref41.commit;
    var npis = _ref42.npis;

    var url = Object(__WEBPACK_IMPORTED_MODULE_1__core_helpers_parseUrl__["a" /* default */])('/public/providers?npis', { npis: npis });
    return __WEBPACK_IMPORTED_MODULE_0__store_axios__["a" /* default */].get(url).then(function (_ref43) {
      var data = _ref43.data;

      return data;
    });
  },
  getProviderIDFromGooglePlacesID: function getProviderIDFromGooglePlacesID(_ref44, _ref45) {
    var commit = _ref44.commit;
    var googlePlaceIDs = _ref45.googlePlaceIDs;

    console.log(googlePlaceIDs);
    var url = Object(__WEBPACK_IMPORTED_MODULE_1__core_helpers_parseUrl__["a" /* default */])('/public/providers?googlePlaceIDs', {
      googlePlaceIDs: googlePlaceIDs
    });
    return __WEBPACK_IMPORTED_MODULE_0__store_axios__["a" /* default */].get(url).then(function (_ref46) {
      var data = _ref46.data;

      console.log('google places get id return');
      console.log(data);
      return data;
    });
  },
  getProviderInfo: function getProviderInfo(_ref47, _ref48) {
    var commit = _ref47.commit;
    var ids = _ref48.ids;

    var url = Object(__WEBPACK_IMPORTED_MODULE_1__core_helpers_parseUrl__["a" /* default */])('/public/providers?ids', { ids: ids });
    return __WEBPACK_IMPORTED_MODULE_0__store_axios__["a" /* default */].get(url).then(function (_ref49) {
      var data = _ref49.data;

      return data;
    });
  },
  confirmProviders: function confirmProviders(_ref50, _ref51) {
    var commit = _ref50.commit;
    var provider = _ref51.provider,
        providerCode = _ref51.providerCode;

    var url = Object(__WEBPACK_IMPORTED_MODULE_1__core_helpers_parseUrl__["a" /* default */])('/providers/:npi/affiliate/:code', { npi: provider }, { code: providerCode });
    return __WEBPACK_IMPORTED_MODULE_0__store_axios__["a" /* default */].post(url);
  },
  shareChart: function shareChart(_, _ref52) {
    var faxes = _ref52.faxes,
        emails = _ref52.emails,
        patients = _ref52.patients,
        files = _ref52.files;

    console.log('share the chart');
    var payload = {};

    var subdomain = window.location.hostname.split('.')[0];
    if (subdomain) {
      payload['subdomain'] = subdomain;
    }

    payload['emails'] = emails;
    payload['faxes'] = faxes;
    payload['patients'] = patients;
    payload['files'] = files;
    // TODO add subdomain

    var url = Object(__WEBPACK_IMPORTED_MODULE_1__core_helpers_parseUrl__["a" /* default */])('/shares');
    return __WEBPACK_IMPORTED_MODULE_0__store_axios__["a" /* default */].post(url, payload).then(function (_ref53) {
      var data = _ref53.data;

      return data;
    });
  },
  generateSharingLink: function generateSharingLink(_ref54, _ref55) {
    var commit = _ref54.commit;
    var faxes = _ref55.faxes,
        emails = _ref55.emails,
        patients = _ref55.patients,
        files = _ref55.files;

    var payload = {};
    var subdomain = window.location.hostname.split('.')[0];

    if (subdomain) {
      payload['subdomain'] = subdomain;
    }

    payload['emails'] = emails;
    payload['faxes'] = faxes;
    payload['patients'] = patients;
    payload['files'] = files;
    // TODO add subdomain

    var url = Object(__WEBPACK_IMPORTED_MODULE_1__core_helpers_parseUrl__["a" /* default */])('/shares');
    return __WEBPACK_IMPORTED_MODULE_0__store_axios__["a" /* default */].post(url, payload).then(function (_ref56) {
      var data = _ref56.data;

      var link = 'https://patient.onecharthealth.com/shared/' + data.share._id;
      commit('setSharingLink', link);
      return data;
    });
  },
  clearSharingLink: function clearSharingLink(_ref57) {
    var commit = _ref57.commit;

    commit('setSharingLink', null);
  },
  multipleShareFiles: function multipleShareFiles(_, _ref58) {
    var providers = _ref58.providers,
        emails = _ref58.emails,
        files = _ref58.files;

    var payload = {};
    var filesHere = {};

    __WEBPACK_IMPORTED_MODULE_2_lodash_each___default()(files, function (file) {
      filesHere[file._id] = ['VIEW'];
    });

    payload['files'] = filesHere;
    payload['emails'] = emails;
    payload['providers'] = providers;

    var url = Object(__WEBPACK_IMPORTED_MODULE_1__core_helpers_parseUrl__["a" /* default */])('/share');
    return __WEBPACK_IMPORTED_MODULE_0__store_axios__["a" /* default */].post(url, payload).then(function (_ref59) {
      var data = _ref59.data;

      return data;
    });
  }
});

/***/ }),
/* 761 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__state__ = __webpack_require__(762);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__getters__ = __webpack_require__(763);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__mutations__ = __webpack_require__(764);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3__actions__ = __webpack_require__(765);





/* harmony default export */ __webpack_exports__["a"] = ({
  namespaced: true,
  state: __WEBPACK_IMPORTED_MODULE_0__state__["a" /* default */],
  getters: __WEBPACK_IMPORTED_MODULE_1__getters__["a" /* default */],
  mutations: __WEBPACK_IMPORTED_MODULE_2__mutations__["a" /* default */],
  actions: __WEBPACK_IMPORTED_MODULE_3__actions__["a" /* default */]
});

/***/ }),
/* 762 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony default export */ __webpack_exports__["a"] = ({
  type: '',
  partner: {},
  // Credentials
  email: 'test@test.test',
  password: '',
  confirmPassword: '',
  // Profile
  firstName: '',
  lastName: '',
  phone: '',
  birthdate: '',
  gender: 'MALE',
  // Address
  line1: '',
  line2: '',
  city: '',
  state: '',
  zip: ''
});

/***/ }),
/* 763 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony default export */ __webpack_exports__["a"] = ({
  getType: function getType(state) {
    return state.type;
  },
  getPartner: function getPartner(state) {
    return state.partner;
  },
  getCredentials: function getCredentials(state) {
    return {
      email: state.email,
      password: state.password,
      confirmPassword: state.confirmPassword
    };
  },
  getProfile: function getProfile(state) {
    return {
      firstName: state.firstName,
      lastName: state.lastName,
      phone: state.phone,
      birthdate: state.birthdate,
      gender: state.gender
    };
  },
  getAddress: function getAddress(state) {
    return {
      line1: state.line1,
      line2: state.line2,
      city: state.city,
      state: state.state,
      zip: state.zip
    };
  },
  getFormData: function getFormData(state) {
    return {
      email: state.email,
      password: state.password,
      confirmPassword: state.confirmPassword,

      firstName: state.firstName,
      lastName: state.lastName,
      phone: state.phone,
      birthdate: state.birthdate,
      gender: state.gender,
      ssn: state.ssn,

      line1: state.line1,
      line2: state.line2,
      city: state.city,
      state: state.state,
      zip: state.zip
    };
  }
});

/***/ }),
/* 764 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony default export */ __webpack_exports__["a"] = ({
  clear: function clear(state) {
    state.type = '';
    state.partner = {};

    state.email = '';
    state.password = '';
    state.confirmPassword = '';

    state.firstName = '';
    state.lastName = '';
    state.phone = '';
    state.birthdate = '';
    state.gender = 'MALE';

    state.line1 = '';
    state.line2 = '';
    state.city = '';
    state.state = '';
    state.zip = '';
  },
  setType: function setType(state, type) {
    state.type = type;
  },
  setPartner: function setPartner(state, partner) {
    state.partner = partner;
  },
  setCredentials: function setCredentials(state, credentials) {
    state.email = credentials.email;
    state.password = credentials.password;
    state.confirmPassword = credentials.confirmPassword;
  },
  setProfile: function setProfile(state, profile) {
    state.firstName = profile.firstName;
    state.lastName = profile.lastName;
    state.phone = profile.phone;
    state.birthdate = profile.birthdate;
    state.gender = profile.gender;
    state.ssn = profile.ssn;
  },
  setAddress: function setAddress(state, address) {
    state.line1 = address.line1;
    state.line2 = address.line2;
    state.city = address.city;
    state.state = address.state;
    state.zip = address.zip;
  }
});

/***/ }),
/* 765 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony default export */ __webpack_exports__["a"] = ({});

/***/ }),
/* 766 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__state__ = __webpack_require__(767);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__getters__ = __webpack_require__(768);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__mutations__ = __webpack_require__(769);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3__actions__ = __webpack_require__(770);





/* harmony default export */ __webpack_exports__["a"] = ({
  namespaced: true,
  state: __WEBPACK_IMPORTED_MODULE_0__state__["a" /* default */],
  getters: __WEBPACK_IMPORTED_MODULE_1__getters__["a" /* default */],
  mutations: __WEBPACK_IMPORTED_MODULE_2__mutations__["a" /* default */],
  actions: __WEBPACK_IMPORTED_MODULE_3__actions__["a" /* default */]
});

/***/ }),
/* 767 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony default export */ __webpack_exports__["a"] = ({
  patient: null,
  provider: null,
  uploadInfo: null,
  uploadURL: null,
  patientUploadURL: null
});

/***/ }),
/* 768 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony default export */ __webpack_exports__["a"] = ({});

/***/ }),
/* 769 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony default export */ __webpack_exports__["a"] = ({
  setPatient: function setPatient(state, patient) {
    state.patient = patient;
  },
  setProvider: function setProvider(state, provider) {
    state.provider = provider;
  },
  setUploadInfo: function setUploadInfo(state, uploadInfo) {
    state.uploadInfo = uploadInfo;
  },
  setUploadURL: function setUploadURL(state, uploadURL) {
    state.uploadURL = uploadURL;
  },
  setPatientUploadURL: function setPatientUploadURL(state, uploadPatientURL) {
    state.uploadPatientURL = uploadPatientURL;
  }
});

/***/ }),
/* 770 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__store_axios__ = __webpack_require__(46);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__core_helpers_parseUrl__ = __webpack_require__(47);



/* harmony default export */ __webpack_exports__["a"] = ({
  getUploadInfo: function getUploadInfo(_ref, id) {
    var commit = _ref.commit;

    var url = Object(__WEBPACK_IMPORTED_MODULE_1__core_helpers_parseUrl__["a" /* default */])('/upload/request/:id', { id: id });
    return __WEBPACK_IMPORTED_MODULE_0__store_axios__["a" /* default */].get(url).then(function (_ref2) {
      var data = _ref2.data;

      commit('setUploadInfo', data);
      return data;
    });
  },

  // TODO:
  getProvider: function getProvider(_ref3, id) {
    var commit = _ref3.commit;

    var url = Object(__WEBPACK_IMPORTED_MODULE_1__core_helpers_parseUrl__["a" /* default */])('/upload/request/:id', { id: id });
    return __WEBPACK_IMPORTED_MODULE_0__store_axios__["a" /* default */].get(url).then(function (_ref4) {
      var data = _ref4.data;

      commit('setDateOfCare', data);
      return data;
    });
  },
  getPatientUploadURL: function getPatientUploadURL(_ref5, _ref6) {
    var commit = _ref5.commit;
    var patientId = _ref6.patientId,
        renderingProvider = _ref6.renderingProvider,
        mimetype = _ref6.mimetype,
        encounterDate = _ref6.encounterDate,
        recordType = _ref6.recordType,
        description = _ref6.description;

    if (renderingProvider === null) {
      renderingProvider = undefined;
    }

    if (encounterDate === null) {
      encounterDate = undefined;
    }

    if (recordType === null) {
      recordType = undefined;
    }

    if (description === null) {
      description = undefined;
    }

    var url = Object(__WEBPACK_IMPORTED_MODULE_1__core_helpers_parseUrl__["a" /* default */])('/patients/:id/files', { id: patientId });
    return __WEBPACK_IMPORTED_MODULE_0__store_axios__["a" /* default */].post(url, { mimetype: mimetype, renderingProvider: renderingProvider, encounterDate: encounterDate, recordType: recordType }).then(function (_ref7) {
      var data = _ref7.data;

      commit('setPatientUploadURL', data);
      return data;
    });
  },
  getPatientUploadInfo: function getPatientUploadInfo(_ref8, id) {
    var commit = _ref8.commit;

    var url = Object(__WEBPACK_IMPORTED_MODULE_1__core_helpers_parseUrl__["a" /* default */])('/patients/:id', { id: id });
    return __WEBPACK_IMPORTED_MODULE_0__store_axios__["a" /* default */].post(url).then(function (_ref9) {
      var data = _ref9.data;

      commit('setPatientInformation', data);
      return data;
    });
  },
  getUploadURL: function getUploadURL(_ref10, _ref11) {
    var commit = _ref10.commit;
    var request = _ref11.request,
        mimetype = _ref11.mimetype;

    var url = '/file';
    return __WEBPACK_IMPORTED_MODULE_0__store_axios__["a" /* default */].post(url, {
      request: request,
      mimetype: mimetype
    }).then(function (_ref12) {
      var data = _ref12.data;

      commit('setUploadURL', data);
      return data;
    });
  },
  initUploadGoogleStorage: function initUploadGoogleStorage(_ref13, _ref14) {
    var commit = _ref13.commit;
    var url = _ref14.url,
        type = _ref14.type;

    var request = new Request(url, {
      method: 'POST',
      redirect: 'follow',
      headers: new Headers({
        'Content-Type': type,
        'x-goog-resumable': 'start'
      })
    });
    return fetch(request).then(function (data) {
      console.log('returning freaking data');
      console.log(data);
      return data;
    });
  },
  getUploadFailPosition: function getUploadFailPosition(_ref15, _ref16) {
    var commit = _ref15.commit;
    var url = _ref16.url,
        uploadSize = _ref16.uploadSize;

    console.log('fail position');
    console.log(url);
    var request = new Request(url, {
      method: 'PUT',
      redirect: 'follow',
      headers: new Headers({
        'Content-Range': 'bytes */' + uploadSize
      })
    });
    return fetch(request).then(function (data) {
      console.log('returning freaking data');
      console.log(data);
      return data;
    });
  }
});

/***/ }),
/* 771 */,
/* 772 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__en__ = __webpack_require__(773);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__es__ = __webpack_require__(774);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__ja__ = __webpack_require__(775);




/* harmony default export */ __webpack_exports__["a"] = ({
  en: __WEBPACK_IMPORTED_MODULE_0__en__["a" /* default */],
  es: __WEBPACK_IMPORTED_MODULE_1__es__["a" /* default */],
  ja: __WEBPACK_IMPORTED_MODULE_2__ja__["a" /* default */]
});

/***/ }),
/* 773 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony default export */ __webpack_exports__["a"] = ({
  profile: {
    name: 'OneChart',
    phone: '801.555.5555',
    address: {
      line1: '555 Cherry Lane',
      line2: '',
      city: 'American Fork',
      state: 'UT',
      zip: '82703'
    }
  },
  version: '1.0.0',
  providedBy: 'Provided by',
  links: {
    support: {
      label: 'Support',
      href: 'https://zendesk.com'
    },
    signout: {
      label: 'Sign Out',
      href: ''
    },
    account: {
      label: 'Account',
      href: ''
    }
  },
  patients: {
    title: 'Profiles',
    addProfile: 'Add Profile',
    pending: 'Pending invites',
    remove: 'Remove',
    viewDetails: 'View Chart'
  },
  providers: {
    addProvider: 'Add Provider',
    changePatient: 'Change Patient',
    selectProvider: 'Select Provider',
    newRequest: 'New Request',
    request: 'Select',
    share: 'Share with provider'
  },
  request: {
    requestRecordsFor: 'Records Request',
    fromProvider: 'Requesting records from:',
    recordsFromDate: 'How far back would you like to request records?',
    signature: 'Sign here to authorize this request.',
    signatureDesc: 'Signing below will append your signature to the medical records request. Sign to continue.',
    submitRequest: 'Submit request',
    fallback: "Can't find your provider?",
    providerInfoForm: 'Provider information form',
    infoOnProvider: 'Please enter the name and address of your provider...'
  },
  label: {
    provider: 'Provider',
    patient: 'Patient',
    requestDate: 'Request records since date',
    patients: 'Patient Charts',
    edit: 'Edit',
    remove: 'Remove',
    requestRecords: 'Request records',
    typeSearch: 'Search',
    shareProviders: 'Share providers...',
    records: 'Records'
  },
  auth: {
    authorization: 'AUTHORIZATION',
    medicalRecords: 'Medical records for the office of:',
    notice: 'CONFIDENTIALITY NOTICE -- This secure portal contains confidential information, some or all of which may be protected health information as defined by the federal Health Insurance Portability & Accountability Act (HIPAA) Privacy Rule. This portal is intended for the exclusive use of the individual or entity to whom it is addressed and may contain information that is proprietary, privileged, confidential and/or exempt from disclosure under applicable law. If you are not the intended recipient (or an employee or agent responsible for delivering the linked information to the intended recipient), you are hereby notified that any disclosure, dissemination, distribution or copying of this information is strictly prohibited and may be subject to legal restriction or sanction. Please notify the sender by telephone (number listed above) to arrange the return or destruction of the information and all copies.',
    agreement: 'I certify that I am a member of the staff at the above named practice',
    sendResetPasswordContent: 'You are required to reset your password, a link will be sent to the following email address...',
    sendResetPasswordSent: 'A link has been sent to your email address, please check your inbox now.',
    sendResetPassword: 'Send reset password',
    noEmail: 'No email on record'
  },
  share: {
    shareWith: 'Share Records',
    selectFilesToShare: 'Select the files you want to share...',
    forPatient: 'For the patient...',
    message: 'Type a message for the recipients...',
    addRecipients: 'Add recipient',
    enterEmail: 'Enter recipient email...',
    emailPerson: 'Share by email  '
  },
  signup: {
    complete: 'Complete Profile'
  },
  files: {
    sending: 'Verifying the provider contact info.',
    sent: 'This request has been sent.',
    missingProvider: 'OneChart is processing your feedback.',
    search: 'Search',
    noRequests: 'No current pending requests',
    noRecords: "This chart is empty. Click 'Request Records' to add to this chart"
  }
});

/***/ }),
/* 774 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony default export */ __webpack_exports__["a"] = ({
  message: {
    hello: 'hola mundo'
  }
});

/***/ }),
/* 775 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony default export */ __webpack_exports__["a"] = ({
  message: {
    hello: 'こんにちは、世界'
  }
});

/***/ })
],[288]);


// WEBPACK FOOTER //
// static/js/app.e4e08a7b75f4366dd31f.js